import React from "react";

export const World = () => {
  return (
    <svg
      width="311"
      height="283"
      viewBox="0 0 311 283"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "100", height: "100" }}
    >
      <g opacity="0.5">
        <mask
          id="mask0_21_10691"
          style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          style={{ width: "311", height: "283" }}
        >
          <path
            d="M306.598 1.97365C306.598 2.95659 307.395 3.75342 308.378 3.75342C309.361 3.75342 310.158 2.95659 310.158 1.97365C310.158 0.990709 309.361 0.193878 308.378 0.193878C307.395 0.193878 306.598 0.990708 306.598 1.97365Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.439 1.97342C300.439 2.95636 301.236 3.75319 302.219 3.75319C303.202 3.75319 303.999 2.95636 303.999 1.97342C303.999 0.99048 303.202 0.193649 302.219 0.193649C301.236 0.193649 300.439 0.990479 300.439 1.97342Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.223 1.97342C294.223 2.95636 295.02 3.75319 296.003 3.75319C296.986 3.75319 297.782 2.95636 297.782 1.97342C297.782 0.99048 296.986 0.193649 296.003 0.193649C295.02 0.193649 294.223 0.990479 294.223 1.97342Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.064 1.97342C288.064 2.95636 288.861 3.75319 289.844 3.75319C290.827 3.75319 291.624 2.95636 291.624 1.97342C291.624 0.99048 290.827 0.193649 289.844 0.193649C288.861 0.193649 288.064 0.990479 288.064 1.97342Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.915 1.96434C281.915 2.94728 282.712 3.74411 283.695 3.74411C284.678 3.74411 285.475 2.94728 285.475 1.96434C285.475 0.981401 284.678 0.18457 283.695 0.18457C282.712 0.18457 281.915 0.981401 281.915 1.96434Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.756 1.96434C275.756 2.94728 276.553 3.74411 277.536 3.74411C278.519 3.74411 279.316 2.94728 279.316 1.96434C279.316 0.981401 278.519 0.18457 277.536 0.18457C276.553 0.18457 275.756 0.981401 275.756 1.96434Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.557 1.97342C269.557 2.95636 270.354 3.75319 271.337 3.75319C272.32 3.75319 273.117 2.95636 273.117 1.97342C273.117 0.99048 272.32 0.193649 271.337 0.193649C270.354 0.193649 269.557 0.990479 269.557 1.97342Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.398 1.97342C263.398 2.95636 264.195 3.75319 265.178 3.75319C266.161 3.75319 266.958 2.95636 266.958 1.97342C266.958 0.99048 266.161 0.193649 265.178 0.193649C264.195 0.193649 263.398 0.990479 263.398 1.97342Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.232 1.97342C257.232 2.95636 258.029 3.75319 259.012 3.75319C259.995 3.75319 260.792 2.95636 260.792 1.97342C260.792 0.99048 259.995 0.193649 259.012 0.193649C258.029 0.193649 257.232 0.990479 257.232 1.97342Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.073 1.97342C251.073 2.95636 251.87 3.75319 252.853 3.75319C253.836 3.75319 254.633 2.95636 254.633 1.97342C254.633 0.99048 253.836 0.193649 252.853 0.193649C251.87 0.193649 251.073 0.990479 251.073 1.97342Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.874 1.97342C244.874 2.95636 245.671 3.75319 246.654 3.75319C247.637 3.75319 248.434 2.95636 248.434 1.97342C248.434 0.99048 247.637 0.193649 246.654 0.193649C245.671 0.193649 244.874 0.990479 244.874 1.97342Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.715 1.97342C238.715 2.95636 239.512 3.75319 240.495 3.75319C241.478 3.75319 242.275 2.95636 242.275 1.97342C242.275 0.99048 241.478 0.193649 240.495 0.193649C239.512 0.193649 238.715 0.990479 238.715 1.97342Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.546 1.97859C232.546 2.96153 233.343 3.75836 234.325 3.75836C235.308 3.75836 236.105 2.96153 236.105 1.97859C236.105 0.995652 235.308 0.198822 234.325 0.198822C233.343 0.198822 232.546 0.995652 232.546 1.97859Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.387 1.97859C226.387 2.96153 227.183 3.75836 228.166 3.75836C229.149 3.75836 229.946 2.96153 229.946 1.97859C229.946 0.995652 229.149 0.198822 228.166 0.198822C227.183 0.198822 226.387 0.995652 226.387 1.97859Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.17 1.97859C220.17 2.96153 220.967 3.75836 221.95 3.75836C222.933 3.75836 223.73 2.96153 223.73 1.97859C223.73 0.995652 222.933 0.198822 221.95 0.198822C220.967 0.198822 220.17 0.995652 220.17 1.97859Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.012 1.97859C214.012 2.96153 214.808 3.75836 215.791 3.75836C216.774 3.75836 217.571 2.96153 217.571 1.97859C217.571 0.995652 216.774 0.198822 215.791 0.198822C214.808 0.198822 214.012 0.995652 214.012 1.97859Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.863 1.9695C207.863 2.95244 208.66 3.74927 209.643 3.74927C210.626 3.74927 211.422 2.95244 211.422 1.9695C211.422 0.986558 210.626 0.189728 209.643 0.189728C208.66 0.189728 207.863 0.986558 207.863 1.9695Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.703 1.9695C201.703 2.95244 202.5 3.74927 203.483 3.74927C204.466 3.74927 205.263 2.95244 205.263 1.9695C205.263 0.986558 204.466 0.189728 203.483 0.189728C202.5 0.189728 201.703 0.986558 201.703 1.9695Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.503 1.97859C195.503 2.96153 196.3 3.75836 197.282 3.75836C198.265 3.75836 199.062 2.96153 199.062 1.97859C199.062 0.995652 198.265 0.198822 197.282 0.198822C196.3 0.198822 195.503 0.995652 195.503 1.97859Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.344 1.97859C189.344 2.96153 190.141 3.75836 191.124 3.75836C192.106 3.75836 192.903 2.96153 192.903 1.97859C192.903 0.995652 192.106 0.198822 191.124 0.198822C190.141 0.198822 189.344 0.995652 189.344 1.97859Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.179 1.97859C183.179 2.96153 183.976 3.75836 184.959 3.75836C185.942 3.75836 186.739 2.96153 186.739 1.97859C186.739 0.995652 185.942 0.198822 184.959 0.198822C183.976 0.198822 183.179 0.995652 183.179 1.97859Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.021 1.97859C177.021 2.96153 177.818 3.75836 178.801 3.75836C179.783 3.75836 180.58 2.96153 180.58 1.97859C180.58 0.995652 179.783 0.198822 178.801 0.198822C177.818 0.198822 177.021 0.995652 177.021 1.97859Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.82 1.97859C170.82 2.96153 171.617 3.75836 172.6 3.75836C173.583 3.75836 174.38 2.96153 174.38 1.97859C174.38 0.995652 173.583 0.198822 172.6 0.198822C171.617 0.198822 170.82 0.995652 170.82 1.97859Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.661 1.97859C164.661 2.96153 165.458 3.75836 166.441 3.75836C167.424 3.75836 168.22 2.96153 168.22 1.97859C168.22 0.995652 167.424 0.198822 166.441 0.198822C165.458 0.198822 164.661 0.995652 164.661 1.97859Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.514 7.27507C303.514 8.25801 304.311 9.05484 305.294 9.05484C306.277 9.05484 307.074 8.25801 307.074 7.27507C307.074 6.29213 306.277 5.4953 305.294 5.4953C304.311 5.4953 303.514 6.29213 303.514 7.27507Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.355 7.27507C297.355 8.25801 298.152 9.05484 299.135 9.05484C300.118 9.05484 300.915 8.25801 300.915 7.27507C300.915 6.29213 300.118 5.4953 299.135 5.4953C298.152 5.4953 297.355 6.29213 297.355 7.27507Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.139 7.27507C291.139 8.25801 291.936 9.05484 292.919 9.05484C293.902 9.05484 294.698 8.25801 294.698 7.27507C294.698 6.29213 293.902 5.4953 292.919 5.4953C291.936 5.4953 291.139 6.29213 291.139 7.27507Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.98 7.27507C284.98 8.25801 285.777 9.05484 286.76 9.05484C287.743 9.05484 288.54 8.25801 288.54 7.27507C288.54 6.29213 287.743 5.4953 286.76 5.4953C285.777 5.4953 284.98 6.29213 284.98 7.27507Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.831 7.26596C278.831 8.2489 279.628 9.04573 280.611 9.04573C281.594 9.04573 282.391 8.2489 282.391 7.26596C282.391 6.28302 281.594 5.48619 280.611 5.48619C279.628 5.48619 278.831 6.28302 278.831 7.26596Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.673 7.26596C272.673 8.2489 273.469 9.04573 274.452 9.04573C275.435 9.04573 276.232 8.2489 276.232 7.26596C276.232 6.28302 275.435 5.48619 274.452 5.48619C273.469 5.48619 272.673 6.28302 272.673 7.26596Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.472 7.27507C266.472 8.25801 267.269 9.05484 268.251 9.05484C269.234 9.05484 270.031 8.25801 270.031 7.27507C270.031 6.29213 269.234 5.4953 268.251 5.4953C267.269 5.4953 266.472 6.29213 266.472 7.27507Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.313 7.27507C260.313 8.25801 261.109 9.05484 262.092 9.05484C263.075 9.05484 263.872 8.25801 263.872 7.27507C263.872 6.29213 263.075 5.4953 262.092 5.4953C261.109 5.4953 260.313 6.29213 260.313 7.27507Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.148 7.27507C254.148 8.25801 254.945 9.05484 255.928 9.05484C256.911 9.05484 257.708 8.25801 257.708 7.27507C257.708 6.29213 256.911 5.4953 255.928 5.4953C254.945 5.4953 254.148 6.29213 254.148 7.27507Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.99 7.27507C247.99 8.25801 248.786 9.05484 249.769 9.05484C250.752 9.05484 251.549 8.25801 251.549 7.27507C251.549 6.29213 250.752 5.4953 249.769 5.4953C248.786 5.4953 247.99 6.29213 247.99 7.27507Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.789 7.27507C241.789 8.25801 242.585 9.05484 243.568 9.05484C244.551 9.05484 245.348 8.25801 245.348 7.27507C245.348 6.29213 244.551 5.4953 243.568 5.4953C242.585 5.4953 241.789 6.29213 241.789 7.27507Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.63 7.27507C235.63 8.25801 236.426 9.05484 237.409 9.05484C238.392 9.05484 239.189 8.25801 239.189 7.27507C239.189 6.29213 238.392 5.4953 237.409 5.4953C236.426 5.4953 235.63 6.29213 235.63 7.27507Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.46 7.2802C229.46 8.26314 230.257 9.05997 231.24 9.05997C232.223 9.05997 233.02 8.26314 233.02 7.2802C233.02 6.29726 232.223 5.50043 231.24 5.50043C230.257 5.50043 229.46 6.29726 229.46 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.301 7.2802C223.301 8.26314 224.098 9.05997 225.081 9.05997C226.064 9.05997 226.861 8.26314 226.861 7.2802C226.861 6.29726 226.064 5.50043 225.081 5.50043C224.098 5.50043 223.301 6.29726 223.301 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.085 7.2802C217.085 8.26314 217.882 9.05997 218.865 9.05997C219.848 9.05997 220.645 8.26314 220.645 7.2802C220.645 6.29726 219.848 5.50043 218.865 5.50043C217.882 5.50043 217.085 6.29726 217.085 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.926 7.2802C210.926 8.26314 211.723 9.05997 212.706 9.05997C213.689 9.05997 214.485 8.26314 214.485 7.2802C214.485 6.29726 213.689 5.50043 212.706 5.50043C211.723 5.50043 210.926 6.29726 210.926 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.777 7.27115C204.777 8.25409 205.574 9.05092 206.557 9.05092C207.54 9.05092 208.337 8.25409 208.337 7.27115C208.337 6.28821 207.54 5.49138 206.557 5.49138C205.574 5.49138 204.777 6.28821 204.777 7.27115Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.618 7.27115C198.618 8.25409 199.415 9.05092 200.398 9.05092C201.381 9.05092 202.177 8.25409 202.177 7.27115C202.177 6.28821 201.381 5.49138 200.398 5.49138C199.415 5.49138 198.618 6.28821 198.618 7.27115Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.419 7.2802C192.419 8.26314 193.216 9.05997 194.199 9.05997C195.181 9.05997 195.978 8.26314 195.978 7.2802C195.978 6.29726 195.181 5.50043 194.199 5.50043C193.216 5.50043 192.419 6.29726 192.419 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.26 7.2802C186.26 8.26314 187.057 9.05997 188.04 9.05997C189.023 9.05997 189.819 8.26314 189.819 7.2802C189.819 6.29726 189.023 5.50043 188.04 5.50043C187.057 5.50043 186.26 6.29726 186.26 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.094 7.2802C180.094 8.26314 180.891 9.05997 181.874 9.05997C182.857 9.05997 183.654 8.26314 183.654 7.2802C183.654 6.29726 182.857 5.50043 181.874 5.50043C180.891 5.50043 180.094 6.29726 180.094 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.935 7.2802C173.935 8.26314 174.732 9.05997 175.715 9.05997C176.698 9.05997 177.495 8.26314 177.495 7.2802C177.495 6.29726 176.698 5.50043 175.715 5.50043C174.732 5.50043 173.935 6.29726 173.935 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.736 7.2802C167.736 8.26314 168.533 9.05997 169.516 9.05997C170.499 9.05997 171.296 8.26314 171.296 7.2802C171.296 6.29726 170.499 5.50043 169.516 5.50043C168.533 5.50043 167.736 6.29726 167.736 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.577 7.2802C161.577 8.26314 162.374 9.05997 163.356 9.05997C164.339 9.05997 165.136 8.26314 165.136 7.2802C165.136 6.29726 164.339 5.50043 163.356 5.50043C162.374 5.50043 161.577 6.29726 161.577 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.598 12.5195C306.598 13.5025 307.395 14.2993 308.378 14.2993C309.361 14.2993 310.158 13.5025 310.158 12.5195C310.158 11.5366 309.361 10.7398 308.378 10.7398C307.395 10.7398 306.598 11.5366 306.598 12.5195Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.439 12.5195C300.439 13.5025 301.236 14.2993 302.219 14.2993C303.202 14.2993 303.999 13.5025 303.999 12.5195C303.999 11.5366 303.202 10.7398 302.219 10.7398C301.236 10.7398 300.439 11.5366 300.439 12.5195Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.223 12.5195C294.223 13.5025 295.02 14.2993 296.003 14.2993C296.986 14.2993 297.782 13.5025 297.782 12.5195C297.782 11.5366 296.986 10.7398 296.003 10.7398C295.02 10.7398 294.223 11.5366 294.223 12.5195Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.064 12.5195C288.064 13.5025 288.861 14.2993 289.844 14.2993C290.827 14.2993 291.624 13.5025 291.624 12.5195C291.624 11.5366 290.827 10.7398 289.844 10.7398C288.861 10.7398 288.064 11.5366 288.064 12.5195Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.915 12.5104C281.915 13.4933 282.712 14.2902 283.695 14.2902C284.678 14.2902 285.475 13.4933 285.475 12.5104C285.475 11.5275 284.678 10.7306 283.695 10.7306C282.712 10.7306 281.915 11.5275 281.915 12.5104Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.756 12.5104C275.756 13.4933 276.553 14.2902 277.536 14.2902C278.519 14.2902 279.316 13.4933 279.316 12.5104C279.316 11.5275 278.519 10.7306 277.536 10.7306C276.553 10.7306 275.756 11.5275 275.756 12.5104Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.557 12.5195C269.557 13.5025 270.354 14.2993 271.337 14.2993C272.32 14.2993 273.117 13.5025 273.117 12.5195C273.117 11.5366 272.32 10.7398 271.337 10.7398C270.354 10.7398 269.557 11.5366 269.557 12.5195Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.398 12.5195C263.398 13.5025 264.195 14.2993 265.178 14.2993C266.161 14.2993 266.958 13.5025 266.958 12.5195C266.958 11.5366 266.161 10.7398 265.178 10.7398C264.195 10.7398 263.398 11.5366 263.398 12.5195Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.232 12.5195C257.232 13.5025 258.029 14.2993 259.012 14.2993C259.995 14.2993 260.792 13.5025 260.792 12.5195C260.792 11.5366 259.995 10.7397 259.012 10.7397C258.029 10.7397 257.232 11.5366 257.232 12.5195Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.073 12.5195C251.073 13.5025 251.87 14.2993 252.853 14.2993C253.836 14.2993 254.633 13.5025 254.633 12.5195C254.633 11.5366 253.836 10.7397 252.853 10.7397C251.87 10.7397 251.073 11.5366 251.073 12.5195Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.874 12.5195C244.874 13.5025 245.671 14.2993 246.654 14.2993C247.637 14.2993 248.434 13.5025 248.434 12.5195C248.434 11.5366 247.637 10.7397 246.654 10.7397C245.671 10.7397 244.874 11.5366 244.874 12.5195Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.715 12.5195C238.715 13.5025 239.512 14.2993 240.495 14.2993C241.478 14.2993 242.275 13.5025 242.275 12.5195C242.275 11.5366 241.478 10.7397 240.495 10.7397C239.512 10.7397 238.715 11.5366 238.715 12.5195Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.546 12.5248C232.546 13.5077 233.343 14.3045 234.325 14.3045C235.308 14.3045 236.105 13.5077 236.105 12.5248C236.105 11.5418 235.308 10.745 234.325 10.745C233.343 10.745 232.546 11.5418 232.546 12.5248Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.387 12.5247C226.387 13.5076 227.183 14.3045 228.166 14.3045C229.149 14.3045 229.946 13.5076 229.946 12.5247C229.946 11.5418 229.149 10.7449 228.166 10.7449C227.183 10.7449 226.387 11.5418 226.387 12.5247Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.17 12.5247C220.17 13.5076 220.967 14.3045 221.95 14.3045C222.933 14.3045 223.73 13.5076 223.73 12.5247C223.73 11.5418 222.933 10.7449 221.95 10.7449C220.967 10.7449 220.17 11.5418 220.17 12.5247Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.012 12.5248C214.012 13.5077 214.808 14.3045 215.791 14.3045C216.774 14.3045 217.571 13.5077 217.571 12.5248C217.571 11.5418 216.774 10.745 215.791 10.745C214.808 10.745 214.012 11.5418 214.012 12.5248Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.863 12.5156C207.863 13.4986 208.66 14.2954 209.643 14.2954C210.626 14.2954 211.422 13.4986 211.422 12.5156C211.422 11.5327 210.626 10.7359 209.643 10.7359C208.66 10.7359 207.863 11.5327 207.863 12.5156Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.703 12.5156C201.703 13.4986 202.5 14.2954 203.483 14.2954C204.466 14.2954 205.263 13.4986 205.263 12.5156C205.263 11.5327 204.466 10.7359 203.483 10.7359C202.5 10.7359 201.703 11.5327 201.703 12.5156Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.503 12.5247C195.503 13.5076 196.3 14.3045 197.282 14.3045C198.265 14.3045 199.062 13.5076 199.062 12.5247C199.062 11.5418 198.265 10.7449 197.282 10.7449C196.3 10.7449 195.503 11.5418 195.503 12.5247Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.344 12.5248C189.344 13.5077 190.141 14.3045 191.124 14.3045C192.106 14.3045 192.903 13.5077 192.903 12.5248C192.903 11.5418 192.106 10.745 191.124 10.745C190.141 10.745 189.344 11.5418 189.344 12.5248Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.179 12.5248C183.179 13.5077 183.976 14.3045 184.959 14.3045C185.942 14.3045 186.739 13.5077 186.739 12.5248C186.739 11.5418 185.942 10.745 184.959 10.745C183.976 10.745 183.179 11.5418 183.179 12.5248Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.021 12.5247C177.021 13.5076 177.818 14.3045 178.801 14.3045C179.783 14.3045 180.58 13.5076 180.58 12.5247C180.58 11.5418 179.783 10.7449 178.801 10.7449C177.818 10.7449 177.021 11.5418 177.021 12.5247Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.82 12.5247C170.82 13.5076 171.617 14.3045 172.6 14.3045C173.583 14.3045 174.38 13.5076 174.38 12.5247C174.38 11.5418 173.583 10.7449 172.6 10.7449C171.617 10.7449 170.82 11.5418 170.82 12.5247Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.661 12.5248C164.661 13.5077 165.458 14.3045 166.441 14.3045C167.424 14.3045 168.22 13.5077 168.22 12.5248C168.22 11.5418 167.424 10.745 166.441 10.745C165.458 10.745 164.661 11.5418 164.661 12.5248Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.525 17.8108C303.525 18.7937 304.322 19.5905 305.304 19.5905C306.287 19.5905 307.084 18.7937 307.084 17.8108C307.084 16.8278 306.287 16.031 305.304 16.031C304.322 16.031 303.525 16.8278 303.525 17.8108Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.366 17.8108C297.366 18.7937 298.163 19.5905 299.146 19.5905C300.128 19.5905 300.925 18.7937 300.925 17.8108C300.925 16.8278 300.128 16.031 299.146 16.031C298.163 16.031 297.366 16.8278 297.366 17.8108Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.149 17.8108C291.149 18.7937 291.946 19.5905 292.929 19.5905C293.912 19.5905 294.709 18.7937 294.709 17.8108C294.709 16.8278 293.912 16.031 292.929 16.031C291.946 16.031 291.149 16.8278 291.149 17.8108Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.99 17.8108C284.99 18.7937 285.787 19.5905 286.77 19.5905C287.753 19.5905 288.55 18.7937 288.55 17.8108C288.55 16.8278 287.753 16.031 286.77 16.031C285.787 16.031 284.99 16.8278 284.99 17.8108Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.842 17.8004C278.842 18.7833 279.639 19.5802 280.622 19.5802C281.605 19.5802 282.401 18.7833 282.401 17.8004C282.401 16.8174 281.605 16.0206 280.622 16.0206C279.639 16.0206 278.842 16.8174 278.842 17.8004Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.682 17.8004C272.682 18.7833 273.479 19.5802 274.462 19.5802C275.445 19.5802 276.242 18.7833 276.242 17.8004C276.242 16.8174 275.445 16.0206 274.462 16.0206C273.479 16.0206 272.682 16.8174 272.682 17.8004Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.483 17.8108C266.483 18.7937 267.28 19.5905 268.263 19.5905C269.246 19.5905 270.043 18.7937 270.043 17.8108C270.043 16.8278 269.246 16.031 268.263 16.031C267.28 16.031 266.483 16.8278 266.483 17.8108Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.324 17.8108C260.324 18.7937 261.121 19.5905 262.104 19.5905C263.087 19.5905 263.884 18.7937 263.884 17.8108C263.884 16.8278 263.087 16.031 262.104 16.031C261.121 16.031 260.324 16.8278 260.324 17.8108Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.159 17.8108C254.159 18.7937 254.956 19.5905 255.938 19.5905C256.921 19.5905 257.718 18.7937 257.718 17.8108C257.718 16.8278 256.921 16.031 255.938 16.031C254.956 16.031 254.159 16.8278 254.159 17.8108Z"
            fill="#B8B7B7"
          />
          <path
            d="M248 17.8108C248 18.7937 248.797 19.5905 249.78 19.5905C250.763 19.5905 251.56 18.7937 251.56 17.8108C251.56 16.8278 250.763 16.031 249.78 16.031C248.797 16.031 248 16.8278 248 17.8108Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.8 17.8108C241.8 18.7937 242.597 19.5905 243.58 19.5905C244.563 19.5905 245.36 18.7937 245.36 17.8108C245.36 16.8278 244.563 16.031 243.58 16.031C242.597 16.031 241.8 16.8278 241.8 17.8108Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.641 17.8108C235.641 18.7937 236.438 19.5905 237.421 19.5905C238.404 19.5905 239.201 18.7937 239.201 17.8108C239.201 16.8278 238.404 16.031 237.421 16.031C236.438 16.031 235.641 16.8278 235.641 17.8108Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.47 17.8147C229.47 18.7976 230.267 19.5944 231.25 19.5944C232.233 19.5944 233.03 18.7976 233.03 17.8147C233.03 16.8317 232.233 16.0349 231.25 16.0349C230.267 16.0349 229.47 16.8317 229.47 17.8147Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.312 17.8147C223.312 18.7976 224.108 19.5944 225.091 19.5944C226.074 19.5944 226.871 18.7976 226.871 17.8147C226.871 16.8317 226.074 16.0349 225.091 16.0349C224.108 16.0349 223.312 16.8317 223.312 17.8147Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.095 17.8147C217.095 18.7976 217.892 19.5944 218.875 19.5944C219.858 19.5944 220.655 18.7976 220.655 17.8147C220.655 16.8317 219.858 16.0349 218.875 16.0349C217.892 16.0349 217.095 16.8317 217.095 17.8147Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.938 17.8147C210.938 18.7976 211.735 19.5944 212.718 19.5944C213.7 19.5944 214.497 18.7976 214.497 17.8147C214.497 16.8317 213.7 16.0349 212.718 16.0349C211.735 16.0349 210.938 16.8317 210.938 17.8147Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.788 17.8056C204.788 18.7885 205.584 19.5853 206.567 19.5853C207.55 19.5853 208.347 18.7885 208.347 17.8056C208.347 16.8226 207.55 16.0258 206.567 16.0258C205.584 16.0258 204.788 16.8226 204.788 17.8056Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.629 17.8056C198.629 18.7885 199.426 19.5854 200.408 19.5854C201.391 19.5854 202.188 18.7885 202.188 17.8056C202.188 16.8226 201.391 16.0258 200.408 16.0258C199.426 16.0258 198.629 16.8226 198.629 17.8056Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.429 17.8147C192.429 18.7976 193.226 19.5944 194.209 19.5944C195.192 19.5944 195.989 18.7976 195.989 17.8147C195.989 16.8317 195.192 16.0349 194.209 16.0349C193.226 16.0349 192.429 16.8317 192.429 17.8147Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.27 17.8147C186.27 18.7976 187.067 19.5944 188.05 19.5944C189.033 19.5944 189.83 18.7976 189.83 17.8147C189.83 16.8317 189.033 16.0349 188.05 16.0349C187.067 16.0349 186.27 16.8317 186.27 17.8147Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.105 17.8147C180.105 18.7976 180.902 19.5944 181.885 19.5944C182.868 19.5944 183.665 18.7976 183.665 17.8147C183.665 16.8317 182.868 16.0349 181.885 16.0349C180.902 16.0349 180.105 16.8317 180.105 17.8147Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.946 17.8147C173.946 18.7976 174.742 19.5944 175.725 19.5944C176.708 19.5944 177.505 18.7976 177.505 17.8147C177.505 16.8317 176.708 16.0349 175.725 16.0349C174.742 16.0349 173.946 16.8317 173.946 17.8147Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.747 17.8147C167.747 18.7976 168.543 19.5944 169.526 19.5944C170.509 19.5944 171.306 18.7976 171.306 17.8147C171.306 16.8317 170.509 16.0349 169.526 16.0349C168.543 16.0349 167.747 16.8317 167.747 17.8147Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.587 17.8147C161.587 18.7976 162.384 19.5944 163.367 19.5944C164.35 19.5944 165.147 18.7976 165.147 17.8147C165.147 16.8317 164.35 16.0349 163.367 16.0349C162.384 16.0349 161.587 16.8317 161.587 17.8147Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.439 23.1111C300.439 24.0941 301.236 24.8909 302.219 24.8909C303.202 24.8909 303.999 24.0941 303.999 23.1111C303.999 22.1282 303.202 21.3313 302.219 21.3313C301.236 21.3313 300.439 22.1282 300.439 23.1111Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.282 23.1111C294.282 24.0941 295.079 24.8909 296.062 24.8909C297.044 24.8909 297.841 24.0941 297.841 23.1111C297.841 22.1282 297.044 21.3313 296.062 21.3313C295.079 21.3313 294.282 22.1282 294.282 23.1111Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.064 23.1111C288.064 24.0941 288.861 24.8909 289.844 24.8909C290.827 24.8909 291.624 24.0941 291.624 23.1111C291.624 22.1282 290.827 21.3313 289.844 21.3313C288.861 21.3313 288.064 22.1282 288.064 23.1111Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.906 23.1111C281.906 24.0941 282.703 24.8909 283.686 24.8909C284.669 24.8909 285.466 24.0941 285.466 23.1111C285.466 22.1282 284.669 21.3313 283.686 21.3313C282.703 21.3313 281.906 22.1282 281.906 23.1111Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.756 23.102C275.756 24.085 276.553 24.8818 277.536 24.8818C278.519 24.8818 279.316 24.085 279.316 23.102C279.316 22.1191 278.519 21.3223 277.536 21.3223C276.553 21.3223 275.756 22.1191 275.756 23.102Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.598 23.102C269.598 24.085 270.395 24.8818 271.378 24.8818C272.361 24.8818 273.158 24.085 273.158 23.102C273.158 22.1191 272.361 21.3223 271.378 21.3223C270.395 21.3223 269.598 22.1191 269.598 23.102Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.398 23.1111C263.398 24.0941 264.195 24.8909 265.178 24.8909C266.161 24.8909 266.958 24.0941 266.958 23.1111C266.958 22.1282 266.161 21.3314 265.178 21.3314C264.195 21.3314 263.398 22.1282 263.398 23.1111Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.239 23.1111C257.239 24.0941 258.036 24.8909 259.019 24.8909C260.002 24.8909 260.799 24.0941 260.799 23.1111C260.799 22.1282 260.002 21.3313 259.019 21.3313C258.036 21.3313 257.239 22.1282 257.239 23.1111Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.073 23.1111C251.073 24.0941 251.87 24.8909 252.853 24.8909C253.836 24.8909 254.633 24.0941 254.633 23.1111C254.633 22.1282 253.836 21.3313 252.853 21.3313C251.87 21.3313 251.073 22.1282 251.073 23.1111Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.916 23.1111C244.916 24.0941 245.713 24.8909 246.696 24.8909C247.679 24.8909 248.475 24.0941 248.475 23.1111C248.475 22.1282 247.679 21.3313 246.696 21.3313C245.713 21.3313 244.916 22.1282 244.916 23.1111Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.715 23.1111C238.715 24.0941 239.512 24.8909 240.495 24.8909C241.478 24.8909 242.275 24.0941 242.275 23.1111C242.275 22.1282 241.478 21.3313 240.495 21.3313C239.512 21.3313 238.715 22.1282 238.715 23.1111Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.556 23.1111C232.556 24.0941 233.353 24.8909 234.336 24.8909C235.319 24.8909 236.115 24.0941 236.115 23.1111C236.115 22.1282 235.319 21.3313 234.336 21.3313C233.353 21.3313 232.556 22.1282 232.556 23.1111Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.387 23.1163C226.387 24.0993 227.183 24.8961 228.166 24.8961C229.149 24.8961 229.946 24.0993 229.946 23.1163C229.946 22.1334 229.149 21.3365 228.166 21.3365C227.183 21.3365 226.387 22.1334 226.387 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.227 23.1163C220.227 24.0993 221.024 24.8961 222.007 24.8961C222.99 24.8961 223.787 24.0993 223.787 23.1163C223.787 22.1334 222.99 21.3365 222.007 21.3365C221.024 21.3365 220.227 22.1334 220.227 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.012 23.1163C214.012 24.0993 214.808 24.8961 215.791 24.8961C216.774 24.8961 217.571 24.0993 217.571 23.1163C217.571 22.1334 216.774 21.3365 215.791 21.3365C214.808 21.3365 214.012 22.1334 214.012 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.852 23.1163C207.852 24.0993 208.649 24.8961 209.632 24.8961C210.615 24.8961 211.412 24.0993 211.412 23.1163C211.412 22.1334 210.615 21.3365 209.632 21.3365C208.649 21.3365 207.852 22.1334 207.852 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.703 23.1072C201.703 24.0901 202.5 24.8869 203.483 24.8869C204.466 24.8869 205.263 24.0901 205.263 23.1072C205.263 22.1242 204.466 21.3274 203.483 21.3274C202.5 21.3274 201.703 22.1242 201.703 23.1072Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.544 23.1072C195.544 24.0901 196.341 24.8869 197.324 24.8869C198.307 24.8869 199.104 24.0901 199.104 23.1072C199.104 22.1242 198.307 21.3274 197.324 21.3274C196.341 21.3274 195.544 22.1242 195.544 23.1072Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.344 23.1163C189.344 24.0993 190.141 24.8961 191.124 24.8961C192.106 24.8961 192.903 24.0993 192.903 23.1163C192.903 22.1334 192.106 21.3365 191.124 21.3365C190.141 21.3365 189.344 22.1334 189.344 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.185 23.1163C183.185 24.0993 183.982 24.8961 184.965 24.8961C185.948 24.8961 186.745 24.0993 186.745 23.1163C186.745 22.1334 185.948 21.3365 184.965 21.3365C183.982 21.3365 183.185 22.1334 183.185 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.021 23.1163C177.021 24.0993 177.818 24.8961 178.801 24.8961C179.783 24.8961 180.58 24.0993 180.58 23.1163C180.58 22.1334 179.783 21.3365 178.801 21.3365C177.818 21.3365 177.021 22.1334 177.021 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.861 23.1163C170.861 24.0993 171.658 24.8961 172.641 24.8961C173.624 24.8961 174.421 24.0993 174.421 23.1163C174.421 22.1334 173.624 21.3365 172.641 21.3365C171.658 21.3365 170.861 22.1334 170.861 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.661 23.1163C164.661 24.0993 165.458 24.8961 166.441 24.8961C167.424 24.8961 168.22 24.0993 168.22 23.1163C168.22 22.1334 167.424 21.3365 166.441 21.3365C165.458 21.3365 164.661 22.1334 164.661 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.502 23.1163C158.502 24.0993 159.299 24.8961 160.282 24.8961C161.265 24.8961 162.062 24.0993 162.062 23.1163C162.062 22.1334 161.265 21.3365 160.282 21.3365C159.299 21.3365 158.502 22.1334 158.502 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.525 28.3569C303.525 29.3398 304.322 30.1367 305.304 30.1367C306.287 30.1367 307.084 29.3398 307.084 28.3569C307.084 27.3739 306.287 26.5771 305.304 26.5771C304.322 26.5771 303.525 27.3739 303.525 28.3569Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.366 28.3569C297.366 29.3398 298.163 30.1367 299.146 30.1367C300.128 30.1367 300.925 29.3398 300.925 28.3569C300.925 27.3739 300.128 26.5771 299.146 26.5771C298.163 26.5771 297.366 27.3739 297.366 28.3569Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.149 28.3569C291.149 29.3398 291.946 30.1367 292.929 30.1367C293.912 30.1367 294.709 29.3398 294.709 28.3569C294.709 27.3739 293.912 26.5771 292.929 26.5771C291.946 26.5771 291.149 27.3739 291.149 28.3569Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.99 28.3569C284.99 29.3398 285.787 30.1367 286.77 30.1367C287.753 30.1367 288.55 29.3398 288.55 28.3569C288.55 27.3739 287.753 26.5771 286.77 26.5771C285.787 26.5771 284.99 27.3739 284.99 28.3569Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.842 28.3465C278.842 29.3294 279.639 30.1262 280.622 30.1262C281.605 30.1262 282.401 29.3294 282.401 28.3465C282.401 27.3635 281.605 26.5667 280.622 26.5667C279.639 26.5667 278.842 27.3635 278.842 28.3465Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.682 28.3465C272.682 29.3294 273.479 30.1263 274.462 30.1263C275.445 30.1263 276.242 29.3294 276.242 28.3465C276.242 27.3636 275.445 26.5667 274.462 26.5667C273.479 26.5667 272.682 27.3636 272.682 28.3465Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.483 28.3569C266.483 29.3398 267.28 30.1367 268.263 30.1367C269.246 30.1367 270.043 29.3398 270.043 28.3569C270.043 27.3739 269.246 26.5771 268.263 26.5771C267.28 26.5771 266.483 27.3739 266.483 28.3569Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.324 28.3569C260.324 29.3398 261.121 30.1367 262.104 30.1367C263.087 30.1367 263.884 29.3398 263.884 28.3569C263.884 27.3739 263.087 26.5771 262.104 26.5771C261.121 26.5771 260.324 27.3739 260.324 28.3569Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.159 28.3569C254.159 29.3398 254.956 30.1367 255.938 30.1367C256.921 30.1367 257.718 29.3398 257.718 28.3569C257.718 27.3739 256.921 26.5771 255.938 26.5771C254.956 26.5771 254.159 27.3739 254.159 28.3569Z"
            fill="#B8B7B7"
          />
          <path
            d="M248 28.3569C248 29.3398 248.797 30.1367 249.78 30.1367C250.763 30.1367 251.56 29.3398 251.56 28.3569C251.56 27.3739 250.763 26.5771 249.78 26.5771C248.797 26.5771 248 27.3739 248 28.3569Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.8 28.3569C241.8 29.3398 242.597 30.1367 243.58 30.1367C244.563 30.1367 245.36 29.3398 245.36 28.3569C245.36 27.3739 244.563 26.5771 243.58 26.5771C242.597 26.5771 241.8 27.3739 241.8 28.3569Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.641 28.3569C235.641 29.3398 236.438 30.1367 237.421 30.1367C238.404 30.1367 239.201 29.3398 239.201 28.3569C239.201 27.3739 238.404 26.5771 237.421 26.5771C236.438 26.5771 235.641 27.3739 235.641 28.3569Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.47 28.3608C229.47 29.3437 230.267 30.1405 231.25 30.1405C232.233 30.1405 233.03 29.3437 233.03 28.3608C233.03 27.3778 232.233 26.581 231.25 26.581C230.267 26.581 229.47 27.3778 229.47 28.3608Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.312 28.3608C223.312 29.3437 224.108 30.1405 225.091 30.1405C226.074 30.1405 226.871 29.3437 226.871 28.3608C226.871 27.3778 226.074 26.581 225.091 26.581C224.108 26.581 223.312 27.3778 223.312 28.3608Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.095 28.3608C217.095 29.3437 217.892 30.1405 218.875 30.1405C219.858 30.1405 220.655 29.3437 220.655 28.3608C220.655 27.3778 219.858 26.581 218.875 26.581C217.892 26.581 217.095 27.3778 217.095 28.3608Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.938 28.3608C210.938 29.3437 211.735 30.1405 212.718 30.1405C213.7 30.1405 214.497 29.3437 214.497 28.3608C214.497 27.3778 213.7 26.581 212.718 26.581C211.735 26.581 210.938 27.3778 210.938 28.3608Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.788 28.3517C204.788 29.3347 205.584 30.1315 206.567 30.1315C207.55 30.1315 208.347 29.3347 208.347 28.3517C208.347 27.3688 207.55 26.572 206.567 26.572C205.584 26.572 204.788 27.3688 204.788 28.3517Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.629 28.3517C198.629 29.3347 199.426 30.1315 200.408 30.1315C201.391 30.1315 202.188 29.3347 202.188 28.3517C202.188 27.3688 201.391 26.572 200.408 26.572C199.426 26.572 198.629 27.3688 198.629 28.3517Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.429 28.3608C192.429 29.3437 193.226 30.1405 194.209 30.1405C195.192 30.1405 195.989 29.3437 195.989 28.3608C195.989 27.3778 195.192 26.581 194.209 26.581C193.226 26.581 192.429 27.3778 192.429 28.3608Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.27 28.3608C186.27 29.3437 187.067 30.1405 188.05 30.1405C189.033 30.1405 189.83 29.3437 189.83 28.3608C189.83 27.3778 189.033 26.581 188.05 26.581C187.067 26.581 186.27 27.3778 186.27 28.3608Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.105 28.3608C180.105 29.3437 180.902 30.1405 181.885 30.1405C182.868 30.1405 183.665 29.3437 183.665 28.3608C183.665 27.3778 182.868 26.581 181.885 26.581C180.902 26.581 180.105 27.3778 180.105 28.3608Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.946 28.3608C173.946 29.3437 174.742 30.1405 175.725 30.1405C176.708 30.1405 177.505 29.3437 177.505 28.3608C177.505 27.3778 176.708 26.581 175.725 26.581C174.742 26.581 173.946 27.3778 173.946 28.3608Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.747 28.3608C167.747 29.3437 168.543 30.1405 169.526 30.1405C170.509 30.1405 171.306 29.3437 171.306 28.3608C171.306 27.3778 170.509 26.581 169.526 26.581C168.543 26.581 167.747 27.3778 167.747 28.3608Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.587 28.3608C161.587 29.3437 162.384 30.1405 163.367 30.1405C164.35 30.1405 165.147 29.3437 165.147 28.3608C165.147 27.3778 164.35 26.581 163.367 26.581C162.384 26.581 161.587 27.3778 161.587 28.3608Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.598 23.0838C306.598 24.0667 307.395 24.8636 308.378 24.8636C309.361 24.8636 310.158 24.0667 310.158 23.0838C310.158 22.1009 309.361 21.304 308.378 21.304C307.395 21.304 306.598 22.1009 306.598 23.0838Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 33.7196C306.603 34.7025 307.4 35.4994 308.383 35.4994C309.366 35.4994 310.163 34.7025 310.163 33.7196C310.163 32.7367 309.366 31.9398 308.383 31.9398C307.4 31.9398 306.603 32.7367 306.603 33.7196Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 33.7196C300.446 34.7025 301.243 35.4994 302.226 35.4994C303.209 35.4994 304.005 34.7025 304.005 33.7196C304.005 32.7367 303.209 31.9398 302.226 31.9398C301.243 31.9398 300.446 32.7367 300.446 33.7196Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.23 33.7196C294.23 34.7025 295.026 35.4994 296.009 35.4994C296.992 35.4994 297.789 34.7025 297.789 33.7196C297.789 32.7367 296.992 31.9398 296.009 31.9398C295.026 31.9398 294.23 32.7367 294.23 33.7196Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 33.7196C288.07 34.7025 288.867 35.4994 289.85 35.4994C290.833 35.4994 291.63 34.7025 291.63 33.7196C291.63 32.7367 290.833 31.9398 289.85 31.9398C288.867 31.9398 288.07 32.7367 288.07 33.7196Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.92 33.7106C281.92 34.6935 282.717 35.4903 283.7 35.4903C284.683 35.4903 285.48 34.6935 285.48 33.7106C285.48 32.7276 284.683 31.9308 283.7 31.9308C282.717 31.9308 281.92 32.7276 281.92 33.7106Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 33.7106C275.763 34.6935 276.56 35.4903 277.542 35.4903C278.525 35.4903 279.322 34.6935 279.322 33.7106C279.322 32.7276 278.525 31.9308 277.542 31.9308C276.56 31.9308 275.763 32.7276 275.763 33.7106Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.562 33.7196C269.562 34.7026 270.359 35.4994 271.342 35.4994C272.325 35.4994 273.122 34.7026 273.122 33.7196C273.122 32.7367 272.325 31.9398 271.342 31.9398C270.359 31.9398 269.562 32.7367 269.562 33.7196Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 33.7196C263.403 34.7026 264.2 35.4994 265.183 35.4994C266.166 35.4994 266.963 34.7026 266.963 33.7196C266.963 32.7367 266.166 31.9398 265.183 31.9398C264.2 31.9398 263.403 32.7367 263.403 33.7196Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.238 33.7196C257.238 34.7026 258.034 35.4994 259.017 35.4994C260 35.4994 260.797 34.7026 260.797 33.7196C260.797 32.7367 260 31.9398 259.017 31.9398C258.034 31.9398 257.238 32.7367 257.238 33.7196Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 33.7196C251.08 34.7026 251.876 35.4994 252.859 35.4994C253.842 35.4994 254.639 34.7026 254.639 33.7196C254.639 32.7367 253.842 31.9398 252.859 31.9398C251.876 31.9398 251.08 32.7367 251.08 33.7196Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.879 33.7196C244.879 34.7026 245.676 35.4994 246.659 35.4994C247.642 35.4994 248.439 34.7026 248.439 33.7196C248.439 32.7367 247.642 31.9398 246.659 31.9398C245.676 31.9398 244.879 32.7367 244.879 33.7196Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 33.7196C238.72 34.7026 239.517 35.4994 240.5 35.4994C241.483 35.4994 242.28 34.7026 242.28 33.7196C242.28 32.7367 241.483 31.9398 240.5 31.9398C239.517 31.9398 238.72 32.7367 238.72 33.7196Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.551 33.7248C232.551 34.7077 233.348 35.5046 234.331 35.5046C235.314 35.5046 236.111 34.7077 236.111 33.7248C236.111 32.7419 235.314 31.945 234.331 31.945C233.348 31.945 232.551 32.7419 232.551 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 33.7248C226.392 34.7077 227.189 35.5046 228.172 35.5046C229.155 35.5046 229.951 34.7077 229.951 33.7248C229.951 32.7419 229.155 31.945 228.172 31.945C227.189 31.945 226.392 32.7419 226.392 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.175 33.7248C220.175 34.7077 220.972 35.5046 221.955 35.5046C222.938 35.5046 223.735 34.7077 223.735 33.7248C223.735 32.7419 222.938 31.945 221.955 31.945C220.972 31.945 220.175 32.7419 220.175 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 33.7248C214.017 34.7077 214.813 35.5046 215.796 35.5046C216.779 35.5046 217.576 34.7077 217.576 33.7248C217.576 32.7419 216.779 31.945 215.796 31.945C214.813 31.945 214.017 32.7419 214.017 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.868 33.7144C207.868 34.6973 208.665 35.4941 209.648 35.4941C210.631 35.4941 211.427 34.6973 211.427 33.7144C211.427 32.7314 210.631 31.9346 209.648 31.9346C208.665 31.9346 207.868 32.7314 207.868 33.7144Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 33.7144C201.709 34.6973 202.506 35.4941 203.489 35.4941C204.471 35.4941 205.268 34.6973 205.268 33.7144C205.268 32.7314 204.471 31.9346 203.489 31.9346C202.506 31.9346 201.709 32.7314 201.709 33.7144Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.508 33.7248C195.508 34.7077 196.305 35.5046 197.288 35.5046C198.271 35.5046 199.068 34.7077 199.068 33.7248C199.068 32.7419 198.271 31.945 197.288 31.945C196.305 31.945 195.508 32.7419 195.508 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 33.7248C189.349 34.7077 190.146 35.5046 191.129 35.5046C192.112 35.5046 192.908 34.7077 192.908 33.7248C192.908 32.7419 192.112 31.945 191.129 31.945C190.146 31.945 189.349 32.7419 189.349 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.185 33.7248C183.185 34.7077 183.982 35.5046 184.965 35.5046C185.948 35.5046 186.745 34.7077 186.745 33.7248C186.745 32.7419 185.948 31.945 184.965 31.945C183.982 31.945 183.185 32.7419 183.185 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 33.7248C177.026 34.7077 177.823 35.5046 178.806 35.5046C179.789 35.5046 180.585 34.7077 180.585 33.7248C180.585 32.7419 179.789 31.945 178.806 31.945C177.823 31.945 177.026 32.7419 177.026 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.825 33.7248C170.825 34.7077 171.622 35.5046 172.605 35.5046C173.588 35.5046 174.385 34.7077 174.385 33.7248C174.385 32.7419 173.588 31.945 172.605 31.945C171.622 31.945 170.825 32.7419 170.825 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 33.7248C164.666 34.7077 165.463 35.5046 166.446 35.5046C167.429 35.5046 168.225 34.7077 168.225 33.7248C168.225 32.7419 167.429 31.945 166.446 31.945C165.463 31.945 164.666 32.7419 164.666 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.519 39.0212C303.519 40.0042 304.316 40.801 305.299 40.801C306.282 40.801 307.079 40.0042 307.079 39.0212C307.079 38.0383 306.282 37.2415 305.299 37.2415C304.316 37.2415 303.519 38.0383 303.519 39.0212Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.36 39.0212C297.36 40.0042 298.157 40.801 299.14 40.801C300.123 40.801 300.92 40.0042 300.92 39.0212C300.92 38.0383 300.123 37.2415 299.14 37.2415C298.157 37.2415 297.36 38.0383 297.36 39.0212Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.144 39.0212C291.144 40.0042 291.941 40.801 292.924 40.801C293.907 40.801 294.704 40.0042 294.704 39.0212C294.704 38.0383 293.907 37.2415 292.924 37.2415C291.941 37.2415 291.144 38.0383 291.144 39.0212Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.985 39.0212C284.985 40.0042 285.782 40.801 286.765 40.801C287.748 40.801 288.545 40.0042 288.545 39.0212C288.545 38.0383 287.748 37.2415 286.765 37.2415C285.782 37.2415 284.985 38.0383 284.985 39.0212Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.836 39.0108C278.836 39.9937 279.633 40.7906 280.616 40.7906C281.599 40.7906 282.396 39.9937 282.396 39.0108C282.396 38.0279 281.599 37.231 280.616 37.231C279.633 37.231 278.836 38.0279 278.836 39.0108Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.678 39.0108C272.678 39.9937 273.474 40.7906 274.457 40.7906C275.44 40.7906 276.237 39.9937 276.237 39.0108C276.237 38.0279 275.44 37.231 274.457 37.231C273.474 37.231 272.678 38.0279 272.678 39.0108Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.477 39.0213C266.477 40.0042 267.274 40.801 268.257 40.801C269.24 40.801 270.036 40.0042 270.036 39.0213C270.036 38.0383 269.24 37.2415 268.257 37.2415C267.274 37.2415 266.477 38.0383 266.477 39.0213Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.318 39.0213C260.318 40.0042 261.115 40.801 262.098 40.801C263.081 40.801 263.878 40.0042 263.878 39.0213C263.878 38.0383 263.081 37.2415 262.098 37.2415C261.115 37.2415 260.318 38.0383 260.318 39.0213Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.153 39.0213C254.153 40.0042 254.95 40.801 255.933 40.801C256.916 40.801 257.713 40.0042 257.713 39.0213C257.713 38.0383 256.916 37.2415 255.933 37.2415C254.95 37.2415 254.153 38.0383 254.153 39.0213Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.995 39.0213C247.995 40.0042 248.791 40.801 249.774 40.801C250.757 40.801 251.554 40.0042 251.554 39.0213C251.554 38.0383 250.757 37.2415 249.774 37.2415C248.791 37.2415 247.995 38.0383 247.995 39.0213Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.794 39.0212C241.794 40.0041 242.591 40.801 243.574 40.801C244.557 40.801 245.354 40.0041 245.354 39.0212C245.354 38.0383 244.557 37.2414 243.574 37.2414C242.591 37.2414 241.794 38.0383 241.794 39.0212Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.635 39.0212C235.635 40.0041 236.432 40.801 237.415 40.801C238.398 40.801 239.195 40.0041 239.195 39.0212C239.195 38.0383 238.398 37.2414 237.415 37.2414C236.432 37.2414 235.635 38.0383 235.635 39.0212Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.466 39.0251C229.466 40.008 230.262 40.8049 231.245 40.8049C232.228 40.8049 233.025 40.008 233.025 39.0251C233.025 38.0422 232.228 37.2453 231.245 37.2453C230.262 37.2453 229.466 38.0422 229.466 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.306 39.0251C223.306 40.008 224.103 40.8049 225.086 40.8049C226.069 40.8049 226.866 40.008 226.866 39.0251C226.866 38.0422 226.069 37.2453 225.086 37.2453C224.103 37.2453 223.306 38.0422 223.306 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.09 39.0251C217.09 40.008 217.887 40.8049 218.87 40.8049C219.853 40.8049 220.65 40.008 220.65 39.0251C220.65 38.0421 219.853 37.2453 218.87 37.2453C217.887 37.2453 217.09 38.0421 217.09 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.931 39.0251C210.931 40.008 211.728 40.8049 212.711 40.8049C213.694 40.8049 214.49 40.008 214.49 39.0251C214.49 38.0421 213.694 37.2453 212.711 37.2453C211.728 37.2453 210.931 38.0421 210.931 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.782 39.016C204.782 39.999 205.579 40.7958 206.562 40.7958C207.545 40.7958 208.342 39.999 208.342 39.016C208.342 38.0331 207.545 37.2363 206.562 37.2363C205.579 37.2363 204.782 38.0331 204.782 39.016Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.624 39.016C198.624 39.999 199.42 40.7958 200.403 40.7958C201.386 40.7958 202.183 39.999 202.183 39.016C202.183 38.0331 201.386 37.2363 200.403 37.2363C199.42 37.2363 198.624 38.0331 198.624 39.016Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.424 39.0251C192.424 40.008 193.221 40.8049 194.204 40.8049C195.187 40.8049 195.984 40.008 195.984 39.0251C195.984 38.0421 195.187 37.2453 194.204 37.2453C193.221 37.2453 192.424 38.0421 192.424 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.265 39.0251C186.265 40.008 187.062 40.8049 188.045 40.8049C189.028 40.8049 189.825 40.008 189.825 39.0251C189.825 38.0421 189.028 37.2453 188.045 37.2453C187.062 37.2453 186.265 38.0421 186.265 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.099 39.0251C180.099 40.008 180.896 40.8049 181.879 40.8049C182.862 40.8049 183.659 40.008 183.659 39.0251C183.659 38.0421 182.862 37.2453 181.879 37.2453C180.896 37.2453 180.099 38.0421 180.099 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.94 39.0251C173.94 40.008 174.737 40.8049 175.72 40.8049C176.703 40.8049 177.5 40.008 177.5 39.0251C177.5 38.0422 176.703 37.2453 175.72 37.2453C174.737 37.2453 173.94 38.0422 173.94 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.741 39.0251C167.741 40.008 168.538 40.8049 169.521 40.8049C170.504 40.8049 171.301 40.008 171.301 39.0251C171.301 38.0422 170.504 37.2453 169.521 37.2453C168.538 37.2453 167.741 38.0422 167.741 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.582 39.0251C161.582 40.008 162.379 40.8049 163.362 40.8049C164.345 40.8049 165.142 40.008 165.142 39.0251C165.142 38.0422 164.345 37.2453 163.362 37.2453C162.379 37.2453 161.582 38.0422 161.582 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 44.2657C306.603 45.2487 307.4 46.0455 308.383 46.0455C309.366 46.0455 310.163 45.2487 310.163 44.2657C310.163 43.2828 309.366 42.486 308.383 42.486C307.4 42.486 306.603 43.2828 306.603 44.2657Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 44.2657C300.446 45.2487 301.243 46.0455 302.226 46.0455C303.209 46.0455 304.005 45.2487 304.005 44.2657C304.005 43.2828 303.209 42.486 302.226 42.486C301.243 42.486 300.446 43.2828 300.446 44.2657Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.23 44.2657C294.23 45.2487 295.026 46.0455 296.009 46.0455C296.992 46.0455 297.789 45.2487 297.789 44.2657C297.789 43.2828 296.992 42.486 296.009 42.486C295.026 42.486 294.23 43.2828 294.23 44.2657Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 44.2657C288.07 45.2487 288.867 46.0455 289.85 46.0455C290.833 46.0455 291.63 45.2487 291.63 44.2657C291.63 43.2828 290.833 42.486 289.85 42.486C288.867 42.486 288.07 43.2828 288.07 44.2657Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.92 44.2566C281.92 45.2396 282.717 46.0364 283.7 46.0364C284.683 46.0364 285.48 45.2396 285.48 44.2566C285.48 43.2737 284.683 42.4769 283.7 42.4769C282.717 42.4769 281.92 43.2737 281.92 44.2566Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 44.2566C275.763 45.2396 276.56 46.0364 277.542 46.0364C278.525 46.0364 279.322 45.2396 279.322 44.2566C279.322 43.2737 278.525 42.4769 277.542 42.4769C276.56 42.4769 275.763 43.2737 275.763 44.2566Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.562 44.2657C269.562 45.2487 270.359 46.0455 271.342 46.0455C272.325 46.0455 273.122 45.2487 273.122 44.2657C273.122 43.2828 272.325 42.486 271.342 42.486C270.359 42.486 269.562 43.2828 269.562 44.2657Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 44.2657C263.403 45.2487 264.2 46.0455 265.183 46.0455C266.166 46.0455 266.963 45.2487 266.963 44.2657C266.963 43.2828 266.166 42.486 265.183 42.486C264.2 42.486 263.403 43.2828 263.403 44.2657Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.238 44.2657C257.238 45.2487 258.034 46.0455 259.017 46.0455C260 46.0455 260.797 45.2487 260.797 44.2657C260.797 43.2828 260 42.486 259.017 42.486C258.034 42.486 257.238 43.2828 257.238 44.2657Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 44.2657C251.08 45.2487 251.876 46.0455 252.859 46.0455C253.842 46.0455 254.639 45.2487 254.639 44.2657C254.639 43.2828 253.842 42.486 252.859 42.486C251.876 42.486 251.08 43.2828 251.08 44.2657Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.879 44.2657C244.879 45.2487 245.676 46.0455 246.659 46.0455C247.642 46.0455 248.439 45.2487 248.439 44.2657C248.439 43.2828 247.642 42.486 246.659 42.486C245.676 42.486 244.879 43.2828 244.879 44.2657Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 44.2657C238.72 45.2487 239.517 46.0455 240.5 46.0455C241.483 46.0455 242.28 45.2487 242.28 44.2657C242.28 43.2828 241.483 42.486 240.5 42.486C239.517 42.486 238.72 43.2828 238.72 44.2657Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.551 44.2696C232.551 45.2525 233.348 46.0493 234.331 46.0493C235.314 46.0493 236.111 45.2525 236.111 44.2696C236.111 43.2866 235.314 42.4898 234.331 42.4898C233.348 42.4898 232.551 43.2866 232.551 44.2696Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 44.2696C226.392 45.2526 227.189 46.0494 228.172 46.0494C229.155 46.0494 229.951 45.2526 229.951 44.2696C229.951 43.2867 229.155 42.4899 228.172 42.4899C227.189 42.4899 226.392 43.2867 226.392 44.2696Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.175 44.2696C220.175 45.2526 220.972 46.0494 221.955 46.0494C222.938 46.0494 223.735 45.2526 223.735 44.2696C223.735 43.2867 222.938 42.4899 221.955 42.4899C220.972 42.4899 220.175 43.2867 220.175 44.2696Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 44.2696C214.017 45.2526 214.813 46.0494 215.796 46.0494C216.779 46.0494 217.576 45.2526 217.576 44.2696C217.576 43.2867 216.779 42.4899 215.796 42.4899C214.813 42.4899 214.017 43.2867 214.017 44.2696Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.868 44.2605C207.868 45.2434 208.665 46.0403 209.648 46.0403C210.631 46.0403 211.427 45.2434 211.427 44.2605C211.427 43.2775 210.631 42.4807 209.648 42.4807C208.665 42.4807 207.868 43.2775 207.868 44.2605Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 44.2605C201.709 45.2434 202.506 46.0403 203.489 46.0403C204.471 46.0403 205.268 45.2434 205.268 44.2605C205.268 43.2775 204.471 42.4807 203.489 42.4807C202.506 42.4807 201.709 43.2775 201.709 44.2605Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.508 44.2696C195.508 45.2525 196.305 46.0493 197.288 46.0493C198.271 46.0493 199.068 45.2525 199.068 44.2696C199.068 43.2866 198.271 42.4898 197.288 42.4898C196.305 42.4898 195.508 43.2866 195.508 44.2696Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 44.2696C189.349 45.2525 190.146 46.0493 191.129 46.0493C192.112 46.0493 192.908 45.2525 192.908 44.2696C192.908 43.2866 192.112 42.4898 191.129 42.4898C190.146 42.4898 189.349 43.2866 189.349 44.2696Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.185 44.2696C183.185 45.2525 183.982 46.0493 184.965 46.0493C185.948 46.0493 186.745 45.2525 186.745 44.2696C186.745 43.2866 185.948 42.4898 184.965 42.4898C183.982 42.4898 183.185 43.2866 183.185 44.2696Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 44.2696C177.026 45.2525 177.823 46.0493 178.806 46.0493C179.789 46.0493 180.585 45.2525 180.585 44.2696C180.585 43.2866 179.789 42.4898 178.806 42.4898C177.823 42.4898 177.026 43.2866 177.026 44.2696Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.825 44.2696C170.825 45.2525 171.622 46.0493 172.605 46.0493C173.588 46.0493 174.385 45.2525 174.385 44.2696C174.385 43.2866 173.588 42.4898 172.605 42.4898C171.622 42.4898 170.825 43.2866 170.825 44.2696Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 44.2696C164.666 45.2525 165.463 46.0493 166.446 46.0493C167.429 46.0493 168.225 45.2525 168.225 44.2696C168.225 43.2866 167.429 42.4898 166.446 42.4898C165.463 42.4898 164.666 43.2866 164.666 44.2696Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.53 49.5557C303.53 50.5386 304.327 51.3355 305.31 51.3355C306.293 51.3355 307.09 50.5386 307.09 49.5557C307.09 48.5727 306.293 47.7759 305.31 47.7759C304.327 47.7759 303.53 48.5727 303.53 49.5557Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.371 49.5557C297.371 50.5386 298.168 51.3355 299.151 51.3355C300.134 51.3355 300.93 50.5386 300.93 49.5557C300.93 48.5727 300.134 47.7759 299.151 47.7759C298.168 47.7759 297.371 48.5727 297.371 49.5557Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.155 49.5557C291.155 50.5386 291.951 51.3355 292.934 51.3355C293.917 51.3355 294.714 50.5386 294.714 49.5557C294.714 48.5727 293.917 47.7759 292.934 47.7759C291.951 47.7759 291.155 48.5727 291.155 49.5557Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.995 49.5557C284.995 50.5386 285.792 51.3355 286.775 51.3355C287.758 51.3355 288.555 50.5386 288.555 49.5557C288.555 48.5727 287.758 47.7759 286.775 47.7759C285.792 47.7759 284.995 48.5727 284.995 49.5557Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.847 49.5466C278.847 50.5295 279.644 51.3263 280.626 51.3263C281.609 51.3263 282.406 50.5295 282.406 49.5466C282.406 48.5636 281.609 47.7668 280.626 47.7668C279.644 47.7668 278.847 48.5636 278.847 49.5466Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.688 49.5466C272.688 50.5295 273.485 51.3263 274.468 51.3263C275.451 51.3263 276.248 50.5295 276.248 49.5466C276.248 48.5636 275.451 47.7668 274.468 47.7668C273.485 47.7668 272.688 48.5636 272.688 49.5466Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.489 49.5557C266.489 50.5386 267.286 51.3355 268.269 51.3355C269.252 51.3355 270.048 50.5386 270.048 49.5557C270.048 48.5727 269.252 47.7759 268.269 47.7759C267.286 47.7759 266.489 48.5727 266.489 49.5557Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.33 49.5557C260.33 50.5386 261.126 51.3355 262.109 51.3355C263.092 51.3355 263.889 50.5386 263.889 49.5557C263.889 48.5727 263.092 47.7759 262.109 47.7759C261.126 47.7759 260.33 48.5727 260.33 49.5557Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.164 49.5557C254.164 50.5386 254.961 51.3355 255.944 51.3355C256.927 51.3355 257.723 50.5386 257.723 49.5557C257.723 48.5727 256.927 47.7759 255.944 47.7759C254.961 47.7759 254.164 48.5727 254.164 49.5557Z"
            fill="#B8B7B7"
          />
          <path
            d="M248.005 49.5557C248.005 50.5386 248.802 51.3355 249.785 51.3355C250.768 51.3355 251.564 50.5386 251.564 49.5557C251.564 48.5727 250.768 47.7759 249.785 47.7759C248.802 47.7759 248.005 48.5727 248.005 49.5557Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.806 49.5557C241.806 50.5386 242.603 51.3355 243.586 51.3355C244.569 51.3355 245.365 50.5386 245.365 49.5557C245.365 48.5727 244.569 47.7759 243.586 47.7759C242.603 47.7759 241.806 48.5727 241.806 49.5557Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.647 49.5557C235.647 50.5386 236.443 51.3355 237.426 51.3355C238.409 51.3355 239.206 50.5386 239.206 49.5557C239.206 48.5727 238.409 47.7759 237.426 47.7759C236.443 47.7759 235.647 48.5727 235.647 49.5557Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.477 49.5609C229.477 50.5438 230.274 51.3406 231.257 51.3406C232.24 51.3406 233.037 50.5438 233.037 49.5609C233.037 48.5779 232.24 47.7811 231.257 47.7811C230.274 47.7811 229.477 48.5779 229.477 49.5609Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.318 49.5609C223.318 50.5438 224.115 51.3406 225.098 51.3406C226.081 51.3406 226.877 50.5438 226.877 49.5609C226.877 48.5779 226.081 47.7811 225.098 47.7811C224.115 47.7811 223.318 48.5779 223.318 49.5609Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.102 49.5609C217.102 50.5438 217.898 51.3406 218.881 51.3406C219.864 51.3406 220.661 50.5438 220.661 49.5609C220.661 48.5779 219.864 47.7811 218.881 47.7811C217.898 47.7811 217.102 48.5779 217.102 49.5609Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.943 49.5609C210.943 50.5438 211.739 51.3406 212.722 51.3406C213.705 51.3406 214.502 50.5438 214.502 49.5609C214.502 48.5779 213.705 47.7811 212.722 47.7811C211.739 47.7811 210.943 48.5779 210.943 49.5609Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.794 49.5518C204.794 50.5347 205.591 51.3316 206.574 51.3316C207.557 51.3316 208.354 50.5347 208.354 49.5518C208.354 48.5688 207.557 47.772 206.574 47.772C205.591 47.772 204.794 48.5688 204.794 49.5518Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.635 49.5518C198.635 50.5347 199.432 51.3316 200.415 51.3316C201.398 51.3316 202.195 50.5347 202.195 49.5518C202.195 48.5688 201.398 47.772 200.415 47.772C199.432 47.772 198.635 48.5688 198.635 49.5518Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.434 49.5609C192.434 50.5438 193.231 51.3406 194.214 51.3406C195.197 51.3406 195.994 50.5438 195.994 49.5609C195.994 48.5779 195.197 47.7811 194.214 47.7811C193.231 47.7811 192.434 48.5779 192.434 49.5609Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.275 49.5609C186.275 50.5438 187.072 51.3406 188.055 51.3406C189.038 51.3406 189.835 50.5438 189.835 49.5609C189.835 48.5779 189.038 47.7811 188.055 47.7811C187.072 47.7811 186.275 48.5779 186.275 49.5609Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.111 49.5609C180.111 50.5438 180.908 51.3406 181.891 51.3406C182.874 51.3406 183.671 50.5438 183.671 49.5609C183.671 48.5779 182.874 47.7811 181.891 47.7811C180.908 47.7811 180.111 48.5779 180.111 49.5609Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.952 49.5608C173.952 50.5438 174.749 51.3406 175.732 51.3406C176.715 51.3406 177.512 50.5438 177.512 49.5608C177.512 48.5779 176.715 47.7811 175.732 47.7811C174.749 47.7811 173.952 48.5779 173.952 49.5608Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.751 49.5608C167.751 50.5438 168.548 51.3406 169.531 51.3406C170.514 51.3406 171.311 50.5438 171.311 49.5608C171.311 48.5779 170.514 47.7811 169.531 47.7811C168.548 47.7811 167.751 48.5779 167.751 49.5608Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.593 49.5608C161.593 50.5438 162.389 51.3406 163.372 51.3406C164.355 51.3406 165.152 50.5438 165.152 49.5608C165.152 48.5779 164.355 47.7811 163.372 47.7811C162.389 47.7811 161.593 48.5779 161.593 49.5608Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 54.8572C300.446 55.8402 301.243 56.637 302.226 56.637C303.209 56.637 304.005 55.8402 304.005 54.8572C304.005 53.8743 303.209 53.0775 302.226 53.0775C301.243 53.0775 300.446 53.8743 300.446 54.8572Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.287 54.8573C294.287 55.8402 295.083 56.637 296.066 56.637C297.049 56.637 297.846 55.8402 297.846 54.8573C297.846 53.8743 297.049 53.0775 296.066 53.0775C295.083 53.0775 294.287 53.8743 294.287 54.8573Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 54.8573C288.07 55.8402 288.867 56.637 289.85 56.637C290.833 56.637 291.63 55.8402 291.63 54.8573C291.63 53.8743 290.833 53.0775 289.85 53.0775C288.867 53.0775 288.07 53.8743 288.07 54.8573Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.912 54.8573C281.912 55.8402 282.708 56.637 283.691 56.637C284.674 56.637 285.471 55.8402 285.471 54.8573C285.471 53.8743 284.674 53.0775 283.691 53.0775C282.708 53.0775 281.912 53.8743 281.912 54.8573Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 54.8482C275.763 55.8311 276.56 56.628 277.542 56.628C278.525 56.628 279.322 55.8311 279.322 54.8482C279.322 53.8653 278.525 53.0684 277.542 53.0684C276.56 53.0684 275.763 53.8653 275.763 54.8482Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.604 54.8482C269.604 55.8311 270.401 56.628 271.384 56.628C272.367 56.628 273.164 55.8311 273.164 54.8482C273.164 53.8653 272.367 53.0684 271.384 53.0684C270.401 53.0684 269.604 53.8653 269.604 54.8482Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 54.8573C263.403 55.8402 264.2 56.6371 265.183 56.6371C266.166 56.6371 266.963 55.8402 266.963 54.8573C266.963 53.8743 266.166 53.0775 265.183 53.0775C264.2 53.0775 263.403 53.8743 263.403 54.8573Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.244 54.8573C257.244 55.8402 258.041 56.6371 259.024 56.6371C260.007 56.6371 260.803 55.8402 260.803 54.8573C260.803 53.8743 260.007 53.0775 259.024 53.0775C258.041 53.0775 257.244 53.8743 257.244 54.8573Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 54.8573C251.08 55.8402 251.876 56.6371 252.859 56.6371C253.842 56.6371 254.639 55.8402 254.639 54.8573C254.639 53.8743 253.842 53.0775 252.859 53.0775C251.876 53.0775 251.08 53.8743 251.08 54.8573Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.921 54.8573C244.921 55.8402 245.718 56.6371 246.701 56.6371C247.684 56.6371 248.48 55.8402 248.48 54.8573C248.48 53.8743 247.684 53.0775 246.701 53.0775C245.718 53.0775 244.921 53.8743 244.921 54.8573Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 54.8573C238.72 55.8402 239.517 56.6371 240.5 56.6371C241.483 56.6371 242.28 55.8402 242.28 54.8573C242.28 53.8743 241.483 53.0775 240.5 53.0775C239.517 53.0775 238.72 53.8743 238.72 54.8573Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.561 54.8573C232.561 55.8402 233.358 56.6371 234.341 56.6371C235.324 56.6371 236.121 55.8402 236.121 54.8573C236.121 53.8743 235.324 53.0775 234.341 53.0775C233.358 53.0775 232.561 53.8743 232.561 54.8573Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 54.8625C226.392 55.8454 227.189 56.6422 228.172 56.6422C229.155 56.6422 229.951 55.8454 229.951 54.8625C229.951 53.8795 229.155 53.0827 228.172 53.0827C227.189 53.0827 226.392 53.8795 226.392 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.233 54.8625C220.233 55.8454 221.03 56.6422 222.012 56.6422C222.995 56.6422 223.792 55.8454 223.792 54.8625C223.792 53.8795 222.995 53.0827 222.012 53.0827C221.03 53.0827 220.233 53.8795 220.233 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 54.8625C214.017 55.8454 214.813 56.6422 215.796 56.6422C216.779 56.6422 217.576 55.8454 217.576 54.8625C217.576 53.8795 216.779 53.0827 215.796 53.0827C214.813 53.0827 214.017 53.8795 214.017 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.857 54.8625C207.857 55.8454 208.654 56.6422 209.637 56.6422C210.62 56.6422 211.417 55.8454 211.417 54.8625C211.417 53.8795 210.62 53.0827 209.637 53.0827C208.654 53.0827 207.857 53.8795 207.857 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 54.8521C201.709 55.8351 202.506 56.6319 203.489 56.6319C204.471 56.6319 205.268 55.8351 205.268 54.8521C205.268 53.8692 204.471 53.0724 203.489 53.0724C202.506 53.0724 201.709 53.8692 201.709 54.8521Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.55 54.8521C195.55 55.835 196.347 56.6319 197.33 56.6319C198.313 56.6319 199.109 55.835 199.109 54.8521C199.109 53.8692 198.313 53.0723 197.33 53.0723C196.347 53.0723 195.55 53.8692 195.55 54.8521Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 54.8625C189.349 55.8454 190.146 56.6423 191.129 56.6423C192.112 56.6423 192.908 55.8454 192.908 54.8625C192.908 53.8795 192.112 53.0827 191.129 53.0827C190.146 53.0827 189.349 53.8795 189.349 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.191 54.8625C183.191 55.8454 183.988 56.6423 184.971 56.6423C185.954 56.6423 186.751 55.8454 186.751 54.8625C186.751 53.8795 185.954 53.0827 184.971 53.0827C183.988 53.0827 183.191 53.8795 183.191 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 54.8625C177.026 55.8454 177.823 56.6423 178.806 56.6423C179.789 56.6423 180.585 55.8454 180.585 54.8625C180.585 53.8795 179.789 53.0827 178.806 53.0827C177.823 53.0827 177.026 53.8795 177.026 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.867 54.8625C170.867 55.8454 171.664 56.6423 172.646 56.6423C173.629 56.6423 174.426 55.8454 174.426 54.8625C174.426 53.8795 173.629 53.0827 172.646 53.0827C171.664 53.0827 170.867 53.8795 170.867 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 54.8625C164.666 55.8454 165.463 56.6423 166.446 56.6423C167.429 56.6423 168.225 55.8454 168.225 54.8625C168.225 53.8795 167.429 53.0827 166.446 53.0827C165.463 53.0827 164.666 53.8795 164.666 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.508 54.8625C158.508 55.8454 159.305 56.6422 160.288 56.6422C161.271 56.6422 162.068 55.8454 162.068 54.8625C162.068 53.8795 161.271 53.0827 160.288 53.0827C159.305 53.0827 158.508 53.8795 158.508 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.53 60.1018C303.53 61.0847 304.327 61.8815 305.31 61.8815C306.293 61.8815 307.09 61.0847 307.09 60.1018C307.09 59.1188 306.293 58.322 305.31 58.322C304.327 58.322 303.53 59.1188 303.53 60.1018Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.371 60.1018C297.371 61.0847 298.168 61.8815 299.151 61.8815C300.134 61.8815 300.93 61.0847 300.93 60.1018C300.93 59.1188 300.134 58.322 299.151 58.322C298.168 58.322 297.371 59.1188 297.371 60.1018Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.155 60.1018C291.155 61.0847 291.951 61.8815 292.934 61.8815C293.917 61.8815 294.714 61.0847 294.714 60.1018C294.714 59.1188 293.917 58.322 292.934 58.322C291.951 58.322 291.155 59.1188 291.155 60.1018Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.995 60.1018C284.995 61.0847 285.792 61.8815 286.775 61.8815C287.758 61.8815 288.555 61.0847 288.555 60.1018C288.555 59.1188 287.758 58.322 286.775 58.322C285.792 58.322 284.995 59.1188 284.995 60.1018Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.847 60.0926C278.847 61.0756 279.644 61.8724 280.626 61.8724C281.609 61.8724 282.406 61.0756 282.406 60.0926C282.406 59.1097 281.609 58.3129 280.626 58.3129C279.644 58.3129 278.847 59.1097 278.847 60.0926Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.688 60.0926C272.688 61.0756 273.485 61.8724 274.468 61.8724C275.451 61.8724 276.248 61.0756 276.248 60.0926C276.248 59.1097 275.451 58.3129 274.468 58.3129C273.485 58.3129 272.688 59.1097 272.688 60.0926Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.489 60.1018C266.489 61.0847 267.286 61.8815 268.269 61.8815C269.252 61.8815 270.048 61.0847 270.048 60.1018C270.048 59.1188 269.252 58.322 268.269 58.322C267.286 58.322 266.489 59.1188 266.489 60.1018Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.33 60.1018C260.33 61.0847 261.126 61.8815 262.109 61.8815C263.092 61.8815 263.889 61.0847 263.889 60.1018C263.889 59.1188 263.092 58.322 262.109 58.322C261.126 58.322 260.33 59.1188 260.33 60.1018Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.164 60.1018C254.164 61.0847 254.961 61.8815 255.944 61.8815C256.927 61.8815 257.723 61.0847 257.723 60.1018C257.723 59.1188 256.927 58.322 255.944 58.322C254.961 58.322 254.164 59.1188 254.164 60.1018Z"
            fill="#B8B7B7"
          />
          <path
            d="M248.005 60.1018C248.005 61.0847 248.802 61.8815 249.785 61.8815C250.768 61.8815 251.564 61.0847 251.564 60.1018C251.564 59.1188 250.768 58.322 249.785 58.322C248.802 58.322 248.005 59.1188 248.005 60.1018Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.806 60.1018C241.806 61.0847 242.603 61.8815 243.586 61.8815C244.569 61.8815 245.365 61.0847 245.365 60.1018C245.365 59.1188 244.569 58.322 243.586 58.322C242.603 58.322 241.806 59.1188 241.806 60.1018Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.647 60.1018C235.647 61.0847 236.443 61.8815 237.426 61.8815C238.409 61.8815 239.206 61.0847 239.206 60.1018C239.206 59.1188 238.409 58.322 237.426 58.322C236.443 58.322 235.647 59.1188 235.647 60.1018Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.477 60.1069C229.477 61.0899 230.274 61.8867 231.257 61.8867C232.24 61.8867 233.037 61.0899 233.037 60.1069C233.037 59.124 232.24 58.3272 231.257 58.3272C230.274 58.3272 229.477 59.124 229.477 60.1069Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.318 60.1069C223.318 61.0899 224.115 61.8867 225.098 61.8867C226.081 61.8867 226.877 61.0899 226.877 60.1069C226.877 59.124 226.081 58.3272 225.098 58.3272C224.115 58.3272 223.318 59.124 223.318 60.1069Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.102 60.1069C217.102 61.0899 217.898 61.8867 218.881 61.8867C219.864 61.8867 220.661 61.0899 220.661 60.1069C220.661 59.124 219.864 58.3272 218.881 58.3272C217.898 58.3272 217.102 59.124 217.102 60.1069Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.943 60.1069C210.943 61.0899 211.739 61.8867 212.722 61.8867C213.705 61.8867 214.502 61.0899 214.502 60.1069C214.502 59.124 213.705 58.3272 212.722 58.3272C211.739 58.3272 210.943 59.124 210.943 60.1069Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.794 60.0966C204.794 61.0795 205.591 61.8763 206.574 61.8763C207.557 61.8763 208.354 61.0795 208.354 60.0966C208.354 59.1136 207.557 58.3168 206.574 58.3168C205.591 58.3168 204.794 59.1136 204.794 60.0966Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.635 60.0966C198.635 61.0795 199.432 61.8763 200.415 61.8763C201.398 61.8763 202.195 61.0795 202.195 60.0966C202.195 59.1136 201.398 58.3168 200.415 58.3168C199.432 58.3168 198.635 59.1136 198.635 60.0966Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.434 60.1069C192.434 61.0899 193.231 61.8867 194.214 61.8867C195.197 61.8867 195.994 61.0899 195.994 60.1069C195.994 59.124 195.197 58.3272 194.214 58.3272C193.231 58.3272 192.434 59.124 192.434 60.1069Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.275 60.1069C186.275 61.0899 187.072 61.8867 188.055 61.8867C189.038 61.8867 189.835 61.0899 189.835 60.1069C189.835 59.124 189.038 58.3272 188.055 58.3272C187.072 58.3272 186.275 59.124 186.275 60.1069Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.111 60.1069C180.111 61.0899 180.908 61.8867 181.891 61.8867C182.874 61.8867 183.671 61.0899 183.671 60.1069C183.671 59.124 182.874 58.3272 181.891 58.3272C180.908 58.3272 180.111 59.124 180.111 60.1069Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.952 60.1069C173.952 61.0899 174.749 61.8867 175.732 61.8867C176.715 61.8867 177.512 61.0899 177.512 60.1069C177.512 59.124 176.715 58.3272 175.732 58.3272C174.749 58.3272 173.952 59.124 173.952 60.1069Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.751 60.1069C167.751 61.0899 168.548 61.8867 169.531 61.8867C170.514 61.8867 171.311 61.0899 171.311 60.1069C171.311 59.124 170.514 58.3272 169.531 58.3272C168.548 58.3272 167.751 59.124 167.751 60.1069Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.593 60.1069C161.593 61.0899 162.389 61.8867 163.372 61.8867C164.355 61.8867 165.152 61.0899 165.152 60.1069C165.152 59.124 164.355 58.3272 163.372 58.3272C162.389 58.3272 161.593 59.124 161.593 60.1069Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 54.8287C306.603 55.8116 307.4 56.6085 308.383 56.6085C309.366 56.6085 310.163 55.8116 310.163 54.8287C310.163 53.8458 309.366 53.0489 308.383 53.0489C307.4 53.0489 306.603 53.8457 306.603 54.8287Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 65.2852C306.603 66.2681 307.4 67.0649 308.383 67.0649C309.366 67.0649 310.163 66.2681 310.163 65.2852C310.163 64.3022 309.366 63.5054 308.383 63.5054C307.4 63.5054 306.603 64.3022 306.603 65.2852Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 65.2852C300.446 66.2681 301.243 67.0649 302.226 67.0649C303.209 67.0649 304.005 66.2681 304.005 65.2852C304.005 64.3022 303.209 63.5054 302.226 63.5054C301.243 63.5054 300.446 64.3022 300.446 65.2852Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.23 65.2852C294.23 66.2681 295.026 67.0649 296.009 67.0649C296.992 67.0649 297.789 66.2681 297.789 65.2852C297.789 64.3022 296.992 63.5054 296.009 63.5054C295.026 63.5054 294.23 64.3022 294.23 65.2852Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 65.2852C288.07 66.2681 288.867 67.0649 289.85 67.0649C290.833 67.0649 291.63 66.2681 291.63 65.2852C291.63 64.3022 290.833 63.5054 289.85 63.5054C288.867 63.5054 288.07 64.3022 288.07 65.2852Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.92 65.276C281.92 66.259 282.717 67.0558 283.7 67.0558C284.683 67.0558 285.48 66.259 285.48 65.276C285.48 64.2931 284.683 63.4963 283.7 63.4963C282.717 63.4963 281.92 64.2931 281.92 65.276Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 65.276C275.763 66.259 276.56 67.0558 277.542 67.0558C278.525 67.0558 279.322 66.259 279.322 65.276C279.322 64.2931 278.525 63.4963 277.542 63.4963C276.56 63.4963 275.763 64.2931 275.763 65.276Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.562 65.2852C269.562 66.2681 270.359 67.0649 271.342 67.0649C272.325 67.0649 273.122 66.2681 273.122 65.2852C273.122 64.3022 272.325 63.5054 271.342 63.5054C270.359 63.5054 269.562 64.3022 269.562 65.2852Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 65.2852C263.403 66.2681 264.2 67.065 265.183 67.065C266.166 67.065 266.963 66.2681 266.963 65.2852C266.963 64.3022 266.166 63.5054 265.183 63.5054C264.2 63.5054 263.403 64.3022 263.403 65.2852Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.238 65.2852C257.238 66.2681 258.034 67.065 259.017 67.065C260 67.065 260.797 66.2681 260.797 65.2852C260.797 64.3022 260 63.5054 259.017 63.5054C258.034 63.5054 257.238 64.3022 257.238 65.2852Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 65.2852C251.08 66.2681 251.876 67.065 252.859 67.065C253.842 67.065 254.639 66.2681 254.639 65.2852C254.639 64.3022 253.842 63.5054 252.859 63.5054C251.876 63.5054 251.08 64.3022 251.08 65.2852Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.879 65.2852C244.879 66.2681 245.676 67.065 246.659 67.065C247.642 67.065 248.439 66.2681 248.439 65.2852C248.439 64.3022 247.642 63.5054 246.659 63.5054C245.676 63.5054 244.879 64.3022 244.879 65.2852Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 65.2852C238.72 66.2681 239.517 67.065 240.5 67.065C241.483 67.065 242.28 66.2681 242.28 65.2852C242.28 64.3022 241.483 63.5054 240.5 63.5054C239.517 63.5054 238.72 64.3022 238.72 65.2852Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.551 65.2904C232.551 66.2734 233.348 67.0702 234.331 67.0702C235.314 67.0702 236.111 66.2734 236.111 65.2904C236.111 64.3075 235.314 63.5107 234.331 63.5107C233.348 63.5107 232.551 64.3075 232.551 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 65.2904C226.392 66.2734 227.189 67.0702 228.172 67.0702C229.155 67.0702 229.951 66.2734 229.951 65.2904C229.951 64.3075 229.155 63.5107 228.172 63.5107C227.189 63.5107 226.392 64.3075 226.392 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.175 65.2904C220.175 66.2734 220.972 67.0702 221.955 67.0702C222.938 67.0702 223.735 66.2734 223.735 65.2904C223.735 64.3075 222.938 63.5107 221.955 63.5107C220.972 63.5107 220.175 64.3075 220.175 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 65.2904C214.017 66.2733 214.813 67.0702 215.796 67.0702C216.779 67.0702 217.576 66.2733 217.576 65.2904C217.576 64.3075 216.779 63.5106 215.796 63.5106C214.813 63.5106 214.017 64.3075 214.017 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.868 65.28C207.868 66.2629 208.665 67.0598 209.648 67.0598C210.631 67.0598 211.427 66.2629 211.427 65.28C211.427 64.297 210.631 63.5002 209.648 63.5002C208.665 63.5002 207.868 64.297 207.868 65.28Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 65.28C201.709 66.2629 202.506 67.0598 203.489 67.0598C204.471 67.0598 205.268 66.2629 205.268 65.28C205.268 64.297 204.471 63.5002 203.489 63.5002C202.506 63.5002 201.709 64.297 201.709 65.28Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.508 65.2904C195.508 66.2733 196.305 67.0702 197.288 67.0702C198.271 67.0702 199.068 66.2733 199.068 65.2904C199.068 64.3075 198.271 63.5106 197.288 63.5106C196.305 63.5106 195.508 64.3075 195.508 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 65.2904C189.349 66.2733 190.146 67.0702 191.129 67.0702C192.112 67.0702 192.908 66.2733 192.908 65.2904C192.908 64.3075 192.112 63.5106 191.129 63.5106C190.146 63.5106 189.349 64.3075 189.349 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.185 65.2904C183.185 66.2733 183.982 67.0702 184.965 67.0702C185.948 67.0702 186.745 66.2733 186.745 65.2904C186.745 64.3075 185.948 63.5106 184.965 63.5106C183.982 63.5106 183.185 64.3075 183.185 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 65.2904C177.026 66.2733 177.823 67.0702 178.806 67.0702C179.789 67.0702 180.585 66.2733 180.585 65.2904C180.585 64.3075 179.789 63.5106 178.806 63.5106C177.823 63.5106 177.026 64.3075 177.026 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.825 65.2904C170.825 66.2733 171.622 67.0702 172.605 67.0702C173.588 67.0702 174.385 66.2733 174.385 65.2904C174.385 64.3075 173.588 63.5106 172.605 63.5106C171.622 63.5106 170.825 64.3075 170.825 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 65.2904C164.666 66.2733 165.463 67.0702 166.446 67.0702C167.429 67.0702 168.225 66.2733 168.225 65.2904C168.225 64.3075 167.429 63.5106 166.446 63.5106C165.463 63.5106 164.666 64.3075 164.666 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.519 70.5868C303.519 71.5697 304.316 72.3666 305.299 72.3666C306.282 72.3666 307.079 71.5697 307.079 70.5868C307.079 69.6039 306.282 68.807 305.299 68.807C304.316 68.807 303.519 69.6039 303.519 70.5868Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.36 70.5868C297.36 71.5697 298.157 72.3666 299.14 72.3666C300.123 72.3666 300.92 71.5697 300.92 70.5868C300.92 69.6039 300.123 68.807 299.14 68.807C298.157 68.807 297.36 69.6039 297.36 70.5868Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.144 70.5868C291.144 71.5697 291.941 72.3666 292.924 72.3666C293.907 72.3666 294.704 71.5697 294.704 70.5868C294.704 69.6039 293.907 68.807 292.924 68.807C291.941 68.807 291.144 69.6039 291.144 70.5868Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.985 70.5868C284.985 71.5697 285.782 72.3666 286.765 72.3666C287.748 72.3666 288.545 71.5697 288.545 70.5868C288.545 69.6039 287.748 68.807 286.765 68.807C285.782 68.807 284.985 69.6039 284.985 70.5868Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.836 70.5778C278.836 71.5607 279.633 72.3575 280.616 72.3575C281.599 72.3575 282.396 71.5607 282.396 70.5778C282.396 69.5948 281.599 68.798 280.616 68.798C279.633 68.798 278.836 69.5948 278.836 70.5778Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.678 70.5778C272.678 71.5607 273.474 72.3575 274.457 72.3575C275.44 72.3575 276.237 71.5607 276.237 70.5778C276.237 69.5948 275.44 68.798 274.457 68.798C273.474 68.798 272.678 69.5948 272.678 70.5778Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.477 70.5868C266.477 71.5698 267.274 72.3666 268.257 72.3666C269.24 72.3666 270.036 71.5698 270.036 70.5868C270.036 69.6039 269.24 68.8071 268.257 68.8071C267.274 68.8071 266.477 69.6039 266.477 70.5868Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.318 70.5868C260.318 71.5698 261.115 72.3666 262.098 72.3666C263.081 72.3666 263.878 71.5698 263.878 70.5868C263.878 69.6039 263.081 68.8071 262.098 68.8071C261.115 68.8071 260.318 69.6039 260.318 70.5868Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.153 70.5868C254.153 71.5698 254.95 72.3666 255.933 72.3666C256.916 72.3666 257.713 71.5698 257.713 70.5868C257.713 69.6039 256.916 68.8071 255.933 68.8071C254.95 68.8071 254.153 69.6039 254.153 70.5868Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.995 70.5868C247.995 71.5698 248.791 72.3666 249.774 72.3666C250.757 72.3666 251.554 71.5698 251.554 70.5868C251.554 69.6039 250.757 68.8071 249.774 68.8071C248.791 68.8071 247.995 69.6039 247.995 70.5868Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.794 70.5868C241.794 71.5698 242.591 72.3666 243.574 72.3666C244.557 72.3666 245.354 71.5698 245.354 70.5868C245.354 69.6039 244.557 68.8071 243.574 68.8071C242.591 68.8071 241.794 69.6039 241.794 70.5868Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.635 70.5868C235.635 71.5698 236.432 72.3666 237.415 72.3666C238.398 72.3666 239.195 71.5698 239.195 70.5868C239.195 69.6039 238.398 68.8071 237.415 68.8071C236.432 68.8071 235.635 69.6039 235.635 70.5868Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.466 70.5907C229.466 71.5736 230.262 72.3705 231.245 72.3705C232.228 72.3705 233.025 71.5736 233.025 70.5907C233.025 69.6077 232.228 68.8109 231.245 68.8109C230.262 68.8109 229.466 69.6077 229.466 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.306 70.5907C223.306 71.5736 224.103 72.3705 225.086 72.3705C226.069 72.3705 226.866 71.5736 226.866 70.5907C226.866 69.6078 226.069 68.8109 225.086 68.8109C224.103 68.8109 223.306 69.6078 223.306 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.09 70.5907C217.09 71.5736 217.887 72.3705 218.87 72.3705C219.853 72.3705 220.65 71.5736 220.65 70.5907C220.65 69.6077 219.853 68.8109 218.87 68.8109C217.887 68.8109 217.09 69.6077 217.09 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.931 70.5907C210.931 71.5737 211.728 72.3705 212.711 72.3705C213.694 72.3705 214.49 71.5737 214.49 70.5907C214.49 69.6078 213.694 68.811 212.711 68.811C211.728 68.811 210.931 69.6078 210.931 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.782 70.5816C204.782 71.5646 205.579 72.3614 206.562 72.3614C207.545 72.3614 208.342 71.5646 208.342 70.5816C208.342 69.5987 207.545 68.8019 206.562 68.8019C205.579 68.8019 204.782 69.5987 204.782 70.5816Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.624 70.5816C198.624 71.5646 199.42 72.3614 200.403 72.3614C201.386 72.3614 202.183 71.5646 202.183 70.5816C202.183 69.5987 201.386 68.8019 200.403 68.8019C199.42 68.8019 198.624 69.5987 198.624 70.5816Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.424 70.5907C192.424 71.5736 193.221 72.3705 194.204 72.3705C195.187 72.3705 195.984 71.5736 195.984 70.5907C195.984 69.6077 195.187 68.8109 194.204 68.8109C193.221 68.8109 192.424 69.6077 192.424 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.265 70.5907C186.265 71.5736 187.062 72.3705 188.045 72.3705C189.028 72.3705 189.825 71.5736 189.825 70.5907C189.825 69.6077 189.028 68.8109 188.045 68.8109C187.062 68.8109 186.265 69.6077 186.265 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.099 70.5907C180.099 71.5736 180.896 72.3705 181.879 72.3705C182.862 72.3705 183.659 71.5736 183.659 70.5907C183.659 69.6077 182.862 68.8109 181.879 68.8109C180.896 68.8109 180.099 69.6077 180.099 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.94 70.5907C173.94 71.5736 174.737 72.3705 175.72 72.3705C176.703 72.3705 177.5 71.5736 177.5 70.5907C177.5 69.6077 176.703 68.8109 175.72 68.8109C174.737 68.8109 173.94 69.6077 173.94 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.741 70.5907C167.741 71.5736 168.538 72.3705 169.521 72.3705C170.504 72.3705 171.301 71.5736 171.301 70.5907C171.301 69.6077 170.504 68.8109 169.521 68.8109C168.538 68.8109 167.741 69.6077 167.741 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.582 70.5907C161.582 71.5736 162.379 72.3704 163.362 72.3704C164.345 72.3704 165.142 71.5736 165.142 70.5907C165.142 69.6077 164.345 68.8109 163.362 68.8109C162.379 68.8109 161.582 69.6077 161.582 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 75.8313C306.603 76.8142 307.4 77.611 308.383 77.611C309.366 77.611 310.163 76.8142 310.163 75.8313C310.163 74.8483 309.366 74.0515 308.383 74.0515C307.4 74.0515 306.603 74.8483 306.603 75.8313Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 75.8313C300.446 76.8142 301.243 77.611 302.226 77.611C303.209 77.611 304.005 76.8142 304.005 75.8313C304.005 74.8483 303.209 74.0515 302.226 74.0515C301.243 74.0515 300.446 74.8483 300.446 75.8313Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.23 75.8313C294.23 76.8142 295.026 77.611 296.009 77.611C296.992 77.611 297.789 76.8142 297.789 75.8313C297.789 74.8483 296.992 74.0515 296.009 74.0515C295.026 74.0515 294.23 74.8483 294.23 75.8313Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 75.8313C288.07 76.8142 288.867 77.611 289.85 77.611C290.833 77.611 291.63 76.8142 291.63 75.8313C291.63 74.8483 290.833 74.0515 289.85 74.0515C288.867 74.0515 288.07 74.8483 288.07 75.8313Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.92 75.8222C281.92 76.8052 282.717 77.602 283.7 77.602C284.683 77.602 285.48 76.8052 285.48 75.8222C285.48 74.8393 284.683 74.0424 283.7 74.0424C282.717 74.0424 281.92 74.8393 281.92 75.8222Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 75.8222C275.763 76.8052 276.56 77.602 277.542 77.602C278.525 77.602 279.322 76.8052 279.322 75.8222C279.322 74.8393 278.525 74.0424 277.542 74.0424C276.56 74.0424 275.763 74.8393 275.763 75.8222Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.562 75.8313C269.562 76.8142 270.359 77.611 271.342 77.611C272.325 77.611 273.122 76.8142 273.122 75.8313C273.122 74.8483 272.325 74.0515 271.342 74.0515C270.359 74.0515 269.562 74.8483 269.562 75.8313Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 75.8313C263.403 76.8142 264.2 77.611 265.183 77.611C266.166 77.611 266.963 76.8142 266.963 75.8313C266.963 74.8483 266.166 74.0515 265.183 74.0515C264.2 74.0515 263.403 74.8483 263.403 75.8313Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.238 75.8313C257.238 76.8142 258.034 77.611 259.017 77.611C260 77.611 260.797 76.8142 260.797 75.8313C260.797 74.8483 260 74.0515 259.017 74.0515C258.034 74.0515 257.238 74.8483 257.238 75.8313Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 75.8313C251.08 76.8142 251.876 77.611 252.859 77.611C253.842 77.611 254.639 76.8142 254.639 75.8313C254.639 74.8483 253.842 74.0515 252.859 74.0515C251.876 74.0515 251.08 74.8483 251.08 75.8313Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.879 75.8313C244.879 76.8142 245.676 77.611 246.659 77.611C247.642 77.611 248.439 76.8142 248.439 75.8313C248.439 74.8483 247.642 74.0515 246.659 74.0515C245.676 74.0515 244.879 74.8483 244.879 75.8313Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 75.8313C238.72 76.8142 239.517 77.611 240.5 77.611C241.483 77.611 242.28 76.8142 242.28 75.8313C242.28 74.8483 241.483 74.0515 240.5 74.0515C239.517 74.0515 238.72 74.8483 238.72 75.8313Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.551 75.8365C232.551 76.8195 233.348 77.6163 234.331 77.6163C235.314 77.6163 236.111 76.8195 236.111 75.8365C236.111 74.8536 235.314 74.0568 234.331 74.0568C233.348 74.0568 232.551 74.8536 232.551 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 75.8365C226.392 76.8195 227.189 77.6163 228.172 77.6163C229.155 77.6163 229.951 76.8195 229.951 75.8365C229.951 74.8536 229.155 74.0568 228.172 74.0568C227.189 74.0568 226.392 74.8536 226.392 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.175 75.8365C220.175 76.8195 220.972 77.6163 221.955 77.6163C222.938 77.6163 223.735 76.8195 223.735 75.8365C223.735 74.8536 222.938 74.0568 221.955 74.0568C220.972 74.0568 220.175 74.8536 220.175 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 75.8365C214.017 76.8195 214.813 77.6163 215.796 77.6163C216.779 77.6163 217.576 76.8195 217.576 75.8365C217.576 74.8536 216.779 74.0568 215.796 74.0568C214.813 74.0568 214.017 74.8536 214.017 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.868 75.8261C207.868 76.809 208.665 77.6058 209.648 77.6058C210.631 77.6058 211.427 76.809 211.427 75.8261C211.427 74.8431 210.631 74.0463 209.648 74.0463C208.665 74.0463 207.868 74.8431 207.868 75.8261Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 75.8261C201.709 76.809 202.506 77.6058 203.489 77.6058C204.471 77.6058 205.268 76.809 205.268 75.8261C205.268 74.8431 204.471 74.0463 203.489 74.0463C202.506 74.0463 201.709 74.8431 201.709 75.8261Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.508 75.8365C195.508 76.8194 196.305 77.6163 197.288 77.6163C198.271 77.6163 199.068 76.8194 199.068 75.8365C199.068 74.8535 198.271 74.0567 197.288 74.0567C196.305 74.0567 195.508 74.8535 195.508 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 75.8365C189.349 76.8194 190.146 77.6163 191.129 77.6163C192.112 77.6163 192.908 76.8194 192.908 75.8365C192.908 74.8535 192.112 74.0567 191.129 74.0567C190.146 74.0567 189.349 74.8535 189.349 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.185 75.8365C183.185 76.8194 183.982 77.6163 184.965 77.6163C185.948 77.6163 186.745 76.8194 186.745 75.8365C186.745 74.8535 185.948 74.0567 184.965 74.0567C183.982 74.0567 183.185 74.8535 183.185 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 75.8365C177.026 76.8194 177.823 77.6163 178.806 77.6163C179.789 77.6163 180.585 76.8194 180.585 75.8365C180.585 74.8535 179.789 74.0567 178.806 74.0567C177.823 74.0567 177.026 74.8535 177.026 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.825 75.8365C170.825 76.8194 171.622 77.6163 172.605 77.6163C173.588 77.6163 174.385 76.8194 174.385 75.8365C174.385 74.8535 173.588 74.0567 172.605 74.0567C171.622 74.0567 170.825 74.8535 170.825 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 75.8365C164.666 76.8194 165.463 77.6163 166.446 77.6163C167.429 77.6163 168.225 76.8194 168.225 75.8365C168.225 74.8536 167.429 74.0567 166.446 74.0567C165.463 74.0567 164.666 74.8536 164.666 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.53 81.1212C303.53 82.1042 304.327 82.901 305.31 82.901C306.293 82.901 307.09 82.1042 307.09 81.1212C307.09 80.1383 306.293 79.3414 305.31 79.3414C304.327 79.3414 303.53 80.1383 303.53 81.1212Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.371 81.1212C297.371 82.1042 298.168 82.901 299.151 82.901C300.134 82.901 300.93 82.1042 300.93 81.1212C300.93 80.1383 300.134 79.3415 299.151 79.3415C298.168 79.3415 297.371 80.1383 297.371 81.1212Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.155 81.1212C291.155 82.1042 291.951 82.901 292.934 82.901C293.917 82.901 294.714 82.1042 294.714 81.1212C294.714 80.1383 293.917 79.3415 292.934 79.3415C291.951 79.3415 291.155 80.1383 291.155 81.1212Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.995 81.1212C284.995 82.1042 285.792 82.901 286.775 82.901C287.758 82.901 288.555 82.1042 288.555 81.1212C288.555 80.1383 287.758 79.3415 286.775 79.3415C285.792 79.3415 284.995 80.1383 284.995 81.1212Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.847 81.1121C278.847 82.0951 279.644 82.8919 280.626 82.8919C281.609 82.8919 282.406 82.0951 282.406 81.1121C282.406 80.1292 281.609 79.3324 280.626 79.3324C279.644 79.3324 278.847 80.1292 278.847 81.1121Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.688 81.1121C272.688 82.0951 273.485 82.8919 274.468 82.8919C275.451 82.8919 276.248 82.0951 276.248 81.1121C276.248 80.1292 275.451 79.3324 274.468 79.3324C273.485 79.3324 272.688 80.1292 272.688 81.1121Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.489 81.1212C266.489 82.1042 267.286 82.901 268.269 82.901C269.252 82.901 270.048 82.1042 270.048 81.1212C270.048 80.1383 269.252 79.3415 268.269 79.3415C267.286 79.3415 266.489 80.1383 266.489 81.1212Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.33 81.1212C260.33 82.1042 261.126 82.901 262.109 82.901C263.092 82.901 263.889 82.1042 263.889 81.1212C263.889 80.1383 263.092 79.3415 262.109 79.3415C261.126 79.3415 260.33 80.1383 260.33 81.1212Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.164 81.1212C254.164 82.1042 254.961 82.901 255.944 82.901C256.927 82.901 257.723 82.1042 257.723 81.1212C257.723 80.1383 256.927 79.3415 255.944 79.3415C254.961 79.3415 254.164 80.1383 254.164 81.1212Z"
            fill="#B8B7B7"
          />
          <path
            d="M248.005 81.1212C248.005 82.1042 248.802 82.901 249.785 82.901C250.768 82.901 251.564 82.1042 251.564 81.1212C251.564 80.1383 250.768 79.3415 249.785 79.3415C248.802 79.3415 248.005 80.1383 248.005 81.1212Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.806 81.1213C241.806 82.1042 242.603 82.901 243.586 82.901C244.569 82.901 245.365 82.1042 245.365 81.1213C245.365 80.1383 244.569 79.3415 243.586 79.3415C242.603 79.3415 241.806 80.1383 241.806 81.1213Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.647 81.1213C235.647 82.1042 236.443 82.901 237.426 82.901C238.409 82.901 239.206 82.1042 239.206 81.1213C239.206 80.1383 238.409 79.3415 237.426 79.3415C236.443 79.3415 235.647 80.1383 235.647 81.1213Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.477 81.1265C229.477 82.1094 230.274 82.9062 231.257 82.9062C232.24 82.9062 233.037 82.1094 233.037 81.1265C233.037 80.1435 232.24 79.3467 231.257 79.3467C230.274 79.3467 229.477 80.1435 229.477 81.1265Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.318 81.1265C223.318 82.1094 224.115 82.9062 225.098 82.9062C226.081 82.9062 226.877 82.1094 226.877 81.1265C226.877 80.1435 226.081 79.3467 225.098 79.3467C224.115 79.3467 223.318 80.1435 223.318 81.1265Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.102 81.1265C217.102 82.1094 217.898 82.9062 218.881 82.9062C219.864 82.9062 220.661 82.1094 220.661 81.1265C220.661 80.1435 219.864 79.3467 218.881 79.3467C217.898 79.3467 217.102 80.1435 217.102 81.1265Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.943 81.1265C210.943 82.1094 211.739 82.9062 212.722 82.9062C213.705 82.9062 214.502 82.1094 214.502 81.1265C214.502 80.1435 213.705 79.3467 212.722 79.3467C211.739 79.3467 210.943 80.1435 210.943 81.1265Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.794 81.1174C204.794 82.1003 205.591 82.8971 206.574 82.8971C207.557 82.8971 208.354 82.1003 208.354 81.1174C208.354 80.1344 207.557 79.3376 206.574 79.3376C205.591 79.3376 204.794 80.1344 204.794 81.1174Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.635 81.1174C198.635 82.1003 199.432 82.8971 200.415 82.8971C201.398 82.8971 202.195 82.1003 202.195 81.1174C202.195 80.1344 201.398 79.3376 200.415 79.3376C199.432 79.3376 198.635 80.1344 198.635 81.1174Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.434 81.1265C192.434 82.1094 193.231 82.9062 194.214 82.9062C195.197 82.9062 195.994 82.1094 195.994 81.1265C195.994 80.1435 195.197 79.3467 194.214 79.3467C193.231 79.3467 192.434 80.1435 192.434 81.1265Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.275 81.1265C186.275 82.1094 187.072 82.9062 188.055 82.9062C189.038 82.9062 189.835 82.1094 189.835 81.1265C189.835 80.1435 189.038 79.3467 188.055 79.3467C187.072 79.3467 186.275 80.1435 186.275 81.1265Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.111 81.1265C180.111 82.1094 180.908 82.9062 181.891 82.9062C182.874 82.9062 183.671 82.1094 183.671 81.1265C183.671 80.1435 182.874 79.3467 181.891 79.3467C180.908 79.3467 180.111 80.1435 180.111 81.1265Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.952 81.1265C173.952 82.1094 174.749 82.9062 175.732 82.9062C176.715 82.9062 177.512 82.1094 177.512 81.1265C177.512 80.1435 176.715 79.3467 175.732 79.3467C174.749 79.3467 173.952 80.1435 173.952 81.1265Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.751 81.1265C167.751 82.1094 168.548 82.9062 169.531 82.9062C170.514 82.9062 171.311 82.1094 171.311 81.1265C171.311 80.1435 170.514 79.3467 169.531 79.3467C168.548 79.3467 167.751 80.1435 167.751 81.1265Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.593 81.1265C161.593 82.1094 162.389 82.9062 163.372 82.9062C164.355 82.9062 165.152 82.1094 165.152 81.1265C165.152 80.1435 164.355 79.3467 163.372 79.3467C162.389 79.3467 161.593 80.1435 161.593 81.1265Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 86.4229C300.446 87.4058 301.243 88.2027 302.226 88.2027C303.209 88.2027 304.005 87.4058 304.005 86.4229C304.005 85.44 303.209 84.6431 302.226 84.6431C301.243 84.6431 300.446 85.44 300.446 86.4229Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.287 86.4229C294.287 87.4058 295.083 88.2027 296.066 88.2027C297.049 88.2027 297.846 87.4058 297.846 86.4229C297.846 85.44 297.049 84.6431 296.066 84.6431C295.083 84.6431 294.287 85.44 294.287 86.4229Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 86.4229C288.07 87.4058 288.867 88.2027 289.85 88.2027C290.833 88.2027 291.63 87.4058 291.63 86.4229C291.63 85.44 290.833 84.6431 289.85 84.6431C288.867 84.6431 288.07 85.44 288.07 86.4229Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.912 86.4229C281.912 87.4058 282.708 88.2027 283.691 88.2027C284.674 88.2027 285.471 87.4058 285.471 86.4229C285.471 85.44 284.674 84.6431 283.691 84.6431C282.708 84.6431 281.912 85.44 281.912 86.4229Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 86.4138C275.763 87.3967 276.56 88.1935 277.542 88.1935C278.525 88.1935 279.322 87.3967 279.322 86.4138C279.322 85.4308 278.525 84.634 277.542 84.634C276.56 84.634 275.763 85.4308 275.763 86.4138Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.604 86.4138C269.604 87.3967 270.401 88.1935 271.384 88.1935C272.367 88.1935 273.164 87.3967 273.164 86.4138C273.164 85.4308 272.367 84.634 271.384 84.634C270.401 84.634 269.604 85.4308 269.604 86.4138Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 86.4229C263.403 87.4058 264.2 88.2027 265.183 88.2027C266.166 88.2027 266.963 87.4058 266.963 86.4229C266.963 85.44 266.166 84.6431 265.183 84.6431C264.2 84.6431 263.403 85.44 263.403 86.4229Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.244 86.4229C257.244 87.4058 258.041 88.2027 259.024 88.2027C260.007 88.2027 260.803 87.4058 260.803 86.4229C260.803 85.44 260.007 84.6431 259.024 84.6431C258.041 84.6431 257.244 85.44 257.244 86.4229Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 86.4229C251.08 87.4058 251.876 88.2027 252.859 88.2027C253.842 88.2027 254.639 87.4058 254.639 86.4229C254.639 85.44 253.842 84.6431 252.859 84.6431C251.876 84.6431 251.08 85.44 251.08 86.4229Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.921 86.4229C244.921 87.4058 245.718 88.2027 246.701 88.2027C247.684 88.2027 248.48 87.4058 248.48 86.4229C248.48 85.44 247.684 84.6431 246.701 84.6431C245.718 84.6431 244.921 85.44 244.921 86.4229Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 86.4229C238.72 87.4058 239.517 88.2027 240.5 88.2027C241.483 88.2027 242.28 87.4058 242.28 86.4229C242.28 85.44 241.483 84.6431 240.5 84.6431C239.517 84.6431 238.72 85.44 238.72 86.4229Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.561 86.4229C232.561 87.4058 233.358 88.2027 234.341 88.2027C235.324 88.2027 236.121 87.4058 236.121 86.4229C236.121 85.44 235.324 84.6431 234.341 84.6431C233.358 84.6431 232.561 85.44 232.561 86.4229Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 86.4281C226.392 87.411 227.189 88.2079 228.172 88.2079C229.155 88.2079 229.951 87.411 229.951 86.4281C229.951 85.4452 229.155 84.6483 228.172 84.6483C227.189 84.6483 226.392 85.4452 226.392 86.4281Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.233 86.4281C220.233 87.411 221.03 88.2079 222.012 88.2079C222.995 88.2079 223.792 87.411 223.792 86.4281C223.792 85.4452 222.995 84.6483 222.012 84.6483C221.03 84.6483 220.233 85.4452 220.233 86.4281Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 86.4281C214.017 87.411 214.813 88.2079 215.796 88.2079C216.779 88.2079 217.576 87.411 217.576 86.4281C217.576 85.4451 216.779 84.6483 215.796 84.6483C214.813 84.6483 214.017 85.4451 214.017 86.4281Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.857 86.4281C207.857 87.411 208.654 88.2079 209.637 88.2079C210.62 88.2079 211.417 87.411 211.417 86.4281C211.417 85.4451 210.62 84.6483 209.637 84.6483C208.654 84.6483 207.857 85.4451 207.857 86.4281Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 86.4177C201.709 87.4006 202.506 88.1975 203.489 88.1975C204.471 88.1975 205.268 87.4006 205.268 86.4177C205.268 85.4348 204.471 84.6379 203.489 84.6379C202.506 84.6379 201.709 85.4348 201.709 86.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.55 86.4177C195.55 87.4006 196.347 88.1974 197.33 88.1974C198.313 88.1974 199.109 87.4006 199.109 86.4177C199.109 85.4347 198.313 84.6379 197.33 84.6379C196.347 84.6379 195.55 85.4347 195.55 86.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 86.4281C189.349 87.411 190.146 88.2079 191.129 88.2079C192.112 88.2079 192.908 87.411 192.908 86.4281C192.908 85.4452 192.112 84.6483 191.129 84.6483C190.146 84.6483 189.349 85.4452 189.349 86.4281Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.191 86.4281C183.191 87.411 183.988 88.2079 184.971 88.2079C185.954 88.2079 186.751 87.411 186.751 86.4281C186.751 85.4452 185.954 84.6483 184.971 84.6483C183.988 84.6483 183.191 85.4452 183.191 86.4281Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 86.4281C177.026 87.411 177.823 88.2078 178.806 88.2078C179.789 88.2078 180.585 87.411 180.585 86.4281C180.585 85.4451 179.789 84.6483 178.806 84.6483C177.823 84.6483 177.026 85.4451 177.026 86.4281Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.867 86.4281C170.867 87.411 171.664 88.2078 172.646 88.2078C173.629 88.2078 174.426 87.411 174.426 86.4281C174.426 85.4451 173.629 84.6483 172.646 84.6483C171.664 84.6483 170.867 85.4451 170.867 86.4281Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 86.4281C164.666 87.411 165.463 88.2078 166.446 88.2078C167.429 88.2078 168.225 87.411 168.225 86.4281C168.225 85.4451 167.429 84.6483 166.446 84.6483C165.463 84.6483 164.666 85.4451 164.666 86.4281Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.508 86.4281C158.508 87.411 159.305 88.2078 160.288 88.2078C161.271 88.2078 162.068 87.411 162.068 86.4281C162.068 85.4451 161.271 84.6483 160.288 84.6483C159.305 84.6483 158.508 85.4451 158.508 86.4281Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.53 91.6673C303.53 92.6503 304.327 93.4471 305.31 93.4471C306.293 93.4471 307.09 92.6503 307.09 91.6673C307.09 90.6844 306.293 89.8876 305.31 89.8876C304.327 89.8876 303.53 90.6844 303.53 91.6673Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.371 91.6673C297.371 92.6503 298.168 93.4471 299.151 93.4471C300.134 93.4471 300.93 92.6503 300.93 91.6673C300.93 90.6844 300.134 89.8876 299.151 89.8876C298.168 89.8876 297.371 90.6844 297.371 91.6673Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.155 91.6673C291.155 92.6503 291.951 93.4471 292.934 93.4471C293.917 93.4471 294.714 92.6503 294.714 91.6673C294.714 90.6844 293.917 89.8876 292.934 89.8876C291.951 89.8876 291.155 90.6844 291.155 91.6673Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.995 91.6673C284.995 92.6503 285.792 93.4471 286.775 93.4471C287.758 93.4471 288.555 92.6503 288.555 91.6673C288.555 90.6844 287.758 89.8876 286.775 89.8876C285.792 89.8876 284.995 90.6844 284.995 91.6673Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.847 91.6582C278.847 92.6412 279.644 93.438 280.626 93.438C281.609 93.438 282.406 92.6412 282.406 91.6582C282.406 90.6753 281.609 89.8785 280.626 89.8785C279.644 89.8785 278.847 90.6753 278.847 91.6582Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.688 91.6582C272.688 92.6412 273.485 93.438 274.468 93.438C275.451 93.438 276.248 92.6412 276.248 91.6582C276.248 90.6753 275.451 89.8785 274.468 89.8785C273.485 89.8785 272.688 90.6753 272.688 91.6582Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.489 91.6673C266.489 92.6503 267.286 93.4471 268.269 93.4471C269.252 93.4471 270.048 92.6503 270.048 91.6673C270.048 90.6844 269.252 89.8876 268.269 89.8876C267.286 89.8876 266.489 90.6844 266.489 91.6673Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.33 91.6673C260.33 92.6503 261.126 93.4471 262.109 93.4471C263.092 93.4471 263.889 92.6503 263.889 91.6673C263.889 90.6844 263.092 89.8876 262.109 89.8876C261.126 89.8876 260.33 90.6844 260.33 91.6673Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.164 91.6673C254.164 92.6503 254.961 93.4471 255.944 93.4471C256.927 93.4471 257.723 92.6503 257.723 91.6673C257.723 90.6844 256.927 89.8876 255.944 89.8876C254.961 89.8876 254.164 90.6844 254.164 91.6673Z"
            fill="#B8B7B7"
          />
          <path
            d="M248.005 91.6673C248.005 92.6503 248.802 93.4471 249.785 93.4471C250.768 93.4471 251.564 92.6503 251.564 91.6673C251.564 90.6844 250.768 89.8876 249.785 89.8876C248.802 89.8876 248.005 90.6844 248.005 91.6673Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.806 91.6673C241.806 92.6503 242.603 93.4471 243.586 93.4471C244.569 93.4471 245.365 92.6503 245.365 91.6673C245.365 90.6844 244.569 89.8876 243.586 89.8876C242.603 89.8876 241.806 90.6844 241.806 91.6673Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.647 91.6673C235.647 92.6503 236.443 93.4471 237.426 93.4471C238.409 93.4471 239.206 92.6503 239.206 91.6673C239.206 90.6844 238.409 89.8876 237.426 89.8876C236.443 89.8876 235.647 90.6844 235.647 91.6673Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.477 91.6725C229.477 92.6555 230.274 93.4523 231.257 93.4523C232.24 93.4523 233.037 92.6555 233.037 91.6725C233.037 90.6896 232.24 89.8928 231.257 89.8928C230.274 89.8928 229.477 90.6896 229.477 91.6725Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.318 91.6725C223.318 92.6555 224.115 93.4523 225.098 93.4523C226.081 93.4523 226.877 92.6555 226.877 91.6725C226.877 90.6896 226.081 89.8928 225.098 89.8928C224.115 89.8928 223.318 90.6896 223.318 91.6725Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.102 91.6725C217.102 92.6555 217.898 93.4523 218.881 93.4523C219.864 93.4523 220.661 92.6555 220.661 91.6725C220.661 90.6896 219.864 89.8928 218.881 89.8928C217.898 89.8928 217.102 90.6896 217.102 91.6725Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.943 91.6725C210.943 92.6555 211.739 93.4523 212.722 93.4523C213.705 93.4523 214.502 92.6555 214.502 91.6725C214.502 90.6896 213.705 89.8928 212.722 89.8928C211.739 89.8928 210.943 90.6896 210.943 91.6725Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.794 91.6635C204.794 92.6464 205.591 93.4433 206.574 93.4433C207.557 93.4433 208.354 92.6464 208.354 91.6635C208.354 90.6806 207.557 89.8837 206.574 89.8837C205.591 89.8837 204.794 90.6806 204.794 91.6635Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.635 91.6635C198.635 92.6464 199.432 93.4433 200.415 93.4433C201.398 93.4433 202.195 92.6464 202.195 91.6635C202.195 90.6806 201.398 89.8837 200.415 89.8837C199.432 89.8837 198.635 90.6806 198.635 91.6635Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.434 91.6725C192.434 92.6555 193.231 93.4523 194.214 93.4523C195.197 93.4523 195.994 92.6555 195.994 91.6725C195.994 90.6896 195.197 89.8928 194.214 89.8928C193.231 89.8928 192.434 90.6896 192.434 91.6725Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.275 91.6725C186.275 92.6555 187.072 93.4523 188.055 93.4523C189.038 93.4523 189.835 92.6555 189.835 91.6725C189.835 90.6896 189.038 89.8928 188.055 89.8928C187.072 89.8928 186.275 90.6896 186.275 91.6725Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.111 91.6725C180.111 92.6555 180.908 93.4523 181.891 93.4523C182.874 93.4523 183.671 92.6555 183.671 91.6725C183.671 90.6896 182.874 89.8928 181.891 89.8928C180.908 89.8928 180.111 90.6896 180.111 91.6725Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.952 91.6725C173.952 92.6555 174.749 93.4523 175.732 93.4523C176.715 93.4523 177.512 92.6555 177.512 91.6725C177.512 90.6896 176.715 89.8928 175.732 89.8928C174.749 89.8928 173.952 90.6896 173.952 91.6725Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.751 91.6725C167.751 92.6555 168.548 93.4523 169.531 93.4523C170.514 93.4523 171.311 92.6555 171.311 91.6725C171.311 90.6896 170.514 89.8928 169.531 89.8928C168.548 89.8928 167.751 90.6896 167.751 91.6725Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.593 91.6725C161.593 92.6555 162.389 93.4523 163.372 93.4523C164.355 93.4523 165.152 92.6555 165.152 91.6725C165.152 90.6896 164.355 89.8928 163.372 89.8928C162.389 89.8928 161.593 90.6896 161.593 91.6725Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 86.3943C306.603 87.3772 307.4 88.1741 308.383 88.1741C309.366 88.1741 310.163 87.3772 310.163 86.3943C310.163 85.4113 309.366 84.6145 308.383 84.6145C307.4 84.6145 306.603 85.4113 306.603 86.3943Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.412 7.28932C155.412 8.27226 156.209 9.06909 157.192 9.06909C158.175 9.06909 158.972 8.27226 158.972 7.28932C158.972 6.30638 158.175 5.50955 157.192 5.50955C156.209 5.50955 155.412 6.30638 155.412 7.28932Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.254 7.28932C149.254 8.27226 150.051 9.06909 151.033 9.06909C152.016 9.06909 152.813 8.27226 152.813 7.28932C152.813 6.30638 152.016 5.50955 151.033 5.50955C150.051 5.50955 149.254 6.30638 149.254 7.28932Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.037 7.28932C143.037 8.27226 143.834 9.06909 144.817 9.06909C145.8 9.06909 146.597 8.27226 146.597 7.28932C146.597 6.30638 145.8 5.50955 144.817 5.50955C143.834 5.50955 143.037 6.30638 143.037 7.28932Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.878 7.28932C136.878 8.27226 137.675 9.06909 138.658 9.06909C139.641 9.06909 140.438 8.27226 140.438 7.28932C140.438 6.30638 139.641 5.50955 138.658 5.50955C137.675 5.50955 136.878 6.30638 136.878 7.28932Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.73 7.2802C130.73 8.26314 131.527 9.05997 132.51 9.05997C133.493 9.05997 134.289 8.26314 134.289 7.2802C134.289 6.29726 133.493 5.50043 132.51 5.50043C131.527 5.50043 130.73 6.29726 130.73 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.571 7.2802C124.571 8.26314 125.367 9.05997 126.35 9.05997C127.333 9.05997 128.13 8.26314 128.13 7.2802C128.13 6.29726 127.333 5.50043 126.35 5.50043C125.367 5.50043 124.571 6.29726 124.571 7.2802Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.37 7.28932C118.37 8.27226 119.167 9.06909 120.15 9.06909C121.133 9.06909 121.929 8.27226 121.929 7.28932C121.929 6.30638 121.133 5.50955 120.15 5.50955C119.167 5.50955 118.37 6.30638 118.37 7.28932Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.211 7.28932C112.211 8.27226 113.008 9.06909 113.99 9.06909C114.973 9.06909 115.77 8.27226 115.77 7.28932C115.77 6.30638 114.973 5.50955 113.99 5.50955C113.008 5.50955 112.211 6.30638 112.211 7.28932Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.047 7.28932C106.047 8.27226 106.844 9.06909 107.827 9.06909C108.81 9.06909 109.606 8.27226 109.606 7.28932C109.606 6.30638 108.81 5.50955 107.827 5.50955C106.844 5.50955 106.047 6.30638 106.047 7.28932Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8877 7.28932C99.8877 8.27226 100.685 9.06909 101.667 9.06909C102.65 9.06909 103.447 8.27226 103.447 7.28932C103.447 6.30638 102.65 5.50955 101.667 5.50955C100.685 5.50955 99.8877 6.30638 99.8877 7.28932Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.687 7.28932C93.687 8.27226 94.4839 9.06909 95.4668 9.06909C96.4498 9.06909 97.2466 8.27226 97.2466 7.28932C97.2466 6.30638 96.4498 5.50955 95.4668 5.50955C94.4839 5.50955 93.687 6.30638 93.687 7.28932Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5281 7.28932C87.5281 8.27226 88.3249 9.06909 89.3079 9.06909C90.2908 9.06909 91.0876 8.27226 91.0876 7.28932C91.0876 6.30638 90.2908 5.50955 89.3079 5.50955C88.3249 5.50955 87.5281 6.30638 87.5281 7.28932Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3587 7.29451C81.3587 8.27745 82.1555 9.07428 83.1384 9.07428C84.1214 9.07428 84.9182 8.27745 84.9182 7.29451C84.9182 6.31157 84.1214 5.51474 83.1384 5.51474C82.1555 5.51474 81.3587 6.31157 81.3587 7.29451Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.1996 7.29451C75.1996 8.27745 75.9964 9.07428 76.9794 9.07428C77.9623 9.07428 78.7592 8.27745 78.7592 7.29451C78.7592 6.31157 77.9623 5.51474 76.9794 5.51474C75.9964 5.51474 75.1996 6.31157 75.1996 7.29451Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9832 7.29451C68.9832 8.27745 69.78 9.07428 70.763 9.07428C71.7459 9.07428 72.5427 8.27745 72.5427 7.29451C72.5427 6.31157 71.7459 5.51474 70.763 5.51474C69.78 5.51474 68.9832 6.31157 68.9832 7.29451Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8244 7.29451C62.8244 8.27745 63.6212 9.07428 64.6041 9.07428C65.5871 9.07428 66.3839 8.27745 66.3839 7.29451C66.3839 6.31157 65.5871 5.51474 64.6041 5.51474C63.6212 5.51474 62.8244 6.31157 62.8244 7.29451Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6756 7.28416C56.6756 8.2671 57.4724 9.06394 58.4553 9.06394C59.4383 9.06394 60.2351 8.26711 60.2351 7.28417C60.2351 6.30122 59.4383 5.50439 58.4553 5.50439C57.4724 5.50439 56.6756 6.30122 56.6756 7.28416Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5166 7.28416C50.5166 8.2671 51.3135 9.06394 52.2964 9.06394C53.2793 9.06394 54.0762 8.26711 54.0762 7.28417C54.0762 6.30122 53.2793 5.50439 52.2964 5.50439C51.3135 5.50439 50.5166 6.30122 50.5166 7.28416Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3161 7.29451C44.3161 8.27745 45.1129 9.07428 46.0958 9.07428C47.0788 9.07428 47.8756 8.27745 47.8756 7.29451C47.8756 6.31157 47.0788 5.51474 46.0958 5.51474C45.1129 5.51474 44.3161 6.31157 44.3161 7.29451Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1582 7.29451C38.1582 8.27745 38.9551 9.07428 39.938 9.07428C40.9209 9.07428 41.7178 8.27745 41.7178 7.29451C41.7178 6.31157 40.9209 5.51474 39.938 5.51474C38.9551 5.51474 38.1582 6.31157 38.1582 7.29451Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.9926 7.29451C31.9926 8.27745 32.7894 9.07428 33.7724 9.07428C34.7553 9.07428 35.5521 8.27745 35.5521 7.29451C35.5521 6.31157 34.7553 5.51474 33.7724 5.51474C32.7894 5.51474 31.9926 6.31157 31.9926 7.29451Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8335 7.29451C25.8335 8.27745 26.6304 9.07428 27.6133 9.07428C28.5962 9.07428 29.3931 8.27745 29.3931 7.29451C29.3931 6.31157 28.5962 5.51474 27.6133 5.51474C26.6304 5.51474 25.8335 6.31157 25.8335 7.29451Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6332 7.29451C19.6332 8.27745 20.43 9.07428 21.413 9.07428C22.3959 9.07428 23.1927 8.27745 23.1927 7.29451C23.1927 6.31157 22.3959 5.51474 21.413 5.51474C20.43 5.51474 19.6332 6.31157 19.6332 7.29451Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4754 7.29451C13.4754 8.27745 14.2722 9.07428 15.2551 9.07428C16.2381 9.07428 17.0349 8.27745 17.0349 7.29451C17.0349 6.31157 16.2381 5.51474 15.2551 5.51474C14.2722 5.51474 13.4754 6.31157 13.4754 7.29451Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.327 12.591C152.327 13.5739 153.124 14.3707 154.107 14.3707C155.09 14.3707 155.887 13.5739 155.887 12.591C155.887 11.608 155.09 10.8112 154.107 10.8112C153.124 10.8112 152.327 11.608 152.327 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.168 12.591C146.168 13.5739 146.965 14.3707 147.948 14.3707C148.931 14.3707 149.728 13.5739 149.728 12.591C149.728 11.608 148.931 10.8112 147.948 10.8112C146.965 10.8112 146.168 11.608 146.168 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.952 12.591C139.952 13.5739 140.749 14.3707 141.732 14.3707C142.715 14.3707 143.512 13.5739 143.512 12.591C143.512 11.608 142.715 10.8112 141.732 10.8112C140.749 10.8112 139.952 11.608 139.952 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.793 12.591C133.793 13.5739 134.59 14.3707 135.573 14.3707C136.556 14.3707 137.353 13.5739 137.353 12.591C137.353 11.608 136.556 10.8112 135.573 10.8112C134.59 10.8112 133.793 11.608 133.793 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.644 12.5819C127.644 13.5648 128.441 14.3616 129.424 14.3616C130.407 14.3616 131.204 13.5648 131.204 12.5819C131.204 11.5989 130.407 10.8021 129.424 10.8021C128.441 10.8021 127.644 11.5989 127.644 12.5819Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.485 12.5819C121.485 13.5648 122.282 14.3616 123.265 14.3616C124.248 14.3616 125.045 13.5648 125.045 12.5819C125.045 11.5989 124.248 10.8021 123.265 10.8021C122.282 10.8021 121.485 11.5989 121.485 12.5819Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.285 12.591C115.285 13.5739 116.081 14.3707 117.064 14.3707C118.047 14.3707 118.844 13.5739 118.844 12.591C118.844 11.608 118.047 10.8112 117.064 10.8112C116.081 10.8112 115.285 11.608 115.285 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.127 12.591C109.127 13.5739 109.924 14.3707 110.907 14.3707C111.89 14.3707 112.687 13.5739 112.687 12.591C112.687 11.608 111.89 10.8112 110.907 10.8112C109.924 10.8112 109.127 11.608 109.127 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.961 12.591C102.961 13.5739 103.758 14.3707 104.741 14.3707C105.724 14.3707 106.521 13.5739 106.521 12.591C106.521 11.608 105.724 10.8112 104.741 10.8112C103.758 10.8112 102.961 11.608 102.961 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.802 12.591C96.802 13.5739 97.5989 14.3707 98.5818 14.3707C99.5647 14.3707 100.362 13.5739 100.362 12.591C100.362 11.608 99.5647 10.8112 98.5818 10.8112C97.5989 10.8112 96.802 11.608 96.802 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6015 12.591C90.6015 13.5739 91.3983 14.3707 92.3812 14.3707C93.3642 14.3707 94.161 13.5739 94.161 12.591C94.161 11.608 93.3642 10.8112 92.3812 10.8112C91.3983 10.8112 90.6015 11.608 90.6015 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.444 12.591C84.444 13.5739 85.2408 14.3707 86.2238 14.3707C87.2067 14.3707 88.0035 13.5739 88.0035 12.591C88.0035 11.608 87.2067 10.8112 86.2238 10.8112C85.2408 10.8112 84.444 11.608 84.444 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2733 12.5949C78.2733 13.5778 79.0702 14.3746 80.0531 14.3746C81.0361 14.3746 81.8329 13.5778 81.8329 12.5949C81.8329 11.6119 81.0361 10.8151 80.0531 10.8151C79.0702 10.8151 78.2733 11.6119 78.2733 12.5949Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.114 12.5949C72.114 13.5778 72.9109 14.3746 73.8938 14.3746C74.8768 14.3746 75.6736 13.5778 75.6736 12.5949C75.6736 11.6119 74.8768 10.8151 73.8938 10.8151C72.9109 10.8151 72.114 11.6119 72.114 12.5949Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.8981 12.5949C65.8981 13.5778 66.6949 14.3746 67.6779 14.3746C68.6608 14.3746 69.4576 13.5778 69.4576 12.5949C69.4576 11.6119 68.6608 10.8151 67.6779 10.8151C66.6949 10.8151 65.8981 11.6119 65.8981 12.5949Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.7388 12.5949C59.7388 13.5778 60.5356 14.3746 61.5186 14.3746C62.5015 14.3746 63.2983 13.5778 63.2983 12.5949C63.2983 11.6119 62.5015 10.8151 61.5186 10.8151C60.5356 10.8151 59.7388 11.6119 59.7388 12.5949Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.5902 12.5858C53.5902 13.5687 54.3871 14.3655 55.37 14.3655C56.3529 14.3655 57.1498 13.5687 57.1498 12.5858C57.1498 11.6028 56.3529 10.806 55.37 10.806C54.3871 10.806 53.5902 11.6028 53.5902 12.5858Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4311 12.5858C47.4311 13.5687 48.2279 14.3655 49.2108 14.3655C50.1938 14.3655 50.9906 13.5687 50.9906 12.5858C50.9906 11.6028 50.1938 10.806 49.2108 10.806C48.2279 10.806 47.4311 11.6028 47.4311 12.5858Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2321 12.5949C41.2321 13.5778 42.0289 14.3746 43.0119 14.3746C43.9948 14.3746 44.7916 13.5778 44.7916 12.5949C44.7916 11.6119 43.9948 10.8151 43.0119 10.8151C42.0289 10.8151 41.2321 11.6119 41.2321 12.5949Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.073 12.5949C35.073 13.5778 35.8699 14.3746 36.8528 14.3746C37.8357 14.3746 38.6326 13.5778 38.6326 12.5949C38.6326 11.6119 37.8357 10.8151 36.8528 10.8151C35.8699 10.8151 35.073 11.6119 35.073 12.5949Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9074 12.5949C28.9074 13.5778 29.7042 14.3746 30.6871 14.3746C31.6701 14.3746 32.4669 13.5778 32.4669 12.5949C32.4669 11.6119 31.6701 10.8151 30.6871 10.8151C29.7042 10.8151 28.9074 11.6119 28.9074 12.5949Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7484 12.5949C22.7484 13.5778 23.5453 14.3746 24.5282 14.3746C25.5112 14.3746 26.308 13.5778 26.308 12.5949C26.308 11.6119 25.5112 10.8151 24.5282 10.8151C23.5453 10.8151 22.7484 11.6119 22.7484 12.5949Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.549 12.5949C16.549 13.5778 17.3458 14.3746 18.3287 14.3746C19.3117 14.3746 20.1085 13.5778 20.1085 12.5949C20.1085 11.6119 19.3117 10.8151 18.3288 10.8151C17.3458 10.8151 16.549 11.6119 16.549 12.5949Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.39 12.5949C10.39 13.5778 11.1869 14.3746 12.1698 14.3746C13.1528 14.3746 13.9496 13.5778 13.9496 12.5949C13.9496 11.6119 13.1528 10.8151 12.1698 10.8151C11.1869 10.8151 10.39 11.6119 10.39 12.5949Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.412 17.8354C155.412 18.8184 156.209 19.6152 157.192 19.6152C158.175 19.6152 158.972 18.8184 158.972 17.8354C158.972 16.8525 158.175 16.0557 157.192 16.0557C156.209 16.0557 155.412 16.8525 155.412 17.8354Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.254 17.8354C149.254 18.8184 150.051 19.6152 151.033 19.6152C152.016 19.6152 152.813 18.8184 152.813 17.8354C152.813 16.8525 152.016 16.0557 151.033 16.0557C150.051 16.0557 149.254 16.8525 149.254 17.8354Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.037 17.8354C143.037 18.8184 143.834 19.6152 144.817 19.6152C145.8 19.6152 146.597 18.8184 146.597 17.8354C146.597 16.8525 145.8 16.0557 144.817 16.0557C143.834 16.0557 143.037 16.8525 143.037 17.8354Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.878 17.8354C136.878 18.8184 137.675 19.6152 138.658 19.6152C139.641 19.6152 140.438 18.8184 140.438 17.8354C140.438 16.8525 139.641 16.0557 138.658 16.0557C137.675 16.0557 136.878 16.8525 136.878 17.8354Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.73 17.8264C130.73 18.8093 131.527 19.6061 132.51 19.6061C133.493 19.6061 134.289 18.8093 134.289 17.8264C134.289 16.8434 133.493 16.0466 132.51 16.0466C131.527 16.0466 130.73 16.8434 130.73 17.8264Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.571 17.8264C124.571 18.8093 125.367 19.6061 126.35 19.6061C127.333 19.6061 128.13 18.8093 128.13 17.8264C128.13 16.8434 127.333 16.0466 126.35 16.0466C125.367 16.0466 124.571 16.8434 124.571 17.8264Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.37 17.8354C118.37 18.8184 119.167 19.6152 120.15 19.6152C121.133 19.6152 121.929 18.8184 121.929 17.8354C121.929 16.8525 121.133 16.0557 120.15 16.0557C119.167 16.0557 118.37 16.8525 118.37 17.8354Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.211 17.8354C112.211 18.8184 113.008 19.6152 113.99 19.6152C114.973 19.6152 115.77 18.8184 115.77 17.8354C115.77 16.8525 114.973 16.0557 113.99 16.0557C113.008 16.0557 112.211 16.8525 112.211 17.8354Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.047 17.8354C106.047 18.8184 106.844 19.6152 107.827 19.6152C108.81 19.6152 109.606 18.8184 109.606 17.8354C109.606 16.8525 108.81 16.0557 107.827 16.0557C106.844 16.0557 106.047 16.8525 106.047 17.8354Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8877 17.8354C99.8877 18.8184 100.685 19.6152 101.667 19.6152C102.65 19.6152 103.447 18.8184 103.447 17.8354C103.447 16.8525 102.65 16.0557 101.667 16.0557C100.685 16.0557 99.8877 16.8525 99.8877 17.8354Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.687 17.8354C93.687 18.8184 94.4839 19.6152 95.4668 19.6152C96.4498 19.6152 97.2466 18.8184 97.2466 17.8354C97.2466 16.8525 96.4498 16.0557 95.4668 16.0557C94.4839 16.0557 93.687 16.8525 93.687 17.8354Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5281 17.8354C87.5281 18.8184 88.3249 19.6152 89.3079 19.6152C90.2908 19.6152 91.0876 18.8184 91.0876 17.8354C91.0876 16.8525 90.2908 16.0557 89.3079 16.0557C88.3249 16.0557 87.5281 16.8525 87.5281 17.8354Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3587 17.8407C81.3587 18.8236 82.1555 19.6204 83.1384 19.6204C84.1214 19.6204 84.9182 18.8236 84.9182 17.8407C84.9182 16.8577 84.1214 16.0609 83.1384 16.0609C82.1555 16.0609 81.3587 16.8577 81.3587 17.8407Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.1996 17.8407C75.1996 18.8236 75.9964 19.6204 76.9794 19.6204C77.9623 19.6204 78.7592 18.8236 78.7592 17.8407C78.7592 16.8577 77.9623 16.0609 76.9794 16.0609C75.9964 16.0609 75.1996 16.8577 75.1996 17.8407Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9832 17.8406C68.9832 18.8236 69.78 19.6204 70.763 19.6204C71.7459 19.6204 72.5427 18.8236 72.5427 17.8406C72.5427 16.8577 71.7459 16.0609 70.763 16.0609C69.78 16.0609 68.9832 16.8577 68.9832 17.8406Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8245 17.8407C62.8245 18.8236 63.6213 19.6204 64.6043 19.6204C65.5872 19.6204 66.384 18.8236 66.384 17.8407C66.384 16.8577 65.5872 16.0609 64.6043 16.0609C63.6213 16.0609 62.8245 16.8577 62.8245 17.8407Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6756 17.8303C56.6756 18.8132 57.4724 19.61 58.4553 19.61C59.4383 19.61 60.2351 18.8132 60.2351 17.8303C60.2351 16.8473 59.4383 16.0505 58.4553 16.0505C57.4724 16.0505 56.6756 16.8473 56.6756 17.8303Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5166 17.8303C50.5166 18.8132 51.3135 19.61 52.2964 19.61C53.2793 19.61 54.0762 18.8132 54.0762 17.8303C54.0762 16.8473 53.2793 16.0505 52.2964 16.0505C51.3135 16.0505 50.5166 16.8473 50.5166 17.8303Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3161 17.8407C44.3161 18.8236 45.1129 19.6204 46.0958 19.6204C47.0788 19.6204 47.8756 18.8236 47.8756 17.8407C47.8756 16.8577 47.0788 16.0609 46.0958 16.0609C45.1129 16.0609 44.3161 16.8577 44.3161 17.8407Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1582 17.8407C38.1582 18.8236 38.9551 19.6204 39.938 19.6204C40.9209 19.6204 41.7178 18.8236 41.7178 17.8407C41.7178 16.8577 40.9209 16.0609 39.938 16.0609C38.9551 16.0609 38.1582 16.8577 38.1582 17.8407Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.9926 17.8407C31.9926 18.8236 32.7894 19.6204 33.7724 19.6204C34.7553 19.6204 35.5521 18.8236 35.5521 17.8407C35.5521 16.8577 34.7553 16.0609 33.7724 16.0609C32.7894 16.0609 31.9926 16.8577 31.9926 17.8407Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8335 17.8407C25.8335 18.8236 26.6304 19.6204 27.6133 19.6204C28.5962 19.6204 29.3931 18.8236 29.3931 17.8407C29.3931 16.8577 28.5962 16.0609 27.6133 16.0609C26.6304 16.0609 25.8335 16.8577 25.8335 17.8407Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6332 17.8407C19.6332 18.8236 20.43 19.6205 21.413 19.6205C22.3959 19.6205 23.1927 18.8236 23.1927 17.8407C23.1927 16.8578 22.3959 16.0609 21.413 16.0609C20.43 16.0609 19.6332 16.8578 19.6332 17.8407Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4754 17.8407C13.4754 18.8236 14.2722 19.6205 15.2551 19.6205C16.2381 19.6205 17.0349 18.8236 17.0349 17.8407C17.0349 16.8578 16.2381 16.0609 15.2551 16.0609C14.2722 16.0609 13.4754 16.8578 13.4754 17.8407Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.338 23.1254C152.338 24.1083 153.135 24.9052 154.117 24.9052C155.1 24.9052 155.897 24.1083 155.897 23.1254C155.897 22.1425 155.1 21.3456 154.117 21.3456C153.135 21.3456 152.338 22.1425 152.338 23.1254Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.178 23.1254C146.178 24.1084 146.975 24.9052 147.958 24.9052C148.941 24.9052 149.738 24.1084 149.738 23.1254C149.738 22.1425 148.941 21.3456 147.958 21.3456C146.975 21.3456 146.178 22.1425 146.178 23.1254Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.963 23.1254C139.963 24.1084 140.76 24.9052 141.742 24.9052C142.725 24.9052 143.522 24.1084 143.522 23.1254C143.522 22.1425 142.725 21.3456 141.742 21.3456C140.76 21.3456 139.963 22.1425 139.963 23.1254Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.803 23.1254C133.803 24.1084 134.6 24.9052 135.583 24.9052C136.566 24.9052 137.363 24.1084 137.363 23.1254C137.363 22.1425 136.566 21.3456 135.583 21.3456C134.6 21.3456 133.803 22.1425 133.803 23.1254Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.655 23.1163C127.655 24.0993 128.452 24.8961 129.434 24.8961C130.417 24.8961 131.214 24.0993 131.214 23.1163C131.214 22.1334 130.417 21.3365 129.434 21.3365C128.452 21.3365 127.655 22.1334 127.655 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.496 23.1163C121.496 24.0993 122.292 24.8961 123.275 24.8961C124.258 24.8961 125.055 24.0993 125.055 23.1163C125.055 22.1334 124.258 21.3365 123.275 21.3365C122.292 21.3365 121.496 22.1334 121.496 23.1163Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.296 23.1254C115.296 24.1083 116.093 24.9052 117.076 24.9052C118.059 24.9052 118.856 24.1083 118.856 23.1254C118.856 22.1425 118.059 21.3456 117.076 21.3456C116.093 21.3456 115.296 22.1425 115.296 23.1254Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.138 23.1254C109.138 24.1083 109.934 24.9052 110.917 24.9052C111.9 24.9052 112.697 24.1083 112.697 23.1254C112.697 22.1425 111.9 21.3456 110.917 21.3456C109.934 21.3456 109.138 22.1425 109.138 23.1254Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.972 23.1254C102.972 24.1084 103.769 24.9052 104.751 24.9052C105.734 24.9052 106.531 24.1084 106.531 23.1254C106.531 22.1425 105.734 21.3456 104.751 21.3456C103.769 21.3456 102.972 22.1425 102.972 23.1254Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8129 23.1254C96.8129 24.1084 97.6097 24.9052 98.5927 24.9052C99.5756 24.9052 100.372 24.1084 100.372 23.1254C100.372 22.1425 99.5756 21.3456 98.5927 21.3456C97.6097 21.3456 96.8129 22.1425 96.8129 23.1254Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6133 23.1254C90.6133 24.1084 91.4101 24.9052 92.3931 24.9052C93.376 24.9052 94.1729 24.1084 94.1729 23.1254C94.1729 22.1425 93.376 21.3456 92.3931 21.3456C91.4101 21.3456 90.6133 22.1425 90.6133 23.1254Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4545 23.1254C84.4545 24.1083 85.2513 24.9052 86.2343 24.9052C87.2172 24.9052 88.014 24.1083 88.014 23.1254C88.014 22.1425 87.2172 21.3456 86.2343 21.3456C85.2513 21.3456 84.4545 22.1425 84.4545 23.1254Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2848 23.1306C78.2848 24.1135 79.0816 24.9104 80.0646 24.9104C81.0475 24.9104 81.8444 24.1135 81.8444 23.1306C81.8444 22.1477 81.0475 21.3508 80.0646 21.3508C79.0816 21.3508 78.2848 22.1477 78.2848 23.1306Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1259 23.1306C72.1259 24.1135 72.9227 24.9104 73.9057 24.9104C74.8886 24.9104 75.6854 24.1135 75.6854 23.1306C75.6854 22.1477 74.8886 21.3508 73.9057 21.3508C72.9227 21.3508 72.1259 22.1477 72.1259 23.1306Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9096 23.1306C65.9096 24.1135 66.7064 24.9104 67.6893 24.9104C68.6723 24.9104 69.4691 24.1135 69.4691 23.1306C69.4691 22.1477 68.6723 21.3508 67.6893 21.3508C66.7064 21.3508 65.9096 22.1477 65.9096 23.1306Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.7505 23.1306C59.7505 24.1135 60.5473 24.9104 61.5303 24.9104C62.5132 24.9104 63.3101 24.1135 63.3101 23.1306C63.3101 22.1477 62.5132 21.3508 61.5303 21.3508C60.5473 21.3508 59.7505 22.1477 59.7505 23.1306Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6017 23.1215C53.6017 24.1044 54.3985 24.9013 55.3815 24.9013C56.3644 24.9013 57.1613 24.1044 57.1613 23.1215C57.1613 22.1386 56.3644 21.3417 55.3815 21.3417C54.3985 21.3417 53.6017 22.1386 53.6017 23.1215Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4429 23.1215C47.4429 24.1044 48.2397 24.9013 49.2227 24.9013C50.2056 24.9013 51.0024 24.1044 51.0024 23.1215C51.0024 22.1386 50.2056 21.3417 49.2227 21.3417C48.2397 21.3417 47.4429 22.1386 47.4429 23.1215Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2423 23.1306C41.2423 24.1135 42.0392 24.9104 43.0221 24.9104C44.005 24.9104 44.8019 24.1135 44.8019 23.1306C44.8019 22.1477 44.005 21.3508 43.0221 21.3508C42.0392 21.3508 41.2423 22.1477 41.2423 23.1306Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.083 23.1306C35.083 24.1135 35.8799 24.9104 36.8628 24.9104C37.8457 24.9104 38.6426 24.1135 38.6426 23.1306C38.6426 22.1477 37.8457 21.3508 36.8628 21.3508C35.8799 21.3508 35.083 22.1477 35.083 23.1306Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9192 23.1306C28.9192 24.1135 29.716 24.9104 30.699 24.9104C31.6819 24.9104 32.4788 24.1135 32.4788 23.1306C32.4788 22.1477 31.6819 21.3508 30.699 21.3508C29.716 21.3508 28.9192 22.1477 28.9192 23.1306Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7599 23.1306C22.7599 24.1135 23.5567 24.9104 24.5397 24.9104C25.5226 24.9104 26.3195 24.1135 26.3195 23.1306C26.3195 22.1477 25.5226 21.3508 24.5397 21.3508C23.5567 21.3508 22.7599 22.1477 22.7599 23.1306Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5594 23.1306C16.5594 24.1135 17.3562 24.9104 18.3391 24.9104C19.3221 24.9104 20.1189 24.1135 20.1189 23.1306C20.1189 22.1477 19.3221 21.3508 18.3391 21.3508C17.3562 21.3508 16.5594 22.1477 16.5594 23.1306Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.4002 23.1306C10.4002 24.1135 11.197 24.9104 12.1799 24.9104C13.1629 24.9104 13.9597 24.1135 13.9597 23.1306C13.9597 22.1477 13.1629 21.3508 12.1799 21.3508C11.197 21.3508 10.4002 22.1477 10.4002 23.1306Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.254 28.427C149.254 29.4099 150.051 30.2068 151.033 30.2068C152.016 30.2068 152.813 29.4099 152.813 28.427C152.813 27.4441 152.016 26.6472 151.033 26.6472C150.051 26.6472 149.254 27.4441 149.254 28.427Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.094 28.427C143.094 29.4099 143.891 30.2068 144.874 30.2068C145.857 30.2068 146.654 29.4099 146.654 28.427C146.654 27.4441 145.857 26.6472 144.874 26.6472C143.891 26.6472 143.094 27.4441 143.094 28.427Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.878 28.427C136.878 29.4099 137.675 30.2068 138.658 30.2068C139.641 30.2068 140.438 29.4099 140.438 28.427C140.438 27.4441 139.641 26.6472 138.658 26.6472C137.675 26.6472 136.878 27.4441 136.878 28.427Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.719 28.427C130.719 29.4099 131.516 30.2068 132.499 30.2068C133.482 30.2068 134.279 29.4099 134.279 28.427C134.279 27.4441 133.482 26.6472 132.499 26.6472C131.516 26.6472 130.719 27.4441 130.719 28.427Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.571 28.418C124.571 29.4009 125.367 30.1977 126.35 30.1977C127.333 30.1977 128.13 29.4009 128.13 28.418C128.13 27.435 127.333 26.6382 126.35 26.6382C125.367 26.6382 124.571 27.435 124.571 28.418Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.412 28.418C118.412 29.4009 119.208 30.1977 120.191 30.1977C121.174 30.1977 121.971 29.4009 121.971 28.418C121.971 27.435 121.174 26.6382 120.191 26.6382C119.208 26.6382 118.412 27.435 118.412 28.418Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.211 28.427C112.211 29.4099 113.008 30.2068 113.99 30.2068C114.973 30.2068 115.77 29.4099 115.77 28.427C115.77 27.4441 114.973 26.6472 113.99 26.6472C113.008 26.6472 112.211 27.4441 112.211 28.427Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.052 28.427C106.052 29.4099 106.849 30.2068 107.832 30.2068C108.815 30.2068 109.611 29.4099 109.611 28.427C109.611 27.4441 108.815 26.6472 107.832 26.6472C106.849 26.6472 106.052 27.4441 106.052 28.427Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8877 28.427C99.8877 29.4099 100.685 30.2068 101.667 30.2068C102.65 30.2068 103.447 29.4099 103.447 28.427C103.447 27.4441 102.65 26.6472 101.667 26.6472C100.685 26.6472 99.8877 27.4441 99.8877 28.427Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.7287 28.427C93.7287 29.4099 94.5255 30.2068 95.5084 30.2068C96.4914 30.2068 97.2882 29.4099 97.2882 28.427C97.2882 27.4441 96.4914 26.6472 95.5084 26.6472C94.5255 26.6472 93.7287 27.4441 93.7287 28.427Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5281 28.427C87.5281 29.4099 88.3249 30.2068 89.3079 30.2068C90.2908 30.2068 91.0876 29.4099 91.0876 28.427C91.0876 27.4441 90.2908 26.6472 89.3079 26.6472C88.3249 26.6472 87.5281 27.4441 87.5281 28.427Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3688 28.427C81.3688 29.4099 82.1656 30.2068 83.1486 30.2068C84.1315 30.2068 84.9283 29.4099 84.9283 28.427C84.9283 27.4441 84.1315 26.6472 83.1486 26.6472C82.1656 26.6472 81.3688 27.4441 81.3688 28.427Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.1996 28.4323C75.1996 29.4152 75.9964 30.212 76.9794 30.212C77.9623 30.212 78.7592 29.4152 78.7592 28.4323C78.7592 27.4493 77.9623 26.6525 76.9794 26.6525C75.9964 26.6525 75.1996 27.4493 75.1996 28.4323Z"
            fill="#B8B7B7"
          />
          <path
            d="M69.0407 28.4323C69.0407 29.4152 69.8375 30.212 70.8204 30.212C71.8034 30.212 72.6002 29.4152 72.6002 28.4323C72.6002 27.4493 71.8034 26.6525 70.8204 26.6525C69.8375 26.6525 69.0407 27.4493 69.0407 28.4323Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8245 28.4323C62.8245 29.4152 63.6213 30.212 64.6043 30.212C65.5872 30.212 66.384 29.4152 66.384 28.4323C66.384 27.4493 65.5872 26.6525 64.6043 26.6525C63.6213 26.6525 62.8245 27.4493 62.8245 28.4323Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6651 28.4323C56.6651 29.4152 57.4619 30.212 58.4448 30.212C59.4278 30.212 60.2246 29.4152 60.2246 28.4323C60.2246 27.4493 59.4278 26.6525 58.4448 26.6525C57.4619 26.6525 56.6651 27.4493 56.6651 28.4323Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5166 28.4219C50.5166 29.4048 51.3135 30.2016 52.2964 30.2016C53.2793 30.2016 54.0762 29.4048 54.0762 28.4219C54.0762 27.4389 53.2793 26.6421 52.2964 26.6421C51.3135 26.6421 50.5166 27.4389 50.5166 28.4219Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3578 28.4219C44.3578 29.4048 45.1546 30.2016 46.1376 30.2016C47.1205 30.2016 47.9174 29.4048 47.9174 28.4219C47.9174 27.4389 47.1205 26.6421 46.1376 26.6421C45.1546 26.6421 44.3578 27.4389 44.3578 28.4219Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1582 28.4323C38.1582 29.4152 38.9551 30.212 39.938 30.212C40.9209 30.212 41.7178 29.4152 41.7178 28.4323C41.7178 27.4493 40.9209 26.6525 39.938 26.6525C38.9551 26.6525 38.1582 27.4493 38.1582 28.4323Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.9991 28.4323C31.9991 29.4152 32.7959 30.212 33.7788 30.212C34.7618 30.212 35.5586 29.4152 35.5586 28.4323C35.5586 27.4493 34.7618 26.6525 33.7788 26.6525C32.7959 26.6525 31.9991 27.4493 31.9991 28.4323Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8335 28.4323C25.8335 29.4152 26.6304 30.212 27.6133 30.212C28.5962 30.212 29.3931 29.4152 29.3931 28.4323C29.3931 27.4493 28.5962 26.6525 27.6133 26.6525C26.6304 26.6525 25.8335 27.4493 25.8335 28.4323Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6747 28.4323C19.6747 29.4152 20.4715 30.212 21.4545 30.212C22.4374 30.212 23.2343 29.4152 23.2343 28.4323C23.2343 27.4493 22.4374 26.6525 21.4545 26.6525C20.4715 26.6525 19.6747 27.4493 19.6747 28.4323Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4754 28.4323C13.4754 29.4152 14.2722 30.212 15.2551 30.212C16.2381 30.212 17.0349 29.4152 17.0349 28.4323C17.0349 27.4493 16.2381 26.6525 15.2551 26.6525C14.2722 26.6525 13.4754 27.4493 13.4754 28.4323Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.31631 28.4323C7.31631 29.4152 8.11314 30.212 9.09608 30.212C10.079 30.212 10.8759 29.4152 10.8759 28.4323C10.8759 27.4493 10.079 26.6525 9.09608 26.6525C8.11314 26.6525 7.31631 27.4493 7.31631 28.4323Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.338 33.6716C152.338 34.6545 153.135 35.4513 154.117 35.4513C155.1 35.4513 155.897 34.6545 155.897 33.6716C155.897 32.6886 155.1 31.8918 154.117 31.8918C153.135 31.8918 152.338 32.6886 152.338 33.6716Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.178 33.6716C146.178 34.6545 146.975 35.4513 147.958 35.4513C148.941 35.4513 149.738 34.6545 149.738 33.6716C149.738 32.6886 148.941 31.8918 147.958 31.8918C146.975 31.8918 146.178 32.6886 146.178 33.6716Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.963 33.6716C139.963 34.6545 140.76 35.4513 141.742 35.4513C142.725 35.4513 143.522 34.6545 143.522 33.6716C143.522 32.6886 142.725 31.8918 141.742 31.8918C140.76 31.8918 139.963 32.6886 139.963 33.6716Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.803 33.6716C133.803 34.6545 134.6 35.4513 135.583 35.4513C136.566 35.4513 137.363 34.6545 137.363 33.6716C137.363 32.6886 136.566 31.8918 135.583 31.8918C134.6 31.8918 133.803 32.6886 133.803 33.6716Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.655 33.6624C127.655 34.6453 128.452 35.4422 129.434 35.4422C130.417 35.4422 131.214 34.6453 131.214 33.6624C131.214 32.6794 130.417 31.8826 129.434 31.8826C128.452 31.8826 127.655 32.6794 127.655 33.6624Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.496 33.6624C121.496 34.6453 122.292 35.4422 123.275 35.4422C124.258 35.4422 125.055 34.6453 125.055 33.6624C125.055 32.6794 124.258 31.8826 123.275 31.8826C122.292 31.8826 121.496 32.6794 121.496 33.6624Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.296 33.6716C115.296 34.6545 116.093 35.4513 117.076 35.4513C118.059 35.4513 118.856 34.6545 118.856 33.6716C118.856 32.6886 118.059 31.8918 117.076 31.8918C116.093 31.8918 115.296 32.6886 115.296 33.6716Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.138 33.6716C109.138 34.6545 109.934 35.4513 110.917 35.4513C111.9 35.4513 112.697 34.6545 112.697 33.6716C112.697 32.6886 111.9 31.8918 110.917 31.8918C109.934 31.8918 109.138 32.6886 109.138 33.6716Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.972 33.6716C102.972 34.6545 103.769 35.4513 104.751 35.4513C105.734 35.4513 106.531 34.6545 106.531 33.6716C106.531 32.6886 105.734 31.8918 104.751 31.8918C103.769 31.8918 102.972 32.6886 102.972 33.6716Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8129 33.6716C96.8129 34.6545 97.6097 35.4513 98.5927 35.4513C99.5756 35.4513 100.372 34.6545 100.372 33.6716C100.372 32.6886 99.5756 31.8918 98.5927 31.8918C97.6097 31.8918 96.8129 32.6886 96.8129 33.6716Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6133 33.6716C90.6133 34.6545 91.4101 35.4513 92.3931 35.4513C93.376 35.4513 94.1729 34.6545 94.1729 33.6716C94.1729 32.6886 93.376 31.8918 92.3931 31.8918C91.4101 31.8918 90.6133 32.6886 90.6133 33.6716Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4545 33.6715C84.4545 34.6545 85.2513 35.4513 86.2343 35.4513C87.2172 35.4513 88.014 34.6545 88.014 33.6715C88.014 32.6886 87.2172 31.8918 86.2343 31.8918C85.2513 31.8918 84.4545 32.6886 84.4545 33.6715Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2848 33.6767C78.2848 34.6597 79.0816 35.4565 80.0646 35.4565C81.0475 35.4565 81.8444 34.6597 81.8444 33.6767C81.8444 32.6938 81.0475 31.8969 80.0646 31.8969C79.0816 31.8969 78.2848 32.6938 78.2848 33.6767Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1259 33.6767C72.1259 34.6597 72.9227 35.4565 73.9057 35.4565C74.8886 35.4565 75.6854 34.6597 75.6854 33.6767C75.6854 32.6938 74.8886 31.8969 73.9057 31.8969C72.9227 31.8969 72.1259 32.6938 72.1259 33.6767Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9096 33.6767C65.9096 34.6597 66.7064 35.4565 67.6893 35.4565C68.6723 35.4565 69.4691 34.6597 69.4691 33.6767C69.4691 32.6938 68.6723 31.8969 67.6893 31.8969C66.7064 31.8969 65.9096 32.6938 65.9096 33.6767Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.7505 33.6767C59.7505 34.6597 60.5473 35.4565 61.5303 35.4565C62.5132 35.4565 63.3101 34.6597 63.3101 33.6767C63.3101 32.6938 62.5132 31.8969 61.5303 31.8969C60.5473 31.8969 59.7505 32.6938 59.7505 33.6767Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6017 33.6676C53.6017 34.6505 54.3985 35.4473 55.3815 35.4473C56.3644 35.4473 57.1613 34.6505 57.1613 33.6676C57.1613 32.6846 56.3644 31.8878 55.3815 31.8878C54.3985 31.8878 53.6017 32.6846 53.6017 33.6676Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4429 33.6676C47.4429 34.6505 48.2397 35.4473 49.2227 35.4473C50.2056 35.4473 51.0024 34.6505 51.0024 33.6676C51.0024 32.6846 50.2056 31.8878 49.2227 31.8878C48.2397 31.8878 47.4429 32.6846 47.4429 33.6676Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2423 33.6767C41.2423 34.6597 42.0392 35.4565 43.0221 35.4565C44.005 35.4565 44.8019 34.6597 44.8019 33.6767C44.8019 32.6938 44.005 31.8969 43.0221 31.8969C42.0392 31.8969 41.2423 32.6938 41.2423 33.6767Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.083 33.6767C35.083 34.6597 35.8799 35.4565 36.8628 35.4565C37.8457 35.4565 38.6426 34.6597 38.6426 33.6767C38.6426 32.6938 37.8457 31.8969 36.8628 31.8969C35.8799 31.8969 35.083 32.6938 35.083 33.6767Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9192 33.6767C28.9192 34.6597 29.716 35.4565 30.699 35.4565C31.6819 35.4565 32.4788 34.6597 32.4788 33.6767C32.4788 32.6938 31.6819 31.8969 30.699 31.8969C29.716 31.8969 28.9192 32.6938 28.9192 33.6767Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7599 33.6767C22.7599 34.6597 23.5567 35.4565 24.5397 35.4565C25.5226 35.4565 26.3195 34.6597 26.3195 33.6767C26.3195 32.6938 25.5226 31.8969 24.5397 31.8969C23.5567 31.8969 22.7599 32.6938 22.7599 33.6767Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5594 33.6767C16.5594 34.6597 17.3562 35.4565 18.3391 35.4565C19.3221 35.4565 20.1189 34.6597 20.1189 33.6767C20.1189 32.6938 19.3221 31.8969 18.3391 31.8969C17.3562 31.8969 16.5594 32.6938 16.5594 33.6767Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.4002 33.6767C10.4002 34.6597 11.197 35.4565 12.1799 35.4565C13.1629 35.4565 13.9597 34.6597 13.9597 33.6767C13.9597 32.6938 13.1629 31.8969 12.1799 31.8969C11.197 31.8969 10.4002 32.6938 10.4002 33.6767Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.412 28.3984C155.412 29.3814 156.209 30.1782 157.192 30.1782C158.175 30.1782 158.972 29.3814 158.972 28.3984C158.972 27.4155 158.175 26.6187 157.192 26.6187C156.209 26.6187 155.412 27.4155 155.412 28.3984Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 39.0355C155.418 40.0185 156.215 40.8153 157.198 40.8153C158.18 40.8153 158.977 40.0185 158.977 39.0355C158.977 38.0526 158.18 37.2558 157.198 37.2558C156.215 37.2558 155.418 38.0526 155.418 39.0355Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 39.0355C149.259 40.0185 150.056 40.8153 151.039 40.8153C152.022 40.8153 152.819 40.0185 152.819 39.0355C152.819 38.0526 152.022 37.2558 151.039 37.2558C150.056 37.2558 149.259 38.0526 149.259 39.0355Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.042 39.0355C143.042 40.0185 143.839 40.8153 144.822 40.8153C145.805 40.8153 146.602 40.0185 146.602 39.0355C146.602 38.0526 145.805 37.2558 144.822 37.2558C143.839 37.2558 143.042 38.0526 143.042 39.0355Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 39.0355C136.883 40.0184 137.68 40.8153 138.663 40.8153C139.646 40.8153 140.443 40.0184 140.443 39.0355C140.443 38.0526 139.646 37.2557 138.663 37.2557C137.68 37.2557 136.883 38.0526 136.883 39.0355Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.735 39.0251C130.735 40.008 131.532 40.8049 132.515 40.8049C133.498 40.8049 134.294 40.008 134.294 39.0251C134.294 38.0421 133.498 37.2453 132.515 37.2453C131.532 37.2453 130.735 38.0421 130.735 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 39.0251C124.576 40.008 125.373 40.8049 126.356 40.8049C127.339 40.8049 128.135 40.008 128.135 39.0251C128.135 38.0421 127.339 37.2453 126.356 37.2453C125.373 37.2453 124.576 38.0421 124.576 39.0251Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.375 39.0355C118.375 40.0184 119.172 40.8152 120.155 40.8152C121.138 40.8152 121.935 40.0184 121.935 39.0355C121.935 38.0525 121.138 37.2557 120.155 37.2557C119.172 37.2557 118.375 38.0525 118.375 39.0355Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 39.0355C112.216 40.0185 113.013 40.8153 113.996 40.8153C114.979 40.8153 115.776 40.0185 115.776 39.0355C115.776 38.0526 114.979 37.2558 113.996 37.2558C113.013 37.2558 112.216 38.0526 112.216 39.0355Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.052 39.0355C106.052 40.0185 106.849 40.8153 107.832 40.8153C108.815 40.8153 109.611 40.0185 109.611 39.0355C109.611 38.0526 108.815 37.2558 107.832 37.2558C106.849 37.2558 106.052 38.0526 106.052 39.0355Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 39.0355C99.8931 40.0185 100.69 40.8153 101.673 40.8153C102.656 40.8153 103.453 40.0185 103.453 39.0355C103.453 38.0526 102.656 37.2558 101.673 37.2558C100.69 37.2558 99.8931 38.0526 99.8931 39.0355Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.6922 39.0355C93.6922 40.0185 94.489 40.8153 95.4719 40.8153C96.4549 40.8153 97.2517 40.0185 97.2517 39.0355C97.2517 38.0526 96.4549 37.2558 95.4719 37.2558C94.489 37.2558 93.6922 38.0526 93.6922 39.0355Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5331 39.0355C87.5331 40.0185 88.3299 40.8153 89.3129 40.8153C90.2958 40.8153 91.0927 40.0185 91.0927 39.0355C91.0927 38.0526 90.2958 37.2558 89.3129 37.2558C88.3299 37.2558 87.5331 38.0526 87.5331 39.0355Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3638 39.0394C81.3638 40.0224 82.1606 40.8192 83.1436 40.8192C84.1265 40.8192 84.9233 40.0224 84.9233 39.0394C84.9233 38.0565 84.1265 37.2597 83.1436 37.2597C82.1606 37.2597 81.3638 38.0565 81.3638 39.0394Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 39.0394C75.2046 40.0224 76.0014 40.8192 76.9844 40.8192C77.9673 40.8192 78.7642 40.0224 78.7642 39.0394C78.7642 38.0565 77.9673 37.2597 76.9844 37.2597C76.0014 37.2597 75.2046 38.0565 75.2046 39.0394Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9887 39.0394C68.9887 40.0224 69.7855 40.8192 70.7684 40.8192C71.7514 40.8192 72.5482 40.0224 72.5482 39.0394C72.5482 38.0565 71.7514 37.2597 70.7684 37.2597C69.7855 37.2597 68.9887 38.0565 68.9887 39.0394Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 39.0394C62.8294 40.0224 63.6262 40.8192 64.6091 40.8192C65.5921 40.8192 66.3889 40.0224 66.3889 39.0394C66.3889 38.0565 65.5921 37.2597 64.6091 37.2597C63.6262 37.2597 62.8294 38.0565 62.8294 39.0394Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6808 39.0303C56.6808 40.0133 57.4776 40.8101 58.4606 40.8101C59.4435 40.8101 60.2404 40.0133 60.2404 39.0303C60.2404 38.0474 59.4435 37.2506 58.4606 37.2506C57.4776 37.2506 56.6808 38.0474 56.6808 39.0303Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 39.0303C50.5216 40.0133 51.3185 40.8101 52.3014 40.8101C53.2843 40.8101 54.0812 40.0133 54.0812 39.0303C54.0812 38.0474 53.2843 37.2506 52.3014 37.2506C51.3185 37.2506 50.5216 38.0474 50.5216 39.0303Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3225 39.0394C44.3225 40.0224 45.1194 40.8192 46.1023 40.8192C47.0852 40.8192 47.8821 40.0224 47.8821 39.0394C47.8821 38.0565 47.0852 37.2597 46.1023 37.2597C45.1194 37.2597 44.3225 38.0565 44.3225 39.0394Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 39.0394C38.1634 40.0224 38.9602 40.8192 39.9431 40.8192C40.9261 40.8192 41.7229 40.0224 41.7229 39.0394C41.7229 38.0565 40.9261 37.2597 39.9431 37.2597C38.9602 37.2597 38.1634 38.0565 38.1634 39.0394Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.998 39.0394C31.998 40.0224 32.7948 40.8192 33.7777 40.8192C34.7607 40.8192 35.5575 40.0224 35.5575 39.0394C35.5575 38.0565 34.7607 37.2597 33.7777 37.2597C32.7948 37.2597 31.998 38.0565 31.998 39.0394Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 39.0394C25.8387 40.0224 26.6355 40.8192 27.6184 40.8192C28.6014 40.8192 29.3982 40.0224 29.3982 39.0394C29.3982 38.0565 28.6014 37.2597 27.6184 37.2597C26.6355 37.2597 25.8387 38.0565 25.8387 39.0394Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6396 39.0394C19.6396 40.0224 20.4364 40.8192 21.4193 40.8192C22.4023 40.8192 23.1991 40.0224 23.1991 39.0394C23.1991 38.0565 22.4023 37.2597 21.4193 37.2597C20.4364 37.2597 19.6396 38.0565 19.6396 39.0394Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4803 39.0394C13.4803 40.0224 14.2771 40.8192 15.26 40.8192C16.243 40.8192 17.0398 40.0224 17.0398 39.0394C17.0398 38.0565 16.243 37.2597 15.26 37.2597C14.2771 37.2597 13.4803 38.0565 13.4803 39.0394Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.333 44.3359C152.333 45.3188 153.129 46.1156 154.112 46.1156C155.095 46.1156 155.892 45.3188 155.892 44.3359C155.892 43.3529 155.095 42.5561 154.112 42.5561C153.129 42.5561 152.333 43.3529 152.333 44.3359Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.173 44.3359C146.173 45.3188 146.97 46.1156 147.953 46.1156C148.936 46.1156 149.733 45.3188 149.733 44.3359C149.733 43.3529 148.936 42.5561 147.953 42.5561C146.97 42.5561 146.173 43.3529 146.173 44.3359Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.957 44.3359C139.957 45.3188 140.754 46.1156 141.737 46.1156C142.72 46.1156 143.517 45.3188 143.517 44.3359C143.517 43.3529 142.72 42.5561 141.737 42.5561C140.754 42.5561 139.957 43.3529 139.957 44.3359Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.798 44.3359C133.798 45.3188 134.595 46.1156 135.578 46.1156C136.561 46.1156 137.358 45.3188 137.358 44.3359C137.358 43.3529 136.561 42.5561 135.578 42.5561C134.595 42.5561 133.798 43.3529 133.798 44.3359Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.65 44.3268C127.65 45.3097 128.447 46.1065 129.43 46.1065C130.413 46.1065 131.209 45.3097 131.209 44.3268C131.209 43.3438 130.413 42.547 129.43 42.547C128.447 42.547 127.65 43.3438 127.65 44.3268Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.491 44.3268C121.491 45.3097 122.287 46.1065 123.27 46.1065C124.253 46.1065 125.05 45.3097 125.05 44.3268C125.05 43.3438 124.253 42.547 123.27 42.547C122.287 42.547 121.491 43.3438 121.491 44.3268Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.291 44.3359C115.291 45.3188 116.088 46.1156 117.071 46.1156C118.054 46.1156 118.851 45.3188 118.851 44.3359C118.851 43.3529 118.054 42.5561 117.071 42.5561C116.088 42.5561 115.291 43.3529 115.291 44.3359Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.132 44.3359C109.132 45.3188 109.929 46.1156 110.912 46.1156C111.895 46.1156 112.692 45.3188 112.692 44.3359C112.692 43.3529 111.895 42.5561 110.912 42.5561C109.929 42.5561 109.132 43.3529 109.132 44.3359Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.967 44.3359C102.967 45.3188 103.764 46.1156 104.747 46.1156C105.73 46.1156 106.526 45.3188 106.526 44.3359C106.526 43.3529 105.73 42.5561 104.747 42.5561C103.764 42.5561 102.967 43.3529 102.967 44.3359Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8074 44.3359C96.8074 45.3188 97.6042 46.1156 98.5872 46.1156C99.5701 46.1156 100.367 45.3188 100.367 44.3359C100.367 43.3529 99.5701 42.5561 98.5872 42.5561C97.6042 42.5561 96.8074 43.3529 96.8074 44.3359Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6079 44.3359C90.6079 45.3188 91.4048 46.1156 92.3877 46.1156C93.3706 46.1156 94.1675 45.3188 94.1675 44.3359C94.1675 43.3529 93.3707 42.5561 92.3877 42.5561C91.4048 42.5561 90.6079 43.3529 90.6079 44.3359Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4491 44.3358C84.4491 45.3188 85.246 46.1156 86.2289 46.1156C87.2118 46.1156 88.0087 45.3188 88.0087 44.3358C88.0087 43.3529 87.2118 42.5561 86.2289 42.5561C85.246 42.5561 84.4491 43.3529 84.4491 44.3358Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2783 44.341C78.2783 45.324 79.0752 46.1208 80.0581 46.1208C81.0411 46.1208 81.8379 45.324 81.8379 44.341C81.8379 43.3581 81.0411 42.5613 80.0581 42.5613C79.0752 42.5613 78.2783 43.3581 78.2783 44.341Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1205 44.341C72.1205 45.324 72.9173 46.1208 73.9003 46.1208C74.8832 46.1208 75.6801 45.324 75.6801 44.341C75.6801 43.3581 74.8832 42.5613 73.9003 42.5613C72.9173 42.5613 72.1205 43.3581 72.1205 44.341Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9046 44.341C65.9046 45.324 66.7014 46.1208 67.6843 46.1208C68.6673 46.1208 69.4641 45.324 69.4641 44.341C69.4641 43.3581 68.6673 42.5613 67.6843 42.5613C66.7014 42.5613 65.9046 43.3581 65.9046 44.341Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.7453 44.341C59.7453 45.324 60.5421 46.1208 61.525 46.1208C62.508 46.1208 63.3048 45.324 63.3048 44.341C63.3048 43.3581 62.508 42.5613 61.525 42.5613C60.5421 42.5613 59.7453 43.3581 59.7453 44.341Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.5954 44.3319C53.5954 45.3149 54.3922 46.1117 55.3751 46.1117C56.3581 46.1117 57.1549 45.3149 57.1549 44.3319C57.1549 43.349 56.3581 42.5522 55.3751 42.5522C54.3922 42.5522 53.5954 43.349 53.5954 44.3319Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.438 44.3319C47.438 45.3149 48.2348 46.1117 49.2178 46.1117C50.2007 46.1117 50.9976 45.3149 50.9976 44.3319C50.9976 43.349 50.2007 42.5522 49.2178 42.5522C48.2348 42.5522 47.438 43.349 47.438 44.3319Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.237 44.3411C41.237 45.324 42.0338 46.1209 43.0167 46.1209C43.9997 46.1209 44.7965 45.324 44.7965 44.3411C44.7965 43.3581 43.9997 42.5613 43.0167 42.5613C42.0338 42.5613 41.237 43.3581 41.237 44.3411Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.078 44.3411C35.078 45.324 35.8749 46.1209 36.8578 46.1209C37.8407 46.1209 38.6376 45.324 38.6376 44.3411C38.6376 43.3581 37.8407 42.5613 36.8578 42.5613C35.8749 42.5613 35.078 43.3581 35.078 44.3411Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9124 44.3411C28.9124 45.324 29.7092 46.1209 30.6922 46.1209C31.6751 46.1209 32.4719 45.324 32.4719 44.3411C32.4719 43.3581 31.6751 42.5613 30.6922 42.5613C29.7092 42.5613 28.9124 43.3581 28.9124 44.3411Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7549 44.3411C22.7549 45.324 23.5517 46.1209 24.5347 46.1209C25.5176 46.1209 26.3145 45.324 26.3145 44.3411C26.3145 43.3581 25.5176 42.5613 24.5347 42.5613C23.5517 42.5613 22.7549 43.3581 22.7549 44.3411Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.554 44.3411C16.554 45.324 17.3508 46.1209 18.3338 46.1209C19.3167 46.1209 20.1135 45.324 20.1135 44.3411C20.1135 43.3581 19.3167 42.5613 18.3338 42.5613C17.3508 42.5613 16.554 43.3581 16.554 44.3411Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.3952 44.3411C10.3952 45.324 11.192 46.1209 12.1749 46.1209C13.1579 46.1209 13.9547 45.324 13.9547 44.3411C13.9547 43.3581 13.1579 42.5613 12.1749 42.5613C11.192 42.5613 10.3952 43.3581 10.3952 44.3411Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 49.5803C155.418 50.5632 156.215 51.3601 157.198 51.3601C158.18 51.3601 158.977 50.5632 158.977 49.5803C158.977 48.5974 158.18 47.8005 157.198 47.8005C156.215 47.8005 155.418 48.5974 155.418 49.5803Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 49.5803C149.259 50.5632 150.056 51.3601 151.039 51.3601C152.022 51.3601 152.819 50.5632 152.819 49.5803C152.819 48.5974 152.022 47.8005 151.039 47.8005C150.056 47.8005 149.259 48.5974 149.259 49.5803Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.042 49.5803C143.042 50.5632 143.839 51.3601 144.822 51.3601C145.805 51.3601 146.602 50.5632 146.602 49.5803C146.602 48.5974 145.805 47.8005 144.822 47.8005C143.839 47.8005 143.042 48.5974 143.042 49.5803Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 49.5803C136.883 50.5632 137.68 51.3601 138.663 51.3601C139.646 51.3601 140.443 50.5632 140.443 49.5803C140.443 48.5974 139.646 47.8005 138.663 47.8005C137.68 47.8005 136.883 48.5974 136.883 49.5803Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.735 49.5712C130.735 50.5542 131.532 51.351 132.515 51.351C133.498 51.351 134.294 50.5542 134.294 49.5712C134.294 48.5883 133.498 47.7914 132.515 47.7914C131.532 47.7914 130.735 48.5883 130.735 49.5712Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 49.5712C124.576 50.5542 125.373 51.351 126.356 51.351C127.339 51.351 128.135 50.5542 128.135 49.5712C128.135 48.5883 127.339 47.7914 126.356 47.7914C125.373 47.7914 124.576 48.5883 124.576 49.5712Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.375 49.5803C118.375 50.5632 119.172 51.3601 120.155 51.3601C121.138 51.3601 121.935 50.5632 121.935 49.5803C121.935 48.5974 121.138 47.8005 120.155 47.8005C119.172 47.8005 118.375 48.5974 118.375 49.5803Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 49.5803C112.216 50.5632 113.013 51.3601 113.996 51.3601C114.979 51.3601 115.776 50.5632 115.776 49.5803C115.776 48.5974 114.979 47.8005 113.996 47.8005C113.013 47.8005 112.216 48.5974 112.216 49.5803Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.052 49.5803C106.052 50.5632 106.849 51.3601 107.832 51.3601C108.815 51.3601 109.611 50.5632 109.611 49.5803C109.611 48.5974 108.815 47.8005 107.832 47.8005C106.849 47.8005 106.052 48.5974 106.052 49.5803Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 49.5803C99.8931 50.5633 100.69 51.3601 101.673 51.3601C102.656 51.3601 103.453 50.5633 103.453 49.5803C103.453 48.5974 102.656 47.8006 101.673 47.8006C100.69 47.8006 99.8931 48.5974 99.8931 49.5803Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.6922 49.5803C93.6922 50.5633 94.489 51.3601 95.4719 51.3601C96.4549 51.3601 97.2517 50.5633 97.2517 49.5803C97.2517 48.5974 96.4549 47.8006 95.4719 47.8006C94.489 47.8006 93.6922 48.5974 93.6922 49.5803Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5331 49.5803C87.5331 50.5632 88.3299 51.3601 89.3129 51.3601C90.2958 51.3601 91.0927 50.5632 91.0927 49.5803C91.0927 48.5974 90.2958 47.8005 89.3129 47.8005C88.3299 47.8005 87.5331 48.5974 87.5331 49.5803Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3638 49.5855C81.3638 50.5685 82.1606 51.3653 83.1436 51.3653C84.1265 51.3653 84.9233 50.5685 84.9233 49.5855C84.9233 48.6026 84.1265 47.8058 83.1436 47.8058C82.1606 47.8058 81.3638 48.6026 81.3638 49.5855Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 49.5855C75.2046 50.5685 76.0014 51.3653 76.9844 51.3653C77.9673 51.3653 78.7642 50.5685 78.7642 49.5855C78.7642 48.6026 77.9673 47.8058 76.9844 47.8058C76.0014 47.8058 75.2046 48.6026 75.2046 49.5855Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9887 49.5855C68.9887 50.5685 69.7855 51.3653 70.7684 51.3653C71.7514 51.3653 72.5482 50.5685 72.5482 49.5855C72.5482 48.6026 71.7514 47.8058 70.7684 47.8058C69.7855 47.8058 68.9887 48.6026 68.9887 49.5855Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 49.5855C62.8294 50.5685 63.6262 51.3653 64.6091 51.3653C65.5921 51.3653 66.3889 50.5685 66.3889 49.5855C66.3889 48.6026 65.5921 47.8058 64.6091 47.8058C63.6262 47.8058 62.8294 48.6026 62.8294 49.5855Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6808 49.5764C56.6808 50.5594 57.4776 51.3562 58.4606 51.3562C59.4435 51.3562 60.2404 50.5594 60.2404 49.5764C60.2404 48.5935 59.4435 47.7967 58.4606 47.7967C57.4776 47.7967 56.6808 48.5935 56.6808 49.5764Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 49.5764C50.5216 50.5594 51.3185 51.3562 52.3014 51.3562C53.2843 51.3562 54.0812 50.5594 54.0812 49.5764C54.0812 48.5935 53.2843 47.7967 52.3014 47.7967C51.3185 47.7967 50.5216 48.5935 50.5216 49.5764Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3225 49.5855C44.3225 50.5685 45.1194 51.3653 46.1023 51.3653C47.0852 51.3653 47.8821 50.5685 47.8821 49.5855C47.8821 48.6026 47.0852 47.8058 46.1023 47.8058C45.1194 47.8058 44.3225 48.6026 44.3225 49.5855Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 49.5855C38.1634 50.5685 38.9602 51.3653 39.9431 51.3653C40.9261 51.3653 41.7229 50.5685 41.7229 49.5855C41.7229 48.6026 40.9261 47.8058 39.9431 47.8058C38.9602 47.8058 38.1634 48.6026 38.1634 49.5855Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.998 49.5855C31.998 50.5685 32.7948 51.3653 33.7777 51.3653C34.7607 51.3653 35.5575 50.5685 35.5575 49.5855C35.5575 48.6026 34.7607 47.8058 33.7777 47.8058C32.7948 47.8058 31.998 48.6026 31.998 49.5855Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 49.5855C25.8387 50.5685 26.6355 51.3653 27.6184 51.3653C28.6014 51.3653 29.3982 50.5685 29.3982 49.5855C29.3982 48.6026 28.6014 47.8058 27.6184 47.8058C26.6355 47.8058 25.8387 48.6026 25.8387 49.5855Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6396 49.5855C19.6396 50.5685 20.4364 51.3653 21.4193 51.3653C22.4023 51.3653 23.1991 50.5685 23.1991 49.5855C23.1991 48.6026 22.4023 47.8058 21.4193 47.8058C20.4364 47.8058 19.6396 48.6026 19.6396 49.5855Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4803 49.5855C13.4803 50.5685 14.2771 51.3653 15.26 51.3653C16.243 51.3653 17.0398 50.5685 17.0398 49.5855C17.0398 48.6026 16.243 47.8058 15.26 47.8058C14.2771 47.8058 13.4803 48.6026 13.4803 49.5855Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.343 54.8716C152.343 55.8545 153.14 56.6513 154.123 56.6513C155.106 56.6513 155.903 55.8545 155.903 54.8716C155.903 53.8886 155.106 53.0918 154.123 53.0918C153.14 53.0918 152.343 53.8886 152.343 54.8716Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.185 54.8716C146.185 55.8545 146.982 56.6513 147.965 56.6513C148.948 56.6513 149.744 55.8545 149.744 54.8716C149.744 53.8886 148.948 53.0918 147.965 53.0918C146.982 53.0918 146.185 53.8886 146.185 54.8716Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.969 54.8716C139.969 55.8545 140.766 56.6513 141.749 56.6513C142.732 56.6513 143.529 55.8545 143.529 54.8716C143.529 53.8886 142.732 53.0918 141.749 53.0918C140.766 53.0918 139.969 53.8886 139.969 54.8716Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.81 54.8716C133.81 55.8545 134.607 56.6513 135.589 56.6513C136.572 56.6513 137.369 55.8545 137.369 54.8716C137.369 53.8886 136.572 53.0918 135.589 53.0918C134.607 53.0918 133.81 53.8886 133.81 54.8716Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.66 54.8625C127.66 55.8454 128.457 56.6423 129.44 56.6423C130.423 56.6423 131.22 55.8454 131.22 54.8625C131.22 53.8795 130.423 53.0827 129.44 53.0827C128.457 53.0827 127.66 53.8795 127.66 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.502 54.8625C121.502 55.8454 122.299 56.6423 123.282 56.6423C124.265 56.6423 125.062 55.8454 125.062 54.8625C125.062 53.8795 124.265 53.0827 123.282 53.0827C122.299 53.0827 121.502 53.8795 121.502 54.8625Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.302 54.8716C115.302 55.8545 116.099 56.6513 117.082 56.6513C118.064 56.6513 118.861 55.8545 118.861 54.8716C118.861 53.8886 118.064 53.0918 117.082 53.0918C116.099 53.0918 115.302 53.8886 115.302 54.8716Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.143 54.8716C109.143 55.8545 109.939 56.6513 110.922 56.6513C111.905 56.6513 112.702 55.8545 112.702 54.8716C112.702 53.8886 111.905 53.0918 110.922 53.0918C109.939 53.0918 109.143 53.8886 109.143 54.8716Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.977 54.8716C102.977 55.8545 103.774 56.6513 104.757 56.6513C105.74 56.6513 106.537 55.8545 106.537 54.8716C106.537 53.8886 105.74 53.0918 104.757 53.0918C103.774 53.0918 102.977 53.8886 102.977 54.8716Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8192 54.8716C96.8192 55.8545 97.6161 56.6513 98.599 56.6513C99.582 56.6513 100.379 55.8545 100.379 54.8716C100.379 53.8886 99.582 53.0918 98.599 53.0918C97.6161 53.0918 96.8192 53.8886 96.8192 54.8716Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6188 54.8716C90.6188 55.8545 91.4156 56.6513 92.3986 56.6513C93.3815 56.6513 94.1783 55.8545 94.1783 54.8716C94.1783 53.8886 93.3815 53.0918 92.3986 53.0918C91.4156 53.0918 90.6188 53.8886 90.6188 54.8716Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4594 54.8716C84.4594 55.8545 85.2562 56.6513 86.2392 56.6513C87.2221 56.6513 88.0189 55.8545 88.0189 54.8716C88.0189 53.8886 87.2221 53.0918 86.2392 53.0918C85.2562 53.0918 84.4594 53.8886 84.4594 54.8716Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2898 54.8755C78.2898 55.8584 79.0867 56.6552 80.0696 56.6552C81.0525 56.6552 81.8494 55.8584 81.8494 54.8755C81.8494 53.8925 81.0525 53.0957 80.0696 53.0957C79.0867 53.0957 78.2898 53.8925 78.2898 54.8755Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1309 54.8755C72.1309 55.8584 72.9277 56.6552 73.9107 56.6552C74.8936 56.6552 75.6904 55.8584 75.6904 54.8755C75.6904 53.8925 74.8936 53.0957 73.9107 53.0957C72.9277 53.0957 72.1309 53.8925 72.1309 54.8755Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9149 54.8755C65.9149 55.8584 66.7118 56.6552 67.6947 56.6552C68.6777 56.6552 69.4745 55.8584 69.4745 54.8755C69.4745 53.8925 68.6777 53.0957 67.6947 53.0957C66.7118 53.0957 65.9149 53.8925 65.9149 54.8755Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.756 54.8755C59.756 55.8584 60.5528 56.6552 61.5358 56.6552C62.5187 56.6552 63.3156 55.8584 63.3156 54.8755C63.3156 53.8925 62.5187 53.0957 61.5358 53.0957C60.5528 53.0957 59.756 53.8925 59.756 54.8755Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6073 54.8664C53.6073 55.8493 54.4042 56.6461 55.3871 56.6461C56.37 56.6461 57.1669 55.8493 57.1669 54.8664C57.1669 53.8834 56.37 53.0866 55.3871 53.0866C54.4042 53.0866 53.6073 53.8834 53.6073 54.8664Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4479 54.8664C47.4479 55.8493 48.2447 56.6461 49.2277 56.6461C50.2106 56.6461 51.0074 55.8493 51.0074 54.8664C51.0074 53.8834 50.2106 53.0866 49.2277 53.0866C48.2447 53.0866 47.4479 53.8834 47.4479 54.8664Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2475 54.8755C41.2475 55.8584 42.0443 56.6552 43.0272 56.6552C44.0102 56.6552 44.807 55.8584 44.807 54.8755C44.807 53.8925 44.0102 53.0957 43.0272 53.0957C42.0443 53.0957 41.2475 53.8925 41.2475 54.8755Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.0884 54.8755C35.0884 55.8584 35.8852 56.6552 36.8682 56.6552C37.8511 56.6552 38.6479 55.8584 38.6479 54.8755C38.6479 53.8925 37.8511 53.0957 36.8682 53.0957C35.8852 53.0957 35.0884 53.8925 35.0884 54.8755Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9241 54.8755C28.9241 55.8584 29.7209 56.6552 30.7039 56.6552C31.6868 56.6552 32.4836 55.8584 32.4836 54.8755C32.4836 53.8925 31.6868 53.0957 30.7039 53.0957C29.7209 53.0957 28.9241 53.8925 28.9241 54.8755Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7649 54.8755C22.7649 55.8584 23.5618 56.6552 24.5447 56.6552C25.5276 56.6552 26.3245 55.8584 26.3245 54.8755C26.3245 53.8925 25.5276 53.0957 24.5447 53.0957C23.5618 53.0957 22.7649 53.8925 22.7649 54.8755Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5645 54.8755C16.5645 55.8584 17.3613 56.6552 18.3443 56.6552C19.3272 56.6552 20.124 55.8584 20.124 54.8755C20.124 53.8925 19.3272 53.0957 18.3443 53.0957C17.3613 53.0957 16.5645 53.8925 16.5645 54.8755Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.4054 54.8755C10.4054 55.8584 11.2023 56.6552 12.1852 56.6552C13.1681 56.6552 13.965 55.8584 13.965 54.8755C13.965 53.8925 13.1681 53.0957 12.1852 53.0957C11.2023 53.0957 10.4054 53.8925 10.4054 54.8755Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 60.1732C149.259 61.1562 150.056 61.953 151.039 61.953C152.022 61.953 152.819 61.1562 152.819 60.1732C152.819 59.1903 152.022 58.3935 151.039 58.3935C150.056 58.3935 149.259 59.1903 149.259 60.1732Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.1 60.1732C143.1 61.1562 143.896 61.953 144.879 61.953C145.862 61.953 146.659 61.1562 146.659 60.1732C146.659 59.1903 145.862 58.3935 144.879 58.3935C143.896 58.3935 143.1 59.1903 143.1 60.1732Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 60.1732C136.883 61.1562 137.68 61.953 138.663 61.953C139.646 61.953 140.443 61.1562 140.443 60.1732C140.443 59.1903 139.646 58.3935 138.663 58.3935C137.68 58.3935 136.883 59.1903 136.883 60.1732Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.724 60.1732C130.724 61.1562 131.521 61.953 132.504 61.953C133.487 61.953 134.284 61.1562 134.284 60.1732C134.284 59.1903 133.487 58.3935 132.504 58.3935C131.521 58.3935 130.724 59.1903 130.724 60.1732Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 60.1628C124.576 61.1458 125.373 61.9426 126.356 61.9426C127.339 61.9426 128.135 61.1458 128.135 60.1628C128.135 59.1799 127.339 58.383 126.356 58.383C125.373 58.383 124.576 59.1799 124.576 60.1628Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.417 60.1628C118.417 61.1458 119.214 61.9426 120.197 61.9426C121.179 61.9426 121.976 61.1458 121.976 60.1628C121.976 59.1799 121.179 58.383 120.197 58.383C119.214 58.383 118.417 59.1799 118.417 60.1628Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 60.1732C112.216 61.1562 113.013 61.953 113.996 61.953C114.979 61.953 115.776 61.1562 115.776 60.1732C115.776 59.1903 114.979 58.3935 113.996 58.3935C113.013 58.3935 112.216 59.1903 112.216 60.1732Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.057 60.1732C106.057 61.1562 106.854 61.953 107.837 61.953C108.82 61.953 109.616 61.1562 109.616 60.1732C109.616 59.1903 108.82 58.3935 107.837 58.3935C106.854 58.3935 106.057 59.1903 106.057 60.1732Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 60.1732C99.8931 61.1562 100.69 61.953 101.673 61.953C102.656 61.953 103.453 61.1562 103.453 60.1732C103.453 59.1903 102.656 58.3935 101.673 58.3935C100.69 58.3935 99.8931 59.1903 99.8931 60.1732Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.7337 60.1732C93.7337 61.1561 94.5305 61.953 95.5134 61.953C96.4964 61.953 97.2932 61.1561 97.2932 60.1732C97.2932 59.1903 96.4964 58.3934 95.5134 58.3934C94.5305 58.3934 93.7337 59.1903 93.7337 60.1732Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5332 60.1732C87.5332 61.1562 88.3301 61.953 89.313 61.953C90.2959 61.953 91.0928 61.1562 91.0928 60.1732C91.0928 59.1903 90.2959 58.3935 89.313 58.3935C88.3301 58.3935 87.5332 59.1903 87.5332 60.1732Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3741 60.1732C81.3741 61.1562 82.1709 61.953 83.1538 61.953C84.1368 61.953 84.9336 61.1562 84.9336 60.1732C84.9336 59.1903 84.1368 58.3935 83.1538 58.3935C82.1709 58.3935 81.3741 59.1903 81.3741 60.1732Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 60.1772C75.2046 61.1601 76.0014 61.9569 76.9844 61.9569C77.9673 61.9569 78.7642 61.1601 78.7642 60.1772C78.7642 59.1942 77.9673 58.3974 76.9844 58.3974C76.0014 58.3974 75.2046 59.1942 75.2046 60.1772Z"
            fill="#B8B7B7"
          />
          <path
            d="M69.0458 60.1772C69.0458 61.1601 69.8426 61.9569 70.8256 61.9569C71.8085 61.9569 72.6053 61.1601 72.6053 60.1772C72.6053 59.1942 71.8085 58.3974 70.8256 58.3974C69.8426 58.3974 69.0458 59.1942 69.0458 60.1772Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 60.1772C62.8294 61.1601 63.6262 61.9569 64.6091 61.9569C65.5921 61.9569 66.3889 61.1601 66.3889 60.1772C66.3889 59.1942 65.5921 58.3974 64.6091 58.3974C63.6262 58.3974 62.8294 59.1942 62.8294 60.1772Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6704 60.1772C56.6704 61.1601 57.4673 61.9569 58.4502 61.9569C59.4331 61.9569 60.23 61.1601 60.23 60.1772C60.23 59.1942 59.4332 58.3974 58.4502 58.3974C57.4673 58.3974 56.6704 59.1942 56.6704 60.1772Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 60.168C50.5216 61.151 51.3185 61.9478 52.3014 61.9478C53.2843 61.9478 54.0812 61.151 54.0812 60.168C54.0812 59.1851 53.2843 58.3883 52.3014 58.3883C51.3185 58.3883 50.5216 59.1851 50.5216 60.168Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3627 60.168C44.3627 61.151 45.1595 61.9478 46.1425 61.9478C47.1254 61.9478 47.9222 61.151 47.9222 60.168C47.9222 59.1851 47.1254 58.3883 46.1425 58.3883C45.1595 58.3883 44.3627 59.1851 44.3627 60.168Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 60.1771C38.1634 61.16 38.9602 61.9569 39.9431 61.9569C40.9261 61.9569 41.7229 61.16 41.7229 60.1771C41.7229 59.1942 40.9261 58.3973 39.9431 58.3973C38.9602 58.3973 38.1634 59.1942 38.1634 60.1771Z"
            fill="#B8B7B7"
          />
          <path
            d="M32.0044 60.1771C32.0044 61.16 32.8013 61.9569 33.7842 61.9569C34.7671 61.9569 35.564 61.16 35.564 60.1771C35.564 59.1942 34.7671 58.3973 33.7842 58.3973C32.8013 58.3973 32.0044 59.1942 32.0044 60.1771Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 60.1771C25.8387 61.16 26.6355 61.9569 27.6184 61.9569C28.6014 61.9569 29.3982 61.16 29.3982 60.1771C29.3982 59.1942 28.6014 58.3973 27.6184 58.3973C26.6355 58.3973 25.8387 59.1942 25.8387 60.1771Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6797 60.1771C19.6797 61.16 20.4765 61.9569 21.4595 61.9569C22.4424 61.9569 23.2393 61.16 23.2393 60.1771C23.2393 59.1942 22.4424 58.3973 21.4595 58.3973C20.4765 58.3973 19.6797 59.1942 19.6797 60.1771Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4804 60.1771C13.4804 61.16 14.2772 61.9569 15.2601 61.9569C16.2431 61.9569 17.0399 61.16 17.0399 60.1771C17.0399 59.1942 16.2431 58.3973 15.2601 58.3973C14.2772 58.3973 13.4804 59.1942 13.4804 60.1771Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.32144 60.1771C7.32144 61.16 8.11827 61.9569 9.10121 61.9569C10.0842 61.9569 10.881 61.16 10.881 60.1771C10.881 59.1942 10.0842 58.3973 9.10121 58.3973C8.11827 58.3973 7.32144 59.1942 7.32144 60.1771Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.343 65.4177C152.343 66.4006 153.14 67.1974 154.123 67.1974C155.106 67.1974 155.903 66.4006 155.903 65.4177C155.903 64.4347 155.106 63.6379 154.123 63.6379C153.14 63.6379 152.343 64.4347 152.343 65.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.185 65.4177C146.185 66.4006 146.982 67.1974 147.965 67.1974C148.948 67.1974 149.744 66.4006 149.744 65.4177C149.744 64.4347 148.948 63.6379 147.965 63.6379C146.982 63.6379 146.185 64.4347 146.185 65.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.969 65.4177C139.969 66.4006 140.766 67.1974 141.749 67.1974C142.732 67.1974 143.529 66.4006 143.529 65.4177C143.529 64.4347 142.732 63.6379 141.749 63.6379C140.766 63.6379 139.969 64.4347 139.969 65.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.81 65.4177C133.81 66.4006 134.607 67.1974 135.589 67.1974C136.572 67.1974 137.369 66.4006 137.369 65.4177C137.369 64.4347 136.572 63.6379 135.589 63.6379C134.607 63.6379 133.81 64.4347 133.81 65.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.66 65.4073C127.66 66.3902 128.457 67.1871 129.44 67.1871C130.423 67.1871 131.22 66.3902 131.22 65.4073C131.22 64.4244 130.423 63.6275 129.44 63.6275C128.457 63.6275 127.66 64.4244 127.66 65.4073Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.502 65.4073C121.502 66.3902 122.299 67.1871 123.282 67.1871C124.265 67.1871 125.062 66.3902 125.062 65.4073C125.062 64.4244 124.265 63.6275 123.282 63.6275C122.299 63.6275 121.502 64.4244 121.502 65.4073Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.302 65.4177C115.302 66.4006 116.099 67.1975 117.082 67.1975C118.064 67.1975 118.861 66.4006 118.861 65.4177C118.861 64.4348 118.064 63.6379 117.082 63.6379C116.099 63.6379 115.302 64.4348 115.302 65.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.143 65.4177C109.143 66.4006 109.939 67.1975 110.922 67.1975C111.905 67.1975 112.702 66.4006 112.702 65.4177C112.702 64.4348 111.905 63.6379 110.922 63.6379C109.939 63.6379 109.143 64.4348 109.143 65.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.977 65.4177C102.977 66.4006 103.774 67.1975 104.757 67.1975C105.74 67.1975 106.537 66.4006 106.537 65.4177C106.537 64.4348 105.74 63.6379 104.757 63.6379C103.774 63.6379 102.977 64.4348 102.977 65.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8192 65.4177C96.8192 66.4006 97.6161 67.1975 98.599 67.1975C99.582 67.1975 100.379 66.4006 100.379 65.4177C100.379 64.4348 99.582 63.6379 98.599 63.6379C97.6161 63.6379 96.8192 64.4348 96.8192 65.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6188 65.4177C90.6188 66.4006 91.4156 67.1975 92.3986 67.1975C93.3815 67.1975 94.1783 66.4006 94.1783 65.4177C94.1783 64.4348 93.3815 63.6379 92.3986 63.6379C91.4156 63.6379 90.6188 64.4348 90.6188 65.4177Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4594 65.4176C84.4594 66.4006 85.2562 67.1974 86.2392 67.1974C87.2221 67.1974 88.0189 66.4006 88.0189 65.4176C88.0189 64.4347 87.2221 63.6379 86.2392 63.6379C85.2562 63.6379 84.4594 64.4347 84.4594 65.4176Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2898 65.4216C78.2898 66.4045 79.0867 67.2014 80.0696 67.2014C81.0525 67.2014 81.8494 66.4045 81.8494 65.4216C81.8494 64.4386 81.0525 63.6418 80.0696 63.6418C79.0867 63.6418 78.2898 64.4386 78.2898 65.4216Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1309 65.4216C72.1309 66.4045 72.9277 67.2014 73.9107 67.2014C74.8936 67.2014 75.6904 66.4045 75.6904 65.4216C75.6904 64.4386 74.8936 63.6418 73.9107 63.6418C72.9277 63.6418 72.1309 64.4386 72.1309 65.4216Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9149 65.4216C65.9149 66.4045 66.7118 67.2014 67.6947 67.2014C68.6777 67.2014 69.4745 66.4045 69.4745 65.4216C69.4745 64.4386 68.6777 63.6418 67.6947 63.6418C66.7118 63.6418 65.9149 64.4386 65.9149 65.4216Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.756 65.4216C59.756 66.4045 60.5528 67.2014 61.5358 67.2014C62.5187 67.2014 63.3156 66.4045 63.3156 65.4216C63.3156 64.4386 62.5187 63.6418 61.5358 63.6418C60.5528 63.6418 59.756 64.4386 59.756 65.4216Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6073 65.4125C53.6073 66.3954 54.4042 67.1923 55.3871 67.1923C56.37 67.1923 57.1669 66.3954 57.1669 65.4125C57.1669 64.4296 56.37 63.6327 55.3871 63.6327C54.4042 63.6327 53.6073 64.4296 53.6073 65.4125Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4479 65.4125C47.4479 66.3954 48.2447 67.1922 49.2277 67.1922C50.2106 67.1922 51.0074 66.3954 51.0074 65.4125C51.0074 64.4295 50.2106 63.6327 49.2277 63.6327C48.2447 63.6327 47.4479 64.4295 47.4479 65.4125Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2475 65.4216C41.2475 66.4045 42.0443 67.2014 43.0272 67.2014C44.0102 67.2014 44.807 66.4045 44.807 65.4216C44.807 64.4386 44.0102 63.6418 43.0272 63.6418C42.0443 63.6418 41.2475 64.4386 41.2475 65.4216Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.0884 65.4216C35.0884 66.4045 35.8852 67.2014 36.8682 67.2014C37.8511 67.2014 38.6479 66.4045 38.6479 65.4216C38.6479 64.4386 37.8511 63.6418 36.8682 63.6418C35.8852 63.6418 35.0884 64.4386 35.0884 65.4216Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9241 65.4216C28.9241 66.4045 29.7209 67.2014 30.7039 67.2014C31.6868 67.2014 32.4836 66.4045 32.4836 65.4216C32.4836 64.4386 31.6868 63.6418 30.7039 63.6418C29.7209 63.6418 28.9241 64.4386 28.9241 65.4216Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7649 65.4216C22.7649 66.4045 23.5618 67.2014 24.5447 67.2014C25.5276 67.2014 26.3245 66.4045 26.3245 65.4216C26.3245 64.4386 25.5276 63.6418 24.5447 63.6418C23.5618 63.6418 22.7649 64.4386 22.7649 65.4216Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5645 65.4216C16.5645 66.4045 17.3613 67.2014 18.3443 67.2014C19.3272 67.2014 20.124 66.4045 20.124 65.4216C20.124 64.4386 19.3272 63.6418 18.3443 63.6418C17.3613 63.6418 16.5645 64.4386 16.5645 65.4216Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.4055 65.4216C10.4055 66.4045 11.2024 67.2014 12.1853 67.2014C13.1683 67.2014 13.9651 66.4045 13.9651 65.4216C13.9651 64.4386 13.1683 63.6418 12.1853 63.6418C11.2024 63.6418 10.4055 64.4386 10.4055 65.4216Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 60.1446C155.418 61.1276 156.215 61.9244 157.198 61.9244C158.181 61.9244 158.978 61.1276 158.978 60.1446C158.978 59.1617 158.181 58.3649 157.198 58.3649C156.215 58.3649 155.418 59.1617 155.418 60.1446Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 70.6011C155.418 71.584 156.215 72.3809 157.198 72.3809C158.181 72.3809 158.978 71.584 158.978 70.6011C158.978 69.6182 158.181 68.8213 157.198 68.8213C156.215 68.8213 155.418 69.6182 155.418 70.6011Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 70.6011C149.259 71.584 150.056 72.3809 151.039 72.3809C152.022 72.3809 152.819 71.584 152.819 70.6011C152.819 69.6182 152.022 68.8213 151.039 68.8213C150.056 68.8213 149.259 69.6182 149.259 70.6011Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.042 70.6011C143.042 71.584 143.839 72.3809 144.822 72.3809C145.805 72.3809 146.602 71.584 146.602 70.6011C146.602 69.6182 145.805 68.8213 144.822 68.8213C143.839 68.8213 143.042 69.6182 143.042 70.6011Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 70.6011C136.883 71.584 137.68 72.3809 138.663 72.3809C139.646 72.3809 140.443 71.584 140.443 70.6011C140.443 69.6182 139.646 68.8213 138.663 68.8213C137.68 68.8213 136.883 69.6182 136.883 70.6011Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.735 70.5907C130.735 71.5736 131.532 72.3705 132.515 72.3705C133.498 72.3705 134.294 71.5736 134.294 70.5907C134.294 69.6077 133.498 68.8109 132.515 68.8109C131.532 68.8109 130.735 69.6077 130.735 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 70.5907C124.576 71.5736 125.373 72.3705 126.356 72.3705C127.339 72.3705 128.135 71.5736 128.135 70.5907C128.135 69.6077 127.339 68.8109 126.356 68.8109C125.373 68.8109 124.576 69.6077 124.576 70.5907Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.375 70.6011C118.375 71.584 119.172 72.3809 120.155 72.3809C121.138 72.3809 121.935 71.584 121.935 70.6011C121.935 69.6182 121.138 68.8213 120.155 68.8213C119.172 68.8213 118.375 69.6182 118.375 70.6011Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 70.6011C112.216 71.584 113.013 72.3809 113.996 72.3809C114.979 72.3809 115.776 71.584 115.776 70.6011C115.776 69.6182 114.979 68.8213 113.996 68.8213C113.013 68.8213 112.216 69.6182 112.216 70.6011Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.052 70.6011C106.052 71.584 106.849 72.3809 107.832 72.3809C108.815 72.3809 109.611 71.584 109.611 70.6011C109.611 69.6182 108.815 68.8213 107.832 68.8213C106.849 68.8213 106.052 69.6182 106.052 70.6011Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 70.6011C99.8931 71.584 100.69 72.3809 101.673 72.3809C102.656 72.3809 103.453 71.584 103.453 70.6011C103.453 69.6182 102.656 68.8213 101.673 68.8213C100.69 68.8213 99.8931 69.6182 99.8931 70.6011Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.6922 70.6011C93.6922 71.5841 94.489 72.3809 95.4719 72.3809C96.4549 72.3809 97.2517 71.5841 97.2517 70.6011C97.2517 69.6182 96.4549 68.8213 95.4719 68.8213C94.489 68.8213 93.6922 69.6182 93.6922 70.6011Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5332 70.6011C87.5332 71.5841 88.3301 72.3809 89.313 72.3809C90.2959 72.3809 91.0928 71.5841 91.0928 70.6011C91.0928 69.6182 90.2959 68.8213 89.313 68.8213C88.3301 68.8213 87.5332 69.6182 87.5332 70.6011Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3638 70.605C81.3638 71.5879 82.1606 72.3848 83.1436 72.3848C84.1265 72.3848 84.9233 71.5879 84.9233 70.605C84.9233 69.6221 84.1265 68.8252 83.1436 68.8252C82.1606 68.8252 81.3638 69.6221 81.3638 70.605Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 70.605C75.2046 71.5879 76.0014 72.3848 76.9844 72.3848C77.9673 72.3848 78.7642 71.5879 78.7642 70.605C78.7642 69.6221 77.9673 68.8252 76.9844 68.8252C76.0014 68.8252 75.2046 69.6221 75.2046 70.605Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9887 70.605C68.9887 71.5879 69.7855 72.3848 70.7684 72.3848C71.7514 72.3848 72.5482 71.5879 72.5482 70.605C72.5482 69.6221 71.7514 68.8252 70.7684 68.8252C69.7855 68.8252 68.9887 69.6221 68.9887 70.605Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 70.605C62.8294 71.5879 63.6262 72.3848 64.6091 72.3848C65.5921 72.3848 66.3889 71.5879 66.3889 70.605C66.3889 69.6221 65.5921 68.8252 64.6091 68.8252C63.6262 68.8252 62.8294 69.6221 62.8294 70.605Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6808 70.5959C56.6808 71.5788 57.4776 72.3756 58.4606 72.3756C59.4435 72.3756 60.2404 71.5788 60.2404 70.5959C60.2404 69.6129 59.4435 68.8161 58.4606 68.8161C57.4776 68.8161 56.6808 69.6129 56.6808 70.5959Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 70.5959C50.5216 71.5788 51.3185 72.3756 52.3014 72.3756C53.2843 72.3756 54.0812 71.5788 54.0812 70.5959C54.0812 69.6129 53.2843 68.8161 52.3014 68.8161C51.3185 68.8161 50.5216 69.6129 50.5216 70.5959Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3225 70.605C44.3225 71.5879 45.1194 72.3848 46.1023 72.3848C47.0852 72.3848 47.8821 71.5879 47.8821 70.605C47.8821 69.6221 47.0852 68.8252 46.1023 68.8252C45.1194 68.8252 44.3225 69.6221 44.3225 70.605Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 70.605C38.1634 71.5879 38.9602 72.3848 39.9431 72.3848C40.9261 72.3848 41.7229 71.5879 41.7229 70.605C41.7229 69.6221 40.9261 68.8252 39.9431 68.8252C38.9602 68.8252 38.1634 69.6221 38.1634 70.605Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.998 70.605C31.998 71.5879 32.7948 72.3848 33.7777 72.3848C34.7607 72.3848 35.5575 71.5879 35.5575 70.605C35.5575 69.6221 34.7607 68.8252 33.7777 68.8252C32.7948 68.8252 31.998 69.6221 31.998 70.605Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 70.605C25.8387 71.5879 26.6355 72.3848 27.6184 72.3848C28.6014 72.3848 29.3982 71.5879 29.3982 70.605C29.3982 69.6221 28.6014 68.8252 27.6184 68.8252C26.6355 68.8252 25.8387 69.6221 25.8387 70.605Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6396 70.605C19.6396 71.5879 20.4364 72.3848 21.4193 72.3848C22.4023 72.3848 23.1991 71.5879 23.1991 70.605C23.1991 69.6221 22.4023 68.8252 21.4193 68.8252C20.4364 68.8252 19.6396 69.6221 19.6396 70.605Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4804 70.605C13.4804 71.5879 14.2772 72.3848 15.2601 72.3848C16.2431 72.3848 17.0399 71.5879 17.0399 70.605C17.0399 69.622 16.2431 68.8252 15.2601 68.8252C14.2772 68.8252 13.4804 69.622 13.4804 70.605Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.333 75.9014C152.333 76.8844 153.129 77.6812 154.112 77.6812C155.095 77.6812 155.892 76.8844 155.892 75.9014C155.892 74.9185 155.095 74.1217 154.112 74.1217C153.129 74.1217 152.333 74.9185 152.333 75.9014Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.173 75.9014C146.173 76.8844 146.97 77.6812 147.953 77.6812C148.936 77.6812 149.733 76.8844 149.733 75.9014C149.733 74.9185 148.936 74.1217 147.953 74.1217C146.97 74.1217 146.173 74.9185 146.173 75.9014Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.957 75.9014C139.957 76.8844 140.754 77.6812 141.737 77.6812C142.72 77.6812 143.517 76.8844 143.517 75.9014C143.517 74.9185 142.72 74.1217 141.737 74.1217C140.754 74.1217 139.957 74.9185 139.957 75.9014Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.798 75.9014C133.798 76.8844 134.595 77.6812 135.578 77.6812C136.561 77.6812 137.358 76.8844 137.358 75.9014C137.358 74.9185 136.561 74.1217 135.578 74.1217C134.595 74.1217 133.798 74.9185 133.798 75.9014Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.65 75.8924C127.65 76.8753 128.447 77.6722 129.43 77.6722C130.413 77.6722 131.209 76.8753 131.209 75.8924C131.209 74.9095 130.413 74.1126 129.43 74.1126C128.447 74.1126 127.65 74.9095 127.65 75.8924Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.491 75.8924C121.491 76.8753 122.287 77.6722 123.27 77.6722C124.253 77.6722 125.05 76.8753 125.05 75.8924C125.05 74.9095 124.253 74.1126 123.27 74.1126C122.287 74.1126 121.491 74.9095 121.491 75.8924Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.291 75.9014C115.291 76.8844 116.088 77.6812 117.071 77.6812C118.054 77.6812 118.851 76.8844 118.851 75.9014C118.851 74.9185 118.054 74.1217 117.071 74.1217C116.088 74.1217 115.291 74.9185 115.291 75.9014Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.132 75.9014C109.132 76.8844 109.929 77.6812 110.912 77.6812C111.895 77.6812 112.692 76.8844 112.692 75.9014C112.692 74.9185 111.895 74.1217 110.912 74.1217C109.929 74.1217 109.132 74.9185 109.132 75.9014Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.967 75.9015C102.967 76.8844 103.764 77.6812 104.747 77.6812C105.73 77.6812 106.526 76.8844 106.526 75.9015C106.526 74.9185 105.73 74.1217 104.747 74.1217C103.764 74.1217 102.967 74.9185 102.967 75.9015Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8074 75.9015C96.8074 76.8844 97.6042 77.6812 98.5872 77.6812C99.5701 77.6812 100.367 76.8844 100.367 75.9015C100.367 74.9185 99.5701 74.1217 98.5872 74.1217C97.6042 74.1217 96.8074 74.9185 96.8074 75.9015Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6079 75.9015C90.6079 76.8844 91.4048 77.6812 92.3877 77.6812C93.3706 77.6812 94.1675 76.8844 94.1675 75.9015C94.1675 74.9185 93.3707 74.1217 92.3877 74.1217C91.4048 74.1217 90.6079 74.9185 90.6079 75.9015Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4491 75.9015C84.4491 76.8844 85.246 77.6812 86.2289 77.6812C87.2118 77.6812 88.0087 76.8844 88.0087 75.9015C88.0087 74.9185 87.2118 74.1217 86.2289 74.1217C85.246 74.1217 84.4491 74.9185 84.4491 75.9015Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2783 75.9066C78.2783 76.8896 79.0752 77.6864 80.0581 77.6864C81.0411 77.6864 81.8379 76.8896 81.8379 75.9066C81.8379 74.9237 81.0411 74.1269 80.0581 74.1269C79.0752 74.1269 78.2783 74.9237 78.2783 75.9066Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1205 75.9066C72.1205 76.8896 72.9173 77.6864 73.9003 77.6864C74.8832 77.6864 75.6801 76.8896 75.6801 75.9066C75.6801 74.9237 74.8832 74.1269 73.9003 74.1269C72.9173 74.1269 72.1205 74.9237 72.1205 75.9066Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9046 75.9066C65.9046 76.8896 66.7014 77.6864 67.6843 77.6864C68.6673 77.6864 69.4641 76.8896 69.4641 75.9066C69.4641 74.9237 68.6673 74.1269 67.6843 74.1269C66.7014 74.1269 65.9046 74.9237 65.9046 75.9066Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.7453 75.9067C59.7453 76.8896 60.5421 77.6864 61.525 77.6864C62.508 77.6864 63.3048 76.8896 63.3048 75.9067C63.3048 74.9237 62.508 74.1269 61.525 74.1269C60.5421 74.1269 59.7453 74.9237 59.7453 75.9067Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.5954 75.8976C53.5954 76.8805 54.3922 77.6774 55.3751 77.6774C56.3581 77.6774 57.1549 76.8805 57.1549 75.8976C57.1549 74.9147 56.3581 74.1178 55.3751 74.1178C54.3922 74.1178 53.5954 74.9147 53.5954 75.8976Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.438 75.8976C47.438 76.8805 48.2348 77.6774 49.2178 77.6774C50.2007 77.6774 50.9976 76.8805 50.9976 75.8976C50.9976 74.9147 50.2007 74.1178 49.2178 74.1178C48.2348 74.1178 47.438 74.9147 47.438 75.8976Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.237 75.9066C41.237 76.8896 42.0338 77.6864 43.0167 77.6864C43.9997 77.6864 44.7965 76.8896 44.7965 75.9066C44.7965 74.9237 43.9997 74.1269 43.0167 74.1269C42.0338 74.1269 41.237 74.9237 41.237 75.9066Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.078 75.9066C35.078 76.8896 35.8749 77.6864 36.8578 77.6864C37.8407 77.6864 38.6376 76.8896 38.6376 75.9066C38.6376 74.9237 37.8407 74.1269 36.8578 74.1269C35.8749 74.1269 35.078 74.9237 35.078 75.9066Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9124 75.9066C28.9124 76.8896 29.7092 77.6864 30.6922 77.6864C31.6751 77.6864 32.4719 76.8896 32.4719 75.9066C32.4719 74.9237 31.6751 74.1269 30.6922 74.1269C29.7092 74.1269 28.9124 74.9237 28.9124 75.9066Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7549 75.9066C22.7549 76.8896 23.5517 77.6864 24.5347 77.6864C25.5176 77.6864 26.3145 76.8896 26.3145 75.9066C26.3145 74.9237 25.5176 74.1269 24.5347 74.1269C23.5517 74.1269 22.7549 74.9237 22.7549 75.9066Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.554 75.9066C16.554 76.8896 17.3508 77.6864 18.3338 77.6864C19.3167 77.6864 20.1135 76.8896 20.1135 75.9066C20.1135 74.9237 19.3167 74.1269 18.3338 74.1269C17.3508 74.1269 16.554 74.9237 16.554 75.9066Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.3952 75.9066C10.3952 76.8896 11.192 77.6864 12.1749 77.6864C13.1579 77.6864 13.9547 76.8896 13.9547 75.9066C13.9547 74.9237 13.1579 74.1269 12.1749 74.1269C11.192 74.1269 10.3952 74.9237 10.3952 75.9066Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 81.1472C155.418 82.1302 156.215 82.927 157.198 82.927C158.181 82.927 158.978 82.1302 158.978 81.1472C158.978 80.1643 158.181 79.3674 157.198 79.3674C156.215 79.3674 155.418 80.1643 155.418 81.1472Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 81.1472C149.259 82.1302 150.056 82.927 151.039 82.927C152.022 82.927 152.819 82.1302 152.819 81.1472C152.819 80.1643 152.022 79.3674 151.039 79.3674C150.056 79.3674 149.259 80.1643 149.259 81.1472Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.042 81.1472C143.042 82.1302 143.839 82.927 144.822 82.927C145.805 82.927 146.602 82.1302 146.602 81.1472C146.602 80.1643 145.805 79.3674 144.822 79.3674C143.839 79.3674 143.042 80.1643 143.042 81.1472Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 81.1472C136.883 82.1302 137.68 82.927 138.663 82.927C139.646 82.927 140.443 82.1302 140.443 81.1472C140.443 80.1643 139.646 79.3674 138.663 79.3674C137.68 79.3674 136.883 80.1643 136.883 81.1472Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.735 81.1368C130.735 82.1197 131.532 82.9166 132.515 82.9166C133.498 82.9166 134.294 82.1197 134.294 81.1368C134.294 80.1539 133.498 79.357 132.515 79.357C131.532 79.357 130.735 80.1539 130.735 81.1368Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 81.1368C124.576 82.1197 125.373 82.9166 126.356 82.9166C127.339 82.9166 128.135 82.1197 128.135 81.1368C128.135 80.1539 127.339 79.357 126.356 79.357C125.373 79.357 124.576 80.1539 124.576 81.1368Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.375 81.1472C118.375 82.1302 119.172 82.927 120.155 82.927C121.138 82.927 121.935 82.1302 121.935 81.1472C121.935 80.1643 121.138 79.3675 120.155 79.3675C119.172 79.3675 118.375 80.1643 118.375 81.1472Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 81.1472C112.216 82.1302 113.013 82.927 113.996 82.927C114.979 82.927 115.776 82.1302 115.776 81.1472C115.776 80.1643 114.979 79.3675 113.996 79.3675C113.013 79.3675 112.216 80.1643 112.216 81.1472Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.052 81.1472C106.052 82.1302 106.849 82.927 107.832 82.927C108.815 82.927 109.611 82.1302 109.611 81.1472C109.611 80.1643 108.815 79.3675 107.832 79.3675C106.849 79.3675 106.052 80.1643 106.052 81.1472Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 81.1472C99.8931 82.1302 100.69 82.927 101.673 82.927C102.656 82.927 103.453 82.1302 103.453 81.1472C103.453 80.1643 102.656 79.3675 101.673 79.3675C100.69 79.3675 99.8931 80.1643 99.8931 81.1472Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.6922 81.1472C93.6922 82.1302 94.489 82.927 95.4719 82.927C96.4549 82.927 97.2517 82.1302 97.2517 81.1472C97.2517 80.1643 96.4549 79.3675 95.4719 79.3675C94.489 79.3675 93.6922 80.1643 93.6922 81.1472Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5332 81.1472C87.5332 82.1302 88.3301 82.927 89.313 82.927C90.2959 82.927 91.0928 82.1302 91.0928 81.1472C91.0928 80.1643 90.2959 79.3675 89.313 79.3675C88.3301 79.3675 87.5332 80.1643 87.5332 81.1472Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3638 81.1511C81.3638 82.134 82.1606 82.9309 83.1436 82.9309C84.1265 82.9309 84.9233 82.134 84.9233 81.1511C84.9233 80.1681 84.1265 79.3713 83.1436 79.3713C82.1606 79.3713 81.3638 80.1681 81.3638 81.1511Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 81.1511C75.2046 82.134 76.0014 82.9309 76.9844 82.9309C77.9673 82.9309 78.7642 82.134 78.7642 81.1511C78.7642 80.1681 77.9673 79.3713 76.9844 79.3713C76.0014 79.3713 75.2046 80.1681 75.2046 81.1511Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9887 81.1511C68.9887 82.134 69.7855 82.9309 70.7684 82.9309C71.7514 82.9309 72.5482 82.134 72.5482 81.1511C72.5482 80.1681 71.7514 79.3713 70.7684 79.3713C69.7855 79.3713 68.9887 80.1681 68.9887 81.1511Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 81.1511C62.8294 82.134 63.6262 82.9309 64.6091 82.9309C65.5921 82.9309 66.3889 82.134 66.3889 81.1511C66.3889 80.1681 65.5921 79.3713 64.6091 79.3713C63.6262 79.3713 62.8294 80.1681 62.8294 81.1511Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6808 81.142C56.6808 82.125 57.4776 82.9218 58.4606 82.9218C59.4435 82.9218 60.2404 82.125 60.2404 81.142C60.2404 80.1591 59.4435 79.3623 58.4606 79.3623C57.4776 79.3623 56.6808 80.1591 56.6808 81.142Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 81.142C50.5216 82.125 51.3185 82.9218 52.3014 82.9218C53.2843 82.9218 54.0812 82.125 54.0812 81.142C54.0812 80.1591 53.2843 79.3623 52.3014 79.3623C51.3185 79.3623 50.5216 80.1591 50.5216 81.142Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3225 81.1511C44.3225 82.134 45.1194 82.9308 46.1023 82.9308C47.0852 82.9308 47.8821 82.134 47.8821 81.1511C47.8821 80.1681 47.0852 79.3713 46.1023 79.3713C45.1194 79.3713 44.3225 80.1681 44.3225 81.1511Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 81.1511C38.1634 82.134 38.9602 82.9308 39.9431 82.9308C40.9261 82.9308 41.7229 82.134 41.7229 81.1511C41.7229 80.1681 40.9261 79.3713 39.9431 79.3713C38.9602 79.3713 38.1634 80.1681 38.1634 81.1511Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.998 81.1511C31.998 82.134 32.7948 82.9308 33.7777 82.9308C34.7607 82.9308 35.5575 82.134 35.5575 81.1511C35.5575 80.1681 34.7607 79.3713 33.7777 79.3713C32.7948 79.3713 31.998 80.1681 31.998 81.1511Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 81.1511C25.8387 82.134 26.6355 82.9308 27.6184 82.9308C28.6014 82.9308 29.3982 82.134 29.3982 81.1511C29.3982 80.1681 28.6014 79.3713 27.6184 79.3713C26.6355 79.3713 25.8387 80.1681 25.8387 81.1511Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6396 81.1511C19.6396 82.134 20.4364 82.9308 21.4193 82.9308C22.4023 82.9308 23.1991 82.134 23.1991 81.1511C23.1991 80.1681 22.4023 79.3713 21.4193 79.3713C20.4364 79.3713 19.6396 80.1681 19.6396 81.1511Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4804 81.1511C13.4804 82.134 14.2772 82.9308 15.2601 82.9308C16.2431 82.9308 17.0399 82.134 17.0399 81.1511C17.0399 80.1681 16.2431 79.3713 15.2601 79.3713C14.2772 79.3713 13.4804 80.1681 13.4804 81.1511Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.343 86.4371C152.343 87.4201 153.14 88.2169 154.123 88.2169C155.106 88.2169 155.903 87.4201 155.903 86.4371C155.903 85.4542 155.106 84.6574 154.123 84.6574C153.14 84.6574 152.343 85.4542 152.343 86.4371Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.185 86.4371C146.185 87.4201 146.982 88.2169 147.965 88.2169C148.948 88.2169 149.744 87.4201 149.744 86.4371C149.744 85.4542 148.948 84.6574 147.965 84.6574C146.982 84.6574 146.185 85.4542 146.185 86.4371Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.969 86.4371C139.969 87.4201 140.766 88.2169 141.749 88.2169C142.732 88.2169 143.529 87.4201 143.529 86.4371C143.529 85.4542 142.732 84.6574 141.749 84.6574C140.766 84.6574 139.969 85.4542 139.969 86.4371Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.81 86.4371C133.81 87.4201 134.607 88.2169 135.589 88.2169C136.572 88.2169 137.369 87.4201 137.369 86.4371C137.369 85.4542 136.572 84.6574 135.589 84.6574C134.607 84.6574 133.81 85.4542 133.81 86.4371Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.66 86.428C127.66 87.411 128.457 88.2078 129.44 88.2078C130.423 88.2078 131.22 87.411 131.22 86.428C131.22 85.4451 130.423 84.6483 129.44 84.6483C128.457 84.6483 127.66 85.4451 127.66 86.428Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.502 86.428C121.502 87.411 122.299 88.2078 123.282 88.2078C124.265 88.2078 125.062 87.411 125.062 86.428C125.062 85.4451 124.265 84.6483 123.282 84.6483C122.299 84.6483 121.502 85.4451 121.502 86.428Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.302 86.4371C115.302 87.4201 116.099 88.2169 117.082 88.2169C118.064 88.2169 118.861 87.4201 118.861 86.4371C118.861 85.4542 118.064 84.6574 117.082 84.6574C116.099 84.6574 115.302 85.4542 115.302 86.4371Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.143 86.4371C109.143 87.4201 109.939 88.2169 110.922 88.2169C111.905 88.2169 112.702 87.4201 112.702 86.4371C112.702 85.4542 111.905 84.6574 110.922 84.6574C109.939 84.6574 109.143 85.4542 109.143 86.4371Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.977 86.4372C102.977 87.4201 103.774 88.2169 104.757 88.2169C105.74 88.2169 106.537 87.4201 106.537 86.4372C106.537 85.4542 105.74 84.6574 104.757 84.6574C103.774 84.6574 102.977 85.4542 102.977 86.4372Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8192 86.4371C96.8192 87.4201 97.6161 88.2169 98.599 88.2169C99.582 88.2169 100.379 87.4201 100.379 86.4371C100.379 85.4542 99.582 84.6574 98.599 84.6574C97.6161 84.6574 96.8192 85.4542 96.8192 86.4371Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6188 86.4371C90.6188 87.4201 91.4156 88.2169 92.3986 88.2169C93.3815 88.2169 94.1783 87.4201 94.1783 86.4371C94.1783 85.4542 93.3815 84.6574 92.3986 84.6574C91.4156 84.6574 90.6188 85.4542 90.6188 86.4371Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4594 86.4371C84.4594 87.4201 85.2562 88.2169 86.2392 88.2169C87.2221 88.2169 88.0189 87.4201 88.0189 86.4371C88.0189 85.4542 87.2221 84.6574 86.2392 84.6574C85.2562 84.6574 84.4594 85.4542 84.4594 86.4371Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2898 86.4423C78.2898 87.4253 79.0867 88.2221 80.0696 88.2221C81.0525 88.2221 81.8494 87.4253 81.8494 86.4423C81.8494 85.4594 81.0525 84.6626 80.0696 84.6626C79.0867 84.6626 78.2898 85.4594 78.2898 86.4423Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1309 86.4423C72.1309 87.4253 72.9277 88.2221 73.9107 88.2221C74.8936 88.2221 75.6904 87.4253 75.6904 86.4423C75.6904 85.4594 74.8936 84.6626 73.9107 84.6626C72.9277 84.6626 72.1309 85.4594 72.1309 86.4423Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9149 86.4423C65.9149 87.4253 66.7118 88.2221 67.6947 88.2221C68.6777 88.2221 69.4745 87.4253 69.4745 86.4423C69.4745 85.4594 68.6777 84.6626 67.6947 84.6626C66.7118 84.6626 65.9149 85.4594 65.9149 86.4423Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.756 86.4423C59.756 87.4253 60.5528 88.2221 61.5358 88.2221C62.5187 88.2221 63.3156 87.4253 63.3156 86.4423C63.3156 85.4594 62.5187 84.6626 61.5358 84.6626C60.5528 84.6626 59.756 85.4594 59.756 86.4423Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6073 86.432C53.6073 87.4149 54.4042 88.2117 55.3871 88.2117C56.37 88.2117 57.1669 87.4149 57.1669 86.432C57.1669 85.449 56.37 84.6522 55.3871 84.6522C54.4042 84.6522 53.6073 85.449 53.6073 86.432Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4479 86.432C47.4479 87.4149 48.2447 88.2117 49.2277 88.2117C50.2106 88.2117 51.0074 87.4149 51.0074 86.432C51.0074 85.449 50.2106 84.6522 49.2277 84.6522C48.2447 84.6522 47.4479 85.449 47.4479 86.432Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2475 86.4423C41.2475 87.4252 42.0443 88.2221 43.0272 88.2221C44.0102 88.2221 44.807 87.4252 44.807 86.4423C44.807 85.4594 44.0102 84.6625 43.0272 84.6625C42.0443 84.6625 41.2475 85.4594 41.2475 86.4423Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.0884 86.4423C35.0884 87.4252 35.8852 88.2221 36.8682 88.2221C37.8511 88.2221 38.6479 87.4252 38.6479 86.4423C38.6479 85.4594 37.8511 84.6625 36.8682 84.6625C35.8852 84.6625 35.0884 85.4594 35.0884 86.4423Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9241 86.4423C28.9241 87.4252 29.7209 88.2221 30.7039 88.2221C31.6868 88.2221 32.4836 87.4252 32.4836 86.4423C32.4836 85.4594 31.6868 84.6625 30.7039 84.6625C29.7209 84.6625 28.9241 85.4594 28.9241 86.4423Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7649 86.4423C22.7649 87.4252 23.5618 88.2221 24.5447 88.2221C25.5276 88.2221 26.3245 87.4252 26.3245 86.4423C26.3245 85.4594 25.5276 84.6625 24.5447 84.6625C23.5618 84.6625 22.7649 85.4594 22.7649 86.4423Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5645 86.4423C16.5645 87.4252 17.3613 88.2221 18.3443 88.2221C19.3272 88.2221 20.124 87.4252 20.124 86.4423C20.124 85.4594 19.3272 84.6625 18.3443 84.6625C17.3613 84.6625 16.5645 85.4594 16.5645 86.4423Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.4055 86.4423C10.4055 87.4252 11.2024 88.2221 12.1853 88.2221C13.1683 88.2221 13.9651 87.4252 13.9651 86.4423C13.9651 85.4594 13.1683 84.6625 12.1853 84.6625C11.2024 84.6625 10.4055 85.4594 10.4055 86.4423Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 91.7388C149.259 92.7217 150.056 93.5185 151.039 93.5185C152.022 93.5185 152.819 92.7217 152.819 91.7388C152.819 90.7558 152.022 89.959 151.039 89.959C150.056 89.959 149.259 90.7558 149.259 91.7388Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.1 91.7388C143.1 92.7217 143.896 93.5185 144.879 93.5185C145.862 93.5185 146.659 92.7217 146.659 91.7388C146.659 90.7558 145.862 89.959 144.879 89.959C143.896 89.959 143.1 90.7558 143.1 91.7388Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 91.7388C136.883 92.7217 137.68 93.5185 138.663 93.5185C139.646 93.5185 140.443 92.7217 140.443 91.7388C140.443 90.7558 139.646 89.959 138.663 89.959C137.68 89.959 136.883 90.7558 136.883 91.7388Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.724 91.7388C130.724 92.7217 131.521 93.5186 132.504 93.5186C133.487 93.5186 134.284 92.7217 134.284 91.7388C134.284 90.7558 133.487 89.959 132.504 89.959C131.521 89.959 130.724 90.7558 130.724 91.7388Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 91.7284C124.576 92.7113 125.373 93.5082 126.356 93.5082C127.339 93.5082 128.136 92.7113 128.136 91.7284C128.136 90.7455 127.339 89.9486 126.356 89.9486C125.373 89.9486 124.576 90.7455 124.576 91.7284Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.417 91.7284C118.417 92.7113 119.214 93.5082 120.197 93.5082C121.179 93.5082 121.976 92.7113 121.976 91.7284C121.976 90.7455 121.179 89.9486 120.197 89.9486C119.214 89.9486 118.417 90.7455 118.417 91.7284Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 91.7388C112.216 92.7218 113.013 93.5186 113.996 93.5186C114.979 93.5186 115.776 92.7218 115.776 91.7388C115.776 90.7559 114.979 89.9591 113.996 89.9591C113.013 89.9591 112.216 90.7559 112.216 91.7388Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.057 91.7388C106.057 92.7218 106.854 93.5186 107.837 93.5186C108.82 93.5186 109.616 92.7218 109.616 91.7388C109.616 90.7559 108.82 89.9591 107.837 89.9591C106.854 89.9591 106.057 90.7559 106.057 91.7388Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 91.7388C99.8931 92.7217 100.69 93.5186 101.673 93.5186C102.656 93.5186 103.453 92.7217 103.453 91.7388C103.453 90.7558 102.656 89.959 101.673 89.959C100.69 89.959 99.8931 90.7558 99.8931 91.7388Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.7337 91.7388C93.7337 92.7217 94.5305 93.5186 95.5134 93.5186C96.4964 93.5186 97.2932 92.7217 97.2932 91.7388C97.2932 90.7558 96.4964 89.959 95.5134 89.959C94.5305 89.959 93.7337 90.7558 93.7337 91.7388Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5332 91.7388C87.5332 92.7217 88.3301 93.5186 89.313 93.5186C90.2959 93.5186 91.0928 92.7217 91.0928 91.7388C91.0928 90.7559 90.2959 89.959 89.313 89.959C88.3301 89.959 87.5332 90.7559 87.5332 91.7388Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3741 91.7388C81.3741 92.7217 82.1709 93.5186 83.1538 93.5186C84.1368 93.5186 84.9336 92.7217 84.9336 91.7388C84.9336 90.7559 84.1368 89.959 83.1538 89.959C82.1709 89.959 81.3741 90.7559 81.3741 91.7388Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 91.7427C75.2046 92.7256 76.0014 93.5225 76.9844 93.5225C77.9673 93.5225 78.7642 92.7256 78.7642 91.7427C78.7642 90.7598 77.9673 89.9629 76.9844 89.9629C76.0014 89.9629 75.2046 90.7598 75.2046 91.7427Z"
            fill="#B8B7B7"
          />
          <path
            d="M69.0458 91.7427C69.0458 92.7256 69.8426 93.5225 70.8256 93.5225C71.8085 93.5225 72.6053 92.7256 72.6053 91.7427C72.6053 90.7598 71.8085 89.9629 70.8256 89.9629C69.8426 89.9629 69.0458 90.7598 69.0458 91.7427Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 91.7427C62.8294 92.7256 63.6262 93.5225 64.6091 93.5225C65.5921 93.5225 66.3889 92.7256 66.3889 91.7427C66.3889 90.7598 65.5921 89.9629 64.6091 89.9629C63.6262 89.9629 62.8294 90.7598 62.8294 91.7427Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6704 91.7427C56.6704 92.7256 57.4673 93.5225 58.4502 93.5225C59.4331 93.5225 60.23 92.7256 60.23 91.7427C60.23 90.7598 59.4332 89.9629 58.4502 89.9629C57.4673 89.9629 56.6704 90.7598 56.6704 91.7427Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 91.7336C50.5216 92.7166 51.3185 93.5134 52.3014 93.5134C53.2843 93.5134 54.0812 92.7166 54.0812 91.7336C54.0812 90.7507 53.2843 89.9539 52.3014 89.9539C51.3185 89.9539 50.5216 90.7507 50.5216 91.7336Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3627 91.7336C44.3627 92.7165 45.1595 93.5134 46.1425 93.5134C47.1254 93.5134 47.9222 92.7165 47.9222 91.7336C47.9222 90.7507 47.1254 89.9538 46.1425 89.9538C45.1595 89.9538 44.3627 90.7507 44.3627 91.7336Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 91.7427C38.1634 92.7256 38.9602 93.5225 39.9431 93.5225C40.9261 93.5225 41.7229 92.7256 41.7229 91.7427C41.7229 90.7597 40.9261 89.9629 39.9431 89.9629C38.9602 89.9629 38.1634 90.7597 38.1634 91.7427Z"
            fill="#B8B7B7"
          />
          <path
            d="M32.0044 91.7427C32.0044 92.7256 32.8013 93.5225 33.7842 93.5225C34.7671 93.5225 35.564 92.7256 35.564 91.7427C35.564 90.7598 34.7671 89.9629 33.7842 89.9629C32.8013 89.9629 32.0044 90.7598 32.0044 91.7427Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 91.7427C25.8387 92.7256 26.6355 93.5225 27.6184 93.5225C28.6014 93.5225 29.3982 92.7256 29.3982 91.7427C29.3982 90.7598 28.6014 89.9629 27.6184 89.9629C26.6355 89.9629 25.8387 90.7598 25.8387 91.7427Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6797 91.7427C19.6797 92.7256 20.4765 93.5225 21.4595 93.5225C22.4424 93.5225 23.2393 92.7256 23.2393 91.7427C23.2393 90.7598 22.4424 89.9629 21.4595 89.9629C20.4765 89.9629 19.6797 90.7598 19.6797 91.7427Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4804 91.7427C13.4804 92.7257 14.2772 93.5225 15.2601 93.5225C16.2431 93.5225 17.0399 92.7257 17.0399 91.7427C17.0399 90.7598 16.2431 89.963 15.2601 89.963C14.2772 89.963 13.4804 90.7598 13.4804 91.7427Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.32144 91.7427C7.32144 92.7257 8.11827 93.5225 9.10121 93.5225C10.0842 93.5225 10.881 92.7257 10.881 91.7427C10.881 90.7598 10.0842 89.9629 9.10121 89.9629C8.11827 89.9629 7.32144 90.7598 7.32144 91.7427Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 91.7102C155.418 92.6932 156.215 93.49 157.198 93.49C158.181 93.49 158.978 92.6932 158.978 91.7102C158.978 90.7273 158.181 89.9305 157.198 89.9305C156.215 89.9305 155.418 90.7273 155.418 91.7102Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.497 2.03056C158.497 3.0135 159.293 3.81033 160.276 3.81033C161.259 3.81033 162.056 3.0135 162.056 2.03056C162.056 1.04762 161.259 0.250793 160.276 0.250793C159.293 0.250793 158.497 1.04762 158.497 2.03056Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.338 2.03056C152.338 3.0135 153.135 3.81033 154.117 3.81033C155.1 3.81033 155.897 3.0135 155.897 2.03056C155.897 1.04762 155.1 0.250793 154.117 0.250793C153.135 0.250793 152.338 1.04762 152.338 2.03056Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.121 2.03056C146.121 3.0135 146.918 3.81033 147.901 3.81033C148.884 3.81033 149.681 3.0135 149.681 2.03056C149.681 1.04762 148.884 0.250793 147.901 0.250793C146.918 0.250793 146.121 1.04762 146.121 2.03056Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.963 2.03056C139.963 3.0135 140.76 3.81033 141.742 3.81033C142.725 3.81033 143.522 3.0135 143.522 2.03056C143.522 1.04762 142.725 0.250793 141.742 0.250793C140.76 0.250793 139.963 1.04762 139.963 2.03056Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.814 2.02147C133.814 3.00441 134.61 3.80124 135.593 3.80124C136.576 3.80124 137.373 3.00441 137.373 2.02147C137.373 1.03853 136.576 0.241699 135.593 0.241699C134.61 0.241699 133.814 1.03853 133.814 2.02147Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.655 2.02147C127.655 3.00441 128.452 3.80124 129.434 3.80124C130.417 3.80124 131.214 3.00441 131.214 2.02147C131.214 1.03853 130.417 0.241699 129.434 0.241699C128.452 0.241699 127.655 1.03853 127.655 2.02147Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.455 2.03056C121.455 3.0135 122.252 3.81033 123.235 3.81033C124.218 3.81033 125.015 3.0135 125.015 2.03056C125.015 1.04762 124.218 0.250793 123.235 0.250793C122.252 0.250793 121.455 1.04762 121.455 2.03056Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.296 2.03056C115.296 3.0135 116.093 3.81033 117.076 3.81033C118.059 3.81033 118.856 3.0135 118.856 2.03056C118.856 1.04762 118.059 0.250793 117.076 0.250793C116.093 0.250793 115.296 1.04762 115.296 2.03056Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.131 2.03056C109.131 3.0135 109.928 3.81033 110.911 3.81033C111.894 3.81033 112.691 3.0135 112.691 2.03056C112.691 1.04762 111.894 0.250793 110.911 0.250793C109.928 0.250793 109.131 1.04762 109.131 2.03056Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.972 2.03056C102.972 3.0135 103.769 3.81033 104.751 3.81033C105.734 3.81033 106.531 3.0135 106.531 2.03056C106.531 1.04762 105.734 0.250793 104.751 0.250793C103.769 0.250793 102.972 1.04762 102.972 2.03056Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.7722 2.03056C96.7722 3.0135 97.5691 3.81033 98.552 3.81033C99.535 3.81033 100.332 3.0135 100.332 2.03056C100.332 1.04762 99.535 0.250793 98.552 0.250793C97.5691 0.250793 96.7722 1.04762 96.7722 2.03056Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6133 2.03056C90.6133 3.0135 91.4101 3.81033 92.3931 3.81033C93.376 3.81033 94.1729 3.0135 94.1729 2.03056C94.1729 1.04762 93.376 0.250793 92.3931 0.250793C91.4101 0.250793 90.6133 1.04762 90.6133 2.03056Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.444 2.03575C84.444 3.01869 85.2408 3.81552 86.2238 3.81552C87.2067 3.81552 88.0035 3.01869 88.0035 2.03575C88.0035 1.05281 87.2067 0.255981 86.2238 0.255981C85.2408 0.255981 84.444 1.05281 84.444 2.03575Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2848 2.03575C78.2848 3.01869 79.0816 3.81552 80.0646 3.81552C81.0475 3.81552 81.8444 3.01869 81.8444 2.03575C81.8444 1.05281 81.0475 0.255981 80.0646 0.255981C79.0816 0.255981 78.2848 1.05281 78.2848 2.03575Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.0689 2.03575C72.0689 3.01869 72.8657 3.81552 73.8486 3.81552C74.8316 3.81552 75.6284 3.01869 75.6284 2.03575C75.6284 1.05281 74.8316 0.255981 73.8486 0.255981C72.8657 0.255981 72.0689 1.05281 72.0689 2.03575Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9096 2.03575C65.9096 3.01869 66.7064 3.81552 67.6893 3.81552C68.6723 3.81552 69.4691 3.01869 69.4691 2.03575C69.4691 1.05281 68.6723 0.255981 67.6893 0.255981C66.7064 0.255981 65.9096 1.05281 65.9096 2.03575Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.761 2.02538C59.761 3.00832 60.5578 3.80515 61.5408 3.80515C62.5237 3.80515 63.3206 3.00832 63.3206 2.02538C63.3206 1.04244 62.5237 0.245605 61.5408 0.245605C60.5578 0.245605 59.761 1.04244 59.761 2.02538Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6017 2.02538C53.6017 3.00832 54.3985 3.80515 55.3815 3.80515C56.3644 3.80515 57.1613 3.00832 57.1613 2.02538C57.1613 1.04244 56.3644 0.245605 55.3815 0.245605C54.3985 0.245605 53.6017 1.04244 53.6017 2.02538Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4013 2.03575C47.4013 3.01869 48.1981 3.81552 49.181 3.81552C50.164 3.81552 50.9608 3.01869 50.9608 2.03575C50.9608 1.05281 50.164 0.255981 49.181 0.255981C48.1981 0.255981 47.4013 1.05281 47.4013 2.03575Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2423 2.03575C41.2423 3.01869 42.0392 3.81552 43.0221 3.81552C44.005 3.81552 44.8019 3.01869 44.8019 2.03575C44.8019 1.05281 44.005 0.255981 43.0221 0.255981C42.0392 0.255981 41.2423 1.05281 41.2423 2.03575Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.078 2.03575C35.078 3.01869 35.8749 3.81552 36.8578 3.81552C37.8407 3.81552 38.6376 3.01869 38.6376 2.03575C38.6376 1.05281 37.8407 0.255981 36.8578 0.255981C35.8749 0.255981 35.078 1.05281 35.078 2.03575Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9192 2.03575C28.9192 3.01869 29.716 3.81552 30.699 3.81552C31.6819 3.81552 32.4788 3.01869 32.4788 2.03575C32.4788 1.05281 31.6819 0.255981 30.699 0.255981C29.716 0.255981 28.9192 1.05281 28.9192 2.03575Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7182 2.03575C22.7182 3.01869 23.515 3.81552 24.4979 3.81552C25.4809 3.81552 26.2777 3.01869 26.2777 2.03575C26.2777 1.05281 25.4809 0.255981 24.4979 0.255981C23.515 0.255981 22.7182 1.05281 22.7182 2.03575Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5594 2.03575C16.5594 3.01869 17.3562 3.81552 18.3391 3.81552C19.3221 3.81552 20.1189 3.01869 20.1189 2.03575C20.1189 1.05281 19.3221 0.255981 18.3391 0.255981C17.3562 0.255981 16.5594 1.05281 16.5594 2.03575Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.979 12.591C158.979 13.5739 159.776 14.3707 160.759 14.3707C161.741 14.3707 162.538 13.5739 162.538 12.591C162.538 11.608 161.741 10.8112 160.759 10.8112C159.776 10.8112 158.979 11.608 158.979 12.591Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.497 33.7248C158.497 34.7077 159.293 35.5046 160.276 35.5046C161.259 35.5046 162.056 34.7077 162.056 33.7248C162.056 32.7419 161.259 31.945 160.276 31.945C159.293 31.945 158.497 32.7419 158.497 33.7248Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.497 44.3268C158.497 45.3097 159.293 46.1065 160.276 46.1065C161.259 46.1065 162.056 45.3097 162.056 44.3268C162.056 43.3438 161.259 42.547 160.276 42.547C159.293 42.547 158.497 43.3438 158.497 44.3268Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.497 65.2904C158.497 66.2733 159.293 67.0702 160.276 67.0702C161.259 67.0702 162.056 66.2733 162.056 65.2904C162.056 64.3075 161.259 63.5106 160.276 63.5106C159.293 63.5106 158.497 64.3075 158.497 65.2904Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.508 75.8365C158.508 76.8194 159.305 77.6163 160.288 77.6163C161.271 77.6163 162.068 76.8194 162.068 75.8365C162.068 74.8536 161.271 74.0567 160.288 74.0567C159.305 74.0567 158.508 74.8536 158.508 75.8365Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.273 191.095C300.273 192.078 301.07 192.875 302.053 192.875C303.036 192.875 303.833 192.078 303.833 191.095C303.833 190.112 303.036 189.315 302.053 189.315C301.07 189.315 300.273 190.112 300.273 191.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.114 191.095C294.114 192.078 294.911 192.874 295.894 192.874C296.877 192.874 297.674 192.078 297.674 191.095C297.674 190.112 296.877 189.315 295.894 189.315C294.911 189.315 294.114 190.112 294.114 191.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M287.898 191.095C287.898 192.078 288.695 192.874 289.678 192.874C290.661 192.874 291.458 192.078 291.458 191.095C291.458 190.112 290.661 189.315 289.678 189.315C288.695 189.315 287.898 190.112 287.898 191.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.739 191.095C281.739 192.078 282.536 192.874 283.519 192.874C284.502 192.874 285.299 192.078 285.299 191.095C285.299 190.112 284.502 189.315 283.519 189.315C282.536 189.315 281.739 190.112 281.739 191.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.591 191.086C275.591 192.069 276.387 192.865 277.37 192.865C278.353 192.865 279.15 192.069 279.15 191.086C279.15 190.103 278.353 189.306 277.37 189.306C276.387 189.306 275.591 190.103 275.591 191.086Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.431 191.086C269.431 192.069 270.228 192.865 271.211 192.865C272.194 192.865 272.991 192.069 272.991 191.086C272.991 190.103 272.194 189.306 271.211 189.306C270.228 189.306 269.431 190.103 269.431 191.086Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.232 191.095C263.232 192.078 264.029 192.874 265.012 192.874C265.995 192.874 266.792 192.078 266.792 191.095C266.792 190.112 265.995 189.315 265.012 189.315C264.029 189.315 263.232 190.112 263.232 191.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.073 191.095C257.073 192.078 257.87 192.874 258.853 192.874C259.835 192.874 260.632 192.078 260.632 191.095C260.632 190.112 259.835 189.315 258.853 189.315C257.87 189.315 257.073 190.112 257.073 191.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M250.907 191.095C250.907 192.078 251.704 192.874 252.687 192.874C253.67 192.874 254.467 192.078 254.467 191.095C254.467 190.112 253.67 189.315 252.687 189.315C251.704 189.315 250.907 190.112 250.907 191.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.748 191.095C244.748 192.078 245.545 192.874 246.528 192.874C247.511 192.874 248.308 192.078 248.308 191.095C248.308 190.112 247.511 189.315 246.528 189.315C245.545 189.315 244.748 190.112 244.748 191.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.549 191.095C238.549 192.078 239.346 192.874 240.329 192.874C241.312 192.874 242.109 192.078 242.109 191.095C242.109 190.112 241.312 189.315 240.329 189.315C239.346 189.315 238.549 190.112 238.549 191.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.39 191.095C232.39 192.078 233.187 192.874 234.17 192.874C235.153 192.874 235.949 192.078 235.949 191.095C235.949 190.112 235.153 189.315 234.17 189.315C233.187 189.315 232.39 190.112 232.39 191.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.22 191.1C226.22 192.083 227.017 192.88 228 192.88C228.983 192.88 229.78 192.083 229.78 191.1C229.78 190.117 228.983 189.32 228 189.32C227.017 189.32 226.22 190.117 226.22 191.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.061 191.1C220.061 192.083 220.858 192.88 221.841 192.88C222.824 192.88 223.621 192.083 223.621 191.1C223.621 190.117 222.824 189.32 221.841 189.32C220.858 189.32 220.061 190.117 220.061 191.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M213.845 191.1C213.845 192.083 214.642 192.88 215.625 192.88C216.608 192.88 217.405 192.083 217.405 191.1C217.405 190.117 216.608 189.32 215.625 189.32C214.642 189.32 213.845 190.117 213.845 191.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.686 191.1C207.686 192.083 208.483 192.88 209.466 192.88C210.449 192.88 211.246 192.083 211.246 191.1C211.246 190.117 210.449 189.32 209.466 189.32C208.483 189.32 207.686 190.117 207.686 191.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.538 191.091C201.538 192.074 202.335 192.871 203.318 192.871C204.301 192.871 205.097 192.074 205.097 191.091C205.097 190.108 204.301 189.311 203.318 189.311C202.335 189.311 201.538 190.108 201.538 191.091Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.378 191.091C195.378 192.074 196.175 192.871 197.158 192.871C198.141 192.871 198.938 192.074 198.938 191.091C198.938 190.108 198.141 189.311 197.158 189.311C196.175 189.311 195.378 190.108 195.378 191.091Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.178 191.1C189.178 192.083 189.975 192.88 190.958 192.88C191.94 192.88 192.737 192.083 192.737 191.1C192.737 190.117 191.94 189.32 190.958 189.32C189.975 189.32 189.178 190.117 189.178 191.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.019 191.1C183.019 192.083 183.816 192.88 184.799 192.88C185.782 192.88 186.579 192.083 186.579 191.1C186.579 190.117 185.782 189.32 184.799 189.32C183.816 189.32 183.019 190.117 183.019 191.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M176.855 191.1C176.855 192.083 177.652 192.88 178.635 192.88C179.617 192.88 180.414 192.083 180.414 191.1C180.414 190.117 179.617 189.32 178.635 189.32C177.652 189.32 176.855 190.117 176.855 191.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.696 191.1C170.696 192.083 171.493 192.88 172.476 192.88C173.459 192.88 174.255 192.083 174.255 191.1C174.255 190.117 173.459 189.32 172.476 189.32C171.493 189.32 170.696 190.117 170.696 191.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.495 191.1C164.495 192.083 165.292 192.88 166.275 192.88C167.258 192.88 168.055 192.083 168.055 191.1C168.055 190.117 167.258 189.32 166.275 189.32C165.292 189.32 164.495 190.117 164.495 191.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.336 191.1C158.336 192.083 159.133 192.88 160.116 192.88C161.099 192.88 161.896 192.083 161.896 191.1C161.896 190.117 161.099 189.32 160.116 189.32C159.133 189.32 158.336 190.117 158.336 191.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.189 196.396C297.189 197.379 297.986 198.176 298.969 198.176C299.952 198.176 300.749 197.379 300.749 196.396C300.749 195.413 299.952 194.617 298.969 194.617C297.986 194.617 297.189 195.413 297.189 196.396Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.03 196.396C291.03 197.379 291.827 198.176 292.81 198.176C293.793 198.176 294.59 197.379 294.59 196.396C294.59 195.413 293.793 194.617 292.81 194.617C291.827 194.617 291.03 195.413 291.03 196.396Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.814 196.396C284.814 197.379 285.611 198.176 286.594 198.176C287.577 198.176 288.374 197.379 288.374 196.396C288.374 195.413 287.577 194.617 286.594 194.617C285.611 194.617 284.814 195.413 284.814 196.396Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.655 196.396C278.655 197.379 279.452 198.176 280.435 198.176C281.418 198.176 282.214 197.379 282.214 196.396C282.214 195.413 281.418 194.617 280.435 194.617C279.452 194.617 278.655 195.413 278.655 196.396Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.506 196.387C272.506 197.37 273.303 198.167 274.286 198.167C275.269 198.167 276.066 197.37 276.066 196.387C276.066 195.404 275.269 194.607 274.286 194.607C273.303 194.607 272.506 195.404 272.506 196.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.347 196.387C266.347 197.37 267.144 198.167 268.127 198.167C269.11 198.167 269.907 197.37 269.907 196.387C269.907 195.404 269.11 194.607 268.127 194.607C267.144 194.607 266.347 195.404 266.347 196.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.147 196.396C260.147 197.379 260.944 198.176 261.927 198.176C262.909 198.176 263.706 197.379 263.706 196.396C263.706 195.413 262.909 194.617 261.927 194.617C260.944 194.617 260.147 195.413 260.147 196.396Z"
            fill="#B8B7B7"
          />
          <path
            d="M253.988 196.396C253.988 197.379 254.785 198.176 255.768 198.176C256.751 198.176 257.547 197.379 257.547 196.396C257.547 195.413 256.751 194.617 255.768 194.617C254.785 194.617 253.988 195.413 253.988 196.396Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.823 196.396C247.823 197.379 248.62 198.176 249.603 198.176C250.586 198.176 251.383 197.379 251.383 196.396C251.383 195.413 250.586 194.617 249.603 194.617C248.62 194.617 247.823 195.413 247.823 196.396Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.665 196.396C241.665 197.379 242.461 198.176 243.444 198.176C244.427 198.176 245.224 197.379 245.224 196.396C245.224 195.413 244.427 194.617 243.444 194.617C242.461 194.617 241.665 195.413 241.665 196.396Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.464 196.396C235.464 197.379 236.26 198.176 237.243 198.176C238.226 198.176 239.023 197.379 239.023 196.396C239.023 195.413 238.226 194.617 237.243 194.617C236.26 194.617 235.464 195.413 235.464 196.396Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.305 196.396C229.305 197.379 230.102 198.176 231.084 198.176C232.067 198.176 232.864 197.379 232.864 196.396C232.864 195.413 232.067 194.617 231.084 194.617C230.102 194.617 229.305 195.413 229.305 196.396Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.135 196.402C223.135 197.384 223.932 198.181 224.915 198.181C225.898 198.181 226.695 197.384 226.695 196.402C226.695 195.419 225.898 194.622 224.915 194.622C223.932 194.622 223.135 195.419 223.135 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M216.976 196.402C216.976 197.384 217.773 198.181 218.756 198.181C219.739 198.181 220.536 197.384 220.536 196.402C220.536 195.419 219.739 194.622 218.756 194.622C217.773 194.622 216.976 195.419 216.976 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.76 196.402C210.76 197.384 211.557 198.181 212.54 198.181C213.523 198.181 214.32 197.384 214.32 196.402C214.32 195.419 213.523 194.622 212.54 194.622C211.557 194.622 210.76 195.419 210.76 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.601 196.402C204.601 197.384 205.398 198.181 206.381 198.181C207.364 198.181 208.161 197.384 208.161 196.402C208.161 195.419 207.364 194.622 206.381 194.622C205.398 194.622 204.601 195.419 204.601 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.452 196.392C198.452 197.375 199.249 198.172 200.232 198.172C201.215 198.172 202.012 197.375 202.012 196.392C202.012 195.41 201.215 194.613 200.232 194.613C199.249 194.613 198.452 195.41 198.452 196.392Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.293 196.392C192.293 197.375 193.09 198.172 194.073 198.172C195.056 198.172 195.853 197.375 195.853 196.392C195.853 195.41 195.056 194.613 194.073 194.613C193.09 194.613 192.293 195.41 192.293 196.392Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.094 196.402C186.094 197.384 186.891 198.181 187.874 198.181C188.856 198.181 189.653 197.384 189.653 196.402C189.653 195.419 188.856 194.622 187.874 194.622C186.891 194.622 186.094 195.419 186.094 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M179.935 196.402C179.935 197.384 180.732 198.181 181.715 198.181C182.698 198.181 183.494 197.384 183.494 196.402C183.494 195.419 182.698 194.622 181.715 194.622C180.732 194.622 179.935 195.419 179.935 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.769 196.402C173.769 197.384 174.566 198.181 175.549 198.181C176.532 198.181 177.329 197.384 177.329 196.402C177.329 195.419 176.532 194.622 175.549 194.622C174.566 194.622 173.769 195.419 173.769 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.61 196.402C167.61 197.384 168.407 198.181 169.39 198.181C170.373 198.181 171.17 197.384 171.17 196.402C171.17 195.419 170.373 194.622 169.39 194.622C168.407 194.622 167.61 195.419 167.61 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.411 196.402C161.411 197.384 162.208 198.181 163.191 198.181C164.174 198.181 164.97 197.384 164.97 196.402C164.97 195.419 164.174 194.622 163.191 194.622C162.208 194.622 161.411 195.419 161.411 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.252 196.402C155.252 197.384 156.049 198.181 157.032 198.181C158.014 198.181 158.811 197.384 158.811 196.402C158.811 195.419 158.014 194.622 157.032 194.622C156.049 194.622 155.252 195.419 155.252 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.273 201.641C300.273 202.624 301.07 203.421 302.053 203.421C303.036 203.421 303.833 202.624 303.833 201.641C303.833 200.658 303.036 199.861 302.053 199.861C301.07 199.861 300.273 200.658 300.273 201.641Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.114 201.641C294.114 202.624 294.911 203.421 295.894 203.421C296.877 203.421 297.674 202.624 297.674 201.641C297.674 200.658 296.877 199.861 295.894 199.861C294.911 199.861 294.114 200.658 294.114 201.641Z"
            fill="#B8B7B7"
          />
          <path
            d="M287.898 201.641C287.898 202.624 288.695 203.421 289.678 203.421C290.661 203.421 291.458 202.624 291.458 201.641C291.458 200.658 290.661 199.861 289.678 199.861C288.695 199.861 287.898 200.658 287.898 201.641Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.739 201.641C281.739 202.624 282.536 203.421 283.519 203.421C284.502 203.421 285.299 202.624 285.299 201.641C285.299 200.658 284.502 199.861 283.519 199.861C282.536 199.861 281.739 200.658 281.739 201.641Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.591 201.632C275.591 202.615 276.387 203.411 277.37 203.411C278.353 203.411 279.15 202.615 279.15 201.632C279.15 200.649 278.353 199.852 277.37 199.852C276.387 199.852 275.591 200.649 275.591 201.632Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.431 201.632C269.431 202.615 270.228 203.411 271.211 203.411C272.194 203.411 272.991 202.615 272.991 201.632C272.991 200.649 272.194 199.852 271.211 199.852C270.228 199.852 269.431 200.649 269.431 201.632Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.232 201.641C263.232 202.624 264.029 203.421 265.012 203.421C265.995 203.421 266.792 202.624 266.792 201.641C266.792 200.658 265.995 199.861 265.012 199.861C264.029 199.861 263.232 200.658 263.232 201.641Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.073 201.641C257.073 202.624 257.87 203.421 258.853 203.421C259.835 203.421 260.632 202.624 260.632 201.641C260.632 200.658 259.835 199.861 258.853 199.861C257.87 199.861 257.073 200.658 257.073 201.641Z"
            fill="#B8B7B7"
          />
          <path
            d="M250.907 201.641C250.907 202.624 251.704 203.421 252.687 203.421C253.67 203.421 254.467 202.624 254.467 201.641C254.467 200.658 253.67 199.861 252.687 199.861C251.704 199.861 250.907 200.658 250.907 201.641Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.748 201.641C244.748 202.624 245.545 203.421 246.528 203.421C247.511 203.421 248.308 202.624 248.308 201.641C248.308 200.658 247.511 199.861 246.528 199.861C245.545 199.861 244.748 200.658 244.748 201.641Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.549 201.641C238.549 202.624 239.346 203.421 240.329 203.421C241.312 203.421 242.109 202.624 242.109 201.641C242.109 200.658 241.312 199.861 240.329 199.861C239.346 199.861 238.549 200.658 238.549 201.641Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.39 201.641C232.39 202.624 233.187 203.421 234.17 203.421C235.153 203.421 235.949 202.624 235.949 201.641C235.949 200.658 235.153 199.861 234.17 199.861C233.187 199.861 232.39 200.658 232.39 201.641Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.22 201.646C226.22 202.629 227.017 203.426 228 203.426C228.983 203.426 229.78 202.629 229.78 201.646C229.78 200.663 228.983 199.866 228 199.866C227.017 199.866 226.22 200.663 226.22 201.646Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.061 201.646C220.061 202.629 220.858 203.426 221.841 203.426C222.824 203.426 223.621 202.629 223.621 201.646C223.621 200.663 222.824 199.866 221.841 199.866C220.858 199.866 220.061 200.663 220.061 201.646Z"
            fill="#B8B7B7"
          />
          <path
            d="M213.845 201.646C213.845 202.629 214.642 203.426 215.625 203.426C216.608 203.426 217.405 202.629 217.405 201.646C217.405 200.663 216.608 199.866 215.625 199.866C214.642 199.866 213.845 200.663 213.845 201.646Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.686 201.646C207.686 202.629 208.483 203.426 209.466 203.426C210.449 203.426 211.246 202.629 211.246 201.646C211.246 200.663 210.449 199.866 209.466 199.866C208.483 199.866 207.686 200.663 207.686 201.646Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.538 201.637C201.538 202.62 202.335 203.417 203.318 203.417C204.301 203.417 205.097 202.62 205.097 201.637C205.097 200.654 204.301 199.857 203.318 199.857C202.335 199.857 201.538 200.654 201.538 201.637Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.378 201.637C195.378 202.62 196.175 203.417 197.158 203.417C198.141 203.417 198.938 202.62 198.938 201.637C198.938 200.654 198.141 199.857 197.158 199.857C196.175 199.857 195.378 200.654 195.378 201.637Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.178 201.646C189.178 202.629 189.975 203.426 190.958 203.426C191.94 203.426 192.737 202.629 192.737 201.646C192.737 200.663 191.94 199.866 190.958 199.866C189.975 199.866 189.178 200.663 189.178 201.646Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.019 201.646C183.019 202.629 183.816 203.426 184.799 203.426C185.782 203.426 186.579 202.629 186.579 201.646C186.579 200.663 185.782 199.866 184.799 199.866C183.816 199.866 183.019 200.663 183.019 201.646Z"
            fill="#B8B7B7"
          />
          <path
            d="M176.855 201.646C176.855 202.629 177.652 203.426 178.635 203.426C179.617 203.426 180.414 202.629 180.414 201.646C180.414 200.663 179.617 199.866 178.635 199.866C177.652 199.866 176.855 200.663 176.855 201.646Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.696 201.646C170.696 202.629 171.493 203.426 172.476 203.426C173.459 203.426 174.255 202.629 174.255 201.646C174.255 200.663 173.459 199.866 172.476 199.866C171.493 199.866 170.696 200.663 170.696 201.646Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.495 201.646C164.495 202.629 165.292 203.426 166.275 203.426C167.258 203.426 168.055 202.629 168.055 201.646C168.055 200.663 167.258 199.866 166.275 199.866C165.292 199.866 164.495 200.663 164.495 201.646Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.336 201.646C158.336 202.629 159.133 203.426 160.116 203.426C161.099 203.426 161.896 202.629 161.896 201.646C161.896 200.663 161.099 199.866 160.116 199.866C159.133 199.866 158.336 200.663 158.336 201.646Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.2 206.932C297.2 207.915 297.997 208.712 298.98 208.712C299.962 208.712 300.759 207.915 300.759 206.932C300.759 205.949 299.962 205.152 298.98 205.152C297.997 205.152 297.2 205.949 297.2 206.932Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.041 206.932C291.041 207.915 291.838 208.712 292.821 208.712C293.804 208.712 294.6 207.915 294.6 206.932C294.6 205.949 293.804 205.152 292.821 205.152C291.838 205.152 291.041 205.949 291.041 206.932Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.825 206.932C284.825 207.915 285.622 208.712 286.605 208.712C287.587 208.712 288.384 207.915 288.384 206.932C288.384 205.949 287.587 205.152 286.605 205.152C285.622 205.152 284.825 205.949 284.825 206.932Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.665 206.932C278.665 207.915 279.462 208.712 280.445 208.712C281.428 208.712 282.225 207.915 282.225 206.932C282.225 205.949 281.428 205.152 280.445 205.152C279.462 205.152 278.665 205.949 278.665 206.932Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.517 206.922C272.517 207.905 273.314 208.701 274.297 208.701C275.28 208.701 276.076 207.905 276.076 206.922C276.076 205.939 275.28 205.142 274.297 205.142C273.314 205.142 272.517 205.939 272.517 206.922Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.358 206.922C266.358 207.905 267.155 208.701 268.137 208.701C269.12 208.701 269.917 207.905 269.917 206.922C269.917 205.939 269.12 205.142 268.137 205.142C267.155 205.142 266.358 205.939 266.358 206.922Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.158 206.932C260.158 207.915 260.955 208.712 261.938 208.712C262.921 208.712 263.718 207.915 263.718 206.932C263.718 205.949 262.921 205.152 261.938 205.152C260.955 205.152 260.158 205.949 260.158 206.932Z"
            fill="#B8B7B7"
          />
          <path
            d="M253.999 206.932C253.999 207.915 254.796 208.712 255.779 208.712C256.762 208.712 257.559 207.915 257.559 206.932C257.559 205.949 256.762 205.152 255.779 205.152C254.796 205.152 253.999 205.949 253.999 206.932Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.834 206.932C247.834 207.915 248.631 208.712 249.614 208.712C250.597 208.712 251.394 207.915 251.394 206.932C251.394 205.949 250.597 205.152 249.614 205.152C248.631 205.152 247.834 205.949 247.834 206.932Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.675 206.932C241.675 207.915 242.472 208.712 243.455 208.712C244.438 208.712 245.234 207.915 245.234 206.932C245.234 205.949 244.438 205.152 243.455 205.152C242.472 205.152 241.675 205.949 241.675 206.932Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.476 206.932C235.476 207.915 236.272 208.712 237.255 208.712C238.238 208.712 239.035 207.915 239.035 206.932C239.035 205.949 238.238 205.152 237.255 205.152C236.272 205.152 235.476 205.949 235.476 206.932Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.316 206.932C229.316 207.915 230.113 208.712 231.096 208.712C232.079 208.712 232.876 207.915 232.876 206.932C232.876 205.949 232.079 205.152 231.096 205.152C230.113 205.152 229.316 205.949 229.316 206.932Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.146 206.936C223.146 207.919 223.942 208.716 224.925 208.716C225.908 208.716 226.705 207.919 226.705 206.936C226.705 205.953 225.908 205.156 224.925 205.156C223.942 205.156 223.146 205.953 223.146 206.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M216.986 206.936C216.986 207.919 217.783 208.716 218.766 208.716C219.749 208.716 220.546 207.919 220.546 206.936C220.546 205.953 219.749 205.156 218.766 205.156C217.783 205.156 216.986 205.953 216.986 206.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.771 206.936C210.771 207.919 211.567 208.716 212.55 208.716C213.533 208.716 214.33 207.919 214.33 206.936C214.33 205.953 213.533 205.156 212.55 205.156C211.567 205.156 210.771 205.953 210.771 206.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.613 206.936C204.613 207.919 205.41 208.716 206.393 208.716C207.376 208.716 208.172 207.919 208.172 206.936C208.172 205.953 207.376 205.156 206.393 205.156C205.41 205.156 204.613 205.953 204.613 206.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.462 206.927C198.462 207.91 199.259 208.707 200.242 208.707C201.225 208.707 202.022 207.91 202.022 206.927C202.022 205.944 201.225 205.147 200.242 205.147C199.259 205.147 198.462 205.944 198.462 206.927Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.303 206.927C192.303 207.91 193.1 208.707 194.083 208.707C195.066 208.707 195.863 207.91 195.863 206.927C195.863 205.944 195.066 205.147 194.083 205.147C193.1 205.147 192.303 205.944 192.303 206.927Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.104 206.936C186.104 207.919 186.901 208.716 187.884 208.716C188.867 208.716 189.664 207.919 189.664 206.936C189.664 205.953 188.867 205.156 187.884 205.156C186.901 205.156 186.104 205.953 186.104 206.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M179.945 206.936C179.945 207.919 180.742 208.716 181.725 208.716C182.708 208.716 183.505 207.919 183.505 206.936C183.505 205.953 182.708 205.156 181.725 205.156C180.742 205.156 179.945 205.953 179.945 206.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.78 206.936C173.78 207.919 174.577 208.716 175.56 208.716C176.543 208.716 177.339 207.919 177.339 206.936C177.339 205.953 176.543 205.156 175.56 205.156C174.577 205.156 173.78 205.953 173.78 206.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.621 206.936C167.621 207.919 168.417 208.716 169.4 208.716C170.383 208.716 171.18 207.919 171.18 206.936C171.18 205.953 170.383 205.156 169.4 205.156C168.417 205.156 167.621 205.953 167.621 206.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.422 206.936C161.422 207.919 162.218 208.716 163.201 208.716C164.184 208.716 164.981 207.919 164.981 206.936C164.981 205.953 164.184 205.156 163.201 205.156C162.218 205.156 161.422 205.953 161.422 206.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.262 206.936C155.262 207.919 156.059 208.716 157.042 208.716C158.025 208.716 158.822 207.919 158.822 206.936C158.822 205.953 158.025 205.156 157.042 205.156C156.059 205.156 155.262 205.953 155.262 206.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.114 212.232C294.114 213.215 294.911 214.012 295.894 214.012C296.877 214.012 297.674 213.215 297.674 212.232C297.674 211.249 296.877 210.453 295.894 210.453C294.911 210.453 294.114 211.249 294.114 212.232Z"
            fill="#B8B7B7"
          />
          <path
            d="M287.957 212.232C287.957 213.215 288.753 214.012 289.736 214.012C290.719 214.012 291.516 213.215 291.516 212.232C291.516 211.249 290.719 210.453 289.736 210.453C288.753 210.453 287.957 211.249 287.957 212.232Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.739 212.232C281.739 213.215 282.536 214.012 283.519 214.012C284.502 214.012 285.299 213.215 285.299 212.232C285.299 211.249 284.502 210.453 283.519 210.453C282.536 210.453 281.739 211.249 281.739 212.232Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.581 212.232C275.581 213.215 276.378 214.012 277.361 214.012C278.344 214.012 279.141 213.215 279.141 212.232C279.141 211.249 278.344 210.453 277.361 210.453C276.378 210.453 275.581 211.249 275.581 212.232Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.431 212.223C269.431 213.206 270.228 214.003 271.211 214.003C272.194 214.003 272.991 213.206 272.991 212.223C272.991 211.24 272.194 210.444 271.211 210.444C270.228 210.444 269.431 211.24 269.431 212.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.273 212.223C263.273 213.206 264.07 214.003 265.053 214.003C266.036 214.003 266.833 213.206 266.833 212.223C266.833 211.24 266.036 210.444 265.053 210.444C264.07 210.444 263.273 211.24 263.273 212.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.073 212.232C257.073 213.215 257.87 214.012 258.853 214.012C259.835 214.012 260.632 213.215 260.632 212.232C260.632 211.249 259.835 210.453 258.853 210.453C257.87 210.453 257.073 211.249 257.073 212.232Z"
            fill="#B8B7B7"
          />
          <path
            d="M250.914 212.232C250.914 213.215 251.711 214.012 252.694 214.012C253.677 214.012 254.474 213.215 254.474 212.232C254.474 211.249 253.677 210.453 252.694 210.453C251.711 210.453 250.914 211.249 250.914 212.232Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.748 212.232C244.748 213.215 245.545 214.012 246.528 214.012C247.511 214.012 248.308 213.215 248.308 212.232C248.308 211.249 247.511 210.453 246.528 210.453C245.545 210.453 244.748 211.249 244.748 212.232Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.591 212.232C238.591 213.215 239.387 214.012 240.37 214.012C241.353 214.012 242.15 213.215 242.15 212.232C242.15 211.249 241.353 210.453 240.37 210.453C239.387 210.453 238.591 211.249 238.591 212.232Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.39 212.232C232.39 213.215 233.187 214.012 234.17 214.012C235.153 214.012 235.949 213.215 235.949 212.232C235.949 211.249 235.153 210.453 234.17 210.453C233.187 210.453 232.39 211.249 232.39 212.232Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.231 212.232C226.231 213.215 227.028 214.012 228.011 214.012C228.994 214.012 229.791 213.215 229.791 212.232C229.791 211.249 228.994 210.453 228.011 210.453C227.028 210.453 226.231 211.249 226.231 212.232Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.061 212.238C220.061 213.221 220.858 214.017 221.841 214.017C222.824 214.017 223.621 213.221 223.621 212.238C223.621 211.255 222.824 210.458 221.841 210.458C220.858 210.458 220.061 211.255 220.061 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M213.902 212.238C213.902 213.221 214.699 214.017 215.682 214.017C216.665 214.017 217.462 213.221 217.462 212.238C217.462 211.255 216.665 210.458 215.682 210.458C214.699 210.458 213.902 211.255 213.902 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.687 212.238C207.687 213.221 208.483 214.017 209.466 214.017C210.449 214.017 211.246 213.221 211.246 212.238C211.246 211.255 210.449 210.458 209.466 210.458C208.483 210.458 207.687 211.255 207.687 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.527 212.238C201.527 213.221 202.324 214.017 203.307 214.017C204.29 214.017 205.087 213.221 205.087 212.238C205.087 211.255 204.29 210.458 203.307 210.458C202.324 210.458 201.527 211.255 201.527 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.378 212.229C195.378 213.211 196.175 214.008 197.158 214.008C198.141 214.008 198.938 213.211 198.938 212.229C198.938 211.246 198.141 210.449 197.158 210.449C196.175 210.449 195.378 211.246 195.378 212.229Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.22 212.229C189.22 213.211 190.016 214.008 190.999 214.008C191.982 214.008 192.779 213.211 192.779 212.229C192.779 211.246 191.982 210.449 190.999 210.449C190.016 210.449 189.22 211.246 189.22 212.229Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.019 212.238C183.019 213.221 183.816 214.017 184.799 214.017C185.782 214.017 186.579 213.221 186.579 212.238C186.579 211.255 185.782 210.458 184.799 210.458C183.816 210.458 183.019 211.255 183.019 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M176.86 212.238C176.86 213.221 177.657 214.017 178.64 214.017C179.623 214.017 180.42 213.221 180.42 212.238C180.42 211.255 179.623 210.458 178.64 210.458C177.657 210.458 176.86 211.255 176.86 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.696 212.238C170.696 213.221 171.493 214.017 172.476 214.017C173.459 214.017 174.255 213.221 174.255 212.238C174.255 211.255 173.459 210.458 172.476 210.458C171.493 210.458 170.696 211.255 170.696 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.536 212.238C164.536 213.221 165.333 214.017 166.316 214.017C167.299 214.017 168.096 213.221 168.096 212.238C168.096 211.255 167.299 210.458 166.316 210.458C165.333 210.458 164.536 211.255 164.536 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.336 212.238C158.336 213.221 159.133 214.017 160.116 214.017C161.099 214.017 161.896 213.221 161.896 212.238C161.896 211.255 161.099 210.458 160.116 210.458C159.133 210.458 158.336 211.255 158.336 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.177 212.238C152.177 213.221 152.974 214.017 153.957 214.017C154.94 214.017 155.737 213.221 155.737 212.238C155.737 211.255 154.94 210.458 153.957 210.458C152.974 210.458 152.177 211.255 152.177 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.2 217.478C297.2 218.461 297.997 219.258 298.98 219.258C299.962 219.258 300.759 218.461 300.759 217.478C300.759 216.495 299.962 215.698 298.98 215.698C297.997 215.698 297.2 216.495 297.2 217.478Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.041 217.478C291.041 218.461 291.838 219.258 292.821 219.258C293.804 219.258 294.6 218.461 294.6 217.478C294.6 216.495 293.804 215.698 292.821 215.698C291.838 215.698 291.041 216.495 291.041 217.478Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.825 217.478C284.825 218.461 285.622 219.258 286.605 219.258C287.587 219.258 288.384 218.461 288.384 217.478C288.384 216.495 287.587 215.698 286.605 215.698C285.622 215.698 284.825 216.495 284.825 217.478Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.665 217.478C278.665 218.461 279.462 219.258 280.445 219.258C281.428 219.258 282.225 218.461 282.225 217.478C282.225 216.495 281.428 215.698 280.445 215.698C279.462 215.698 278.665 216.495 278.665 217.478Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.517 217.468C272.517 218.451 273.314 219.248 274.297 219.248C275.28 219.248 276.076 218.451 276.076 217.468C276.076 216.485 275.28 215.688 274.297 215.688C273.314 215.688 272.517 216.485 272.517 217.468Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.358 217.468C266.358 218.451 267.155 219.248 268.137 219.248C269.12 219.248 269.917 218.451 269.917 217.468C269.917 216.485 269.12 215.688 268.137 215.688C267.155 215.688 266.358 216.485 266.358 217.468Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.158 217.478C260.158 218.461 260.955 219.258 261.938 219.258C262.921 219.258 263.718 218.461 263.718 217.478C263.718 216.495 262.921 215.698 261.938 215.698C260.955 215.698 260.158 216.495 260.158 217.478Z"
            fill="#B8B7B7"
          />
          <path
            d="M253.999 217.478C253.999 218.461 254.796 219.258 255.779 219.258C256.762 219.258 257.559 218.461 257.559 217.478C257.559 216.495 256.762 215.698 255.779 215.698C254.796 215.698 253.999 216.495 253.999 217.478Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.834 217.478C247.834 218.461 248.631 219.258 249.614 219.258C250.597 219.258 251.394 218.461 251.394 217.478C251.394 216.495 250.597 215.698 249.614 215.698C248.631 215.698 247.834 216.495 247.834 217.478Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.675 217.478C241.675 218.461 242.472 219.258 243.455 219.258C244.438 219.258 245.234 218.461 245.234 217.478C245.234 216.495 244.438 215.698 243.455 215.698C242.472 215.698 241.675 216.495 241.675 217.478Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.476 217.478C235.476 218.461 236.272 219.258 237.255 219.258C238.238 219.258 239.035 218.461 239.035 217.478C239.035 216.495 238.238 215.698 237.255 215.698C236.272 215.698 235.476 216.495 235.476 217.478Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.316 217.478C229.316 218.461 230.113 219.258 231.096 219.258C232.079 219.258 232.876 218.461 232.876 217.478C232.876 216.495 232.079 215.698 231.096 215.698C230.113 215.698 229.316 216.495 229.316 217.478Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.146 217.482C223.146 218.465 223.942 219.262 224.925 219.262C225.908 219.262 226.705 218.465 226.705 217.482C226.705 216.499 225.908 215.702 224.925 215.702C223.942 215.702 223.146 216.499 223.146 217.482Z"
            fill="#B8B7B7"
          />
          <path
            d="M216.986 217.482C216.986 218.465 217.783 219.262 218.766 219.262C219.749 219.262 220.546 218.465 220.546 217.482C220.546 216.499 219.749 215.702 218.766 215.702C217.783 215.702 216.986 216.499 216.986 217.482Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.771 217.482C210.771 218.465 211.567 219.262 212.55 219.262C213.533 219.262 214.33 218.465 214.33 217.482C214.33 216.499 213.533 215.702 212.55 215.702C211.567 215.702 210.771 216.499 210.771 217.482Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.613 217.482C204.613 218.465 205.41 219.262 206.393 219.262C207.376 219.262 208.172 218.465 208.172 217.482C208.172 216.499 207.376 215.702 206.393 215.702C205.41 215.702 204.613 216.499 204.613 217.482Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.462 217.473C198.462 218.456 199.259 219.253 200.242 219.253C201.225 219.253 202.022 218.456 202.022 217.473C202.022 216.49 201.225 215.693 200.242 215.693C199.259 215.693 198.462 216.49 198.462 217.473Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.303 217.473C192.303 218.456 193.1 219.253 194.083 219.253C195.066 219.253 195.863 218.456 195.863 217.473C195.863 216.49 195.066 215.693 194.083 215.693C193.1 215.693 192.303 216.49 192.303 217.473Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.104 217.482C186.104 218.465 186.901 219.262 187.884 219.262C188.867 219.262 189.664 218.465 189.664 217.482C189.664 216.499 188.867 215.702 187.884 215.702C186.901 215.702 186.104 216.499 186.104 217.482Z"
            fill="#B8B7B7"
          />
          <path
            d="M179.945 217.482C179.945 218.465 180.742 219.262 181.725 219.262C182.708 219.262 183.505 218.465 183.505 217.482C183.505 216.499 182.708 215.702 181.725 215.702C180.742 215.702 179.945 216.499 179.945 217.482Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.78 217.482C173.78 218.465 174.577 219.262 175.56 219.262C176.543 219.262 177.339 218.465 177.339 217.482C177.339 216.499 176.543 215.702 175.56 215.702C174.577 215.702 173.78 216.499 173.78 217.482Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.621 217.482C167.621 218.465 168.417 219.262 169.4 219.262C170.383 219.262 171.18 218.465 171.18 217.482C171.18 216.499 170.383 215.702 169.4 215.702C168.417 215.702 167.621 216.499 167.621 217.482Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.422 217.482C161.422 218.465 162.218 219.262 163.201 219.262C164.184 219.262 164.981 218.465 164.981 217.482C164.981 216.499 164.184 215.702 163.201 215.702C162.218 215.702 161.422 216.499 161.422 217.482Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.262 217.482C155.262 218.465 156.059 219.262 157.042 219.262C158.025 219.262 158.822 218.465 158.822 217.482C158.822 216.499 158.025 215.702 157.042 215.702C156.059 215.702 155.262 216.499 155.262 217.482Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.273 212.205C300.273 213.188 301.07 213.985 302.053 213.985C303.036 213.985 303.833 213.188 303.833 212.205C303.833 211.222 303.036 210.425 302.053 210.425C301.07 210.425 300.273 211.222 300.273 212.205Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.279 222.841C300.279 223.824 301.075 224.621 302.058 224.621C303.041 224.621 303.838 223.824 303.838 222.841C303.838 221.858 303.041 221.061 302.058 221.061C301.075 221.061 300.279 221.858 300.279 222.841Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.121 222.841C294.121 223.824 294.918 224.621 295.901 224.621C296.884 224.621 297.68 223.824 297.68 222.841C297.68 221.858 296.884 221.061 295.901 221.061C294.918 221.061 294.121 221.858 294.121 222.841Z"
            fill="#B8B7B7"
          />
          <path
            d="M287.904 222.841C287.904 223.824 288.701 224.621 289.684 224.621C290.667 224.621 291.464 223.824 291.464 222.841C291.464 221.858 290.667 221.061 289.684 221.061C288.701 221.061 287.904 221.858 287.904 222.841Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.746 222.841C281.746 223.824 282.542 224.621 283.525 224.621C284.508 224.621 285.305 223.824 285.305 222.841C285.305 221.858 284.508 221.061 283.525 221.061C282.542 221.061 281.746 221.858 281.746 222.841Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.595 222.832C275.595 223.815 276.392 224.612 277.375 224.612C278.358 224.612 279.155 223.815 279.155 222.832C279.155 221.849 278.358 221.052 277.375 221.052C276.392 221.052 275.595 221.849 275.595 222.832Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.438 222.832C269.438 223.815 270.235 224.612 271.218 224.612C272.2 224.612 272.997 223.815 272.997 222.832C272.997 221.849 272.2 221.052 271.218 221.052C270.235 221.052 269.438 221.849 269.438 222.832Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.237 222.841C263.237 223.824 264.034 224.621 265.017 224.621C266 224.621 266.797 223.824 266.797 222.841C266.797 221.858 266 221.061 265.017 221.061C264.034 221.061 263.237 221.858 263.237 222.841Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.078 222.841C257.078 223.824 257.875 224.621 258.858 224.621C259.841 224.621 260.638 223.824 260.638 222.841C260.638 221.858 259.841 221.061 258.858 221.061C257.875 221.061 257.078 221.858 257.078 222.841Z"
            fill="#B8B7B7"
          />
          <path
            d="M250.912 222.841C250.912 223.824 251.709 224.621 252.692 224.621C253.675 224.621 254.472 223.824 254.472 222.841C254.472 221.858 253.675 221.061 252.692 221.061C251.709 221.061 250.912 221.858 250.912 222.841Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.755 222.841C244.755 223.824 245.551 224.621 246.534 224.621C247.517 224.621 248.314 223.824 248.314 222.841C248.314 221.858 247.517 221.061 246.534 221.061C245.551 221.061 244.755 221.858 244.755 222.841Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.554 222.841C238.554 223.824 239.351 224.621 240.334 224.621C241.317 224.621 242.114 223.824 242.114 222.841C242.114 221.858 241.317 221.061 240.334 221.061C239.351 221.061 238.554 221.858 238.554 222.841Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.395 222.841C232.395 223.824 233.192 224.621 234.175 224.621C235.158 224.621 235.955 223.824 235.955 222.841C235.955 221.858 235.158 221.061 234.175 221.061C233.192 221.061 232.395 221.858 232.395 222.841Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.226 222.846C226.226 223.829 227.023 224.626 228.006 224.626C228.989 224.626 229.786 223.829 229.786 222.846C229.786 221.863 228.989 221.066 228.006 221.066C227.023 221.066 226.226 221.863 226.226 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.067 222.846C220.067 223.829 220.864 224.626 221.846 224.626C222.829 224.626 223.626 223.829 223.626 222.846C223.626 221.863 222.829 221.066 221.846 221.066C220.864 221.066 220.067 221.863 220.067 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M213.85 222.846C213.85 223.829 214.647 224.626 215.63 224.626C216.613 224.626 217.41 223.829 217.41 222.846C217.41 221.863 216.613 221.066 215.63 221.066C214.647 221.066 213.85 221.863 213.85 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.691 222.846C207.691 223.829 208.488 224.626 209.471 224.626C210.454 224.626 211.251 223.829 211.251 222.846C211.251 221.863 210.454 221.066 209.471 221.066C208.488 221.066 207.691 221.863 207.691 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.543 222.836C201.543 223.819 202.34 224.615 203.323 224.615C204.306 224.615 205.103 223.819 205.103 222.836C205.103 221.853 204.306 221.056 203.323 221.056C202.34 221.056 201.543 221.853 201.543 222.836Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.384 222.836C195.384 223.819 196.18 224.615 197.163 224.615C198.146 224.615 198.943 223.819 198.943 222.836C198.943 221.853 198.146 221.056 197.163 221.056C196.18 221.056 195.384 221.853 195.384 222.836Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.183 222.846C189.183 223.829 189.98 224.626 190.963 224.626C191.946 224.626 192.743 223.829 192.743 222.846C192.743 221.863 191.946 221.066 190.963 221.066C189.98 221.066 189.183 221.863 189.183 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.024 222.846C183.024 223.829 183.821 224.626 184.804 224.626C185.787 224.626 186.583 223.829 186.583 222.846C186.583 221.863 185.787 221.066 184.804 221.066C183.821 221.066 183.024 221.863 183.024 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M176.86 222.846C176.86 223.829 177.657 224.626 178.64 224.626C179.623 224.626 180.42 223.829 180.42 222.846C180.42 221.863 179.623 221.066 178.64 221.066C177.657 221.066 176.86 221.863 176.86 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.701 222.846C170.701 223.829 171.498 224.626 172.481 224.626C173.464 224.626 174.261 223.829 174.261 222.846C174.261 221.863 173.464 221.066 172.481 221.066C171.498 221.066 170.701 221.863 170.701 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.5 222.846C164.5 223.829 165.297 224.626 166.28 224.626C167.263 224.626 168.06 223.829 168.06 222.846C168.06 221.863 167.263 221.066 166.28 221.066C165.297 221.066 164.5 221.863 164.5 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.341 222.846C158.341 223.829 159.138 224.626 160.121 224.626C161.104 224.626 161.9 223.829 161.9 222.846C161.9 221.863 161.104 221.066 160.121 221.066C159.138 221.066 158.341 221.863 158.341 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.195 228.143C297.195 229.125 297.991 229.922 298.974 229.922C299.957 229.922 300.754 229.125 300.754 228.143C300.754 227.16 299.957 226.363 298.974 226.363C297.991 226.363 297.195 227.16 297.195 228.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.035 228.143C291.035 229.125 291.832 229.922 292.815 229.922C293.798 229.922 294.595 229.125 294.595 228.143C294.595 227.16 293.798 226.363 292.815 226.363C291.832 226.363 291.035 227.16 291.035 228.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.819 228.143C284.819 229.125 285.616 229.922 286.599 229.922C287.582 229.922 288.379 229.125 288.379 228.143C288.379 227.16 287.582 226.363 286.599 226.363C285.616 226.363 284.819 227.16 284.819 228.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.66 228.143C278.66 229.125 279.457 229.922 280.44 229.922C281.423 229.922 282.22 229.125 282.22 228.143C282.22 227.16 281.423 226.363 280.44 226.363C279.457 226.363 278.66 227.16 278.66 228.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.512 228.132C272.512 229.115 273.308 229.912 274.291 229.912C275.274 229.912 276.071 229.115 276.071 228.132C276.071 227.149 275.274 226.352 274.291 226.352C273.308 226.352 272.512 227.149 272.512 228.132Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.353 228.132C266.353 229.115 267.149 229.912 268.132 229.912C269.115 229.912 269.912 229.115 269.912 228.132C269.912 227.149 269.115 226.352 268.132 226.352C267.149 226.352 266.353 227.149 266.353 228.132Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.152 228.143C260.152 229.125 260.949 229.922 261.932 229.922C262.915 229.922 263.712 229.125 263.712 228.143C263.712 227.16 262.915 226.363 261.932 226.363C260.949 226.363 260.152 227.16 260.152 228.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M253.993 228.143C253.993 229.126 254.79 229.922 255.773 229.922C256.756 229.922 257.553 229.126 257.553 228.143C257.553 227.16 256.756 226.363 255.773 226.363C254.79 226.363 253.993 227.16 253.993 228.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.828 228.143C247.828 229.125 248.625 229.922 249.608 229.922C250.591 229.922 251.388 229.125 251.388 228.143C251.388 227.16 250.591 226.363 249.608 226.363C248.625 226.363 247.828 227.16 247.828 228.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.67 228.143C241.67 229.125 242.467 229.922 243.449 229.922C244.432 229.922 245.229 229.125 245.229 228.143C245.229 227.16 244.432 226.363 243.449 226.363C242.467 226.363 241.67 227.16 241.67 228.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.469 228.143C235.469 229.125 236.266 229.922 237.249 229.922C238.232 229.922 239.029 229.125 239.029 228.143C239.029 227.16 238.232 226.363 237.249 226.363C236.266 226.363 235.469 227.16 235.469 228.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.31 228.143C229.31 229.125 230.107 229.922 231.09 229.922C232.073 229.922 232.87 229.125 232.87 228.143C232.87 227.16 232.073 226.363 231.09 226.363C230.107 226.363 229.31 227.16 229.31 228.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.14 228.146C223.14 229.129 223.937 229.926 224.92 229.926C225.903 229.926 226.7 229.129 226.7 228.146C226.7 227.163 225.903 226.367 224.92 226.367C223.937 226.367 223.14 227.163 223.14 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M216.981 228.146C216.981 229.129 217.778 229.926 218.761 229.926C219.744 229.926 220.541 229.129 220.541 228.146C220.541 227.163 219.744 226.367 218.761 226.367C217.778 226.367 216.981 227.163 216.981 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.765 228.146C210.765 229.129 211.562 229.926 212.545 229.926C213.528 229.926 214.325 229.129 214.325 228.146C214.325 227.163 213.528 226.367 212.545 226.367C211.562 226.367 210.765 227.163 210.765 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.606 228.146C204.606 229.129 205.403 229.926 206.386 229.926C207.368 229.926 208.165 229.129 208.165 228.146C208.165 227.163 207.368 226.367 206.386 226.367C205.403 226.367 204.606 227.163 204.606 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.458 228.137C198.458 229.12 199.254 229.917 200.237 229.917C201.22 229.917 202.017 229.12 202.017 228.137C202.017 227.154 201.22 226.358 200.237 226.358C199.254 226.358 198.458 227.154 198.458 228.137Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.299 228.137C192.299 229.12 193.095 229.917 194.078 229.917C195.061 229.917 195.858 229.12 195.858 228.137C195.858 227.154 195.061 226.358 194.078 226.358C193.095 226.358 192.299 227.154 192.299 228.137Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.099 228.146C186.099 229.129 186.896 229.926 187.879 229.926C188.862 229.926 189.659 229.129 189.659 228.146C189.659 227.163 188.862 226.367 187.879 226.367C186.896 226.367 186.099 227.163 186.099 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M179.94 228.146C179.94 229.129 180.737 229.926 181.72 229.926C182.703 229.926 183.5 229.129 183.5 228.146C183.5 227.163 182.703 226.367 181.72 226.367C180.737 226.367 179.94 227.163 179.94 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.774 228.146C173.774 229.129 174.571 229.926 175.554 229.926C176.537 229.926 177.334 229.129 177.334 228.146C177.334 227.163 176.537 226.367 175.554 226.367C174.571 226.367 173.774 227.163 173.774 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.616 228.146C167.616 229.129 168.412 229.926 169.395 229.926C170.378 229.926 171.175 229.129 171.175 228.146C171.175 227.163 170.378 226.367 169.395 226.367C168.412 226.367 167.616 227.163 167.616 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.416 228.146C161.416 229.129 162.213 229.926 163.196 229.926C164.179 229.926 164.976 229.129 164.976 228.146C164.976 227.163 164.179 226.367 163.196 226.367C162.213 226.367 161.416 227.163 161.416 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.257 228.146C155.257 229.129 156.054 229.926 157.037 229.926C158.02 229.926 158.817 229.129 158.817 228.146C158.817 227.163 158.02 226.367 157.037 226.367C156.054 226.367 155.257 227.163 155.257 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.279 233.387C300.279 234.37 301.075 235.167 302.058 235.167C303.041 235.167 303.838 234.37 303.838 233.387C303.838 232.404 303.041 231.607 302.058 231.607C301.075 231.607 300.279 232.404 300.279 233.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.121 233.387C294.121 234.37 294.918 235.167 295.901 235.167C296.884 235.167 297.68 234.37 297.68 233.387C297.68 232.404 296.884 231.607 295.901 231.607C294.918 231.607 294.121 232.404 294.121 233.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M287.904 233.387C287.904 234.37 288.701 235.167 289.684 235.167C290.667 235.167 291.464 234.37 291.464 233.387C291.464 232.404 290.667 231.607 289.684 231.607C288.701 231.607 287.904 232.404 287.904 233.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.746 233.387C281.746 234.37 282.542 235.167 283.525 235.167C284.508 235.167 285.305 234.37 285.305 233.387C285.305 232.404 284.508 231.607 283.525 231.607C282.542 231.607 281.746 232.404 281.746 233.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.595 233.378C275.595 234.361 276.392 235.158 277.375 235.158C278.358 235.158 279.155 234.361 279.155 233.378C279.155 232.395 278.358 231.598 277.375 231.598C276.392 231.598 275.595 232.395 275.595 233.378Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.438 233.378C269.438 234.361 270.235 235.158 271.218 235.158C272.2 235.158 272.997 234.361 272.997 233.378C272.997 232.395 272.2 231.598 271.218 231.598C270.235 231.598 269.438 232.395 269.438 233.378Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.237 233.387C263.237 234.37 264.034 235.167 265.017 235.167C266 235.167 266.797 234.37 266.797 233.387C266.797 232.404 266 231.607 265.017 231.607C264.034 231.607 263.237 232.404 263.237 233.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.078 233.387C257.078 234.37 257.875 235.167 258.858 235.167C259.841 235.167 260.638 234.37 260.638 233.387C260.638 232.404 259.841 231.607 258.858 231.607C257.875 231.607 257.078 232.404 257.078 233.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M250.912 233.387C250.912 234.37 251.709 235.167 252.692 235.167C253.675 235.167 254.472 234.37 254.472 233.387C254.472 232.404 253.675 231.607 252.692 231.607C251.709 231.607 250.912 232.404 250.912 233.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.755 233.387C244.755 234.37 245.551 235.167 246.534 235.167C247.517 235.167 248.314 234.37 248.314 233.387C248.314 232.404 247.517 231.607 246.534 231.607C245.551 231.607 244.755 232.404 244.755 233.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.554 233.387C238.554 234.37 239.351 235.167 240.334 235.167C241.317 235.167 242.114 234.37 242.114 233.387C242.114 232.404 241.317 231.607 240.334 231.607C239.351 231.607 238.554 232.404 238.554 233.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.395 233.387C232.395 234.37 233.192 235.167 234.175 235.167C235.158 235.167 235.955 234.37 235.955 233.387C235.955 232.404 235.158 231.607 234.175 231.607C233.192 231.607 232.395 232.404 232.395 233.387Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.226 233.391C226.226 234.374 227.023 235.171 228.006 235.171C228.989 235.171 229.786 234.374 229.786 233.391C229.786 232.408 228.989 231.611 228.006 231.611C227.023 231.611 226.226 232.408 226.226 233.391Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.067 233.391C220.067 234.374 220.864 235.171 221.846 235.171C222.829 235.171 223.626 234.374 223.626 233.391C223.626 232.408 222.829 231.611 221.846 231.611C220.864 231.611 220.067 232.408 220.067 233.391Z"
            fill="#B8B7B7"
          />
          <path
            d="M213.85 233.391C213.85 234.374 214.647 235.171 215.63 235.171C216.613 235.171 217.41 234.374 217.41 233.391C217.41 232.408 216.613 231.611 215.63 231.611C214.647 231.611 213.85 232.408 213.85 233.391Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.691 233.391C207.691 234.374 208.488 235.171 209.471 235.171C210.454 235.171 211.251 234.374 211.251 233.391C211.251 232.408 210.454 231.611 209.471 231.611C208.488 231.611 207.691 232.408 207.691 233.391Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.543 233.382C201.543 234.365 202.34 235.162 203.323 235.162C204.306 235.162 205.103 234.365 205.103 233.382C205.103 232.399 204.306 231.602 203.323 231.602C202.34 231.602 201.543 232.399 201.543 233.382Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.384 233.382C195.384 234.365 196.18 235.162 197.163 235.162C198.146 235.162 198.943 234.365 198.943 233.382C198.943 232.399 198.146 231.602 197.163 231.602C196.18 231.602 195.384 232.399 195.384 233.382Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.183 233.391C189.183 234.374 189.98 235.171 190.963 235.171C191.946 235.171 192.743 234.374 192.743 233.391C192.743 232.408 191.946 231.611 190.963 231.611C189.98 231.611 189.183 232.408 189.183 233.391Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.024 233.391C183.024 234.374 183.821 235.171 184.804 235.171C185.787 235.171 186.583 234.374 186.583 233.391C186.583 232.408 185.787 231.611 184.804 231.611C183.821 231.611 183.024 232.408 183.024 233.391Z"
            fill="#B8B7B7"
          />
          <path
            d="M176.86 233.391C176.86 234.374 177.657 235.171 178.64 235.171C179.623 235.171 180.42 234.374 180.42 233.391C180.42 232.408 179.623 231.611 178.64 231.611C177.657 231.611 176.86 232.408 176.86 233.391Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.701 233.391C170.701 234.374 171.498 235.171 172.481 235.171C173.464 235.171 174.261 234.374 174.261 233.391C174.261 232.408 173.464 231.611 172.481 231.611C171.498 231.611 170.701 232.408 170.701 233.391Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.5 233.391C164.5 234.374 165.297 235.171 166.28 235.171C167.263 235.171 168.06 234.374 168.06 233.391C168.06 232.408 167.263 231.611 166.28 231.611C165.297 231.611 164.5 232.408 164.5 233.391Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.341 233.391C158.341 234.374 159.138 235.171 160.121 235.171C161.104 235.171 161.9 234.374 161.9 233.391C161.9 232.408 161.104 231.611 160.121 231.611C159.138 231.611 158.341 232.408 158.341 233.391Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.205 238.677C297.205 239.66 298.002 240.457 298.985 240.457C299.968 240.457 300.764 239.66 300.764 238.677C300.764 237.694 299.968 236.897 298.985 236.897C298.002 236.897 297.205 237.694 297.205 238.677Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.046 238.677C291.046 239.66 291.843 240.457 292.826 240.457C293.809 240.457 294.605 239.66 294.605 238.677C294.605 237.694 293.809 236.897 292.826 236.897C291.843 236.897 291.046 237.694 291.046 238.677Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.83 238.677C284.83 239.66 285.626 240.457 286.609 240.457C287.592 240.457 288.389 239.66 288.389 238.677C288.389 237.694 287.592 236.897 286.609 236.897C285.626 236.897 284.83 237.694 284.83 238.677Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.67 238.677C278.67 239.66 279.467 240.457 280.45 240.457C281.433 240.457 282.23 239.66 282.23 238.677C282.23 237.694 281.433 236.897 280.45 236.897C279.467 236.897 278.67 237.694 278.67 238.677Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.522 238.668C272.522 239.651 273.319 240.448 274.302 240.448C275.285 240.448 276.082 239.651 276.082 238.668C276.082 237.685 275.285 236.888 274.302 236.888C273.319 236.888 272.522 237.685 272.522 238.668Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.363 238.668C266.363 239.651 267.16 240.448 268.143 240.448C269.126 240.448 269.923 239.651 269.923 238.668C269.923 237.685 269.126 236.888 268.143 236.888C267.16 236.888 266.363 237.685 266.363 238.668Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.164 238.677C260.164 239.66 260.961 240.457 261.944 240.457C262.927 240.457 263.723 239.66 263.723 238.677C263.723 237.694 262.927 236.897 261.944 236.897C260.961 236.897 260.164 237.694 260.164 238.677Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.005 238.677C254.005 239.66 254.801 240.457 255.784 240.457C256.767 240.457 257.564 239.66 257.564 238.677C257.564 237.694 256.767 236.897 255.784 236.897C254.801 236.897 254.005 237.694 254.005 238.677Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.839 238.677C247.839 239.66 248.635 240.457 249.618 240.457C250.601 240.457 251.398 239.66 251.398 238.677C251.398 237.694 250.601 236.897 249.618 236.897C248.635 236.897 247.839 237.694 247.839 238.677Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.68 238.677C241.68 239.66 242.477 240.457 243.46 240.457C244.443 240.457 245.24 239.66 245.24 238.677C245.24 237.694 244.443 236.897 243.46 236.897C242.477 236.897 241.68 237.694 241.68 238.677Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.481 238.677C235.481 239.66 236.278 240.457 237.261 240.457C238.243 240.457 239.04 239.66 239.04 238.677C239.04 237.694 238.243 236.897 237.261 236.897C236.278 236.897 235.481 237.694 235.481 238.677Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.322 238.677C229.322 239.66 230.119 240.457 231.102 240.457C232.085 240.457 232.881 239.66 232.881 238.677C232.881 237.694 232.085 236.897 231.102 236.897C230.119 236.897 229.322 237.694 229.322 238.677Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.152 238.682C223.152 239.665 223.949 240.462 224.932 240.462C225.915 240.462 226.712 239.665 226.712 238.682C226.712 237.699 225.915 236.902 224.932 236.902C223.949 236.902 223.152 237.699 223.152 238.682Z"
            fill="#B8B7B7"
          />
          <path
            d="M216.993 238.682C216.993 239.665 217.79 240.462 218.773 240.462C219.756 240.462 220.553 239.665 220.553 238.682C220.553 237.699 219.756 236.902 218.773 236.902C217.79 236.902 216.993 237.699 216.993 238.682Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.777 238.682C210.777 239.665 211.573 240.462 212.556 240.462C213.539 240.462 214.336 239.665 214.336 238.682C214.336 237.699 213.539 236.902 212.556 236.902C211.573 236.902 210.777 237.699 210.777 238.682Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.618 238.682C204.618 239.665 205.415 240.462 206.398 240.462C207.381 240.462 208.177 239.665 208.177 238.682C208.177 237.699 207.381 236.902 206.398 236.902C205.415 236.902 204.618 237.699 204.618 238.682Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.47 238.673C198.47 239.656 199.266 240.453 200.249 240.453C201.232 240.453 202.029 239.656 202.029 238.673C202.029 237.69 201.232 236.893 200.249 236.893C199.266 236.893 198.47 237.69 198.47 238.673Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.31 238.673C192.31 239.656 193.107 240.453 194.09 240.453C195.073 240.453 195.87 239.656 195.87 238.673C195.87 237.69 195.073 236.893 194.09 236.893C193.107 236.893 192.31 237.69 192.31 238.673Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.109 238.682C186.109 239.665 186.906 240.462 187.889 240.462C188.872 240.462 189.669 239.665 189.669 238.682C189.669 237.699 188.872 236.902 187.889 236.902C186.906 236.902 186.109 237.699 186.109 238.682Z"
            fill="#B8B7B7"
          />
          <path
            d="M179.95 238.682C179.95 239.665 180.747 240.462 181.73 240.462C182.713 240.462 183.51 239.665 183.51 238.682C183.51 237.699 182.713 236.902 181.73 236.902C180.747 236.902 179.95 237.699 179.95 238.682Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.786 238.682C173.786 239.665 174.583 240.462 175.566 240.462C176.549 240.462 177.346 239.665 177.346 238.682C177.346 237.699 176.549 236.902 175.566 236.902C174.583 236.902 173.786 237.699 173.786 238.682Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.627 238.682C167.627 239.665 168.424 240.462 169.407 240.462C170.39 240.462 171.187 239.665 171.187 238.682C171.187 237.699 170.39 236.902 169.407 236.902C168.424 236.902 167.627 237.699 167.627 238.682Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.427 238.682C161.427 239.665 162.223 240.462 163.206 240.462C164.189 240.462 164.986 239.665 164.986 238.682C164.986 237.699 164.189 236.902 163.206 236.902C162.223 236.902 161.427 237.699 161.427 238.682Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.268 238.682C155.268 239.665 156.064 240.462 157.047 240.462C158.03 240.462 158.827 239.665 158.827 238.682C158.827 237.699 158.03 236.902 157.047 236.902C156.064 236.902 155.268 237.699 155.268 238.682Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.121 243.979C294.121 244.962 294.918 245.758 295.901 245.758C296.884 245.758 297.68 244.962 297.68 243.979C297.68 242.996 296.884 242.199 295.901 242.199C294.918 242.199 294.121 242.996 294.121 243.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M287.962 243.979C287.962 244.962 288.759 245.758 289.742 245.758C290.725 245.758 291.521 244.962 291.521 243.979C291.521 242.996 290.725 242.199 289.742 242.199C288.759 242.199 287.962 242.996 287.962 243.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.746 243.979C281.746 244.962 282.542 245.758 283.525 245.758C284.508 245.758 285.305 244.962 285.305 243.979C285.305 242.996 284.508 242.199 283.525 242.199C282.542 242.199 281.746 242.996 281.746 243.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.587 243.979C275.587 244.962 276.384 245.758 277.366 245.758C278.349 245.758 279.146 244.962 279.146 243.979C279.146 242.996 278.349 242.199 277.366 242.199C276.384 242.199 275.587 242.996 275.587 243.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.438 243.97C269.438 244.952 270.235 245.749 271.218 245.749C272.2 245.749 272.997 244.952 272.997 243.97C272.997 242.987 272.2 242.19 271.218 242.19C270.235 242.19 269.438 242.987 269.438 243.97Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.279 243.97C263.279 244.952 264.076 245.749 265.059 245.749C266.042 245.749 266.838 244.952 266.838 243.97C266.838 242.987 266.042 242.19 265.059 242.19C264.076 242.19 263.279 242.987 263.279 243.97Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.078 243.979C257.078 244.962 257.875 245.758 258.858 245.758C259.841 245.758 260.638 244.962 260.638 243.979C260.638 242.996 259.841 242.199 258.858 242.199C257.875 242.199 257.078 242.996 257.078 243.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M250.919 243.979C250.919 244.962 251.716 245.758 252.699 245.758C253.682 245.758 254.479 244.962 254.479 243.979C254.479 242.996 253.682 242.199 252.699 242.199C251.716 242.199 250.919 242.996 250.919 243.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.755 243.979C244.755 244.962 245.551 245.758 246.534 245.758C247.517 245.758 248.314 244.962 248.314 243.979C248.314 242.996 247.517 242.199 246.534 242.199C245.551 242.199 244.755 242.996 244.755 243.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.596 243.979C238.596 244.962 239.393 245.758 240.376 245.758C241.359 245.758 242.156 244.962 242.156 243.979C242.156 242.996 241.359 242.199 240.376 242.199C239.393 242.199 238.596 242.996 238.596 243.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.395 243.979C232.395 244.962 233.192 245.758 234.175 245.758C235.158 245.758 235.955 244.962 235.955 243.979C235.955 242.996 235.158 242.199 234.175 242.199C233.192 242.199 232.395 242.996 232.395 243.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.236 243.979C226.236 244.962 227.033 245.758 228.016 245.758C228.999 245.758 229.795 244.962 229.795 243.979C229.795 242.996 228.999 242.199 228.016 242.199C227.033 242.199 226.236 242.996 226.236 243.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.067 243.984C220.067 244.967 220.864 245.764 221.846 245.764C222.829 245.764 223.626 244.967 223.626 243.984C223.626 243.001 222.829 242.204 221.846 242.204C220.864 242.204 220.067 243.001 220.067 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M213.908 243.984C213.908 244.967 214.705 245.764 215.688 245.764C216.67 245.764 217.467 244.967 217.467 243.984C217.467 243.001 216.67 242.204 215.688 242.204C214.705 242.204 213.908 243.001 213.908 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.691 243.984C207.691 244.967 208.488 245.764 209.471 245.764C210.454 245.764 211.251 244.967 211.251 243.984C211.251 243.001 210.454 242.204 209.471 242.204C208.488 242.204 207.691 243.001 207.691 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.532 243.984C201.532 244.967 202.329 245.764 203.312 245.764C204.295 245.764 205.092 244.967 205.092 243.984C205.092 243.001 204.295 242.204 203.312 242.204C202.329 242.204 201.532 243.001 201.532 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.384 243.973C195.384 244.956 196.18 245.753 197.163 245.753C198.146 245.753 198.943 244.956 198.943 243.973C198.943 242.99 198.146 242.194 197.163 242.194C196.18 242.194 195.384 242.99 195.384 243.973Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.225 243.973C189.225 244.956 190.022 245.753 191.005 245.753C191.988 245.753 192.784 244.956 192.784 243.973C192.784 242.99 191.988 242.194 191.005 242.194C190.022 242.194 189.225 242.99 189.225 243.973Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.024 243.984C183.024 244.967 183.821 245.764 184.804 245.764C185.787 245.764 186.583 244.967 186.583 243.984C186.583 243.001 185.787 242.204 184.804 242.204C183.821 242.204 183.024 243.001 183.024 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M176.866 243.984C176.866 244.967 177.663 245.764 178.646 245.764C179.629 245.764 180.426 244.967 180.426 243.984C180.426 243.001 179.629 242.204 178.646 242.204C177.663 242.204 176.866 243.001 176.866 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.701 243.984C170.701 244.967 171.498 245.764 172.481 245.764C173.464 245.764 174.261 244.967 174.261 243.984C174.261 243.001 173.464 242.204 172.481 242.204C171.498 242.204 170.701 243.001 170.701 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.542 243.984C164.542 244.967 165.339 245.764 166.322 245.764C167.304 245.764 168.101 244.967 168.101 243.984C168.101 243.001 167.304 242.204 166.322 242.204C165.339 242.204 164.542 243.001 164.542 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.341 243.984C158.341 244.967 159.138 245.764 160.121 245.764C161.104 245.764 161.9 244.967 161.9 243.984C161.9 243.001 161.104 242.204 160.121 242.204C159.138 242.204 158.341 243.001 158.341 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.183 243.984C152.183 244.967 152.98 245.764 153.963 245.764C154.946 245.764 155.743 244.967 155.743 243.984C155.743 243.001 154.946 242.204 153.963 242.204C152.98 242.204 152.183 243.001 152.183 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.205 249.223C297.205 250.206 298.002 251.003 298.985 251.003C299.968 251.003 300.764 250.206 300.764 249.223C300.764 248.24 299.968 247.443 298.985 247.443C298.002 247.443 297.205 248.24 297.205 249.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.046 249.223C291.046 250.206 291.843 251.003 292.826 251.003C293.809 251.003 294.605 250.206 294.605 249.223C294.605 248.24 293.809 247.443 292.826 247.443C291.843 247.443 291.046 248.24 291.046 249.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.83 249.223C284.83 250.206 285.626 251.003 286.609 251.003C287.592 251.003 288.389 250.206 288.389 249.223C288.389 248.24 287.592 247.443 286.609 247.443C285.626 247.443 284.83 248.24 284.83 249.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.67 249.223C278.67 250.206 279.467 251.003 280.45 251.003C281.433 251.003 282.23 250.206 282.23 249.223C282.23 248.24 281.433 247.443 280.45 247.443C279.467 247.443 278.67 248.24 278.67 249.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.522 249.214C272.522 250.197 273.319 250.994 274.302 250.994C275.285 250.994 276.082 250.197 276.082 249.214C276.082 248.231 275.285 247.434 274.302 247.434C273.319 247.434 272.522 248.231 272.522 249.214Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.363 249.214C266.363 250.197 267.16 250.994 268.143 250.994C269.126 250.994 269.923 250.197 269.923 249.214C269.923 248.231 269.126 247.434 268.143 247.434C267.16 247.434 266.363 248.231 266.363 249.214Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.164 249.223C260.164 250.206 260.961 251.003 261.944 251.003C262.927 251.003 263.723 250.206 263.723 249.223C263.723 248.24 262.927 247.443 261.944 247.443C260.961 247.443 260.164 248.24 260.164 249.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.005 249.223C254.005 250.206 254.801 251.003 255.784 251.003C256.767 251.003 257.564 250.206 257.564 249.223C257.564 248.24 256.767 247.443 255.784 247.443C254.801 247.443 254.005 248.24 254.005 249.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.839 249.223C247.839 250.206 248.635 251.003 249.618 251.003C250.601 251.003 251.398 250.206 251.398 249.223C251.398 248.24 250.601 247.443 249.618 247.443C248.635 247.443 247.839 248.24 247.839 249.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.68 249.223C241.68 250.206 242.477 251.003 243.46 251.003C244.443 251.003 245.24 250.206 245.24 249.223C245.24 248.24 244.443 247.443 243.46 247.443C242.477 247.443 241.68 248.24 241.68 249.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.481 249.223C235.481 250.206 236.278 251.003 237.261 251.003C238.243 251.003 239.04 250.206 239.04 249.223C239.04 248.24 238.243 247.443 237.261 247.443C236.278 247.443 235.481 248.24 235.481 249.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.322 249.223C229.322 250.206 230.119 251.003 231.102 251.003C232.085 251.003 232.881 250.206 232.881 249.223C232.881 248.24 232.085 247.443 231.102 247.443C230.119 247.443 229.322 248.24 229.322 249.223Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.152 249.228C223.152 250.211 223.949 251.008 224.932 251.008C225.915 251.008 226.712 250.211 226.712 249.228C226.712 248.245 225.915 247.449 224.932 247.449C223.949 247.449 223.152 248.245 223.152 249.228Z"
            fill="#B8B7B7"
          />
          <path
            d="M216.993 249.228C216.993 250.211 217.79 251.008 218.773 251.008C219.756 251.008 220.553 250.211 220.553 249.228C220.553 248.245 219.756 247.449 218.773 247.449C217.79 247.449 216.993 248.245 216.993 249.228Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.777 249.228C210.777 250.211 211.573 251.008 212.556 251.008C213.539 251.008 214.336 250.211 214.336 249.228C214.336 248.245 213.539 247.449 212.556 247.449C211.573 247.449 210.777 248.245 210.777 249.228Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.618 249.228C204.618 250.211 205.415 251.008 206.398 251.008C207.381 251.008 208.177 250.211 208.177 249.228C208.177 248.245 207.381 247.449 206.398 247.449C205.415 247.449 204.618 248.245 204.618 249.228Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.47 249.218C198.47 250.201 199.266 250.998 200.249 250.998C201.232 250.998 202.029 250.201 202.029 249.218C202.029 248.235 201.232 247.438 200.249 247.438C199.266 247.438 198.47 248.235 198.47 249.218Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.31 249.218C192.31 250.201 193.107 250.998 194.09 250.998C195.073 250.998 195.87 250.201 195.87 249.218C195.87 248.235 195.073 247.438 194.09 247.438C193.107 247.438 192.31 248.235 192.31 249.218Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.109 249.228C186.109 250.211 186.906 251.008 187.889 251.008C188.872 251.008 189.669 250.211 189.669 249.228C189.669 248.245 188.872 247.449 187.889 247.449C186.906 247.449 186.109 248.245 186.109 249.228Z"
            fill="#B8B7B7"
          />
          <path
            d="M179.95 249.228C179.95 250.211 180.747 251.008 181.73 251.008C182.713 251.008 183.51 250.211 183.51 249.228C183.51 248.245 182.713 247.449 181.73 247.449C180.747 247.449 179.95 248.245 179.95 249.228Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.786 249.228C173.786 250.211 174.583 251.008 175.566 251.008C176.549 251.008 177.346 250.211 177.346 249.228C177.346 248.245 176.549 247.449 175.566 247.449C174.583 247.449 173.786 248.245 173.786 249.228Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.627 249.228C167.627 250.211 168.424 251.008 169.407 251.008C170.39 251.008 171.187 250.211 171.187 249.228C171.187 248.245 170.39 247.448 169.407 247.448C168.424 247.448 167.627 248.245 167.627 249.228Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.427 249.228C161.427 250.211 162.223 251.008 163.206 251.008C164.189 251.008 164.986 250.211 164.986 249.228C164.986 248.245 164.189 247.448 163.206 247.448C162.223 247.448 161.427 248.245 161.427 249.228Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.268 249.228C155.268 250.211 156.064 251.008 157.047 251.008C158.03 251.008 158.827 250.211 158.827 249.228C158.827 248.245 158.03 247.448 157.047 247.448C156.064 247.448 155.268 248.245 155.268 249.228Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.279 243.95C300.279 244.933 301.075 245.73 302.058 245.73C303.041 245.73 303.838 244.933 303.838 243.95C303.838 242.967 303.041 242.17 302.058 242.17C301.075 242.17 300.279 242.967 300.279 243.95Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.279 254.406C300.279 255.389 301.075 256.186 302.058 256.186C303.041 256.186 303.838 255.389 303.838 254.406C303.838 253.424 303.041 252.627 302.058 252.627C301.075 252.627 300.279 253.424 300.279 254.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.121 254.406C294.121 255.389 294.918 256.186 295.901 256.186C296.884 256.186 297.68 255.389 297.68 254.406C297.68 253.424 296.884 252.627 295.901 252.627C294.918 252.627 294.121 253.424 294.121 254.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M287.904 254.406C287.904 255.389 288.701 256.186 289.684 256.186C290.667 256.186 291.464 255.389 291.464 254.406C291.464 253.424 290.667 252.627 289.684 252.627C288.701 252.627 287.904 253.424 287.904 254.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.746 254.406C281.746 255.389 282.542 256.186 283.525 256.186C284.508 256.186 285.305 255.389 285.305 254.406C285.305 253.424 284.508 252.627 283.525 252.627C282.542 252.627 281.746 253.424 281.746 254.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.595 254.397C275.595 255.38 276.392 256.177 277.375 256.177C278.358 256.177 279.155 255.38 279.155 254.397C279.155 253.414 278.358 252.618 277.375 252.618C276.392 252.618 275.595 253.414 275.595 254.397Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.438 254.397C269.438 255.38 270.235 256.177 271.218 256.177C272.2 256.177 272.997 255.38 272.997 254.397C272.997 253.414 272.2 252.618 271.218 252.618C270.235 252.618 269.438 253.414 269.438 254.397Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.237 254.406C263.237 255.389 264.034 256.186 265.017 256.186C266 256.186 266.797 255.389 266.797 254.406C266.797 253.424 266 252.627 265.017 252.627C264.034 252.627 263.237 253.424 263.237 254.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.078 254.406C257.078 255.389 257.875 256.186 258.858 256.186C259.841 256.186 260.638 255.389 260.638 254.406C260.638 253.424 259.841 252.627 258.858 252.627C257.875 252.627 257.078 253.424 257.078 254.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M250.912 254.406C250.912 255.389 251.709 256.186 252.692 256.186C253.675 256.186 254.472 255.389 254.472 254.406C254.472 253.424 253.675 252.627 252.692 252.627C251.709 252.627 250.912 253.424 250.912 254.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.755 254.406C244.755 255.389 245.551 256.186 246.534 256.186C247.517 256.186 248.314 255.389 248.314 254.406C248.314 253.424 247.517 252.627 246.534 252.627C245.551 252.627 244.755 253.424 244.755 254.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.554 254.406C238.554 255.389 239.351 256.186 240.334 256.186C241.317 256.186 242.114 255.389 242.114 254.406C242.114 253.424 241.317 252.627 240.334 252.627C239.351 252.627 238.554 253.424 238.554 254.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.395 254.406C232.395 255.389 233.192 256.186 234.175 256.186C235.158 256.186 235.955 255.389 235.955 254.406C235.955 253.424 235.158 252.627 234.175 252.627C233.192 252.627 232.395 253.424 232.395 254.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.226 254.412C226.226 255.395 227.023 256.191 228.006 256.191C228.989 256.191 229.786 255.395 229.786 254.412C229.786 253.429 228.989 252.632 228.006 252.632C227.023 252.632 226.226 253.429 226.226 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.067 254.412C220.067 255.395 220.864 256.191 221.846 256.191C222.829 256.191 223.626 255.395 223.626 254.412C223.626 253.429 222.829 252.632 221.846 252.632C220.864 252.632 220.067 253.429 220.067 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M213.85 254.412C213.85 255.395 214.647 256.191 215.63 256.191C216.613 256.191 217.41 255.395 217.41 254.412C217.41 253.429 216.613 252.632 215.63 252.632C214.647 252.632 213.85 253.429 213.85 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.691 254.412C207.691 255.395 208.488 256.191 209.471 256.191C210.454 256.191 211.251 255.395 211.251 254.412C211.251 253.429 210.454 252.632 209.471 252.632C208.488 252.632 207.691 253.429 207.691 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.543 254.401C201.543 255.384 202.34 256.181 203.323 256.181C204.306 256.181 205.103 255.384 205.103 254.401C205.103 253.418 204.306 252.622 203.323 252.622C202.34 252.622 201.543 253.418 201.543 254.401Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.384 254.401C195.384 255.384 196.18 256.181 197.163 256.181C198.146 256.181 198.943 255.384 198.943 254.401C198.943 253.418 198.146 252.622 197.163 252.622C196.18 252.622 195.384 253.418 195.384 254.401Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.183 254.412C189.183 255.395 189.98 256.191 190.963 256.191C191.946 256.191 192.743 255.395 192.743 254.412C192.743 253.429 191.946 252.632 190.963 252.632C189.98 252.632 189.183 253.429 189.183 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.024 254.412C183.024 255.395 183.821 256.191 184.804 256.191C185.787 256.191 186.583 255.395 186.583 254.412C186.583 253.429 185.787 252.632 184.804 252.632C183.821 252.632 183.024 253.429 183.024 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M176.86 254.412C176.86 255.395 177.657 256.191 178.64 256.191C179.623 256.191 180.42 255.395 180.42 254.412C180.42 253.429 179.623 252.632 178.64 252.632C177.657 252.632 176.86 253.429 176.86 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.701 254.412C170.701 255.395 171.498 256.191 172.481 256.191C173.464 256.191 174.261 255.395 174.261 254.412C174.261 253.429 173.464 252.632 172.481 252.632C171.498 252.632 170.701 253.429 170.701 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.5 254.412C164.5 255.395 165.297 256.191 166.28 256.191C167.263 256.191 168.06 255.395 168.06 254.412C168.06 253.429 167.263 252.632 166.28 252.632C165.297 252.632 164.5 253.429 164.5 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.341 254.412C158.341 255.395 159.138 256.191 160.121 256.191C161.104 256.191 161.9 255.395 161.9 254.412C161.9 253.429 161.104 252.632 160.121 252.632C159.138 252.632 158.341 253.429 158.341 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.195 259.708C297.195 260.691 297.991 261.488 298.974 261.488C299.957 261.488 300.754 260.691 300.754 259.708C300.754 258.725 299.957 257.928 298.974 257.928C297.991 257.928 297.195 258.725 297.195 259.708Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.035 259.708C291.035 260.691 291.832 261.488 292.815 261.488C293.798 261.488 294.595 260.691 294.595 259.708C294.595 258.725 293.798 257.928 292.815 257.928C291.832 257.928 291.035 258.725 291.035 259.708Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.819 259.708C284.819 260.691 285.616 261.488 286.599 261.488C287.582 261.488 288.379 260.691 288.379 259.708C288.379 258.725 287.582 257.928 286.599 257.928C285.616 257.928 284.819 258.725 284.819 259.708Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.66 259.708C278.66 260.691 279.457 261.488 280.44 261.488C281.423 261.488 282.22 260.691 282.22 259.708C282.22 258.725 281.423 257.928 280.44 257.928C279.457 257.928 278.66 258.725 278.66 259.708Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.512 259.699C272.512 260.682 273.308 261.479 274.291 261.479C275.274 261.479 276.071 260.682 276.071 259.699C276.071 258.716 275.274 257.919 274.291 257.919C273.308 257.919 272.512 258.716 272.512 259.699Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.353 259.699C266.353 260.682 267.149 261.479 268.132 261.479C269.115 261.479 269.912 260.682 269.912 259.699C269.912 258.716 269.115 257.919 268.132 257.919C267.149 257.919 266.353 258.716 266.353 259.699Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.152 259.708C260.152 260.691 260.949 261.488 261.932 261.488C262.915 261.488 263.712 260.691 263.712 259.708C263.712 258.725 262.915 257.928 261.932 257.928C260.949 257.928 260.152 258.725 260.152 259.708Z"
            fill="#B8B7B7"
          />
          <path
            d="M253.993 259.708C253.993 260.691 254.79 261.488 255.773 261.488C256.756 261.488 257.553 260.691 257.553 259.708C257.553 258.725 256.756 257.928 255.773 257.928C254.79 257.928 253.993 258.725 253.993 259.708Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.828 259.708C247.828 260.691 248.625 261.488 249.608 261.488C250.591 261.488 251.388 260.691 251.388 259.708C251.388 258.725 250.591 257.928 249.608 257.928C248.625 257.928 247.828 258.725 247.828 259.708Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.67 259.708C241.67 260.691 242.467 261.488 243.449 261.488C244.432 261.488 245.229 260.691 245.229 259.708C245.229 258.725 244.432 257.928 243.449 257.928C242.467 257.928 241.67 258.725 241.67 259.708Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.469 259.708C235.469 260.691 236.266 261.488 237.249 261.488C238.232 261.488 239.029 260.691 239.029 259.708C239.029 258.725 238.232 257.928 237.249 257.928C236.266 257.928 235.469 258.725 235.469 259.708Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.31 259.708C229.31 260.691 230.107 261.488 231.09 261.488C232.073 261.488 232.87 260.691 232.87 259.708C232.87 258.725 232.073 257.928 231.09 257.928C230.107 257.928 229.31 258.725 229.31 259.708Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.14 259.712C223.14 260.695 223.937 261.492 224.92 261.492C225.903 261.492 226.7 260.695 226.7 259.712C226.7 258.729 225.903 257.932 224.92 257.932C223.937 257.932 223.14 258.729 223.14 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M216.981 259.712C216.981 260.695 217.778 261.492 218.761 261.492C219.744 261.492 220.541 260.695 220.541 259.712C220.541 258.729 219.744 257.932 218.761 257.932C217.778 257.932 216.981 258.729 216.981 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.765 259.712C210.765 260.695 211.562 261.492 212.545 261.492C213.528 261.492 214.325 260.695 214.325 259.712C214.325 258.729 213.528 257.932 212.545 257.932C211.562 257.932 210.765 258.729 210.765 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.606 259.712C204.606 260.695 205.403 261.492 206.386 261.492C207.368 261.492 208.165 260.695 208.165 259.712C208.165 258.729 207.368 257.932 206.386 257.932C205.403 257.932 204.606 258.729 204.606 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.458 259.703C198.458 260.686 199.254 261.483 200.237 261.483C201.22 261.483 202.017 260.686 202.017 259.703C202.017 258.72 201.22 257.923 200.237 257.923C199.254 257.923 198.458 258.72 198.458 259.703Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.299 259.703C192.299 260.686 193.095 261.483 194.078 261.483C195.061 261.483 195.858 260.686 195.858 259.703C195.858 258.72 195.061 257.923 194.078 257.923C193.095 257.923 192.299 258.72 192.299 259.703Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.099 259.712C186.099 260.695 186.896 261.492 187.879 261.492C188.862 261.492 189.659 260.695 189.659 259.712C189.659 258.729 188.862 257.932 187.879 257.932C186.896 257.932 186.099 258.729 186.099 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M179.94 259.712C179.94 260.695 180.737 261.492 181.72 261.492C182.703 261.492 183.5 260.695 183.5 259.712C183.5 258.729 182.703 257.932 181.72 257.932C180.737 257.932 179.94 258.729 179.94 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.774 259.712C173.774 260.695 174.571 261.492 175.554 261.492C176.537 261.492 177.334 260.695 177.334 259.712C177.334 258.729 176.537 257.932 175.554 257.932C174.571 257.932 173.774 258.729 173.774 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.616 259.712C167.616 260.695 168.412 261.492 169.395 261.492C170.378 261.492 171.175 260.695 171.175 259.712C171.175 258.729 170.378 257.932 169.395 257.932C168.412 257.932 167.616 258.729 167.616 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.416 259.712C161.416 260.695 162.213 261.492 163.196 261.492C164.179 261.492 164.976 260.695 164.976 259.712C164.976 258.729 164.179 257.932 163.196 257.932C162.213 257.932 161.416 258.729 161.416 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.257 259.712C155.257 260.695 156.054 261.492 157.037 261.492C158.02 261.492 158.817 260.695 158.817 259.712C158.817 258.729 158.02 257.932 157.037 257.932C156.054 257.932 155.257 258.729 155.257 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.279 264.953C300.279 265.936 301.075 266.732 302.058 266.732C303.041 266.732 303.838 265.936 303.838 264.953C303.838 263.97 303.041 263.173 302.058 263.173C301.075 263.173 300.279 263.97 300.279 264.953Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.121 264.953C294.121 265.936 294.918 266.732 295.901 266.732C296.884 266.732 297.68 265.936 297.68 264.953C297.68 263.97 296.884 263.173 295.901 263.173C294.918 263.173 294.121 263.97 294.121 264.953Z"
            fill="#B8B7B7"
          />
          <path
            d="M287.904 264.953C287.904 265.936 288.701 266.732 289.684 266.732C290.667 266.732 291.464 265.936 291.464 264.953C291.464 263.97 290.667 263.173 289.684 263.173C288.701 263.173 287.904 263.97 287.904 264.953Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.746 264.953C281.746 265.936 282.542 266.732 283.525 266.732C284.508 266.732 285.305 265.936 285.305 264.953C285.305 263.97 284.508 263.173 283.525 263.173C282.542 263.173 281.746 263.97 281.746 264.953Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.595 264.944C275.595 265.926 276.392 266.723 277.375 266.723C278.358 266.723 279.155 265.926 279.155 264.944C279.155 263.961 278.358 263.164 277.375 263.164C276.392 263.164 275.595 263.961 275.595 264.944Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.438 264.944C269.438 265.926 270.235 266.723 271.218 266.723C272.2 266.723 272.997 265.926 272.997 264.944C272.997 263.961 272.2 263.164 271.218 263.164C270.235 263.164 269.438 263.961 269.438 264.944Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.237 264.953C263.237 265.936 264.034 266.732 265.017 266.732C266 266.732 266.797 265.936 266.797 264.953C266.797 263.97 266 263.173 265.017 263.173C264.034 263.173 263.237 263.97 263.237 264.953Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.078 264.953C257.078 265.936 257.875 266.732 258.858 266.732C259.841 266.732 260.638 265.936 260.638 264.953C260.638 263.97 259.841 263.173 258.858 263.173C257.875 263.173 257.078 263.97 257.078 264.953Z"
            fill="#B8B7B7"
          />
          <path
            d="M250.912 264.953C250.912 265.936 251.709 266.732 252.692 266.732C253.675 266.732 254.472 265.936 254.472 264.953C254.472 263.97 253.675 263.173 252.692 263.173C251.709 263.173 250.912 263.97 250.912 264.953Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.755 264.953C244.755 265.936 245.551 266.732 246.534 266.732C247.517 266.732 248.314 265.936 248.314 264.953C248.314 263.97 247.517 263.173 246.534 263.173C245.551 263.173 244.755 263.97 244.755 264.953Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.554 264.953C238.554 265.936 239.351 266.732 240.334 266.732C241.317 266.732 242.114 265.936 242.114 264.953C242.114 263.97 241.317 263.173 240.334 263.173C239.351 263.173 238.554 263.97 238.554 264.953Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.395 264.953C232.395 265.936 233.192 266.732 234.175 266.732C235.158 266.732 235.955 265.936 235.955 264.953C235.955 263.97 235.158 263.173 234.175 263.173C233.192 263.173 232.395 263.97 232.395 264.953Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.226 264.958C226.226 265.941 227.023 266.738 228.006 266.738C228.989 266.738 229.786 265.941 229.786 264.958C229.786 263.975 228.989 263.178 228.006 263.178C227.023 263.178 226.226 263.975 226.226 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.067 264.958C220.067 265.941 220.864 266.738 221.846 266.738C222.829 266.738 223.626 265.941 223.626 264.958C223.626 263.975 222.829 263.178 221.846 263.178C220.864 263.178 220.067 263.975 220.067 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M213.85 264.958C213.85 265.941 214.647 266.738 215.63 266.738C216.613 266.738 217.41 265.941 217.41 264.958C217.41 263.975 216.613 263.178 215.63 263.178C214.647 263.178 213.85 263.975 213.85 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.692 264.958C207.692 265.941 208.489 266.738 209.471 266.738C210.454 266.738 211.251 265.941 211.251 264.958C211.251 263.975 210.454 263.178 209.471 263.178C208.489 263.178 207.692 263.975 207.692 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.543 264.947C201.543 265.93 202.34 266.727 203.323 266.727C204.306 266.727 205.103 265.93 205.103 264.947C205.103 263.964 204.306 263.168 203.323 263.168C202.34 263.168 201.543 263.964 201.543 264.947Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.384 264.947C195.384 265.93 196.18 266.727 197.163 266.727C198.146 266.727 198.943 265.93 198.943 264.947C198.943 263.964 198.146 263.168 197.163 263.168C196.18 263.168 195.384 263.964 195.384 264.947Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.183 264.958C189.183 265.941 189.98 266.738 190.963 266.738C191.946 266.738 192.743 265.941 192.743 264.958C192.743 263.975 191.946 263.178 190.963 263.178C189.98 263.178 189.183 263.975 189.183 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.024 264.958C183.024 265.941 183.821 266.738 184.804 266.738C185.787 266.738 186.583 265.941 186.583 264.958C186.583 263.975 185.787 263.178 184.804 263.178C183.821 263.178 183.024 263.975 183.024 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M176.86 264.958C176.86 265.941 177.657 266.738 178.64 266.738C179.623 266.738 180.42 265.941 180.42 264.958C180.42 263.975 179.623 263.178 178.64 263.178C177.657 263.178 176.86 263.975 176.86 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.701 264.958C170.701 265.941 171.498 266.738 172.481 266.738C173.464 266.738 174.261 265.941 174.261 264.958C174.261 263.975 173.464 263.178 172.481 263.178C171.498 263.178 170.701 263.975 170.701 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.5 264.958C164.5 265.941 165.297 266.738 166.28 266.738C167.263 266.738 168.06 265.941 168.06 264.958C168.06 263.975 167.263 263.178 166.28 263.178C165.297 263.178 164.5 263.975 164.5 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.341 264.958C158.341 265.941 159.138 266.738 160.121 266.738C161.104 266.738 161.9 265.941 161.9 264.958C161.9 263.975 161.104 263.178 160.121 263.178C159.138 263.178 158.341 263.975 158.341 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.205 270.243C297.205 271.225 298.002 272.022 298.985 272.022C299.968 272.022 300.764 271.225 300.764 270.243C300.764 269.26 299.968 268.463 298.985 268.463C298.002 268.463 297.205 269.26 297.205 270.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.046 270.243C291.046 271.225 291.843 272.022 292.826 272.022C293.809 272.022 294.605 271.225 294.605 270.243C294.605 269.26 293.809 268.463 292.826 268.463C291.843 268.463 291.046 269.26 291.046 270.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.83 270.243C284.83 271.225 285.626 272.022 286.609 272.022C287.592 272.022 288.389 271.225 288.389 270.243C288.389 269.26 287.592 268.463 286.609 268.463C285.626 268.463 284.83 269.26 284.83 270.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.67 270.243C278.67 271.225 279.467 272.022 280.45 272.022C281.433 272.022 282.23 271.225 282.23 270.243C282.23 269.26 281.433 268.463 280.45 268.463C279.467 268.463 278.67 269.26 278.67 270.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.522 270.233C272.522 271.216 273.319 272.013 274.302 272.013C275.285 272.013 276.082 271.216 276.082 270.233C276.082 269.251 275.285 268.454 274.302 268.454C273.319 268.454 272.522 269.251 272.522 270.233Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.363 270.233C266.363 271.216 267.16 272.013 268.143 272.013C269.126 272.013 269.923 271.216 269.923 270.233C269.923 269.251 269.126 268.454 268.143 268.454C267.16 268.454 266.363 269.251 266.363 270.233Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.164 270.243C260.164 271.225 260.961 272.022 261.944 272.022C262.927 272.022 263.723 271.225 263.723 270.243C263.723 269.26 262.927 268.463 261.944 268.463C260.961 268.463 260.164 269.26 260.164 270.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.005 270.243C254.005 271.226 254.801 272.022 255.784 272.022C256.767 272.022 257.564 271.226 257.564 270.243C257.564 269.26 256.767 268.463 255.784 268.463C254.801 268.463 254.005 269.26 254.005 270.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.839 270.243C247.839 271.226 248.635 272.022 249.618 272.022C250.601 272.022 251.398 271.226 251.398 270.243C251.398 269.26 250.601 268.463 249.618 268.463C248.635 268.463 247.839 269.26 247.839 270.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.68 270.243C241.68 271.226 242.477 272.022 243.46 272.022C244.443 272.022 245.24 271.226 245.24 270.243C245.24 269.26 244.443 268.463 243.46 268.463C242.477 268.463 241.68 269.26 241.68 270.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.481 270.243C235.481 271.226 236.278 272.022 237.261 272.022C238.243 272.022 239.04 271.226 239.04 270.243C239.04 269.26 238.243 268.463 237.261 268.463C236.278 268.463 235.481 269.26 235.481 270.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.322 270.243C229.322 271.226 230.119 272.022 231.102 272.022C232.085 272.022 232.881 271.226 232.881 270.243C232.881 269.26 232.085 268.463 231.102 268.463C230.119 268.463 229.322 269.26 229.322 270.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.152 270.248C223.152 271.231 223.949 272.028 224.932 272.028C225.915 272.028 226.712 271.231 226.712 270.248C226.712 269.265 225.915 268.468 224.932 268.468C223.949 268.468 223.152 269.265 223.152 270.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M216.993 270.248C216.993 271.231 217.79 272.028 218.773 272.028C219.756 272.028 220.553 271.231 220.553 270.248C220.553 269.265 219.756 268.468 218.773 268.468C217.79 268.468 216.993 269.265 216.993 270.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.777 270.248C210.777 271.231 211.573 272.028 212.556 272.028C213.539 272.028 214.336 271.231 214.336 270.248C214.336 269.265 213.539 268.468 212.556 268.468C211.573 268.468 210.777 269.265 210.777 270.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.618 270.248C204.618 271.231 205.415 272.028 206.398 272.028C207.381 272.028 208.177 271.231 208.177 270.248C208.177 269.265 207.381 268.468 206.398 268.468C205.415 268.468 204.618 269.265 204.618 270.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.47 270.239C198.47 271.222 199.266 272.018 200.249 272.018C201.232 272.018 202.029 271.222 202.029 270.239C202.029 269.256 201.232 268.459 200.249 268.459C199.266 268.459 198.47 269.256 198.47 270.239Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.31 270.239C192.31 271.222 193.107 272.018 194.09 272.018C195.073 272.018 195.87 271.222 195.87 270.239C195.87 269.256 195.073 268.459 194.09 268.459C193.107 268.459 192.31 269.256 192.31 270.239Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.109 270.248C186.109 271.231 186.906 272.028 187.889 272.028C188.872 272.028 189.669 271.231 189.669 270.248C189.669 269.265 188.872 268.468 187.889 268.468C186.906 268.468 186.109 269.265 186.109 270.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M179.95 270.248C179.95 271.231 180.747 272.028 181.73 272.028C182.713 272.028 183.51 271.231 183.51 270.248C183.51 269.265 182.713 268.468 181.73 268.468C180.747 268.468 179.95 269.265 179.95 270.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.786 270.248C173.786 271.231 174.583 272.028 175.566 272.028C176.549 272.028 177.346 271.231 177.346 270.248C177.346 269.265 176.549 268.468 175.566 268.468C174.583 268.468 173.786 269.265 173.786 270.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.627 270.248C167.627 271.231 168.424 272.028 169.407 272.028C170.39 272.028 171.187 271.231 171.187 270.248C171.187 269.265 170.39 268.468 169.407 268.468C168.424 268.468 167.627 269.265 167.627 270.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.427 270.248C161.427 271.231 162.223 272.028 163.206 272.028C164.189 272.028 164.986 271.231 164.986 270.248C164.986 269.265 164.189 268.468 163.206 268.468C162.223 268.468 161.427 269.265 161.427 270.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.268 270.248C155.268 271.231 156.064 272.028 157.047 272.028C158.03 272.028 158.827 271.231 158.827 270.248C158.827 269.265 158.03 268.468 157.047 268.468C156.064 268.468 155.268 269.265 155.268 270.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.121 275.544C294.121 276.527 294.918 277.324 295.901 277.324C296.884 277.324 297.68 276.527 297.68 275.544C297.68 274.561 296.884 273.764 295.901 273.764C294.918 273.764 294.121 274.561 294.121 275.544Z"
            fill="#B8B7B7"
          />
          <path
            d="M287.962 275.544C287.962 276.527 288.759 277.324 289.742 277.324C290.725 277.324 291.521 276.527 291.521 275.544C291.521 274.561 290.725 273.764 289.742 273.764C288.759 273.764 287.962 274.561 287.962 275.544Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.746 275.544C281.746 276.527 282.542 277.324 283.525 277.324C284.508 277.324 285.305 276.527 285.305 275.544C285.305 274.561 284.508 273.764 283.525 273.764C282.542 273.764 281.746 274.561 281.746 275.544Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.587 275.544C275.587 276.527 276.384 277.324 277.366 277.324C278.349 277.324 279.146 276.527 279.146 275.544C279.146 274.561 278.349 273.764 277.366 273.764C276.384 273.764 275.587 274.561 275.587 275.544Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.438 275.535C269.438 276.518 270.235 277.315 271.218 277.315C272.2 277.315 272.997 276.518 272.997 275.535C272.997 274.552 272.2 273.755 271.218 273.755C270.235 273.755 269.438 274.552 269.438 275.535Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.279 275.535C263.279 276.518 264.076 277.315 265.059 277.315C266.042 277.315 266.838 276.518 266.838 275.535C266.838 274.552 266.042 273.755 265.059 273.755C264.076 273.755 263.279 274.552 263.279 275.535Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.078 275.544C257.078 276.527 257.875 277.324 258.858 277.324C259.841 277.324 260.638 276.527 260.638 275.544C260.638 274.561 259.841 273.764 258.858 273.764C257.875 273.764 257.078 274.561 257.078 275.544Z"
            fill="#B8B7B7"
          />
          <path
            d="M250.919 275.544C250.919 276.527 251.716 277.324 252.699 277.324C253.682 277.324 254.479 276.527 254.479 275.544C254.479 274.561 253.682 273.764 252.699 273.764C251.716 273.764 250.919 274.561 250.919 275.544Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.755 275.544C244.755 276.527 245.551 277.324 246.534 277.324C247.517 277.324 248.314 276.527 248.314 275.544C248.314 274.561 247.517 273.764 246.534 273.764C245.551 273.764 244.755 274.561 244.755 275.544Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.596 275.544C238.596 276.527 239.393 277.324 240.376 277.324C241.359 277.324 242.156 276.527 242.156 275.544C242.156 274.561 241.359 273.764 240.376 273.764C239.393 273.764 238.596 274.561 238.596 275.544Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.395 275.544C232.395 276.527 233.192 277.324 234.175 277.324C235.158 277.324 235.955 276.527 235.955 275.544C235.955 274.561 235.158 273.764 234.175 273.764C233.192 273.764 232.395 274.561 232.395 275.544Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.236 275.544C226.236 276.527 227.033 277.324 228.016 277.324C228.999 277.324 229.795 276.527 229.795 275.544C229.795 274.561 228.999 273.764 228.016 273.764C227.033 273.764 226.236 274.561 226.236 275.544Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.067 275.549C220.067 276.532 220.864 277.329 221.846 277.329C222.829 277.329 223.626 276.532 223.626 275.549C223.626 274.566 222.829 273.77 221.846 273.77C220.864 273.77 220.067 274.566 220.067 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M213.908 275.549C213.908 276.532 214.705 277.329 215.688 277.329C216.67 277.329 217.467 276.532 217.467 275.549C217.467 274.566 216.67 273.77 215.688 273.77C214.705 273.77 213.908 274.566 213.908 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.692 275.549C207.692 276.532 208.489 277.329 209.471 277.329C210.454 277.329 211.251 276.532 211.251 275.549C211.251 274.566 210.454 273.77 209.471 273.77C208.489 273.77 207.692 274.566 207.692 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.532 275.549C201.532 276.532 202.329 277.329 203.312 277.329C204.295 277.329 205.092 276.532 205.092 275.549C205.092 274.566 204.295 273.77 203.312 273.77C202.329 273.77 201.532 274.566 201.532 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.384 275.539C195.384 276.522 196.18 277.319 197.163 277.319C198.146 277.319 198.943 276.522 198.943 275.539C198.943 274.556 198.146 273.759 197.163 273.759C196.18 273.759 195.384 274.556 195.384 275.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.225 275.539C189.225 276.522 190.022 277.319 191.005 277.319C191.988 277.319 192.784 276.522 192.784 275.539C192.784 274.556 191.988 273.759 191.005 273.759C190.022 273.759 189.225 274.556 189.225 275.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.024 275.549C183.024 276.532 183.821 277.329 184.804 277.329C185.787 277.329 186.583 276.532 186.583 275.549C186.583 274.566 185.787 273.77 184.804 273.77C183.821 273.77 183.024 274.566 183.024 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M176.866 275.549C176.866 276.532 177.663 277.329 178.646 277.329C179.629 277.329 180.426 276.532 180.426 275.549C180.426 274.566 179.629 273.77 178.646 273.77C177.663 273.77 176.866 274.566 176.866 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.701 275.549C170.701 276.532 171.498 277.329 172.481 277.329C173.464 277.329 174.261 276.532 174.261 275.549C174.261 274.566 173.464 273.77 172.481 273.77C171.498 273.77 170.701 274.566 170.701 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.542 275.549C164.542 276.532 165.339 277.329 166.322 277.329C167.304 277.329 168.101 276.532 168.101 275.549C168.101 274.566 167.304 273.77 166.322 273.77C165.339 273.77 164.542 274.566 164.542 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.341 275.549C158.341 276.532 159.138 277.329 160.121 277.329C161.104 277.329 161.9 276.532 161.9 275.549C161.9 274.566 161.104 273.77 160.121 273.77C159.138 273.77 158.341 274.566 158.341 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.183 275.549C152.183 276.532 152.98 277.329 153.963 277.329C154.946 277.329 155.743 276.532 155.743 275.549C155.743 274.566 154.946 273.77 153.963 273.77C152.98 273.77 152.183 274.566 152.183 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.205 280.789C297.205 281.772 298.002 282.568 298.985 282.568C299.968 282.568 300.764 281.772 300.764 280.789C300.764 279.806 299.968 279.009 298.985 279.009C298.002 279.009 297.205 279.806 297.205 280.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.046 280.789C291.046 281.772 291.843 282.568 292.826 282.568C293.809 282.568 294.605 281.772 294.605 280.789C294.605 279.806 293.809 279.009 292.826 279.009C291.843 279.009 291.046 279.806 291.046 280.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.83 280.789C284.83 281.772 285.626 282.568 286.609 282.568C287.592 282.568 288.389 281.772 288.389 280.789C288.389 279.806 287.592 279.009 286.609 279.009C285.626 279.009 284.83 279.806 284.83 280.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.67 280.789C278.67 281.772 279.467 282.568 280.45 282.568C281.433 282.568 282.23 281.772 282.23 280.789C282.23 279.806 281.433 279.009 280.45 279.009C279.467 279.009 278.67 279.806 278.67 280.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.522 280.78C272.522 281.763 273.319 282.559 274.302 282.559C275.285 282.559 276.082 281.763 276.082 280.78C276.082 279.797 275.285 279 274.302 279C273.319 279 272.522 279.797 272.522 280.78Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.363 280.78C266.363 281.763 267.16 282.559 268.143 282.559C269.126 282.559 269.923 281.763 269.923 280.78C269.923 279.797 269.126 279 268.143 279C267.16 279 266.363 279.797 266.363 280.78Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.164 280.789C260.164 281.772 260.961 282.568 261.944 282.568C262.927 282.568 263.723 281.772 263.723 280.789C263.723 279.806 262.927 279.009 261.944 279.009C260.961 279.009 260.164 279.806 260.164 280.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.005 280.789C254.005 281.772 254.801 282.568 255.784 282.568C256.767 282.568 257.564 281.772 257.564 280.789C257.564 279.806 256.767 279.009 255.784 279.009C254.801 279.009 254.005 279.806 254.005 280.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.839 280.789C247.839 281.772 248.635 282.568 249.618 282.568C250.601 282.568 251.398 281.772 251.398 280.789C251.398 279.806 250.601 279.009 249.618 279.009C248.635 279.009 247.839 279.806 247.839 280.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.68 280.789C241.68 281.772 242.477 282.568 243.46 282.568C244.443 282.568 245.24 281.772 245.24 280.789C245.24 279.806 244.443 279.009 243.46 279.009C242.477 279.009 241.68 279.806 241.68 280.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.481 280.789C235.481 281.772 236.278 282.568 237.261 282.568C238.243 282.568 239.04 281.772 239.04 280.789C239.04 279.806 238.243 279.009 237.261 279.009C236.278 279.009 235.481 279.806 235.481 280.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.322 280.789C229.322 281.772 230.119 282.568 231.102 282.568C232.085 282.568 232.881 281.772 232.881 280.789C232.881 279.806 232.085 279.009 231.102 279.009C230.119 279.009 229.322 279.806 229.322 280.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.152 280.794C223.152 281.777 223.949 282.574 224.932 282.574C225.915 282.574 226.712 281.777 226.712 280.794C226.712 279.811 225.915 279.014 224.932 279.014C223.949 279.014 223.152 279.811 223.152 280.794Z"
            fill="#B8B7B7"
          />
          <path
            d="M216.993 280.794C216.993 281.777 217.79 282.574 218.773 282.574C219.756 282.574 220.553 281.777 220.553 280.794C220.553 279.811 219.756 279.014 218.773 279.014C217.79 279.014 216.993 279.811 216.993 280.794Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.777 280.794C210.777 281.777 211.573 282.574 212.556 282.574C213.539 282.574 214.336 281.777 214.336 280.794C214.336 279.811 213.539 279.014 212.556 279.014C211.573 279.014 210.777 279.811 210.777 280.794Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.618 280.794C204.618 281.777 205.415 282.574 206.398 282.574C207.381 282.574 208.177 281.777 208.177 280.794C208.177 279.811 207.381 279.014 206.398 279.014C205.415 279.014 204.618 279.811 204.618 280.794Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.47 280.785C198.47 281.768 199.266 282.565 200.249 282.565C201.232 282.565 202.029 281.768 202.029 280.785C202.029 279.802 201.232 279.005 200.249 279.005C199.266 279.005 198.47 279.802 198.47 280.785Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.31 280.785C192.31 281.768 193.107 282.565 194.09 282.565C195.073 282.565 195.87 281.768 195.87 280.785C195.87 279.802 195.073 279.005 194.09 279.005C193.107 279.005 192.31 279.802 192.31 280.785Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.109 280.794C186.109 281.777 186.906 282.574 187.889 282.574C188.872 282.574 189.669 281.777 189.669 280.794C189.669 279.811 188.872 279.014 187.889 279.014C186.906 279.014 186.109 279.811 186.109 280.794Z"
            fill="#B8B7B7"
          />
          <path
            d="M179.95 280.794C179.95 281.777 180.747 282.574 181.73 282.574C182.713 282.574 183.51 281.777 183.51 280.794C183.51 279.811 182.713 279.014 181.73 279.014C180.747 279.014 179.95 279.811 179.95 280.794Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.786 280.794C173.786 281.777 174.583 282.574 175.566 282.574C176.549 282.574 177.346 281.777 177.346 280.794C177.346 279.811 176.549 279.014 175.566 279.014C174.583 279.014 173.786 279.811 173.786 280.794Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.627 280.794C167.627 281.777 168.424 282.574 169.407 282.574C170.39 282.574 171.187 281.777 171.187 280.794C171.187 279.811 170.39 279.014 169.407 279.014C168.424 279.014 167.627 279.811 167.627 280.794Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.427 280.794C161.427 281.777 162.223 282.574 163.206 282.574C164.189 282.574 164.986 281.777 164.986 280.794C164.986 279.811 164.189 279.014 163.206 279.014C162.223 279.014 161.427 279.811 161.427 280.794Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.268 280.794C155.268 281.777 156.064 282.574 157.047 282.574C158.03 282.574 158.827 281.777 158.827 280.794C158.827 279.811 158.03 279.014 157.047 279.014C156.064 279.014 155.268 279.811 155.268 280.794Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.279 275.516C300.279 276.499 301.075 277.295 302.058 277.295C303.041 277.295 303.838 276.499 303.838 275.516C303.838 274.533 303.041 273.736 302.058 273.736C301.075 273.736 300.279 274.533 300.279 275.516Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.087 196.411C149.087 197.394 149.884 198.19 150.867 198.19C151.85 198.19 152.647 197.394 152.647 196.411C152.647 195.428 151.85 194.631 150.867 194.631C149.884 194.631 149.087 195.428 149.087 196.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M142.928 196.411C142.928 197.394 143.725 198.19 144.708 198.19C145.691 198.19 146.488 197.394 146.488 196.411C146.488 195.428 145.691 194.631 144.708 194.631C143.725 194.631 142.928 195.428 142.928 196.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.712 196.411C136.712 197.394 137.509 198.19 138.492 198.19C139.475 198.19 140.272 197.394 140.272 196.411C140.272 195.428 139.475 194.631 138.492 194.631C137.509 194.631 136.712 195.428 136.712 196.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.553 196.411C130.553 197.394 131.35 198.19 132.333 198.19C133.316 198.19 134.113 197.394 134.113 196.411C134.113 195.428 133.316 194.631 132.333 194.631C131.35 194.631 130.553 195.428 130.553 196.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.405 196.402C124.405 197.384 125.202 198.181 126.185 198.181C127.168 198.181 127.964 197.384 127.964 196.402C127.964 195.419 127.168 194.622 126.185 194.622C125.202 194.622 124.405 195.419 124.405 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.246 196.402C118.246 197.384 119.042 198.181 120.025 198.181C121.008 198.181 121.805 197.384 121.805 196.402C121.805 195.419 121.008 194.622 120.025 194.622C119.042 194.622 118.246 195.419 118.246 196.402Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.045 196.411C112.045 197.394 112.842 198.19 113.825 198.19C114.808 198.19 115.604 197.394 115.604 196.411C115.604 195.428 114.808 194.631 113.825 194.631C112.842 194.631 112.045 195.428 112.045 196.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M105.886 196.411C105.886 197.394 106.683 198.19 107.666 198.19C108.648 198.19 109.445 197.394 109.445 196.411C109.445 195.428 108.648 194.631 107.666 194.631C106.683 194.631 105.886 195.428 105.886 196.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.722 196.411C99.722 197.394 100.519 198.19 101.502 198.19C102.485 198.19 103.281 197.394 103.281 196.411C103.281 195.428 102.485 194.631 101.502 194.631C100.519 194.631 99.722 195.428 99.722 196.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.5627 196.411C93.5627 197.394 94.3595 198.19 95.3424 198.19C96.3254 198.19 97.1222 197.394 97.1222 196.411C97.1222 195.428 96.3254 194.631 95.3424 194.631C94.3595 194.631 93.5627 195.428 93.5627 196.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.3622 196.411C87.3622 197.394 88.159 198.19 89.142 198.19C90.1249 198.19 90.9218 197.394 90.9218 196.411C90.9218 195.428 90.1249 194.631 89.142 194.631C88.159 194.631 87.3622 195.428 87.3622 196.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.2032 196.411C81.2032 197.394 82 198.19 82.9829 198.19C83.9659 198.19 84.7627 197.394 84.7627 196.411C84.7627 195.428 83.9659 194.631 82.9829 194.631C82 194.631 81.2032 195.428 81.2032 196.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.0336 196.416C75.0336 197.399 75.8304 198.196 76.8134 198.196C77.7963 198.196 78.5931 197.399 78.5931 196.416C78.5931 195.433 77.7963 194.636 76.8134 194.636C75.8304 194.636 75.0336 195.433 75.0336 196.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.8745 196.416C68.8745 197.399 69.6714 198.196 70.6543 198.196C71.6373 198.196 72.4341 197.399 72.4341 196.416C72.4341 195.433 71.6373 194.636 70.6543 194.636C69.6714 194.636 68.8745 195.433 68.8745 196.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.6582 196.416C62.6582 197.399 63.4551 198.196 64.438 198.196C65.4209 198.196 66.2178 197.399 66.2178 196.416C66.2178 195.433 65.4209 194.636 64.438 194.636C63.4551 194.636 62.6582 195.433 62.6582 196.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.4993 196.416C56.4993 197.399 57.2961 198.196 58.2791 198.196C59.262 198.196 60.0588 197.399 60.0588 196.416C60.0588 195.433 59.262 194.636 58.2791 194.636C57.2961 194.636 56.4993 195.433 56.4993 196.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.3505 196.405C50.3505 197.388 51.1473 198.185 52.1303 198.185C53.1132 198.185 53.91 197.388 53.91 196.405C53.91 195.423 53.1132 194.626 52.1303 194.626C51.1473 194.626 50.3505 195.423 50.3505 196.405Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.1917 196.405C44.1917 197.388 44.9885 198.185 45.9715 198.185C46.9544 198.185 47.7512 197.388 47.7512 196.405C47.7512 195.423 46.9544 194.626 45.9715 194.626C44.9885 194.626 44.1917 195.423 44.1917 196.405Z"
            fill="#B8B7B7"
          />
          <path
            d="M37.9911 196.416C37.9911 197.399 38.7879 198.196 39.7709 198.196C40.7538 198.196 41.5507 197.399 41.5507 196.416C41.5507 195.433 40.7538 194.636 39.7709 194.636C38.7879 194.636 37.9911 195.433 37.9911 196.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.8332 196.416C31.8332 197.399 32.63 198.196 33.6129 198.196C34.5959 198.196 35.3927 197.399 35.3927 196.416C35.3927 195.433 34.5959 194.636 33.6129 194.636C32.63 194.636 31.8332 195.433 31.8332 196.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.6675 196.416C25.6675 197.399 26.4643 198.196 27.4473 198.196C28.4302 198.196 29.2271 197.399 29.2271 196.416C29.2271 195.433 28.4302 194.636 27.4473 194.636C26.4643 194.636 25.6675 195.433 25.6675 196.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.5086 196.416C19.5086 197.399 20.3054 198.196 21.2883 198.196C22.2713 198.196 23.0681 197.399 23.0681 196.416C23.0681 195.433 22.2713 194.636 21.2883 194.636C20.3054 194.636 19.5086 195.433 19.5086 196.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.3081 196.416C13.3081 197.399 14.105 198.196 15.0879 198.196C16.0708 198.196 16.8677 197.399 16.8677 196.416C16.8677 195.433 16.0708 194.636 15.0879 194.636C14.105 194.636 13.3081 195.433 13.3081 196.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.1503 196.416C7.1503 197.399 7.94713 198.196 8.93007 198.196C9.91301 198.196 10.7098 197.399 10.7098 196.416C10.7098 195.433 9.91301 194.636 8.93007 194.636C7.94713 194.636 7.1503 195.433 7.1503 196.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.002 201.712C146.002 202.695 146.799 203.492 147.782 203.492C148.765 203.492 149.562 202.695 149.562 201.712C149.562 200.729 148.765 199.933 147.782 199.933C146.799 199.933 146.002 200.729 146.002 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.843 201.712C139.843 202.695 140.64 203.492 141.623 203.492C142.606 203.492 143.403 202.695 143.403 201.712C143.403 200.729 142.606 199.933 141.623 199.933C140.64 199.933 139.843 200.729 139.843 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.627 201.712C133.627 202.695 134.424 203.492 135.407 203.492C136.39 203.492 137.187 202.695 137.187 201.712C137.187 200.729 136.39 199.932 135.407 199.932C134.424 199.932 133.627 200.729 133.627 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.468 201.712C127.468 202.695 128.265 203.492 129.248 203.492C130.231 203.492 131.028 202.695 131.028 201.712C131.028 200.729 130.231 199.932 129.248 199.932C128.265 199.932 127.468 200.729 127.468 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.319 201.703C121.319 202.686 122.116 203.483 123.099 203.483C124.082 203.483 124.879 202.686 124.879 201.703C124.879 200.72 124.082 199.923 123.099 199.923C122.116 199.923 121.319 200.72 121.319 201.703Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.16 201.703C115.16 202.686 115.957 203.483 116.94 203.483C117.923 203.483 118.72 202.686 118.72 201.703C118.72 200.72 117.923 199.923 116.94 199.923C115.957 199.923 115.16 200.72 115.16 201.703Z"
            fill="#B8B7B7"
          />
          <path
            d="M108.96 201.712C108.96 202.695 109.756 203.492 110.739 203.492C111.722 203.492 112.519 202.695 112.519 201.712C112.519 200.729 111.722 199.933 110.739 199.933C109.756 199.933 108.96 200.729 108.96 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.802 201.712C102.802 202.695 103.599 203.492 104.582 203.492C105.565 203.492 106.362 202.695 106.362 201.712C106.362 200.729 105.565 199.932 104.582 199.932C103.599 199.932 102.802 200.729 102.802 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.6364 201.712C96.6364 202.695 97.4332 203.492 98.4162 203.492C99.3991 203.492 100.196 202.695 100.196 201.712C100.196 200.729 99.3991 199.932 98.4162 199.932C97.4332 199.932 96.6364 200.729 96.6364 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.4771 201.712C90.4771 202.695 91.2739 203.492 92.2569 203.492C93.2398 203.492 94.0366 202.695 94.0366 201.712C94.0366 200.729 93.2398 199.933 92.2569 199.933C91.2739 199.933 90.4771 200.729 90.4771 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.2765 201.712C84.2765 202.695 85.0733 203.492 86.0563 203.492C87.0392 203.492 87.8361 202.695 87.8361 201.712C87.8361 200.729 87.0392 199.933 86.0563 199.933C85.0733 199.933 84.2765 200.729 84.2765 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.119 201.712C78.119 202.695 78.9159 203.492 79.8988 203.492C80.8818 203.492 81.6786 202.695 81.6786 201.712C81.6786 200.729 80.8818 199.932 79.8988 199.932C78.9159 199.932 78.119 200.729 78.119 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M71.9484 201.716C71.9484 202.699 72.7452 203.496 73.7282 203.496C74.7111 203.496 75.5079 202.699 75.5079 201.716C75.5079 200.733 74.7111 199.936 73.7282 199.936C72.7452 199.936 71.9484 200.733 71.9484 201.716Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.7891 201.716C65.7891 202.699 66.5859 203.496 67.5689 203.496C68.5518 203.496 69.3486 202.699 69.3486 201.716C69.3486 200.733 68.5518 199.936 67.5689 199.936C66.5859 199.936 65.7891 200.733 65.7891 201.716Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.5731 201.716C59.5731 202.699 60.37 203.496 61.3529 203.496C62.3359 203.496 63.1327 202.699 63.1327 201.716C63.1327 200.733 62.3359 199.936 61.3529 199.936C60.37 199.936 59.5731 200.733 59.5731 201.716Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.4137 201.716C53.4137 202.699 54.2106 203.496 55.1935 203.496C56.1764 203.496 56.9733 202.699 56.9733 201.716C56.9733 200.733 56.1764 199.936 55.1935 199.936C54.2106 199.936 53.4137 200.733 53.4137 201.716Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.2652 201.707C47.2652 202.69 48.062 203.487 49.0449 203.487C50.0279 203.487 50.8247 202.69 50.8247 201.707C50.8247 200.724 50.0279 199.927 49.0449 199.927C48.062 199.927 47.2652 200.724 47.2652 201.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.106 201.707C41.106 202.69 41.9028 203.487 42.8858 203.487C43.8687 203.487 44.6655 202.69 44.6655 201.707C44.6655 200.724 43.8687 199.927 42.8858 199.927C41.9028 199.927 41.106 200.724 41.106 201.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M34.907 201.716C34.907 202.699 35.7038 203.496 36.6868 203.496C37.6697 203.496 38.4666 202.699 38.4666 201.716C38.4666 200.733 37.6697 199.936 36.6868 199.936C35.7038 199.936 34.907 200.733 34.907 201.716Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.748 201.716C28.748 202.699 29.5448 203.496 30.5277 203.496C31.5107 203.496 32.3075 202.699 32.3075 201.716C32.3075 200.733 31.5107 199.936 30.5277 199.936C29.5448 199.936 28.748 200.733 28.748 201.716Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.5823 201.716C22.5823 202.699 23.3791 203.496 24.3621 203.496C25.345 203.496 26.1418 202.699 26.1418 201.716C26.1418 200.733 25.345 199.936 24.3621 199.936C23.3791 199.936 22.5823 200.733 22.5823 201.716Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.4234 201.716C16.4234 202.699 17.2202 203.496 18.2031 203.496C19.1861 203.496 19.9829 202.699 19.9829 201.716C19.9829 200.733 19.1861 199.936 18.2031 199.936C17.2202 199.936 16.4234 200.733 16.4234 201.716Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.224 201.716C10.224 202.699 11.0209 203.496 12.0038 203.496C12.9867 203.496 13.7836 202.699 13.7836 201.716C13.7836 200.733 12.9867 199.936 12.0038 199.936C11.0209 199.936 10.224 200.733 10.224 201.716Z"
            fill="#B8B7B7"
          />
          <path
            d="M4.06509 201.716C4.06509 202.699 4.86192 203.496 5.84486 203.496C6.8278 203.496 7.62463 202.699 7.62463 201.716C7.62463 200.733 6.8278 199.936 5.84486 199.936C4.86192 199.936 4.06509 200.733 4.06509 201.716Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.087 206.957C149.087 207.94 149.884 208.737 150.867 208.737C151.85 208.737 152.647 207.94 152.647 206.957C152.647 205.974 151.85 205.177 150.867 205.177C149.884 205.177 149.087 205.974 149.087 206.957Z"
            fill="#B8B7B7"
          />
          <path
            d="M142.928 206.957C142.928 207.94 143.725 208.737 144.708 208.737C145.691 208.737 146.488 207.94 146.488 206.957C146.488 205.974 145.691 205.177 144.708 205.177C143.725 205.177 142.928 205.974 142.928 206.957Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.712 206.957C136.712 207.94 137.509 208.737 138.492 208.737C139.475 208.737 140.272 207.94 140.272 206.957C140.272 205.974 139.475 205.177 138.492 205.177C137.509 205.177 136.712 205.974 136.712 206.957Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.553 206.957C130.553 207.94 131.35 208.737 132.333 208.737C133.316 208.737 134.113 207.94 134.113 206.957C134.113 205.974 133.316 205.177 132.333 205.177C131.35 205.177 130.553 205.974 130.553 206.957Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.405 206.948C124.405 207.931 125.202 208.727 126.185 208.727C127.168 208.727 127.964 207.931 127.964 206.948C127.964 205.965 127.168 205.168 126.185 205.168C125.202 205.168 124.405 205.965 124.405 206.948Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.246 206.948C118.246 207.931 119.042 208.727 120.025 208.727C121.008 208.727 121.805 207.931 121.805 206.948C121.805 205.965 121.008 205.168 120.025 205.168C119.042 205.168 118.246 205.965 118.246 206.948Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.045 206.957C112.045 207.94 112.842 208.737 113.825 208.737C114.808 208.737 115.604 207.94 115.604 206.957C115.604 205.974 114.808 205.177 113.825 205.177C112.842 205.177 112.045 205.974 112.045 206.957Z"
            fill="#B8B7B7"
          />
          <path
            d="M105.886 206.957C105.886 207.94 106.683 208.737 107.666 208.737C108.648 208.737 109.445 207.94 109.445 206.957C109.445 205.974 108.648 205.177 107.666 205.177C106.683 205.177 105.886 205.974 105.886 206.957Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.722 206.957C99.722 207.94 100.519 208.737 101.502 208.737C102.485 208.737 103.281 207.94 103.281 206.957C103.281 205.974 102.485 205.177 101.502 205.177C100.519 205.177 99.722 205.974 99.722 206.957Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.5627 206.957C93.5627 207.94 94.3595 208.737 95.3424 208.737C96.3254 208.737 97.1222 207.94 97.1222 206.957C97.1222 205.974 96.3254 205.177 95.3424 205.177C94.3595 205.177 93.5627 205.974 93.5627 206.957Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.3622 206.957C87.3622 207.94 88.159 208.737 89.142 208.737C90.1249 208.737 90.9218 207.94 90.9218 206.957C90.9218 205.974 90.1249 205.177 89.142 205.177C88.159 205.177 87.3622 205.974 87.3622 206.957Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.2032 206.957C81.2032 207.94 82 208.737 82.9829 208.737C83.9659 208.737 84.7627 207.94 84.7627 206.957C84.7627 205.974 83.9659 205.177 82.9829 205.177C82 205.177 81.2032 205.974 81.2032 206.957Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.0336 206.962C75.0336 207.945 75.8304 208.742 76.8134 208.742C77.7963 208.742 78.5931 207.945 78.5931 206.962C78.5931 205.979 77.7963 205.182 76.8134 205.182C75.8304 205.182 75.0336 205.979 75.0336 206.962Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.8745 206.962C68.8745 207.945 69.6714 208.742 70.6543 208.742C71.6373 208.742 72.4341 207.945 72.4341 206.962C72.4341 205.979 71.6373 205.182 70.6543 205.182C69.6714 205.182 68.8745 205.979 68.8745 206.962Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.6582 206.962C62.6582 207.945 63.4551 208.742 64.438 208.742C65.4209 208.742 66.2178 207.945 66.2178 206.962C66.2178 205.979 65.4209 205.182 64.438 205.182C63.4551 205.182 62.6582 205.979 62.6582 206.962Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.4993 206.962C56.4993 207.945 57.2961 208.742 58.2791 208.742C59.262 208.742 60.0588 207.945 60.0588 206.962C60.0588 205.979 59.262 205.182 58.2791 205.182C57.2961 205.182 56.4993 205.979 56.4993 206.962Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.3505 206.952C50.3505 207.935 51.1473 208.731 52.1303 208.731C53.1132 208.731 53.91 207.935 53.91 206.952C53.91 205.969 53.1132 205.172 52.1303 205.172C51.1473 205.172 50.3505 205.969 50.3505 206.952Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.1917 206.952C44.1917 207.935 44.9885 208.731 45.9715 208.731C46.9544 208.731 47.7512 207.935 47.7512 206.952C47.7512 205.969 46.9544 205.172 45.9715 205.172C44.9885 205.172 44.1917 205.969 44.1917 206.952Z"
            fill="#B8B7B7"
          />
          <path
            d="M37.9911 206.962C37.9911 207.945 38.7879 208.742 39.7709 208.742C40.7538 208.742 41.5507 207.945 41.5507 206.962C41.5507 205.979 40.7538 205.182 39.7709 205.182C38.7879 205.182 37.9911 205.979 37.9911 206.962Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.8332 206.962C31.8332 207.945 32.63 208.742 33.6129 208.742C34.5959 208.742 35.3927 207.945 35.3927 206.962C35.3927 205.979 34.5959 205.182 33.6129 205.182C32.63 205.182 31.8332 205.979 31.8332 206.962Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.6675 206.962C25.6675 207.945 26.4643 208.742 27.4473 208.742C28.4302 208.742 29.2271 207.945 29.2271 206.962C29.2271 205.979 28.4302 205.182 27.4473 205.182C26.4643 205.182 25.6675 205.979 25.6675 206.962Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.5086 206.962C19.5086 207.945 20.3054 208.742 21.2883 208.742C22.2713 208.742 23.0681 207.945 23.0681 206.962C23.0681 205.979 22.2713 205.182 21.2883 205.182C20.3054 205.182 19.5086 205.979 19.5086 206.962Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.3081 206.962C13.3081 207.945 14.105 208.742 15.0879 208.742C16.0708 208.742 16.8677 207.945 16.8677 206.962C16.8677 205.979 16.0708 205.182 15.0879 205.182C14.105 205.182 13.3081 205.979 13.3081 206.962Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.1503 206.962C7.1503 207.945 7.94713 208.742 8.93007 208.742C9.91301 208.742 10.7098 207.945 10.7098 206.962C10.7098 205.979 9.91301 205.182 8.93007 205.182C7.94713 205.182 7.1503 205.979 7.1503 206.962Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.013 212.247C146.013 213.23 146.81 214.026 147.792 214.026C148.775 214.026 149.572 213.23 149.572 212.247C149.572 211.264 148.775 210.467 147.792 210.467C146.81 210.467 146.013 211.264 146.013 212.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.853 212.247C139.853 213.23 140.65 214.026 141.633 214.026C142.616 214.026 143.413 213.23 143.413 212.247C143.413 211.264 142.616 210.467 141.633 210.467C140.65 210.467 139.853 211.264 139.853 212.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.638 212.247C133.638 213.23 134.434 214.026 135.417 214.026C136.4 214.026 137.197 213.23 137.197 212.247C137.197 211.264 136.4 210.467 135.417 210.467C134.434 210.467 133.638 211.264 133.638 212.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.478 212.247C127.478 213.23 128.275 214.026 129.258 214.026C130.241 214.026 131.038 213.23 131.038 212.247C131.038 211.264 130.241 210.467 129.258 210.467C128.275 210.467 127.478 211.264 127.478 212.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.33 212.238C121.33 213.221 122.127 214.017 123.11 214.017C124.092 214.017 124.889 213.221 124.889 212.238C124.889 211.255 124.092 210.458 123.11 210.458C122.127 210.458 121.33 211.255 121.33 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.17 212.238C115.17 213.221 115.967 214.017 116.95 214.017C117.933 214.017 118.73 213.221 118.73 212.238C118.73 211.255 117.933 210.458 116.95 210.458C115.967 210.458 115.17 211.255 115.17 212.238Z"
            fill="#B8B7B7"
          />
          <path
            d="M108.971 212.247C108.971 213.23 109.768 214.026 110.751 214.026C111.734 214.026 112.531 213.23 112.531 212.247C112.531 211.264 111.734 210.467 110.751 210.467C109.768 210.467 108.971 211.264 108.971 212.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.813 212.247C102.813 213.23 103.609 214.026 104.592 214.026C105.575 214.026 106.372 213.23 106.372 212.247C106.372 211.264 105.575 210.467 104.592 210.467C103.609 210.467 102.813 211.264 102.813 212.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.6468 212.247C96.6468 213.23 97.4436 214.026 98.4265 214.026C99.4095 214.026 100.206 213.23 100.206 212.247C100.206 211.264 99.4095 210.467 98.4265 210.467C97.4436 210.467 96.6468 211.264 96.6468 212.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.4878 212.247C90.4878 213.23 91.2847 214.026 92.2676 214.026C93.2505 214.026 94.0474 213.23 94.0474 212.247C94.0474 211.264 93.2505 210.467 92.2676 210.467C91.2847 210.467 90.4878 211.264 90.4878 212.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.2885 212.247C84.2885 213.23 85.0853 214.026 86.0683 214.026C87.0512 214.026 87.848 213.23 87.848 212.247C87.848 211.264 87.0512 210.467 86.0683 210.467C85.0853 210.467 84.2885 211.264 84.2885 212.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.1294 212.247C78.1294 213.23 78.9263 214.026 79.9092 214.026C80.8921 214.026 81.689 213.23 81.689 212.247C81.689 211.264 80.8921 210.467 79.9092 210.467C78.9263 210.467 78.1294 211.264 78.1294 212.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M71.9597 212.252C71.9597 213.235 72.7566 214.032 73.7395 214.032C74.7225 214.032 75.5193 213.235 75.5193 212.252C75.5193 211.269 74.7225 210.472 73.7395 210.472C72.7566 210.472 71.9597 211.269 71.9597 212.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.8009 212.252C65.8009 213.235 66.5978 214.032 67.5807 214.032C68.5636 214.032 69.3605 213.235 69.3605 212.252C69.3605 211.269 68.5636 210.472 67.5807 210.472C66.5978 210.472 65.8009 211.269 65.8009 212.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.5846 212.252C59.5846 213.235 60.3815 214.032 61.3644 214.032C62.3473 214.032 63.1442 213.235 63.1442 212.252C63.1442 211.269 62.3473 210.472 61.3644 210.472C60.3815 210.472 59.5846 211.269 59.5846 212.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.4256 212.252C53.4256 213.235 54.2224 214.032 55.2053 214.032C56.1883 214.032 56.9851 213.235 56.9851 212.252C56.9851 211.269 56.1883 210.472 55.2053 210.472C54.2224 210.472 53.4256 211.269 53.4256 212.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.2768 212.243C47.2768 213.226 48.0736 214.023 49.0565 214.023C50.0395 214.023 50.8363 213.226 50.8363 212.243C50.8363 211.26 50.0395 210.463 49.0565 210.463C48.0736 210.463 47.2768 211.26 47.2768 212.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.1179 212.243C41.1179 213.226 41.9148 214.023 42.8977 214.023C43.8807 214.023 44.6775 213.226 44.6775 212.243C44.6775 211.26 43.8807 210.463 42.8977 210.463C41.9148 210.463 41.1179 211.26 41.1179 212.243Z"
            fill="#B8B7B7"
          />
          <path
            d="M34.9174 212.252C34.9174 213.235 35.7142 214.032 36.6972 214.032C37.6801 214.032 38.4769 213.235 38.4769 212.252C38.4769 211.269 37.6801 210.472 36.6972 210.472C35.7142 210.472 34.9174 211.269 34.9174 212.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.7581 212.252C28.7581 213.235 29.5549 214.032 30.5379 214.032C31.5208 214.032 32.3176 213.235 32.3176 212.252C32.3176 211.269 31.5208 210.472 30.5379 210.472C29.5549 210.472 28.7581 211.269 28.7581 212.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.5941 212.252C22.5941 213.235 23.391 214.032 24.3739 214.032C25.3569 214.032 26.1537 213.235 26.1537 212.252C26.1537 211.269 25.3569 210.472 24.3739 210.472C23.391 210.472 22.5941 211.269 22.5941 212.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.435 212.252C16.435 213.235 17.2318 214.032 18.2147 214.032C19.1977 214.032 19.9945 213.235 19.9945 212.252C19.9945 211.269 19.1977 210.472 18.2147 210.472C17.2318 210.472 16.435 211.269 16.435 212.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.2344 212.252C10.2344 213.235 11.0312 214.032 12.0142 214.032C12.9971 214.032 13.7939 213.235 13.7939 212.252C13.7939 211.269 12.9971 210.472 12.0142 210.472C11.0312 210.472 10.2344 211.269 10.2344 212.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M4.0751 212.252C4.0751 213.235 4.87193 214.032 5.85487 214.032C6.83781 214.032 7.63464 213.235 7.63464 212.252C7.63464 211.269 6.83781 210.472 5.85487 210.472C4.87193 210.472 4.0751 211.269 4.0751 212.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M142.928 217.548C142.928 218.531 143.725 219.328 144.708 219.328C145.691 219.328 146.488 218.531 146.488 217.548C146.488 216.565 145.691 215.769 144.708 215.769C143.725 215.769 142.928 216.565 142.928 217.548Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.769 217.548C136.769 218.531 137.566 219.328 138.549 219.328C139.532 219.328 140.329 218.531 140.329 217.548C140.329 216.565 139.532 215.769 138.549 215.769C137.566 215.769 136.769 216.565 136.769 217.548Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.553 217.548C130.553 218.531 131.35 219.328 132.333 219.328C133.316 219.328 134.113 218.531 134.113 217.548C134.113 216.565 133.316 215.769 132.333 215.769C131.35 215.769 130.553 216.565 130.553 217.548Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.394 217.548C124.394 218.531 125.191 219.328 126.174 219.328C127.157 219.328 127.954 218.531 127.954 217.548C127.954 216.565 127.157 215.769 126.174 215.769C125.191 215.769 124.394 216.565 124.394 217.548Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.246 217.539C118.246 218.522 119.042 219.319 120.025 219.319C121.008 219.319 121.805 218.522 121.805 217.539C121.805 216.556 121.008 215.759 120.025 215.759C119.042 215.759 118.246 216.556 118.246 217.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.087 217.539C112.087 218.522 112.884 219.319 113.867 219.319C114.85 219.319 115.646 218.522 115.646 217.539C115.646 216.556 114.85 215.759 113.867 215.759C112.884 215.759 112.087 216.556 112.087 217.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M105.886 217.548C105.886 218.531 106.683 219.328 107.666 219.328C108.648 219.328 109.445 218.531 109.445 217.548C109.445 216.565 108.648 215.769 107.666 215.769C106.683 215.769 105.886 216.565 105.886 217.548Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.727 217.548C99.727 218.531 100.524 219.328 101.507 219.328C102.49 219.328 103.286 218.531 103.286 217.548C103.286 216.565 102.49 215.769 101.507 215.769C100.524 215.769 99.727 216.565 99.727 217.548Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.5627 217.548C93.5627 218.531 94.3595 219.328 95.3424 219.328C96.3254 219.328 97.1222 218.531 97.1222 217.548C97.1222 216.565 96.3254 215.769 95.3424 215.769C94.3595 215.769 93.5627 216.565 93.5627 217.548Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.4036 217.548C87.4036 218.531 88.2004 219.328 89.1834 219.328C90.1663 219.328 90.9631 218.531 90.9631 217.548C90.9631 216.565 90.1663 215.769 89.1834 215.769C88.2004 215.769 87.4036 216.565 87.4036 217.548Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.2032 217.548C81.2032 218.531 82 219.328 82.9829 219.328C83.9659 219.328 84.7627 218.531 84.7627 217.548C84.7627 216.565 83.9659 215.769 82.9829 215.769C82 215.769 81.2032 216.565 81.2032 217.548Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.0437 217.548C75.0437 218.531 75.8406 219.328 76.8235 219.328C77.8064 219.328 78.6033 218.531 78.6033 217.548C78.6033 216.565 77.8064 215.769 76.8235 215.769C75.8406 215.769 75.0437 216.565 75.0437 217.548Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.8745 217.554C68.8745 218.536 69.6714 219.333 70.6543 219.333C71.6373 219.333 72.4341 218.536 72.4341 217.554C72.4341 216.571 71.6373 215.774 70.6543 215.774C69.6714 215.774 68.8745 216.571 68.8745 217.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.7156 217.554C62.7156 218.536 63.5124 219.333 64.4954 219.333C65.4783 219.333 66.2751 218.536 66.2751 217.554C66.2751 216.571 65.4783 215.774 64.4954 215.774C63.5124 215.774 62.7156 216.571 62.7156 217.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.4993 217.554C56.4993 218.536 57.2961 219.333 58.2791 219.333C59.262 219.333 60.0588 218.536 60.0588 217.554C60.0588 216.571 59.262 215.774 58.2791 215.774C57.2961 215.774 56.4993 216.571 56.4993 217.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.3401 217.554C50.3401 218.536 51.1369 219.333 52.1199 219.333C53.1028 219.333 53.8997 218.536 53.8997 217.554C53.8997 216.571 53.1028 215.774 52.1199 215.774C51.1369 215.774 50.3401 216.571 50.3401 217.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.1917 217.543C44.1917 218.526 44.9885 219.323 45.9715 219.323C46.9544 219.323 47.7512 218.526 47.7512 217.543C47.7512 216.56 46.9544 215.763 45.9715 215.763C44.9885 215.763 44.1917 216.56 44.1917 217.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.0327 217.543C38.0327 218.526 38.8296 219.323 39.8125 219.323C40.7955 219.323 41.5923 218.526 41.5923 217.543C41.5923 216.56 40.7955 215.763 39.8125 215.763C38.8296 215.763 38.0327 216.56 38.0327 217.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.8332 217.554C31.8332 218.536 32.63 219.333 33.6129 219.333C34.5959 219.333 35.3927 218.536 35.3927 217.554C35.3927 216.571 34.5959 215.774 33.6129 215.774C32.63 215.774 31.8332 216.571 31.8332 217.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.674 217.554C25.674 218.536 26.4708 219.333 27.4537 219.333C28.4367 219.333 29.2335 218.536 29.2335 217.554C29.2335 216.571 28.4367 215.774 27.4538 215.774C26.4708 215.774 25.674 216.571 25.674 217.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.5086 217.554C19.5086 218.536 20.3054 219.333 21.2883 219.333C22.2713 219.333 23.0681 218.536 23.0681 217.554C23.0681 216.571 22.2713 215.774 21.2883 215.774C20.3054 215.774 19.5086 216.571 19.5086 217.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.3498 217.554C13.3498 218.536 14.1466 219.333 15.1295 219.333C16.1125 219.333 16.9093 218.536 16.9093 217.554C16.9093 216.571 16.1125 215.774 15.1295 215.774C14.1466 215.774 13.3498 216.571 13.3498 217.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.1503 217.554C7.1503 218.536 7.94713 219.333 8.93007 219.333C9.91301 219.333 10.7098 218.536 10.7098 217.554C10.7098 216.571 9.91301 215.774 8.93007 215.774C7.94713 215.774 7.1503 216.571 7.1503 217.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M0.991362 217.554C0.991362 218.536 1.78819 219.333 2.77113 219.333C3.75407 219.333 4.5509 218.536 4.5509 217.554C4.5509 216.571 3.75407 215.774 2.77113 215.774C1.78819 215.774 0.991362 216.571 0.991362 217.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.013 222.793C146.013 223.776 146.81 224.573 147.792 224.573C148.775 224.573 149.572 223.776 149.572 222.793C149.572 221.81 148.775 221.013 147.792 221.013C146.81 221.013 146.013 221.81 146.013 222.793Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.853 222.793C139.853 223.776 140.65 224.573 141.633 224.573C142.616 224.573 143.413 223.776 143.413 222.793C143.413 221.81 142.616 221.013 141.633 221.013C140.65 221.013 139.853 221.81 139.853 222.793Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.638 222.793C133.638 223.776 134.434 224.573 135.417 224.573C136.4 224.573 137.197 223.776 137.197 222.793C137.197 221.81 136.4 221.013 135.417 221.013C134.434 221.013 133.638 221.81 133.638 222.793Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.478 222.793C127.478 223.776 128.275 224.573 129.258 224.573C130.241 224.573 131.038 223.776 131.038 222.793C131.038 221.81 130.241 221.013 129.258 221.013C128.275 221.013 127.478 221.81 127.478 222.793Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.33 222.784C121.33 223.767 122.127 224.563 123.11 224.563C124.092 224.563 124.889 223.767 124.889 222.784C124.889 221.801 124.092 221.004 123.11 221.004C122.127 221.004 121.33 221.801 121.33 222.784Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.17 222.784C115.17 223.767 115.967 224.563 116.95 224.563C117.933 224.563 118.73 223.767 118.73 222.784C118.73 221.801 117.933 221.004 116.95 221.004C115.967 221.004 115.17 221.801 115.17 222.784Z"
            fill="#B8B7B7"
          />
          <path
            d="M108.971 222.793C108.971 223.776 109.768 224.573 110.751 224.573C111.734 224.573 112.531 223.776 112.531 222.793C112.531 221.81 111.734 221.013 110.751 221.013C109.768 221.013 108.971 221.81 108.971 222.793Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.813 222.793C102.813 223.776 103.609 224.573 104.592 224.573C105.575 224.573 106.372 223.776 106.372 222.793C106.372 221.81 105.575 221.013 104.592 221.013C103.609 221.013 102.813 221.81 102.813 222.793Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.6468 222.793C96.6468 223.776 97.4436 224.573 98.4265 224.573C99.4095 224.573 100.206 223.776 100.206 222.793C100.206 221.81 99.4095 221.013 98.4265 221.013C97.4436 221.013 96.6468 221.81 96.6468 222.793Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.4879 222.793C90.4879 223.776 91.2848 224.573 92.2677 224.573C93.2507 224.573 94.0475 223.776 94.0475 222.793C94.0475 221.81 93.2507 221.013 92.2677 221.013C91.2848 221.013 90.4879 221.81 90.4879 222.793Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.2885 222.793C84.2885 223.776 85.0853 224.573 86.0683 224.573C87.0512 224.573 87.848 223.776 87.848 222.793C87.848 221.81 87.0512 221.013 86.0683 221.013C85.0853 221.013 84.2885 221.81 84.2885 222.793Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.1294 222.793C78.1294 223.776 78.9263 224.573 79.9092 224.573C80.8921 224.573 81.689 223.776 81.689 222.793C81.689 221.81 80.8921 221.013 79.9092 221.013C78.9263 221.013 78.1294 221.81 78.1294 222.793Z"
            fill="#B8B7B7"
          />
          <path
            d="M71.9597 222.798C71.9597 223.781 72.7566 224.578 73.7395 224.578C74.7225 224.578 75.5193 223.781 75.5193 222.798C75.5193 221.815 74.7225 221.018 73.7395 221.018C72.7566 221.018 71.9597 221.815 71.9597 222.798Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.8009 222.798C65.8009 223.781 66.5978 224.578 67.5807 224.578C68.5636 224.578 69.3605 223.781 69.3605 222.798C69.3605 221.815 68.5636 221.018 67.5807 221.018C66.5978 221.018 65.8009 221.815 65.8009 222.798Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.5846 222.798C59.5846 223.781 60.3815 224.578 61.3644 224.578C62.3473 224.578 63.1442 223.781 63.1442 222.798C63.1442 221.815 62.3473 221.018 61.3644 221.018C60.3815 221.018 59.5846 221.815 59.5846 222.798Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.4256 222.798C53.4256 223.781 54.2224 224.578 55.2053 224.578C56.1883 224.578 56.9851 223.781 56.9851 222.798C56.9851 221.815 56.1883 221.018 55.2053 221.018C54.2224 221.018 53.4256 221.815 53.4256 222.798Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.2769 222.789C47.2769 223.772 48.0737 224.569 49.0567 224.569C50.0396 224.569 50.8364 223.772 50.8364 222.789C50.8364 221.806 50.0396 221.009 49.0567 221.009C48.0737 221.009 47.2769 221.806 47.2769 222.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.1179 222.789C41.1179 223.772 41.9148 224.569 42.8977 224.569C43.8807 224.569 44.6775 223.772 44.6775 222.789C44.6775 221.806 43.8807 221.009 42.8977 221.009C41.9148 221.009 41.1179 221.806 41.1179 222.789Z"
            fill="#B8B7B7"
          />
          <path
            d="M34.9174 222.798C34.9174 223.781 35.7142 224.578 36.6972 224.578C37.6801 224.578 38.4769 223.781 38.4769 222.798C38.4769 221.815 37.6801 221.018 36.6972 221.018C35.7142 221.018 34.9174 221.815 34.9174 222.798Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.7581 222.798C28.7581 223.781 29.5549 224.578 30.5379 224.578C31.5208 224.578 32.3176 223.781 32.3176 222.798C32.3176 221.815 31.5208 221.018 30.5379 221.018C29.5549 221.018 28.7581 221.815 28.7581 222.798Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.5941 222.798C22.5941 223.781 23.391 224.578 24.3739 224.578C25.3569 224.578 26.1537 223.781 26.1537 222.798C26.1537 221.815 25.3569 221.018 24.3739 221.018C23.391 221.018 22.5941 221.815 22.5941 222.798Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.435 222.798C16.435 223.781 17.2318 224.578 18.2147 224.578C19.1977 224.578 19.9945 223.781 19.9945 222.798C19.9945 221.815 19.1977 221.018 18.2147 221.018C17.2318 221.018 16.435 221.815 16.435 222.798Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.2344 222.798C10.2344 223.781 11.0312 224.578 12.0142 224.578C12.9971 224.578 13.7939 223.781 13.7939 222.798C13.7939 221.815 12.9971 221.018 12.0142 221.018C11.0312 221.018 10.2344 221.815 10.2344 222.798Z"
            fill="#B8B7B7"
          />
          <path
            d="M4.0751 222.798C4.0751 223.781 4.87193 224.578 5.85487 224.578C6.83781 224.578 7.63464 223.781 7.63464 222.798C7.63464 221.815 6.83781 221.018 5.85487 221.018C4.87193 221.018 4.0751 221.815 4.0751 222.798Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.087 217.52C149.087 218.503 149.884 219.3 150.867 219.3C151.85 219.3 152.647 218.503 152.647 217.52C152.647 216.537 151.85 215.74 150.867 215.74C149.884 215.74 149.087 216.537 149.087 217.52Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.093 228.157C149.093 229.14 149.89 229.937 150.873 229.937C151.856 229.937 152.652 229.14 152.652 228.157C152.652 227.174 151.856 226.377 150.873 226.377C149.89 226.377 149.093 227.174 149.093 228.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M142.934 228.157C142.934 229.14 143.731 229.937 144.714 229.937C145.697 229.937 146.493 229.14 146.493 228.157C146.493 227.174 145.697 226.377 144.714 226.377C143.731 226.377 142.934 227.174 142.934 228.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.717 228.157C136.717 229.14 137.514 229.937 138.497 229.937C139.48 229.937 140.277 229.14 140.277 228.157C140.277 227.174 139.48 226.377 138.497 226.377C137.514 226.377 136.717 227.174 136.717 228.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.558 228.157C130.558 229.14 131.355 229.937 132.338 229.937C133.321 229.937 134.118 229.14 134.118 228.157C134.118 227.174 133.321 226.377 132.338 226.377C131.355 226.377 130.558 227.174 130.558 228.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.41 228.146C124.41 229.129 125.207 229.926 126.19 229.926C127.173 229.926 127.969 229.129 127.969 228.146C127.969 227.163 127.173 226.367 126.19 226.367C125.207 226.367 124.41 227.163 124.41 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.251 228.146C118.251 229.129 119.048 229.926 120.031 229.926C121.014 229.926 121.811 229.129 121.811 228.146C121.811 227.163 121.014 226.367 120.031 226.367C119.048 226.367 118.251 227.163 118.251 228.146Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.05 228.157C112.05 229.14 112.847 229.937 113.83 229.937C114.813 229.937 115.61 229.14 115.61 228.157C115.61 227.174 114.813 226.377 113.83 226.377C112.847 226.377 112.05 227.174 112.05 228.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M105.891 228.157C105.891 229.14 106.688 229.937 107.671 229.937C108.654 229.937 109.451 229.14 109.451 228.157C109.451 227.174 108.654 226.377 107.671 226.377C106.688 226.377 105.891 227.174 105.891 228.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.727 228.157C99.727 229.14 100.524 229.937 101.507 229.937C102.49 229.937 103.286 229.14 103.286 228.157C103.286 227.174 102.49 226.377 101.507 226.377C100.524 226.377 99.727 227.174 99.727 228.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.568 228.157C93.568 229.14 94.3649 229.937 95.3478 229.937C96.3307 229.937 97.1276 229.14 97.1276 228.157C97.1276 227.174 96.3307 226.377 95.3478 226.377C94.3649 226.377 93.568 227.174 93.568 228.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.3671 228.157C87.3671 229.14 88.1639 229.937 89.1469 229.937C90.1298 229.937 90.9266 229.14 90.9266 228.157C90.9266 227.174 90.1298 226.377 89.1469 226.377C88.1639 226.377 87.3671 227.174 87.3671 228.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.2082 228.157C81.2082 229.14 82.005 229.937 82.9879 229.937C83.9709 229.937 84.7677 229.14 84.7677 228.157C84.7677 227.174 83.9709 226.377 82.9879 226.377C82.005 226.377 81.2082 227.174 81.2082 228.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.0388 228.161C75.0388 229.144 75.8357 229.94 76.8186 229.94C77.8016 229.94 78.5984 229.144 78.5984 228.161C78.5984 227.178 77.8016 226.381 76.8186 226.381C75.8357 226.381 75.0388 227.178 75.0388 228.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.8797 228.161C68.8797 229.144 69.6765 229.94 70.6594 229.94C71.6424 229.94 72.4392 229.144 72.4392 228.161C72.4392 227.178 71.6424 226.381 70.6594 226.381C69.6765 226.381 68.8797 227.178 68.8797 228.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.6637 228.161C62.6637 229.144 63.4606 229.94 64.4435 229.94C65.4264 229.94 66.2233 229.144 66.2233 228.161C66.2233 227.178 65.4264 226.381 64.4435 226.381C63.4606 226.381 62.6637 227.178 62.6637 228.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.5044 228.161C56.5044 229.144 57.3013 229.94 58.2842 229.94C59.2671 229.94 60.064 229.144 60.064 228.161C60.064 227.178 59.2671 226.381 58.2842 226.381C57.3013 226.381 56.5044 227.178 56.5044 228.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.356 228.152C50.356 229.135 51.1528 229.931 52.1358 229.931C53.1187 229.931 53.9155 229.135 53.9155 228.152C53.9155 227.169 53.1187 226.372 52.1358 226.372C51.1528 226.372 50.356 227.169 50.356 228.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.1967 228.152C44.1967 229.135 44.9935 229.931 45.9765 229.931C46.9594 229.931 47.7562 229.135 47.7562 228.152C47.7562 227.169 46.9594 226.372 45.9765 226.372C44.9935 226.372 44.1967 227.169 44.1967 228.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M37.9975 228.161C37.9975 229.144 38.7943 229.94 39.7772 229.94C40.7602 229.94 41.557 229.144 41.557 228.161C41.557 227.178 40.7602 226.381 39.7772 226.381C38.7943 226.381 37.9975 227.178 37.9975 228.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.8383 228.161C31.8383 229.144 32.6351 229.94 33.6181 229.94C34.601 229.94 35.3978 229.144 35.3978 228.161C35.3978 227.178 34.601 226.381 33.6181 226.381C32.6351 226.381 31.8383 227.178 31.8383 228.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.6728 228.161C25.6728 229.144 26.4696 229.94 27.4525 229.94C28.4355 229.94 29.2323 229.144 29.2323 228.161C29.2323 227.178 28.4355 226.381 27.4525 226.381C26.4696 226.381 25.6728 227.178 25.6728 228.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.5137 228.161C19.5137 229.144 20.3105 229.94 21.2935 229.94C22.2764 229.94 23.0732 229.144 23.0732 228.161C23.0732 227.178 22.2764 226.381 21.2935 226.381C20.3105 226.381 19.5137 227.178 19.5137 228.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.3146 228.161C13.3146 229.144 14.1114 229.94 15.0944 229.94C16.0773 229.94 16.8741 229.144 16.8741 228.161C16.8741 227.178 16.0773 226.381 15.0944 226.381C14.1114 226.381 13.3146 227.178 13.3146 228.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.1553 228.161C7.1553 229.144 7.95213 229.94 8.93507 229.94C9.91801 229.94 10.7148 229.144 10.7148 228.161C10.7148 227.178 9.91801 226.381 8.93507 226.381C7.95213 226.381 7.1553 227.178 7.1553 228.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.008 233.457C146.008 234.44 146.804 235.237 147.787 235.237C148.77 235.237 149.567 234.44 149.567 233.457C149.567 232.474 148.77 231.677 147.787 231.677C146.804 231.677 146.008 232.474 146.008 233.457Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.848 233.457C139.848 234.44 140.645 235.237 141.628 235.237C142.611 235.237 143.408 234.44 143.408 233.457C143.408 232.474 142.611 231.677 141.628 231.677C140.645 231.677 139.848 232.474 139.848 233.457Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.632 233.457C133.632 234.44 134.429 235.237 135.412 235.237C136.395 235.237 137.192 234.44 137.192 233.457C137.192 232.474 136.395 231.677 135.412 231.677C134.429 231.677 133.632 232.474 133.632 233.457Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.473 233.457C127.473 234.44 128.27 235.237 129.253 235.237C130.236 235.237 131.033 234.44 131.033 233.457C131.033 232.474 130.236 231.677 129.253 231.677C128.27 231.677 127.473 232.474 127.473 233.457Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.325 233.448C121.325 234.431 122.122 235.228 123.105 235.228C124.088 235.228 124.884 234.431 124.884 233.448C124.884 232.465 124.088 231.668 123.105 231.668C122.122 231.668 121.325 232.465 121.325 233.448Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.166 233.448C115.166 234.431 115.962 235.228 116.945 235.228C117.928 235.228 118.725 234.431 118.725 233.448C118.725 232.465 117.928 231.668 116.945 231.668C115.962 231.668 115.166 232.465 115.166 233.448Z"
            fill="#B8B7B7"
          />
          <path
            d="M108.966 233.457C108.966 234.44 109.763 235.237 110.746 235.237C111.729 235.237 112.526 234.44 112.526 233.457C112.526 232.474 111.729 231.677 110.746 231.677C109.763 231.677 108.966 232.474 108.966 233.457Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.807 233.457C102.807 234.44 103.604 235.237 104.587 235.237C105.57 235.237 106.367 234.44 106.367 233.457C106.367 232.474 105.57 231.677 104.587 231.677C103.604 231.677 102.807 232.474 102.807 233.457Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.6419 233.457C96.6419 234.44 97.4387 235.237 98.4216 235.237C99.4046 235.237 100.201 234.44 100.201 233.457C100.201 232.474 99.4046 231.677 98.4216 231.677C97.4387 231.677 96.6419 232.474 96.6419 233.457Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.4826 233.457C90.4826 234.44 91.2794 235.237 92.2623 235.237C93.2453 235.237 94.0421 234.44 94.0421 233.457C94.0421 232.474 93.2453 231.677 92.2623 231.677C91.2794 231.677 90.4826 232.474 90.4826 233.457Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.2831 233.457C84.2831 234.44 85.0799 235.237 86.0629 235.237C87.0458 235.237 87.8427 234.44 87.8427 233.457C87.8427 232.474 87.0458 231.677 86.0629 231.677C85.0799 231.677 84.2831 232.474 84.2831 233.457Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.1241 233.457C78.1241 234.44 78.9209 235.237 79.9038 235.237C80.8868 235.237 81.6836 234.44 81.6836 233.457C81.6836 232.474 80.8868 231.677 79.9038 231.677C78.9209 231.677 78.1241 232.474 78.1241 233.457Z"
            fill="#B8B7B7"
          />
          <path
            d="M71.9534 233.462C71.9534 234.445 72.7502 235.242 73.7332 235.242C74.7161 235.242 75.5129 234.445 75.5129 233.462C75.5129 232.479 74.7161 231.683 73.7332 231.683C72.7502 231.683 71.9534 232.479 71.9534 233.462Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.7956 233.462C65.7956 234.445 66.5924 235.242 67.5753 235.242C68.5583 235.242 69.3551 234.445 69.3551 233.462C69.3551 232.479 68.5583 231.683 67.5753 231.683C66.5924 231.683 65.7956 232.479 65.7956 233.462Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.5796 233.462C59.5796 234.445 60.3764 235.242 61.3594 235.242C62.3423 235.242 63.1392 234.445 63.1392 233.462C63.1392 232.479 62.3423 231.683 61.3594 231.683C60.3764 231.683 59.5796 232.479 59.5796 233.462Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.4202 233.462C53.4202 234.445 54.217 235.242 55.2 235.242C56.1829 235.242 56.9797 234.445 56.9797 233.462C56.9797 232.479 56.1829 231.683 55.2 231.683C54.217 231.683 53.4202 232.479 53.4202 233.462Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.2704 233.453C47.2704 234.436 48.0672 235.233 49.0502 235.233C50.0331 235.233 50.83 234.436 50.83 233.453C50.83 232.47 50.0331 231.673 49.0502 231.673C48.0672 231.673 47.2704 232.47 47.2704 233.453Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.1131 233.453C41.1131 234.436 41.9099 235.233 42.8928 235.233C43.8758 235.233 44.6726 234.436 44.6726 233.453C44.6726 232.47 43.8758 231.673 42.8928 231.673C41.9099 231.673 41.1131 232.47 41.1131 233.453Z"
            fill="#B8B7B7"
          />
          <path
            d="M34.912 233.462C34.912 234.445 35.7088 235.242 36.6918 235.242C37.6747 235.242 38.4716 234.445 38.4716 233.462C38.4716 232.479 37.6747 231.683 36.6918 231.683C35.7088 231.683 34.912 232.479 34.912 233.462Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.7531 233.462C28.7531 234.445 29.5499 235.242 30.5329 235.242C31.5158 235.242 32.3126 234.445 32.3126 233.462C32.3126 232.479 31.5158 231.683 30.5329 231.683C29.5499 231.683 28.7531 232.479 28.7531 233.462Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.5874 233.462C22.5874 234.445 23.3843 235.242 24.3672 235.242C25.3501 235.242 26.147 234.445 26.147 233.462C26.147 232.479 25.3501 231.683 24.3672 231.683C23.3843 231.683 22.5874 232.479 22.5874 233.462Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.4298 233.462C16.4298 234.445 17.2267 235.242 18.2096 235.242C19.1925 235.242 19.9894 234.445 19.9894 233.462C19.9894 232.479 19.1925 231.683 18.2096 231.683C17.2267 231.683 16.4298 232.479 16.4298 233.462Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.2289 233.462C10.2289 234.445 11.0257 235.242 12.0087 235.242C12.9916 235.242 13.7885 234.445 13.7885 233.462C13.7885 232.479 12.9916 231.683 12.0087 231.683C11.0257 231.683 10.2289 232.479 10.2289 233.462Z"
            fill="#B8B7B7"
          />
          <path
            d="M4.07022 233.462C4.07022 234.445 4.86705 235.242 5.84999 235.242C6.83293 235.242 7.62976 234.445 7.62976 233.462C7.62976 232.479 6.83293 231.683 5.84999 231.683C4.86705 231.683 4.07022 232.479 4.07022 233.462Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.093 238.702C149.093 239.685 149.89 240.481 150.873 240.481C151.856 240.481 152.652 239.685 152.652 238.702C152.652 237.719 151.856 236.922 150.873 236.922C149.89 236.922 149.093 237.719 149.093 238.702Z"
            fill="#B8B7B7"
          />
          <path
            d="M142.934 238.702C142.934 239.685 143.731 240.481 144.714 240.481C145.697 240.481 146.493 239.685 146.493 238.702C146.493 237.719 145.697 236.922 144.714 236.922C143.731 236.922 142.934 237.719 142.934 238.702Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.717 238.702C136.717 239.685 137.514 240.481 138.497 240.481C139.48 240.481 140.277 239.685 140.277 238.702C140.277 237.719 139.48 236.922 138.497 236.922C137.514 236.922 136.717 237.719 136.717 238.702Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.558 238.702C130.558 239.685 131.355 240.481 132.338 240.481C133.321 240.481 134.118 239.685 134.118 238.702C134.118 237.719 133.321 236.922 132.338 236.922C131.355 236.922 130.558 237.719 130.558 238.702Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.41 238.693C124.41 239.675 125.207 240.472 126.19 240.472C127.173 240.472 127.969 239.675 127.969 238.693C127.969 237.71 127.173 236.913 126.19 236.913C125.207 236.913 124.41 237.71 124.41 238.693Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.251 238.693C118.251 239.675 119.048 240.472 120.031 240.472C121.014 240.472 121.811 239.675 121.811 238.693C121.811 237.71 121.014 236.913 120.031 236.913C119.048 236.913 118.251 237.71 118.251 238.693Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.05 238.702C112.05 239.685 112.847 240.481 113.83 240.481C114.813 240.481 115.61 239.685 115.61 238.702C115.61 237.719 114.813 236.922 113.83 236.922C112.847 236.922 112.05 237.719 112.05 238.702Z"
            fill="#B8B7B7"
          />
          <path
            d="M105.891 238.702C105.891 239.685 106.688 240.481 107.671 240.481C108.654 240.481 109.451 239.685 109.451 238.702C109.451 237.719 108.654 236.922 107.671 236.922C106.688 236.922 105.891 237.719 105.891 238.702Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.727 238.702C99.727 239.685 100.524 240.481 101.507 240.481C102.49 240.481 103.286 239.685 103.286 238.702C103.286 237.719 102.49 236.922 101.507 236.922C100.524 236.922 99.727 237.719 99.727 238.702Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.568 238.702C93.568 239.685 94.3649 240.481 95.3478 240.481C96.3307 240.481 97.1276 239.685 97.1276 238.702C97.1276 237.719 96.3307 236.922 95.3478 236.922C94.3649 236.922 93.568 237.719 93.568 238.702Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.3671 238.702C87.3671 239.685 88.1639 240.481 89.1469 240.481C90.1298 240.481 90.9266 239.685 90.9266 238.702C90.9266 237.719 90.1298 236.922 89.1469 236.922C88.1639 236.922 87.3671 237.719 87.3671 238.702Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.2082 238.702C81.2082 239.685 82.005 240.481 82.9879 240.481C83.9709 240.481 84.7677 239.685 84.7677 238.702C84.7677 237.719 83.9709 236.922 82.9879 236.922C82.005 236.922 81.2082 237.719 81.2082 238.702Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.0388 238.707C75.0388 239.69 75.8357 240.487 76.8186 240.487C77.8016 240.487 78.5984 239.69 78.5984 238.707C78.5984 237.724 77.8016 236.927 76.8186 236.927C75.8357 236.927 75.0388 237.724 75.0388 238.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.8797 238.707C68.8797 239.69 69.6765 240.487 70.6594 240.487C71.6424 240.487 72.4392 239.69 72.4392 238.707C72.4392 237.724 71.6424 236.927 70.6594 236.927C69.6765 236.927 68.8797 237.724 68.8797 238.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.6637 238.707C62.6637 239.69 63.4606 240.487 64.4435 240.487C65.4264 240.487 66.2233 239.69 66.2233 238.707C66.2233 237.724 65.4264 236.927 64.4435 236.927C63.4606 236.927 62.6637 237.724 62.6637 238.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.5044 238.707C56.5044 239.69 57.3013 240.487 58.2842 240.487C59.2671 240.487 60.064 239.69 60.064 238.707C60.064 237.724 59.2671 236.927 58.2842 236.927C57.3013 236.927 56.5044 237.724 56.5044 238.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.356 238.698C50.356 239.681 51.1528 240.478 52.1358 240.478C53.1187 240.478 53.9155 239.681 53.9155 238.698C53.9155 237.715 53.1187 236.918 52.1358 236.918C51.1528 236.918 50.356 237.715 50.356 238.698Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.1967 238.698C44.1967 239.681 44.9935 240.478 45.9765 240.478C46.9594 240.478 47.7562 239.681 47.7562 238.698C47.7562 237.715 46.9594 236.918 45.9765 236.918C44.9935 236.918 44.1967 237.715 44.1967 238.698Z"
            fill="#B8B7B7"
          />
          <path
            d="M37.9975 238.707C37.9975 239.69 38.7943 240.487 39.7772 240.487C40.7602 240.487 41.557 239.69 41.557 238.707C41.557 237.724 40.7602 236.927 39.7772 236.927C38.7943 236.927 37.9975 237.724 37.9975 238.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.8383 238.707C31.8383 239.69 32.6351 240.487 33.6181 240.487C34.601 240.487 35.3978 239.69 35.3978 238.707C35.3978 237.724 34.601 236.927 33.6181 236.927C32.6351 236.927 31.8383 237.724 31.8383 238.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.6728 238.707C25.6728 239.69 26.4696 240.487 27.4525 240.487C28.4355 240.487 29.2323 239.69 29.2323 238.707C29.2323 237.724 28.4355 236.927 27.4525 236.927C26.4696 236.927 25.6728 237.724 25.6728 238.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.5137 238.707C19.5137 239.69 20.3105 240.487 21.2935 240.487C22.2764 240.487 23.0732 239.69 23.0732 238.707C23.0732 237.724 22.2764 236.927 21.2935 236.927C20.3105 236.927 19.5137 237.724 19.5137 238.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.3146 238.707C13.3146 239.69 14.1114 240.487 15.0944 240.487C16.0773 240.487 16.8741 239.69 16.8741 238.707C16.8741 237.724 16.0773 236.927 15.0944 236.927C14.1114 236.927 13.3146 237.724 13.3146 238.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.1553 238.707C7.1553 239.69 7.95213 240.487 8.93507 240.487C9.91801 240.487 10.7148 239.69 10.7148 238.707C10.7148 237.724 9.91801 236.927 8.93507 236.927C7.95213 236.927 7.1553 237.724 7.1553 238.707Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.018 243.993C146.018 244.976 146.815 245.773 147.798 245.773C148.781 245.773 149.578 244.976 149.578 243.993C149.578 243.01 148.781 242.213 147.798 242.213C146.815 242.213 146.018 243.01 146.018 243.993Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.86 243.993C139.86 244.976 140.657 245.773 141.64 245.773C142.623 245.773 143.419 244.976 143.419 243.993C143.419 243.01 142.623 242.213 141.64 242.213C140.657 242.213 139.86 243.01 139.86 243.993Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.644 243.993C133.644 244.976 134.441 245.773 135.424 245.773C136.407 245.773 137.203 244.976 137.203 243.993C137.203 243.01 136.407 242.213 135.424 242.213C134.441 242.213 133.644 243.01 133.644 243.993Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.485 243.993C127.485 244.976 128.282 245.773 129.265 245.773C130.247 245.773 131.044 244.976 131.044 243.993C131.044 243.01 130.247 242.213 129.265 242.213C128.282 242.213 127.485 243.01 127.485 243.993Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.335 243.984C121.335 244.967 122.132 245.764 123.115 245.764C124.098 245.764 124.895 244.967 124.895 243.984C124.895 243.001 124.098 242.204 123.115 242.204C122.132 242.204 121.335 243.001 121.335 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.177 243.984C115.177 244.967 115.974 245.764 116.957 245.764C117.94 245.764 118.737 244.967 118.737 243.984C118.737 243.001 117.94 242.204 116.957 242.204C115.974 242.204 115.177 243.001 115.177 243.984Z"
            fill="#B8B7B7"
          />
          <path
            d="M108.977 243.993C108.977 244.976 109.774 245.773 110.757 245.773C111.74 245.773 112.536 244.976 112.536 243.993C112.536 243.01 111.74 242.213 110.757 242.213C109.774 242.213 108.977 243.01 108.977 243.993Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.818 243.993C102.818 244.976 103.614 245.773 104.597 245.773C105.58 245.773 106.377 244.976 106.377 243.993C106.377 243.01 105.58 242.213 104.597 242.213C103.614 242.213 102.818 243.01 102.818 243.993Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.6521 243.993C96.6521 244.976 97.449 245.773 98.4319 245.773C99.4148 245.773 100.212 244.976 100.212 243.993C100.212 243.01 99.4148 242.213 98.4319 242.213C97.449 242.213 96.6521 243.01 96.6521 243.993Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.4943 243.993C90.4943 244.976 91.2911 245.773 92.2741 245.773C93.257 245.773 94.0538 244.976 94.0538 243.993C94.0538 243.01 93.257 242.213 92.2741 242.213C91.2911 242.213 90.4943 243.01 90.4943 243.993Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.2937 243.993C84.2937 244.976 85.0906 245.773 86.0735 245.773C87.0564 245.773 87.8533 244.976 87.8533 243.993C87.8533 243.01 87.0564 242.213 86.0735 242.213C85.0906 242.213 84.2937 243.01 84.2937 243.993Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.1346 243.993C78.1346 244.976 78.9314 245.773 79.9143 245.773C80.8973 245.773 81.6941 244.976 81.6941 243.993C81.6941 243.01 80.8973 242.213 79.9143 242.213C78.9314 242.213 78.1346 243.01 78.1346 243.993Z"
            fill="#B8B7B7"
          />
          <path
            d="M71.9649 243.997C71.9649 244.98 72.7617 245.777 73.7446 245.777C74.7276 245.777 75.5244 244.98 75.5244 243.997C75.5244 243.014 74.7276 242.217 73.7446 242.217C72.7617 242.217 71.9649 243.014 71.9649 243.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.8059 243.997C65.8059 244.98 66.6028 245.777 67.5857 245.777C68.5686 245.777 69.3655 244.98 69.3655 243.997C69.3655 243.014 68.5686 242.217 67.5857 242.217C66.6028 242.217 65.8059 243.014 65.8059 243.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.59 243.997C59.59 244.98 60.3868 245.777 61.3698 245.777C62.3527 245.777 63.1495 244.98 63.1495 243.997C63.1495 243.014 62.3527 242.217 61.3698 242.217C60.3868 242.217 59.59 243.014 59.59 243.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.4311 243.997C53.4311 244.98 54.2279 245.777 55.2108 245.777C56.1938 245.777 56.9906 244.98 56.9906 243.997C56.9906 243.014 56.1938 242.217 55.2108 242.217C54.2279 242.217 53.4311 243.014 53.4311 243.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.2823 243.988C47.2823 244.971 48.0791 245.767 49.062 245.767C50.045 245.767 50.8418 244.971 50.8418 243.988C50.8418 243.005 50.045 242.208 49.062 242.208C48.0791 242.208 47.2823 243.005 47.2823 243.988Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.123 243.988C41.123 244.971 41.9198 245.767 42.9027 245.767C43.8857 245.767 44.6825 244.971 44.6825 243.988C44.6825 243.005 43.8857 242.208 42.9027 242.208C41.9198 242.208 41.123 243.005 41.123 243.988Z"
            fill="#B8B7B7"
          />
          <path
            d="M34.9224 243.997C34.9224 244.98 35.7192 245.777 36.7022 245.777C37.6851 245.777 38.4819 244.98 38.4819 243.997C38.4819 243.014 37.6851 242.217 36.7022 242.217C35.7192 242.217 34.9224 243.014 34.9224 243.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.7635 243.997C28.7635 244.98 29.5603 245.777 30.5432 245.777C31.5262 245.777 32.323 244.98 32.323 243.997C32.323 243.014 31.5262 242.217 30.5432 242.217C29.5603 242.217 28.7635 243.014 28.7635 243.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.5992 243.997C22.5992 244.98 23.396 245.777 24.3789 245.777C25.3619 245.777 26.1587 244.98 26.1587 243.997C26.1587 243.014 25.3619 242.217 24.3789 242.217C23.396 242.217 22.5992 243.014 22.5992 243.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.4398 243.997C16.4398 244.98 17.2367 245.777 18.2196 245.777C19.2026 245.777 19.9994 244.98 19.9994 243.997C19.9994 243.014 19.2026 242.217 18.2196 242.217C17.2367 242.217 16.4398 243.014 16.4398 243.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.2395 243.997C10.2395 244.98 11.0364 245.777 12.0193 245.777C13.0022 245.777 13.7991 244.98 13.7991 243.997C13.7991 243.014 13.0022 242.217 12.0193 242.217C11.0364 242.217 10.2395 243.014 10.2395 243.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M4.08047 243.997C4.08047 244.98 4.8773 245.777 5.86024 245.777C6.84318 245.777 7.64001 244.98 7.64001 243.997C7.64001 243.014 6.84318 242.217 5.86024 242.217C4.8773 242.217 4.08047 243.014 4.08047 243.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M142.934 249.295C142.934 250.277 143.731 251.074 144.714 251.074C145.697 251.074 146.493 250.277 146.493 249.295C146.493 248.312 145.697 247.515 144.714 247.515C143.731 247.515 142.934 248.312 142.934 249.295Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.775 249.295C136.775 250.277 137.572 251.074 138.554 251.074C139.537 251.074 140.334 250.277 140.334 249.295C140.334 248.312 139.537 247.515 138.554 247.515C137.572 247.515 136.775 248.312 136.775 249.295Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.558 249.295C130.558 250.277 131.355 251.074 132.338 251.074C133.321 251.074 134.118 250.277 134.118 249.295C134.118 248.312 133.321 247.515 132.338 247.515C131.355 247.515 130.558 248.312 130.558 249.295Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.399 249.295C124.399 250.277 125.196 251.074 126.179 251.074C127.162 251.074 127.959 250.277 127.959 249.295C127.959 248.312 127.162 247.515 126.179 247.515C125.196 247.515 124.399 248.312 124.399 249.295Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.251 249.284C118.251 250.267 119.048 251.064 120.031 251.064C121.014 251.064 121.811 250.267 121.811 249.284C121.811 248.301 121.014 247.504 120.031 247.504C119.048 247.504 118.251 248.301 118.251 249.284Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.092 249.284C112.092 250.267 112.889 251.064 113.871 251.064C114.854 251.064 115.651 250.267 115.651 249.284C115.651 248.301 114.854 247.504 113.871 247.504C112.889 247.504 112.092 248.301 112.092 249.284Z"
            fill="#B8B7B7"
          />
          <path
            d="M105.891 249.295C105.891 250.277 106.688 251.074 107.671 251.074C108.654 251.074 109.451 250.277 109.451 249.295C109.451 248.312 108.654 247.515 107.671 247.515C106.688 247.515 105.891 248.312 105.891 249.295Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.732 249.295C99.732 250.277 100.529 251.074 101.512 251.074C102.495 251.074 103.292 250.277 103.292 249.295C103.292 248.312 102.495 247.515 101.512 247.515C100.529 247.515 99.732 248.312 99.732 249.295Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.568 249.295C93.568 250.277 94.3649 251.074 95.3478 251.074C96.3307 251.074 97.1276 250.277 97.1276 249.295C97.1276 248.312 96.3307 247.515 95.3478 247.515C94.3649 247.515 93.568 248.312 93.568 249.295Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.4087 249.295C87.4087 250.277 88.2056 251.074 89.1885 251.074C90.1714 251.074 90.9683 250.277 90.9683 249.295C90.9683 248.312 90.1714 247.515 89.1885 247.515C88.2056 247.515 87.4087 248.312 87.4087 249.295Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.2082 249.295C81.2082 250.277 82.005 251.074 82.9879 251.074C83.9709 251.074 84.7677 250.277 84.7677 249.295C84.7677 248.312 83.9709 247.515 82.9879 247.515C82.005 247.515 81.2082 248.312 81.2082 249.295Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.049 249.295C75.049 250.277 75.8458 251.074 76.8287 251.074C77.8117 251.074 78.6085 250.277 78.6085 249.295C78.6085 248.312 77.8117 247.515 76.8288 247.515C75.8458 247.515 75.049 248.312 75.049 249.295Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.8797 249.298C68.8797 250.281 69.6765 251.078 70.6594 251.078C71.6424 251.078 72.4392 250.281 72.4392 249.298C72.4392 248.315 71.6424 247.519 70.6594 247.519C69.6765 247.519 68.8797 248.315 68.8797 249.298Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.7209 249.298C62.7209 250.281 63.5177 251.078 64.5006 251.078C65.4836 251.078 66.2804 250.281 66.2804 249.298C66.2804 248.315 65.4836 247.519 64.5006 247.519C63.5177 247.519 62.7209 248.315 62.7209 249.298Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.5044 249.298C56.5044 250.281 57.3013 251.078 58.2842 251.078C59.2671 251.078 60.064 250.281 60.064 249.298C60.064 248.315 59.2671 247.519 58.2842 247.519C57.3013 247.519 56.5044 248.315 56.5044 249.298Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.3456 249.298C50.3456 250.281 51.1424 251.078 52.1254 251.078C53.1083 251.078 53.9052 250.281 53.9052 249.298C53.9052 248.315 53.1083 247.519 52.1254 247.519C51.1424 247.519 50.3456 248.315 50.3456 249.298Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.1967 249.289C44.1967 250.272 44.9935 251.069 45.9765 251.069C46.9594 251.069 47.7562 250.272 47.7562 249.289C47.7562 248.306 46.9594 247.51 45.9765 247.51C44.9935 247.51 44.1967 248.306 44.1967 249.289Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.0377 249.289C38.0377 250.272 38.8346 251.069 39.8175 251.069C40.8005 251.069 41.5973 250.272 41.5973 249.289C41.5973 248.306 40.8005 247.51 39.8175 247.51C38.8346 247.51 38.0377 248.306 38.0377 249.289Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.8383 249.298C31.8383 250.281 32.6351 251.078 33.6181 251.078C34.601 251.078 35.3978 250.281 35.3978 249.298C35.3978 248.315 34.601 247.519 33.6181 247.519C32.6351 247.519 31.8383 248.315 31.8383 249.298Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.6794 249.298C25.6794 250.281 26.4762 251.078 27.4591 251.078C28.4421 251.078 29.2389 250.281 29.2389 249.298C29.2389 248.315 28.4421 247.519 27.4591 247.519C26.4762 247.519 25.6794 248.315 25.6794 249.298Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.5137 249.298C19.5137 250.281 20.3105 251.078 21.2935 251.078C22.2764 251.078 23.0732 250.281 23.0732 249.298C23.0732 248.315 22.2764 247.519 21.2935 247.519C20.3105 247.519 19.5137 248.315 19.5137 249.298Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.3548 249.298C13.3548 250.281 14.1516 251.078 15.1345 251.078C16.1175 251.078 16.9143 250.281 16.9143 249.298C16.9143 248.315 16.1175 247.519 15.1345 247.519C14.1516 247.519 13.3548 248.315 13.3548 249.298Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.15542 249.298C7.15542 250.281 7.95226 251.078 8.9352 251.078C9.91814 251.078 10.715 250.281 10.715 249.298C10.715 248.315 9.91814 247.519 8.9352 247.519C7.95226 247.519 7.15542 248.315 7.15542 249.298Z"
            fill="#B8B7B7"
          />
          <path
            d="M0.996489 249.298C0.996489 250.281 1.79332 251.078 2.77626 251.078C3.7592 251.078 4.55603 250.281 4.55603 249.298C4.55603 248.315 3.7592 247.519 2.77626 247.519C1.79332 247.519 0.996489 248.315 0.996489 249.298Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.018 254.539C146.018 255.522 146.815 256.319 147.798 256.319C148.781 256.319 149.578 255.522 149.578 254.539C149.578 253.556 148.781 252.759 147.798 252.759C146.815 252.759 146.018 253.556 146.018 254.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.86 254.539C139.86 255.522 140.657 256.319 141.64 256.319C142.623 256.319 143.419 255.522 143.419 254.539C143.419 253.556 142.623 252.759 141.64 252.759C140.657 252.759 139.86 253.556 139.86 254.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.644 254.539C133.644 255.522 134.441 256.319 135.424 256.319C136.407 256.319 137.203 255.522 137.203 254.539C137.203 253.556 136.407 252.759 135.424 252.759C134.441 252.759 133.644 253.556 133.644 254.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.485 254.539C127.485 255.522 128.282 256.319 129.265 256.319C130.247 256.319 131.044 255.522 131.044 254.539C131.044 253.556 130.247 252.759 129.265 252.759C128.282 252.759 127.485 253.556 127.485 254.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.335 254.529C121.335 255.512 122.132 256.308 123.115 256.308C124.098 256.308 124.895 255.512 124.895 254.529C124.895 253.546 124.098 252.749 123.115 252.749C122.132 252.749 121.335 253.546 121.335 254.529Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.177 254.529C115.177 255.512 115.974 256.308 116.957 256.308C117.94 256.308 118.737 255.512 118.737 254.529C118.737 253.546 117.94 252.749 116.957 252.749C115.974 252.749 115.177 253.546 115.177 254.529Z"
            fill="#B8B7B7"
          />
          <path
            d="M108.977 254.539C108.977 255.522 109.774 256.319 110.757 256.319C111.74 256.319 112.536 255.522 112.536 254.539C112.536 253.556 111.74 252.759 110.757 252.759C109.774 252.759 108.977 253.556 108.977 254.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.818 254.539C102.818 255.522 103.614 256.319 104.597 256.319C105.58 256.319 106.377 255.522 106.377 254.539C106.377 253.556 105.58 252.759 104.597 252.759C103.614 252.759 102.818 253.556 102.818 254.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.6521 254.539C96.6521 255.522 97.449 256.319 98.4319 256.319C99.4148 256.319 100.212 255.522 100.212 254.539C100.212 253.556 99.4148 252.759 98.4319 252.759C97.449 252.759 96.6521 253.556 96.6521 254.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.4943 254.539C90.4943 255.522 91.2911 256.319 92.2741 256.319C93.257 256.319 94.0538 255.522 94.0538 254.539C94.0538 253.556 93.257 252.759 92.2741 252.759C91.2911 252.759 90.4943 253.556 90.4943 254.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.2937 254.539C84.2937 255.522 85.0906 256.319 86.0735 256.319C87.0564 256.319 87.8533 255.522 87.8533 254.539C87.8533 253.556 87.0564 252.759 86.0735 252.759C85.0906 252.759 84.2937 253.556 84.2937 254.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.1346 254.539C78.1346 255.522 78.9314 256.319 79.9143 256.319C80.8973 256.319 81.6941 255.522 81.6941 254.539C81.6941 253.556 80.8973 252.759 79.9143 252.759C78.9314 252.759 78.1346 253.556 78.1346 254.539Z"
            fill="#B8B7B7"
          />
          <path
            d="M71.9649 254.543C71.9649 255.526 72.7617 256.323 73.7446 256.323C74.7276 256.323 75.5244 255.526 75.5244 254.543C75.5244 253.56 74.7276 252.763 73.7446 252.763C72.7617 252.763 71.9649 253.56 71.9649 254.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.8059 254.543C65.8059 255.526 66.6028 256.323 67.5857 256.323C68.5686 256.323 69.3655 255.526 69.3655 254.543C69.3655 253.56 68.5686 252.763 67.5857 252.763C66.6028 252.763 65.8059 253.56 65.8059 254.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.59 254.543C59.59 255.526 60.3868 256.323 61.3698 256.323C62.3527 256.323 63.1495 255.526 63.1495 254.543C63.1495 253.56 62.3527 252.763 61.3698 252.763C60.3868 252.763 59.59 253.56 59.59 254.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.4311 254.543C53.4311 255.526 54.2279 256.323 55.2108 256.323C56.1938 256.323 56.9906 255.526 56.9906 254.543C56.9906 253.56 56.1938 252.763 55.2108 252.763C54.2279 252.763 53.4311 253.56 53.4311 254.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.2823 254.534C47.2823 255.517 48.0791 256.314 49.062 256.314C50.045 256.314 50.8418 255.517 50.8418 254.534C50.8418 253.551 50.045 252.754 49.062 252.754C48.0791 252.754 47.2823 253.551 47.2823 254.534Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.123 254.534C41.123 255.517 41.9198 256.314 42.9027 256.314C43.8857 256.314 44.6825 255.517 44.6825 254.534C44.6825 253.551 43.8857 252.754 42.9027 252.754C41.9198 252.754 41.123 253.551 41.123 254.534Z"
            fill="#B8B7B7"
          />
          <path
            d="M34.9224 254.543C34.9224 255.526 35.7192 256.323 36.7022 256.323C37.6851 256.323 38.4819 255.526 38.4819 254.543C38.4819 253.56 37.6851 252.763 36.7022 252.763C35.7192 252.763 34.9224 253.56 34.9224 254.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.7635 254.543C28.7635 255.526 29.5603 256.323 30.5432 256.323C31.5262 256.323 32.323 255.526 32.323 254.543C32.323 253.56 31.5262 252.763 30.5432 252.763C29.5603 252.763 28.7635 253.56 28.7635 254.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.5992 254.543C22.5992 255.526 23.396 256.323 24.3789 256.323C25.3619 256.323 26.1587 255.526 26.1587 254.543C26.1587 253.56 25.3619 252.763 24.3789 252.763C23.396 252.763 22.5992 253.56 22.5992 254.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.4398 254.543C16.4398 255.526 17.2367 256.323 18.2196 256.323C19.2026 256.323 19.9994 255.526 19.9994 254.543C19.9994 253.56 19.2026 252.763 18.2196 252.763C17.2367 252.763 16.4398 253.56 16.4398 254.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.2395 254.543C10.2395 255.526 11.0364 256.323 12.0193 256.323C13.0022 256.323 13.7991 255.526 13.7991 254.543C13.7991 253.56 13.0022 252.763 12.0193 252.763C11.0364 252.763 10.2395 253.56 10.2395 254.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M4.08047 254.543C4.08047 255.526 4.8773 256.323 5.86024 256.323C6.84318 256.323 7.64001 255.526 7.64001 254.543C7.64001 253.56 6.84318 252.763 5.86024 252.763C4.8773 252.763 4.08047 253.56 4.08047 254.543Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.093 249.266C149.093 250.249 149.89 251.046 150.873 251.046C151.856 251.046 152.653 250.249 152.653 249.266C152.653 248.283 151.856 247.486 150.873 247.486C149.89 247.486 149.093 248.283 149.093 249.266Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.093 259.722C149.093 260.705 149.89 261.502 150.873 261.502C151.856 261.502 152.653 260.705 152.653 259.722C152.653 258.739 151.856 257.943 150.873 257.943C149.89 257.943 149.093 258.739 149.093 259.722Z"
            fill="#B8B7B7"
          />
          <path
            d="M142.934 259.722C142.934 260.705 143.731 261.502 144.714 261.502C145.697 261.502 146.493 260.705 146.493 259.722C146.493 258.739 145.697 257.943 144.714 257.943C143.731 257.943 142.934 258.739 142.934 259.722Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.717 259.722C136.717 260.705 137.514 261.502 138.497 261.502C139.48 261.502 140.277 260.705 140.277 259.722C140.277 258.739 139.48 257.943 138.497 257.943C137.514 257.943 136.717 258.739 136.717 259.722Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.558 259.722C130.558 260.705 131.355 261.502 132.338 261.502C133.321 261.502 134.118 260.705 134.118 259.722C134.118 258.739 133.321 257.943 132.338 257.943C131.355 257.943 130.558 258.739 130.558 259.722Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.41 259.712C124.41 260.695 125.207 261.492 126.19 261.492C127.173 261.492 127.969 260.695 127.969 259.712C127.969 258.729 127.173 257.932 126.19 257.932C125.207 257.932 124.41 258.729 124.41 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.251 259.712C118.251 260.695 119.048 261.492 120.031 261.492C121.014 261.492 121.811 260.695 121.811 259.712C121.811 258.729 121.014 257.932 120.031 257.932C119.048 257.932 118.251 258.729 118.251 259.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.05 259.722C112.05 260.705 112.847 261.502 113.83 261.502C114.813 261.502 115.61 260.705 115.61 259.722C115.61 258.739 114.813 257.943 113.83 257.943C112.847 257.943 112.05 258.739 112.05 259.722Z"
            fill="#B8B7B7"
          />
          <path
            d="M105.891 259.722C105.891 260.705 106.688 261.502 107.671 261.502C108.654 261.502 109.451 260.705 109.451 259.722C109.451 258.739 108.654 257.943 107.671 257.943C106.688 257.943 105.891 258.739 105.891 259.722Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.727 259.722C99.727 260.705 100.524 261.502 101.507 261.502C102.49 261.502 103.286 260.705 103.286 259.722C103.286 258.739 102.49 257.943 101.507 257.943C100.524 257.943 99.727 258.739 99.727 259.722Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.568 259.722C93.568 260.705 94.3649 261.502 95.3478 261.502C96.3307 261.502 97.1276 260.705 97.1276 259.722C97.1276 258.739 96.3307 257.943 95.3478 257.943C94.3649 257.943 93.568 258.739 93.568 259.722Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.3671 259.722C87.3671 260.705 88.1639 261.502 89.1469 261.502C90.1298 261.502 90.9266 260.705 90.9266 259.722C90.9266 258.739 90.1298 257.943 89.1469 257.943C88.1639 257.943 87.3671 258.739 87.3671 259.722Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.2082 259.722C81.2082 260.705 82.005 261.502 82.9879 261.502C83.9709 261.502 84.7677 260.705 84.7677 259.722C84.7677 258.739 83.9709 257.943 82.9879 257.943C82.005 257.943 81.2082 258.739 81.2082 259.722Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.0388 259.726C75.0388 260.709 75.8357 261.506 76.8186 261.506C77.8016 261.506 78.5984 260.709 78.5984 259.726C78.5984 258.743 77.8016 257.947 76.8186 257.947C75.8357 257.947 75.0388 258.743 75.0388 259.726Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.8797 259.726C68.8797 260.709 69.6765 261.506 70.6594 261.506C71.6424 261.506 72.4392 260.709 72.4392 259.726C72.4392 258.743 71.6424 257.947 70.6594 257.947C69.6765 257.947 68.8797 258.743 68.8797 259.726Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.6637 259.726C62.6637 260.709 63.4606 261.506 64.4435 261.506C65.4264 261.506 66.2233 260.709 66.2233 259.726C66.2233 258.743 65.4264 257.947 64.4435 257.947C63.4606 257.947 62.6637 258.743 62.6637 259.726Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.5044 259.726C56.5044 260.709 57.3013 261.506 58.2842 261.506C59.2671 261.506 60.064 260.709 60.064 259.726C60.064 258.743 59.2671 257.947 58.2842 257.947C57.3013 257.947 56.5044 258.743 56.5044 259.726Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.356 259.717C50.356 260.7 51.1528 261.497 52.1358 261.497C53.1187 261.497 53.9155 260.7 53.9155 259.717C53.9155 258.734 53.1187 257.937 52.1358 257.937C51.1528 257.937 50.356 258.734 50.356 259.717Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.1967 259.717C44.1967 260.7 44.9935 261.497 45.9765 261.497C46.9594 261.497 47.7562 260.7 47.7562 259.717C47.7562 258.734 46.9594 257.937 45.9765 257.937C44.9935 257.937 44.1967 258.734 44.1967 259.717Z"
            fill="#B8B7B7"
          />
          <path
            d="M37.9975 259.726C37.9975 260.709 38.7943 261.506 39.7772 261.506C40.7602 261.506 41.557 260.709 41.557 259.726C41.557 258.743 40.7602 257.947 39.7772 257.947C38.7943 257.947 37.9975 258.743 37.9975 259.726Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.8383 259.726C31.8383 260.709 32.6351 261.506 33.6181 261.506C34.601 261.506 35.3978 260.709 35.3978 259.726C35.3978 258.743 34.601 257.947 33.6181 257.947C32.6351 257.947 31.8383 258.743 31.8383 259.726Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.6728 259.726C25.6728 260.709 26.4696 261.506 27.4525 261.506C28.4355 261.506 29.2323 260.709 29.2323 259.726C29.2323 258.743 28.4355 257.947 27.4525 257.947C26.4696 257.947 25.6728 258.743 25.6728 259.726Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.5137 259.726C19.5137 260.709 20.3105 261.506 21.2935 261.506C22.2764 261.506 23.0732 260.709 23.0732 259.726C23.0732 258.743 22.2764 257.947 21.2935 257.947C20.3105 257.947 19.5137 258.743 19.5137 259.726Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.3146 259.726C13.3146 260.709 14.1114 261.506 15.0944 261.506C16.0773 261.506 16.8741 260.709 16.8741 259.726C16.8741 258.743 16.0773 257.947 15.0944 257.947C14.1114 257.947 13.3146 258.743 13.3146 259.726Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.15542 259.726C7.15542 260.709 7.95226 261.506 8.9352 261.506C9.91814 261.506 10.715 260.709 10.715 259.726C10.715 258.743 9.91814 257.947 8.9352 257.947C7.95226 257.947 7.15542 258.743 7.15542 259.726Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.008 265.023C146.008 266.006 146.804 266.803 147.787 266.803C148.77 266.803 149.567 266.006 149.567 265.023C149.567 264.04 148.77 263.243 147.787 263.243C146.804 263.243 146.008 264.04 146.008 265.023Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.848 265.023C139.848 266.006 140.645 266.803 141.628 266.803C142.611 266.803 143.408 266.006 143.408 265.023C143.408 264.04 142.611 263.243 141.628 263.243C140.645 263.243 139.848 264.04 139.848 265.023Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.632 265.023C133.632 266.006 134.429 266.803 135.412 266.803C136.395 266.803 137.192 266.006 137.192 265.023C137.192 264.04 136.395 263.243 135.412 263.243C134.429 263.243 133.632 264.04 133.632 265.023Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.473 265.023C127.473 266.006 128.27 266.803 129.253 266.803C130.236 266.803 131.033 266.006 131.033 265.023C131.033 264.04 130.236 263.243 129.253 263.243C128.27 263.243 127.473 264.04 127.473 265.023Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.325 265.014C121.325 265.997 122.122 266.793 123.105 266.793C124.088 266.793 124.884 265.997 124.884 265.014C124.884 264.031 124.088 263.234 123.105 263.234C122.122 263.234 121.325 264.031 121.325 265.014Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.166 265.014C115.166 265.997 115.962 266.793 116.945 266.793C117.928 266.793 118.725 265.997 118.725 265.014C118.725 264.031 117.928 263.234 116.945 263.234C115.962 263.234 115.166 264.031 115.166 265.014Z"
            fill="#B8B7B7"
          />
          <path
            d="M108.966 265.023C108.966 266.006 109.763 266.803 110.746 266.803C111.729 266.803 112.526 266.006 112.526 265.023C112.526 264.04 111.729 263.243 110.746 263.243C109.763 263.243 108.966 264.04 108.966 265.023Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.807 265.023C102.807 266.006 103.604 266.803 104.587 266.803C105.57 266.803 106.367 266.006 106.367 265.023C106.367 264.04 105.57 263.243 104.587 263.243C103.604 263.243 102.807 264.04 102.807 265.023Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.6419 265.023C96.6419 266.006 97.4387 266.803 98.4216 266.803C99.4046 266.803 100.201 266.006 100.201 265.023C100.201 264.04 99.4046 263.243 98.4216 263.243C97.4387 263.243 96.6419 264.04 96.6419 265.023Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.4826 265.023C90.4826 266.006 91.2794 266.803 92.2623 266.803C93.2453 266.803 94.0421 266.006 94.0421 265.023C94.0421 264.04 93.2453 263.243 92.2623 263.243C91.2794 263.243 90.4826 264.04 90.4826 265.023Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.2831 265.023C84.2831 266.006 85.0799 266.803 86.0629 266.803C87.0458 266.803 87.8427 266.006 87.8427 265.023C87.8427 264.04 87.0458 263.243 86.0629 263.243C85.0799 263.243 84.2831 264.04 84.2831 265.023Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.1241 265.023C78.1241 266.006 78.9209 266.803 79.9038 266.803C80.8868 266.803 81.6836 266.006 81.6836 265.023C81.6836 264.04 80.8868 263.243 79.9038 263.243C78.9209 263.243 78.1241 264.04 78.1241 265.023Z"
            fill="#B8B7B7"
          />
          <path
            d="M71.9534 265.028C71.9534 266.011 72.7502 266.808 73.7332 266.808C74.7161 266.808 75.5129 266.011 75.5129 265.028C75.5129 264.045 74.7161 263.248 73.7332 263.248C72.7502 263.248 71.9534 264.045 71.9534 265.028Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.7956 265.028C65.7956 266.011 66.5924 266.808 67.5753 266.808C68.5583 266.808 69.3551 266.011 69.3551 265.028C69.3551 264.045 68.5583 263.248 67.5753 263.248C66.5924 263.248 65.7956 264.045 65.7956 265.028Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.5796 265.028C59.5796 266.011 60.3764 266.808 61.3594 266.808C62.3423 266.808 63.1392 266.011 63.1392 265.028C63.1392 264.045 62.3423 263.248 61.3594 263.248C60.3764 263.248 59.5796 264.045 59.5796 265.028Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.4202 265.028C53.4202 266.011 54.217 266.808 55.2 266.808C56.1829 266.808 56.9797 266.011 56.9797 265.028C56.9797 264.045 56.1829 263.248 55.2 263.248C54.217 263.248 53.4202 264.045 53.4202 265.028Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.2704 265.019C47.2704 266.002 48.0672 266.799 49.0502 266.799C50.0331 266.799 50.83 266.002 50.83 265.019C50.83 264.036 50.0331 263.239 49.0502 263.239C48.0672 263.239 47.2704 264.036 47.2704 265.019Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.1131 265.019C41.1131 266.002 41.9099 266.799 42.8928 266.799C43.8758 266.799 44.6726 266.002 44.6726 265.019C44.6726 264.036 43.8758 263.239 42.8928 263.239C41.9099 263.239 41.1131 264.036 41.1131 265.019Z"
            fill="#B8B7B7"
          />
          <path
            d="M34.912 265.028C34.912 266.011 35.7088 266.808 36.6918 266.808C37.6747 266.808 38.4716 266.011 38.4716 265.028C38.4716 264.045 37.6747 263.248 36.6918 263.248C35.7088 263.248 34.912 264.045 34.912 265.028Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.7531 265.028C28.7531 266.011 29.5499 266.808 30.5329 266.808C31.5158 266.808 32.3126 266.011 32.3126 265.028C32.3126 264.045 31.5158 263.248 30.5329 263.248C29.5499 263.248 28.7531 264.045 28.7531 265.028Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.5874 265.028C22.5874 266.011 23.3843 266.808 24.3672 266.808C25.3501 266.808 26.147 266.011 26.147 265.028C26.147 264.045 25.3501 263.248 24.3672 263.248C23.3843 263.248 22.5874 264.045 22.5874 265.028Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.4298 265.028C16.4298 266.011 17.2267 266.808 18.2096 266.808C19.1925 266.808 19.9894 266.011 19.9894 265.028C19.9894 264.045 19.1925 263.248 18.2096 263.248C17.2267 263.248 16.4298 264.045 16.4298 265.028Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.2289 265.028C10.2289 266.011 11.0257 266.808 12.0087 266.808C12.9916 266.808 13.7885 266.011 13.7885 265.028C13.7885 264.045 12.9916 263.248 12.0087 263.248C11.0257 263.248 10.2289 264.045 10.2289 265.028Z"
            fill="#B8B7B7"
          />
          <path
            d="M4.07022 265.028C4.07022 266.011 4.86705 266.808 5.84999 266.808C6.83293 266.808 7.62976 266.011 7.62976 265.028C7.62976 264.045 6.83293 263.248 5.84999 263.248C4.86705 263.248 4.07022 264.045 4.07022 265.028Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.093 270.269C149.093 271.251 149.89 272.048 150.873 272.048C151.856 272.048 152.653 271.251 152.653 270.269C152.653 269.286 151.856 268.489 150.873 268.489C149.89 268.489 149.093 269.286 149.093 270.269Z"
            fill="#B8B7B7"
          />
          <path
            d="M142.934 270.269C142.934 271.251 143.731 272.048 144.714 272.048C145.697 272.048 146.493 271.251 146.493 270.269C146.493 269.286 145.697 268.489 144.714 268.489C143.731 268.489 142.934 269.286 142.934 270.269Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.717 270.269C136.717 271.251 137.514 272.048 138.497 272.048C139.48 272.048 140.277 271.251 140.277 270.269C140.277 269.286 139.48 268.489 138.497 268.489C137.514 268.489 136.717 269.286 136.717 270.269Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.558 270.269C130.558 271.251 131.355 272.048 132.338 272.048C133.321 272.048 134.118 271.251 134.118 270.269C134.118 269.286 133.321 268.489 132.338 268.489C131.355 268.489 130.558 269.286 130.558 270.269Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.41 270.258C124.41 271.241 125.207 272.038 126.19 272.038C127.173 272.038 127.969 271.241 127.969 270.258C127.969 269.275 127.173 268.478 126.19 268.478C125.207 268.478 124.41 269.275 124.41 270.258Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.251 270.258C118.251 271.241 119.048 272.038 120.031 272.038C121.014 272.038 121.811 271.241 121.811 270.258C121.811 269.275 121.014 268.478 120.031 268.478C119.048 268.478 118.251 269.275 118.251 270.258Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.05 270.269C112.05 271.251 112.847 272.048 113.83 272.048C114.813 272.048 115.61 271.251 115.61 270.269C115.61 269.286 114.813 268.489 113.83 268.489C112.847 268.489 112.05 269.286 112.05 270.269Z"
            fill="#B8B7B7"
          />
          <path
            d="M105.891 270.269C105.891 271.251 106.688 272.048 107.671 272.048C108.654 272.048 109.451 271.251 109.451 270.269C109.451 269.286 108.654 268.489 107.671 268.489C106.688 268.489 105.891 269.286 105.891 270.269Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.727 270.269C99.727 271.251 100.524 272.048 101.507 272.048C102.49 272.048 103.286 271.251 103.286 270.269C103.286 269.286 102.49 268.489 101.507 268.489C100.524 268.489 99.727 269.286 99.727 270.269Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.568 270.269C93.568 271.251 94.3649 272.048 95.3478 272.048C96.3307 272.048 97.1276 271.251 97.1276 270.269C97.1276 269.286 96.3307 268.489 95.3478 268.489C94.3649 268.489 93.568 269.286 93.568 270.269Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.3671 270.269C87.3671 271.251 88.1639 272.048 89.1469 272.048C90.1298 272.048 90.9266 271.251 90.9266 270.269C90.9266 269.286 90.1298 268.489 89.1469 268.489C88.1639 268.489 87.3671 269.286 87.3671 270.269Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.2082 270.269C81.2082 271.251 82.005 272.048 82.9879 272.048C83.9709 272.048 84.7677 271.251 84.7677 270.269C84.7677 269.286 83.9709 268.489 82.9879 268.489C82.005 268.489 81.2082 269.286 81.2082 270.269Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.0388 270.272C75.0388 271.255 75.8357 272.052 76.8186 272.052C77.8016 272.052 78.5984 271.255 78.5984 270.272C78.5984 269.289 77.8016 268.493 76.8186 268.493C75.8357 268.493 75.0388 269.289 75.0388 270.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.8797 270.272C68.8797 271.255 69.6765 272.052 70.6594 272.052C71.6424 272.052 72.4392 271.255 72.4392 270.272C72.4392 269.289 71.6424 268.493 70.6594 268.493C69.6765 268.493 68.8797 269.289 68.8797 270.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.6637 270.272C62.6637 271.255 63.4606 272.052 64.4435 272.052C65.4264 272.052 66.2233 271.255 66.2233 270.272C66.2233 269.289 65.4264 268.493 64.4435 268.493C63.4606 268.493 62.6637 269.289 62.6637 270.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.5044 270.272C56.5044 271.255 57.3013 272.052 58.2842 272.052C59.2671 272.052 60.064 271.255 60.064 270.272C60.064 269.289 59.2671 268.493 58.2842 268.493C57.3013 268.493 56.5044 269.289 56.5044 270.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.356 270.263C50.356 271.246 51.1528 272.043 52.1358 272.043C53.1187 272.043 53.9155 271.246 53.9155 270.263C53.9155 269.28 53.1187 268.484 52.1358 268.484C51.1528 268.484 50.356 269.28 50.356 270.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.1967 270.263C44.1967 271.246 44.9935 272.043 45.9765 272.043C46.9594 272.043 47.7562 271.246 47.7562 270.263C47.7562 269.28 46.9594 268.484 45.9765 268.484C44.9935 268.484 44.1967 269.28 44.1967 270.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M37.9975 270.272C37.9975 271.255 38.7943 272.052 39.7772 272.052C40.7602 272.052 41.557 271.255 41.557 270.272C41.557 269.289 40.7602 268.493 39.7772 268.493C38.7943 268.493 37.9975 269.289 37.9975 270.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.8383 270.272C31.8383 271.255 32.6351 272.052 33.6181 272.052C34.601 272.052 35.3978 271.255 35.3978 270.272C35.3978 269.289 34.601 268.493 33.6181 268.493C32.6351 268.493 31.8383 269.289 31.8383 270.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.6728 270.272C25.6728 271.255 26.4696 272.052 27.4525 272.052C28.4355 272.052 29.2323 271.255 29.2323 270.272C29.2323 269.289 28.4355 268.493 27.4525 268.493C26.4696 268.493 25.6728 269.289 25.6728 270.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.5137 270.272C19.5137 271.255 20.3105 272.052 21.2935 272.052C22.2764 272.052 23.0732 271.255 23.0732 270.272C23.0732 269.289 22.2764 268.493 21.2935 268.493C20.3105 268.493 19.5137 269.289 19.5137 270.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.3146 270.272C13.3146 271.255 14.1114 272.052 15.0944 272.052C16.0773 272.052 16.8741 271.255 16.8741 270.272C16.8741 269.289 16.0773 268.493 15.0944 268.493C14.1114 268.493 13.3146 269.289 13.3146 270.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.15542 270.272C7.15542 271.255 7.95226 272.052 8.9352 272.052C9.91814 272.052 10.715 271.255 10.715 270.272C10.715 269.289 9.91814 268.493 8.9352 268.493C7.95226 268.493 7.15542 269.289 7.15542 270.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.018 275.558C146.018 276.541 146.815 277.338 147.798 277.338C148.781 277.338 149.578 276.541 149.578 275.558C149.578 274.576 148.781 273.779 147.798 273.779C146.815 273.779 146.018 274.576 146.018 275.558Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.86 275.558C139.86 276.541 140.657 277.338 141.64 277.338C142.623 277.338 143.419 276.541 143.419 275.558C143.419 274.576 142.623 273.779 141.64 273.779C140.657 273.779 139.86 274.576 139.86 275.558Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.644 275.558C133.644 276.541 134.441 277.338 135.424 277.338C136.407 277.338 137.203 276.541 137.203 275.558C137.203 274.576 136.407 273.779 135.424 273.779C134.441 273.779 133.644 274.576 133.644 275.558Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.485 275.558C127.485 276.541 128.282 277.338 129.265 277.338C130.247 277.338 131.044 276.541 131.044 275.558C131.044 274.576 130.247 273.779 129.265 273.779C128.282 273.779 127.485 274.576 127.485 275.558Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.335 275.549C121.335 276.532 122.132 277.329 123.115 277.329C124.098 277.329 124.895 276.532 124.895 275.549C124.895 274.566 124.098 273.77 123.115 273.77C122.132 273.77 121.335 274.566 121.335 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.177 275.549C115.177 276.532 115.974 277.329 116.957 277.329C117.94 277.329 118.737 276.532 118.737 275.549C118.737 274.566 117.94 273.77 116.957 273.77C115.974 273.77 115.177 274.566 115.177 275.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M108.977 275.558C108.977 276.541 109.774 277.338 110.757 277.338C111.74 277.338 112.536 276.541 112.536 275.558C112.536 274.576 111.74 273.779 110.757 273.779C109.774 273.779 108.977 274.576 108.977 275.558Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.818 275.558C102.818 276.541 103.614 277.338 104.597 277.338C105.58 277.338 106.377 276.541 106.377 275.558C106.377 274.576 105.58 273.779 104.597 273.779C103.614 273.779 102.818 274.576 102.818 275.558Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.6521 275.558C96.6521 276.541 97.449 277.338 98.4319 277.338C99.4148 277.338 100.212 276.541 100.212 275.558C100.212 274.576 99.4148 273.779 98.4319 273.779C97.449 273.779 96.6521 274.576 96.6521 275.558Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.4943 275.558C90.4943 276.541 91.2911 277.338 92.2741 277.338C93.257 277.338 94.0538 276.541 94.0538 275.558C94.0538 274.576 93.257 273.779 92.2741 273.779C91.2911 273.779 90.4943 274.576 90.4943 275.558Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.2937 275.558C84.2937 276.541 85.0906 277.338 86.0735 277.338C87.0564 277.338 87.8533 276.541 87.8533 275.558C87.8533 274.576 87.0564 273.779 86.0735 273.779C85.0906 273.779 84.2937 274.576 84.2937 275.558Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.1346 275.558C78.1346 276.541 78.9314 277.338 79.9143 277.338C80.8973 277.338 81.6941 276.541 81.6941 275.558C81.6941 274.576 80.8973 273.779 79.9143 273.779C78.9314 273.779 78.1346 274.576 78.1346 275.558Z"
            fill="#B8B7B7"
          />
          <path
            d="M71.9649 275.564C71.9649 276.547 72.7617 277.343 73.7446 277.343C74.7276 277.343 75.5244 276.547 75.5244 275.564C75.5244 274.581 74.7276 273.784 73.7446 273.784C72.7617 273.784 71.9649 274.581 71.9649 275.564Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.8059 275.564C65.8059 276.547 66.6028 277.343 67.5857 277.343C68.5686 277.343 69.3655 276.547 69.3655 275.564C69.3655 274.581 68.5686 273.784 67.5857 273.784C66.6028 273.784 65.8059 274.581 65.8059 275.564Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.59 275.564C59.59 276.547 60.3868 277.343 61.3698 277.343C62.3527 277.343 63.1495 276.547 63.1495 275.564C63.1495 274.581 62.3527 273.784 61.3698 273.784C60.3868 273.784 59.59 274.581 59.59 275.564Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.4311 275.564C53.4311 276.547 54.2279 277.343 55.2108 277.343C56.1938 277.343 56.9906 276.547 56.9906 275.564C56.9906 274.581 56.1938 273.784 55.2108 273.784C54.2279 273.784 53.4311 274.581 53.4311 275.564Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.2823 275.553C47.2823 276.536 48.0791 277.333 49.062 277.333C50.045 277.333 50.8418 276.536 50.8418 275.553C50.8418 274.57 50.045 273.773 49.062 273.773C48.0791 273.773 47.2823 274.57 47.2823 275.553Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.123 275.553C41.123 276.536 41.9198 277.333 42.9027 277.333C43.8857 277.333 44.6825 276.536 44.6825 275.553C44.6825 274.57 43.8857 273.773 42.9027 273.773C41.9198 273.773 41.123 274.57 41.123 275.553Z"
            fill="#B8B7B7"
          />
          <path
            d="M34.9224 275.564C34.9224 276.547 35.7192 277.343 36.7022 277.343C37.6851 277.343 38.4819 276.547 38.4819 275.564C38.4819 274.581 37.6851 273.784 36.7022 273.784C35.7192 273.784 34.9224 274.581 34.9224 275.564Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.7635 275.564C28.7635 276.547 29.5603 277.343 30.5432 277.343C31.5262 277.343 32.323 276.547 32.323 275.564C32.323 274.581 31.5262 273.784 30.5432 273.784C29.5603 273.784 28.7635 274.581 28.7635 275.564Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.5992 275.564C22.5992 276.547 23.396 277.343 24.3789 277.343C25.3619 277.343 26.1587 276.547 26.1587 275.564C26.1587 274.581 25.3619 273.784 24.3789 273.784C23.396 273.784 22.5992 274.581 22.5992 275.564Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.4398 275.564C16.4398 276.547 17.2367 277.343 18.2196 277.343C19.2026 277.343 19.9994 276.547 19.9994 275.564C19.9994 274.581 19.2026 273.784 18.2196 273.784C17.2367 273.784 16.4398 274.581 16.4398 275.564Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.2395 275.564C10.2395 276.547 11.0364 277.343 12.0193 277.343C13.0022 277.343 13.7991 276.547 13.7991 275.564C13.7991 274.581 13.0022 273.784 12.0193 273.784C11.0364 273.784 10.2395 274.581 10.2395 275.564Z"
            fill="#B8B7B7"
          />
          <path
            d="M4.08047 275.564C4.08047 276.547 4.8773 277.343 5.86024 277.343C6.84318 277.343 7.64001 276.547 7.64001 275.564C7.64001 274.581 6.84318 273.784 5.86024 273.784C4.8773 273.784 4.08047 274.581 4.08047 275.564Z"
            fill="#B8B7B7"
          />
          <path
            d="M142.934 280.86C142.934 281.843 143.731 282.64 144.714 282.64C145.697 282.64 146.493 281.843 146.493 280.86C146.493 279.877 145.697 279.08 144.714 279.08C143.731 279.08 142.934 279.877 142.934 280.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.775 280.86C136.775 281.843 137.572 282.64 138.554 282.64C139.537 282.64 140.334 281.843 140.334 280.86C140.334 279.877 139.537 279.08 138.554 279.08C137.572 279.08 136.775 279.877 136.775 280.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.558 280.86C130.558 281.843 131.355 282.64 132.338 282.64C133.321 282.64 134.118 281.843 134.118 280.86C134.118 279.877 133.321 279.08 132.338 279.08C131.355 279.08 130.558 279.877 130.558 280.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.399 280.86C124.399 281.843 125.196 282.64 126.179 282.64C127.162 282.64 127.959 281.843 127.959 280.86C127.959 279.877 127.162 279.08 126.179 279.08C125.196 279.08 124.399 279.877 124.399 280.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.251 280.85C118.251 281.833 119.048 282.629 120.031 282.629C121.014 282.629 121.811 281.833 121.811 280.85C121.811 279.867 121.014 279.07 120.031 279.07C119.048 279.07 118.251 279.867 118.251 280.85Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.092 280.85C112.092 281.833 112.889 282.629 113.871 282.629C114.854 282.629 115.651 281.833 115.651 280.85C115.651 279.867 114.854 279.07 113.871 279.07C112.889 279.07 112.092 279.867 112.092 280.85Z"
            fill="#B8B7B7"
          />
          <path
            d="M105.891 280.86C105.891 281.843 106.688 282.64 107.671 282.64C108.654 282.64 109.451 281.843 109.451 280.86C109.451 279.877 108.654 279.08 107.671 279.08C106.688 279.08 105.891 279.877 105.891 280.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.732 280.86C99.732 281.843 100.529 282.64 101.512 282.64C102.495 282.64 103.292 281.843 103.292 280.86C103.292 279.877 102.495 279.08 101.512 279.08C100.529 279.08 99.732 279.877 99.732 280.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.568 280.86C93.568 281.843 94.3649 282.64 95.3478 282.64C96.3307 282.64 97.1276 281.843 97.1276 280.86C97.1276 279.877 96.3307 279.08 95.3478 279.08C94.3649 279.08 93.568 279.877 93.568 280.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.4087 280.86C87.4087 281.843 88.2056 282.64 89.1885 282.64C90.1714 282.64 90.9683 281.843 90.9683 280.86C90.9683 279.877 90.1714 279.08 89.1885 279.08C88.2056 279.08 87.4087 279.877 87.4087 280.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.2082 280.86C81.2082 281.843 82.005 282.64 82.9879 282.64C83.9709 282.64 84.7677 281.843 84.7677 280.86C84.7677 279.877 83.9709 279.08 82.9879 279.08C82.005 279.08 81.2082 279.877 81.2082 280.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.049 280.86C75.049 281.843 75.8458 282.64 76.8287 282.64C77.8117 282.64 78.6085 281.843 78.6085 280.86C78.6085 279.877 77.8117 279.08 76.8288 279.08C75.8458 279.08 75.049 279.877 75.049 280.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.8797 280.864C68.8797 281.847 69.6765 282.644 70.6594 282.644C71.6424 282.644 72.4392 281.847 72.4392 280.864C72.4392 279.881 71.6424 279.084 70.6594 279.084C69.6765 279.084 68.8797 279.881 68.8797 280.864Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.7209 280.864C62.7209 281.847 63.5177 282.644 64.5006 282.644C65.4836 282.644 66.2804 281.847 66.2804 280.864C66.2804 279.881 65.4836 279.084 64.5006 279.084C63.5177 279.084 62.7209 279.881 62.7209 280.864Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.5044 280.864C56.5044 281.847 57.3013 282.644 58.2842 282.644C59.2671 282.644 60.064 281.847 60.064 280.864C60.064 279.881 59.2671 279.084 58.2842 279.084C57.3013 279.084 56.5044 279.881 56.5044 280.864Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.3456 280.864C50.3456 281.847 51.1424 282.644 52.1254 282.644C53.1083 282.644 53.9052 281.847 53.9052 280.864C53.9052 279.881 53.1083 279.084 52.1254 279.084C51.1424 279.084 50.3456 279.881 50.3456 280.864Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.1967 280.855C44.1967 281.838 44.9935 282.635 45.9765 282.635C46.9594 282.635 47.7562 281.838 47.7562 280.855C47.7562 279.872 46.9594 279.075 45.9765 279.075C44.9935 279.075 44.1967 279.872 44.1967 280.855Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.0377 280.855C38.0377 281.838 38.8346 282.635 39.8175 282.635C40.8005 282.635 41.5973 281.838 41.5973 280.855C41.5973 279.872 40.8005 279.075 39.8175 279.075C38.8346 279.075 38.0377 279.872 38.0377 280.855Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.8383 280.864C31.8383 281.847 32.6351 282.644 33.6181 282.644C34.601 282.644 35.3978 281.847 35.3978 280.864C35.3978 279.881 34.601 279.084 33.6181 279.084C32.6351 279.084 31.8383 279.881 31.8383 280.864Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.6794 280.864C25.6794 281.847 26.4762 282.644 27.4591 282.644C28.4421 282.644 29.2389 281.847 29.2389 280.864C29.2389 279.881 28.4421 279.084 27.4591 279.084C26.4762 279.084 25.6794 279.881 25.6794 280.864Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.5137 280.864C19.5137 281.847 20.3105 282.644 21.2935 282.644C22.2764 282.644 23.0732 281.847 23.0732 280.864C23.0732 279.881 22.2764 279.084 21.2935 279.084C20.3105 279.084 19.5137 279.881 19.5137 280.864Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.3548 280.864C13.3548 281.847 14.1516 282.644 15.1345 282.644C16.1175 282.644 16.9143 281.847 16.9143 280.864C16.9143 279.881 16.1175 279.084 15.1345 279.084C14.1516 279.084 13.3548 279.881 13.3548 280.864Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.15542 280.864C7.15542 281.847 7.95226 282.644 8.9352 282.644C9.91814 282.644 10.715 281.847 10.715 280.864C10.715 279.881 9.91814 279.084 8.9352 279.084C7.95226 279.084 7.15542 279.881 7.15542 280.864Z"
            fill="#B8B7B7"
          />
          <path
            d="M0.996489 280.864C0.996489 281.847 1.79332 282.644 2.77626 282.644C3.7592 282.644 4.55603 281.847 4.55603 280.864C4.55603 279.881 3.7592 279.084 2.77626 279.084C1.79332 279.084 0.996489 279.881 0.996489 280.864Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.093 280.832C149.093 281.814 149.89 282.611 150.873 282.611C151.856 282.611 152.653 281.814 152.653 280.832C152.653 279.849 151.856 279.052 150.873 279.052C149.89 279.052 149.093 279.849 149.093 280.832Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.172 191.152C152.172 192.135 152.968 192.932 153.951 192.932C154.934 192.932 155.731 192.135 155.731 191.152C155.731 190.169 154.934 189.372 153.951 189.372C152.968 189.372 152.172 190.169 152.172 191.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.013 191.152C146.013 192.135 146.81 192.932 147.792 192.932C148.775 192.932 149.572 192.135 149.572 191.152C149.572 190.169 148.775 189.372 147.792 189.372C146.81 189.372 146.013 190.169 146.013 191.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.796 191.152C139.796 192.135 140.593 192.932 141.576 192.932C142.559 192.932 143.356 192.135 143.356 191.152C143.356 190.169 142.559 189.372 141.576 189.372C140.593 189.372 139.796 190.169 139.796 191.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.638 191.152C133.638 192.135 134.434 192.932 135.417 192.932C136.4 192.932 137.197 192.135 137.197 191.152C137.197 190.169 136.4 189.372 135.417 189.372C134.434 189.372 133.638 190.169 133.638 191.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.489 191.143C127.489 192.126 128.286 192.923 129.268 192.923C130.251 192.923 131.048 192.126 131.048 191.143C131.048 190.16 130.251 189.363 129.268 189.363C128.286 189.363 127.489 190.16 127.489 191.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.33 191.143C121.33 192.126 122.127 192.923 123.11 192.923C124.092 192.923 124.889 192.126 124.889 191.143C124.889 190.16 124.092 189.363 123.11 189.363C122.127 189.363 121.33 190.16 121.33 191.143Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.13 191.152C115.13 192.135 115.927 192.932 116.91 192.932C117.893 192.932 118.69 192.135 118.69 191.152C118.69 190.169 117.893 189.372 116.91 189.372C115.927 189.372 115.13 190.169 115.13 191.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M108.971 191.152C108.971 192.135 109.768 192.932 110.751 192.932C111.734 192.932 112.531 192.135 112.531 191.152C112.531 190.169 111.734 189.372 110.751 189.372C109.768 189.372 108.971 190.169 108.971 191.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.806 191.152C102.806 192.135 103.603 192.932 104.586 192.932C105.569 192.932 106.366 192.135 106.366 191.152C106.366 190.169 105.569 189.372 104.586 189.372C103.603 189.372 102.806 190.169 102.806 191.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.6468 191.152C96.6468 192.135 97.4436 192.932 98.4265 192.932C99.4095 192.932 100.206 192.135 100.206 191.152C100.206 190.169 99.4095 189.372 98.4265 189.372C97.4436 189.372 96.6468 190.169 96.6468 191.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.4473 191.152C90.4473 192.135 91.2441 192.932 92.2271 192.932C93.21 192.932 94.0068 192.135 94.0068 191.152C94.0068 190.169 93.21 189.372 92.2271 189.372C91.2441 189.372 90.4473 190.169 90.4473 191.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.2884 191.152C84.2884 192.135 85.0852 192.932 86.0681 192.932C87.0511 192.932 87.8479 192.135 87.8479 191.152C87.8479 190.169 87.0511 189.372 86.0681 189.372C85.0852 189.372 84.2884 190.169 84.2884 191.152Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.119 191.157C78.119 192.14 78.9159 192.937 79.8988 192.937C80.8818 192.937 81.6786 192.14 81.6786 191.157C81.6786 190.174 80.8818 189.377 79.8988 189.377C78.9159 189.377 78.119 190.174 78.119 191.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M71.9597 191.157C71.9597 192.14 72.7566 192.937 73.7395 192.937C74.7225 192.937 75.5193 192.14 75.5193 191.157C75.5193 190.174 74.7225 189.377 73.7395 189.377C72.7566 189.377 71.9597 190.174 71.9597 191.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.7439 191.157C65.7439 192.14 66.5408 192.937 67.5237 192.937C68.5066 192.937 69.3035 192.14 69.3035 191.157C69.3035 190.174 68.5066 189.377 67.5237 189.377C66.5408 189.377 65.7439 190.174 65.7439 191.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.5846 191.157C59.5846 192.14 60.3815 192.937 61.3644 192.937C62.3473 192.937 63.1442 192.14 63.1442 191.157C63.1442 190.174 62.3473 189.377 61.3644 189.377C60.3815 189.377 59.5846 190.174 59.5846 191.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.4359 191.147C53.4359 192.13 54.2328 192.926 55.2157 192.926C56.1987 192.926 56.9955 192.13 56.9955 191.147C56.9955 190.164 56.1987 189.367 55.2157 189.367C54.2328 189.367 53.4359 190.164 53.4359 191.147Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.2768 191.147C47.2768 192.13 48.0736 192.926 49.0565 192.926C50.0395 192.926 50.8363 192.13 50.8363 191.147C50.8363 190.164 50.0395 189.367 49.0565 189.367C48.0736 189.367 47.2768 190.164 47.2768 191.147Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.0763 191.157C41.0763 192.14 41.8732 192.937 42.8561 192.937C43.839 192.937 44.6359 192.14 44.6359 191.157C44.6359 190.174 43.839 189.377 42.8561 189.377C41.8732 189.377 41.0763 190.174 41.0763 191.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M34.9174 191.157C34.9174 192.14 35.7142 192.937 36.6972 192.937C37.6801 192.937 38.4769 192.14 38.4769 191.157C38.4769 190.174 37.6801 189.377 36.6972 189.377C35.7142 189.377 34.9174 190.174 34.9174 191.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.7531 191.157C28.7531 192.14 29.5499 192.937 30.5329 192.937C31.5158 192.937 32.3126 192.14 32.3126 191.157C32.3126 190.174 31.5158 189.377 30.5329 189.377C29.5499 189.377 28.7531 190.174 28.7531 191.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.5941 191.157C22.5941 192.14 23.391 192.937 24.3739 192.937C25.3569 192.937 26.1537 192.14 26.1537 191.157C26.1537 190.174 25.3569 189.377 24.3739 189.377C23.391 189.377 22.5941 190.174 22.5941 191.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.3932 191.157C16.3932 192.14 17.19 192.937 18.173 192.937C19.1559 192.937 19.9528 192.14 19.9528 191.157C19.9528 190.174 19.1559 189.377 18.173 189.377C17.19 189.377 16.3932 190.174 16.3932 191.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.2344 191.157C10.2344 192.14 11.0312 192.937 12.0142 192.937C12.9971 192.937 13.7939 192.14 13.7939 191.157C13.7939 190.174 12.9971 189.377 12.0142 189.377C11.0312 189.377 10.2344 190.174 10.2344 191.157Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.654 201.712C152.654 202.695 153.451 203.492 154.434 203.492C155.417 203.492 156.213 202.695 156.213 201.712C156.213 200.729 155.417 199.932 154.434 199.932C153.451 199.932 152.654 200.729 152.654 201.712Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.172 222.846C152.172 223.829 152.968 224.626 153.951 224.626C154.934 224.626 155.731 223.829 155.731 222.846C155.731 221.863 154.934 221.066 153.951 221.066C152.968 221.066 152.172 221.863 152.172 222.846Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.172 233.448C152.172 234.431 152.968 235.228 153.951 235.228C154.934 235.228 155.731 234.431 155.731 233.448C155.731 232.465 154.934 231.668 153.951 231.668C152.968 231.668 152.172 232.465 152.172 233.448Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.172 254.412C152.172 255.395 152.968 256.191 153.951 256.191C154.934 256.191 155.731 255.395 155.731 254.412C155.731 253.429 154.934 252.632 153.951 252.632C152.968 252.632 152.172 253.429 152.172 254.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.183 264.958C152.183 265.941 152.98 266.738 153.963 266.738C154.946 266.738 155.743 265.941 155.743 264.958C155.743 263.975 154.946 263.178 153.963 263.178C152.98 263.178 152.183 263.975 152.183 264.958Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.598 96.8081C306.598 97.7911 307.395 98.5879 308.378 98.5879C309.361 98.5879 310.158 97.7911 310.158 96.8081C310.158 95.8252 309.361 95.0284 308.378 95.0284C307.395 95.0284 306.598 95.8252 306.598 96.8081Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.439 96.808C300.439 97.7909 301.236 98.5877 302.219 98.5877C303.202 98.5877 303.999 97.7909 303.999 96.808C303.999 95.825 303.202 95.0282 302.219 95.0282C301.236 95.0282 300.439 95.825 300.439 96.808Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.223 96.808C294.223 97.7909 295.02 98.5877 296.003 98.5877C296.986 98.5877 297.782 97.7909 297.782 96.808C297.782 95.825 296.986 95.0282 296.003 95.0282C295.02 95.0282 294.223 95.825 294.223 96.808Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.064 96.808C288.064 97.7909 288.861 98.5877 289.844 98.5877C290.827 98.5877 291.624 97.7909 291.624 96.808C291.624 95.825 290.827 95.0282 289.844 95.0282C288.861 95.0282 288.064 95.825 288.064 96.808Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.915 96.7989C281.915 97.7818 282.712 98.5787 283.695 98.5787C284.678 98.5787 285.475 97.7818 285.475 96.7989C285.475 95.8159 284.678 95.0191 283.695 95.0191C282.712 95.0191 281.915 95.8159 281.915 96.7989Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.756 96.7989C275.756 97.7818 276.553 98.5787 277.536 98.5787C278.519 98.5787 279.316 97.7818 279.316 96.7989C279.316 95.8159 278.519 95.0191 277.536 95.0191C276.553 95.0191 275.756 95.8159 275.756 96.7989Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.557 96.808C269.557 97.7909 270.354 98.5877 271.337 98.5877C272.32 98.5877 273.117 97.7909 273.117 96.808C273.117 95.825 272.32 95.0282 271.337 95.0282C270.354 95.0282 269.557 95.825 269.557 96.808Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.398 96.808C263.398 97.7909 264.195 98.5877 265.178 98.5877C266.161 98.5877 266.958 97.7909 266.958 96.808C266.958 95.825 266.161 95.0282 265.178 95.0282C264.195 95.0282 263.398 95.825 263.398 96.808Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.232 96.808C257.232 97.7909 258.029 98.5877 259.012 98.5877C259.995 98.5877 260.792 97.7909 260.792 96.808C260.792 95.825 259.995 95.0282 259.012 95.0282C258.029 95.0282 257.232 95.825 257.232 96.808Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.073 96.808C251.073 97.7909 251.87 98.5877 252.853 98.5877C253.836 98.5877 254.633 97.7909 254.633 96.808C254.633 95.825 253.836 95.0282 252.853 95.0282C251.87 95.0282 251.073 95.825 251.073 96.808Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.874 96.808C244.874 97.7909 245.671 98.5877 246.654 98.5877C247.637 98.5877 248.434 97.7909 248.434 96.808C248.434 95.825 247.637 95.0282 246.654 95.0282C245.671 95.0282 244.874 95.825 244.874 96.808Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.715 96.808C238.715 97.7909 239.512 98.5877 240.495 98.5877C241.478 98.5877 242.275 97.7909 242.275 96.808C242.275 95.825 241.478 95.0282 240.495 95.0282C239.512 95.0282 238.715 95.825 238.715 96.808Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.546 96.8132C232.546 97.7961 233.343 98.5929 234.325 98.5929C235.308 98.5929 236.105 97.7961 236.105 96.8132C236.105 95.8302 235.308 95.0334 234.325 95.0334C233.343 95.0334 232.546 95.8302 232.546 96.8132Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.387 96.8132C226.387 97.7961 227.183 98.5929 228.166 98.5929C229.149 98.5929 229.946 97.7961 229.946 96.8132C229.946 95.8302 229.149 95.0334 228.166 95.0334C227.183 95.0334 226.387 95.8302 226.387 96.8132Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.17 96.8132C220.17 97.7961 220.967 98.5929 221.95 98.5929C222.933 98.5929 223.73 97.7961 223.73 96.8132C223.73 95.8302 222.933 95.0334 221.95 95.0334C220.967 95.0334 220.17 95.8302 220.17 96.8132Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.012 96.8132C214.012 97.7961 214.808 98.5929 215.791 98.5929C216.774 98.5929 217.571 97.7961 217.571 96.8132C217.571 95.8302 216.774 95.0334 215.791 95.0334C214.808 95.0334 214.012 95.8302 214.012 96.8132Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.863 96.8041C207.863 97.787 208.66 98.5839 209.643 98.5839C210.626 98.5839 211.422 97.787 211.422 96.8041C211.422 95.8212 210.626 95.0243 209.643 95.0243C208.66 95.0243 207.863 95.8212 207.863 96.8041Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.703 96.8041C201.703 97.787 202.5 98.5839 203.483 98.5839C204.466 98.5839 205.263 97.787 205.263 96.8041C205.263 95.8212 204.466 95.0243 203.483 95.0243C202.5 95.0243 201.703 95.8212 201.703 96.8041Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.503 96.8132C195.503 97.7961 196.3 98.5929 197.282 98.5929C198.265 98.5929 199.062 97.7961 199.062 96.8132C199.062 95.8302 198.265 95.0334 197.282 95.0334C196.3 95.0334 195.503 95.8302 195.503 96.8132Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.344 96.8132C189.344 97.7961 190.141 98.5929 191.124 98.5929C192.106 98.5929 192.903 97.7961 192.903 96.8132C192.903 95.8302 192.106 95.0334 191.124 95.0334C190.141 95.0334 189.344 95.8302 189.344 96.8132Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.179 96.8132C183.179 97.7961 183.976 98.5929 184.959 98.5929C185.942 98.5929 186.739 97.7961 186.739 96.8132C186.739 95.8302 185.942 95.0334 184.959 95.0334C183.976 95.0334 183.179 95.8302 183.179 96.8132Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.021 96.8132C177.021 97.7961 177.818 98.5929 178.801 98.5929C179.783 98.5929 180.58 97.7961 180.58 96.8132C180.58 95.8302 179.783 95.0334 178.801 95.0334C177.818 95.0334 177.021 95.8302 177.021 96.8132Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.82 96.8132C170.82 97.7961 171.617 98.5929 172.6 98.5929C173.583 98.5929 174.38 97.7961 174.38 96.8132C174.38 95.8302 173.583 95.0334 172.6 95.0334C171.617 95.0334 170.82 95.8302 170.82 96.8132Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.661 96.8132C164.661 97.7961 165.458 98.5929 166.441 98.5929C167.424 98.5929 168.22 97.7961 168.22 96.8132C168.22 95.8302 167.424 95.0334 166.441 95.0334C165.458 95.0334 164.661 95.8302 164.661 96.8132Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.514 102.11C303.514 103.093 304.311 103.889 305.294 103.889C306.277 103.889 307.074 103.093 307.074 102.11C307.074 101.127 306.277 100.33 305.294 100.33C304.311 100.33 303.514 101.127 303.514 102.11Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.355 102.11C297.355 103.093 298.152 103.889 299.135 103.889C300.118 103.889 300.915 103.093 300.915 102.11C300.915 101.127 300.118 100.33 299.135 100.33C298.152 100.33 297.355 101.127 297.355 102.11Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.139 102.11C291.139 103.093 291.936 103.889 292.919 103.889C293.902 103.889 294.698 103.093 294.698 102.11C294.698 101.127 293.902 100.33 292.919 100.33C291.936 100.33 291.139 101.127 291.139 102.11Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.98 102.11C284.98 103.093 285.777 103.889 286.76 103.889C287.743 103.889 288.54 103.093 288.54 102.11C288.54 101.127 287.743 100.33 286.76 100.33C285.777 100.33 284.98 101.127 284.98 102.11Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.831 102.101C278.831 103.083 279.628 103.88 280.611 103.88C281.594 103.88 282.391 103.083 282.391 102.101C282.391 101.118 281.594 100.321 280.611 100.321C279.628 100.321 278.831 101.118 278.831 102.101Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.673 102.101C272.673 103.083 273.469 103.88 274.452 103.88C275.435 103.88 276.232 103.083 276.232 102.101C276.232 101.118 275.435 100.321 274.452 100.321C273.469 100.321 272.673 101.118 272.673 102.101Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.472 102.11C266.472 103.093 267.269 103.889 268.251 103.889C269.234 103.889 270.031 103.093 270.031 102.11C270.031 101.127 269.234 100.33 268.251 100.33C267.269 100.33 266.472 101.127 266.472 102.11Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.313 102.11C260.313 103.093 261.109 103.889 262.092 103.889C263.075 103.889 263.872 103.093 263.872 102.11C263.872 101.127 263.075 100.33 262.092 100.33C261.109 100.33 260.313 101.127 260.313 102.11Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.148 102.11C254.148 103.093 254.945 103.889 255.928 103.889C256.911 103.889 257.708 103.093 257.708 102.11C257.708 101.127 256.911 100.33 255.928 100.33C254.945 100.33 254.148 101.127 254.148 102.11Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.99 102.11C247.99 103.093 248.786 103.889 249.769 103.889C250.752 103.889 251.549 103.093 251.549 102.11C251.549 101.127 250.752 100.33 249.769 100.33C248.786 100.33 247.99 101.127 247.99 102.11Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.789 102.11C241.789 103.093 242.585 103.889 243.568 103.889C244.551 103.889 245.348 103.093 245.348 102.11C245.348 101.127 244.551 100.33 243.568 100.33C242.585 100.33 241.789 101.127 241.789 102.11Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.63 102.11C235.63 103.093 236.426 103.889 237.409 103.889C238.392 103.889 239.189 103.093 239.189 102.11C239.189 101.127 238.392 100.33 237.409 100.33C236.426 100.33 235.63 101.127 235.63 102.11Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.46 102.115C229.46 103.098 230.257 103.895 231.24 103.895C232.223 103.895 233.02 103.098 233.02 102.115C233.02 101.132 232.223 100.335 231.24 100.335C230.257 100.335 229.46 101.132 229.46 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.301 102.115C223.301 103.098 224.098 103.895 225.081 103.895C226.064 103.895 226.861 103.098 226.861 102.115C226.861 101.132 226.064 100.335 225.081 100.335C224.098 100.335 223.301 101.132 223.301 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.085 102.115C217.085 103.098 217.882 103.895 218.865 103.895C219.848 103.895 220.645 103.098 220.645 102.115C220.645 101.132 219.848 100.335 218.865 100.335C217.882 100.335 217.085 101.132 217.085 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.926 102.115C210.926 103.098 211.723 103.895 212.706 103.895C213.689 103.895 214.485 103.098 214.485 102.115C214.485 101.132 213.689 100.335 212.706 100.335C211.723 100.335 210.926 101.132 210.926 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.777 102.106C204.777 103.089 205.574 103.885 206.557 103.885C207.54 103.885 208.337 103.089 208.337 102.106C208.337 101.123 207.54 100.326 206.557 100.326C205.574 100.326 204.777 101.123 204.777 102.106Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.618 102.106C198.618 103.089 199.415 103.885 200.398 103.885C201.381 103.885 202.177 103.089 202.177 102.106C202.177 101.123 201.381 100.326 200.398 100.326C199.415 100.326 198.618 101.123 198.618 102.106Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.419 102.115C192.419 103.098 193.216 103.895 194.199 103.895C195.181 103.895 195.978 103.098 195.978 102.115C195.978 101.132 195.181 100.335 194.199 100.335C193.216 100.335 192.419 101.132 192.419 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.26 102.115C186.26 103.098 187.057 103.895 188.04 103.895C189.023 103.895 189.819 103.098 189.819 102.115C189.819 101.132 189.023 100.335 188.04 100.335C187.057 100.335 186.26 101.132 186.26 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.094 102.115C180.094 103.098 180.891 103.895 181.874 103.895C182.857 103.895 183.654 103.098 183.654 102.115C183.654 101.132 182.857 100.335 181.874 100.335C180.891 100.335 180.094 101.132 180.094 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.935 102.115C173.935 103.098 174.732 103.895 175.715 103.895C176.698 103.895 177.495 103.098 177.495 102.115C177.495 101.132 176.698 100.335 175.715 100.335C174.732 100.335 173.935 101.132 173.935 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.736 102.115C167.736 103.098 168.533 103.895 169.516 103.895C170.499 103.895 171.296 103.098 171.296 102.115C171.296 101.132 170.499 100.335 169.516 100.335C168.533 100.335 167.736 101.132 167.736 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.577 102.115C161.577 103.098 162.374 103.895 163.356 103.895C164.339 103.895 165.136 103.098 165.136 102.115C165.136 101.132 164.339 100.335 163.356 100.335C162.374 100.335 161.577 101.132 161.577 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.598 107.354C306.598 108.337 307.395 109.134 308.378 109.134C309.361 109.134 310.158 108.337 310.158 107.354C310.158 106.371 309.361 105.574 308.378 105.574C307.395 105.574 306.598 106.371 306.598 107.354Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.439 107.354C300.439 108.337 301.236 109.134 302.219 109.134C303.202 109.134 303.999 108.337 303.999 107.354C303.999 106.371 303.202 105.574 302.219 105.574C301.236 105.574 300.439 106.371 300.439 107.354Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.223 107.354C294.223 108.337 295.02 109.134 296.003 109.134C296.986 109.134 297.782 108.337 297.782 107.354C297.782 106.371 296.986 105.574 296.003 105.574C295.02 105.574 294.223 106.371 294.223 107.354Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.064 107.354C288.064 108.337 288.861 109.134 289.844 109.134C290.827 109.134 291.624 108.337 291.624 107.354C291.624 106.371 290.827 105.574 289.844 105.574C288.861 105.574 288.064 106.371 288.064 107.354Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.915 107.345C281.915 108.328 282.712 109.125 283.695 109.125C284.678 109.125 285.475 108.328 285.475 107.345C285.475 106.362 284.678 105.565 283.695 105.565C282.712 105.565 281.915 106.362 281.915 107.345Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.756 107.345C275.756 108.328 276.553 109.125 277.536 109.125C278.519 109.125 279.316 108.328 279.316 107.345C279.316 106.362 278.519 105.565 277.536 105.565C276.553 105.565 275.756 106.362 275.756 107.345Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.557 107.354C269.557 108.337 270.354 109.134 271.337 109.134C272.32 109.134 273.117 108.337 273.117 107.354C273.117 106.371 272.32 105.574 271.337 105.574C270.354 105.574 269.557 106.371 269.557 107.354Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.398 107.354C263.398 108.337 264.195 109.134 265.178 109.134C266.161 109.134 266.958 108.337 266.958 107.354C266.958 106.371 266.161 105.574 265.178 105.574C264.195 105.574 263.398 106.371 263.398 107.354Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.232 107.354C257.232 108.337 258.029 109.134 259.012 109.134C259.995 109.134 260.792 108.337 260.792 107.354C260.792 106.371 259.995 105.574 259.012 105.574C258.029 105.574 257.232 106.371 257.232 107.354Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.073 107.354C251.073 108.337 251.87 109.134 252.853 109.134C253.836 109.134 254.633 108.337 254.633 107.354C254.633 106.371 253.836 105.574 252.853 105.574C251.87 105.574 251.073 106.371 251.073 107.354Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.874 107.354C244.874 108.337 245.671 109.134 246.654 109.134C247.637 109.134 248.434 108.337 248.434 107.354C248.434 106.371 247.637 105.574 246.654 105.574C245.671 105.574 244.874 106.371 244.874 107.354Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.715 107.354C238.715 108.337 239.512 109.134 240.495 109.134C241.478 109.134 242.275 108.337 242.275 107.354C242.275 106.371 241.478 105.574 240.495 105.574C239.512 105.574 238.715 106.371 238.715 107.354Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.546 107.359C232.546 108.342 233.343 109.139 234.325 109.139C235.308 109.139 236.105 108.342 236.105 107.359C236.105 106.376 235.308 105.58 234.325 105.58C233.343 105.58 232.546 106.376 232.546 107.359Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.387 107.359C226.387 108.342 227.183 109.139 228.166 109.139C229.149 109.139 229.946 108.342 229.946 107.359C229.946 106.376 229.149 105.58 228.166 105.58C227.183 105.58 226.387 106.376 226.387 107.359Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.17 107.359C220.17 108.342 220.967 109.139 221.95 109.139C222.933 109.139 223.73 108.342 223.73 107.359C223.73 106.376 222.933 105.58 221.95 105.58C220.967 105.58 220.17 106.376 220.17 107.359Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.012 107.359C214.012 108.342 214.808 109.139 215.791 109.139C216.774 109.139 217.571 108.342 217.571 107.359C217.571 106.376 216.774 105.58 215.791 105.58C214.808 105.58 214.012 106.376 214.012 107.359Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.863 107.35C207.863 108.333 208.66 109.13 209.643 109.13C210.626 109.13 211.422 108.333 211.422 107.35C211.422 106.367 210.626 105.57 209.643 105.57C208.66 105.57 207.863 106.367 207.863 107.35Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.703 107.35C201.703 108.333 202.5 109.13 203.483 109.13C204.466 109.13 205.263 108.333 205.263 107.35C205.263 106.367 204.466 105.57 203.483 105.57C202.5 105.57 201.703 106.367 201.703 107.35Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.503 107.359C195.503 108.342 196.3 109.139 197.282 109.139C198.265 109.139 199.062 108.342 199.062 107.359C199.062 106.376 198.265 105.58 197.282 105.58C196.3 105.58 195.503 106.376 195.503 107.359Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.344 107.359C189.344 108.342 190.141 109.139 191.124 109.139C192.106 109.139 192.903 108.342 192.903 107.359C192.903 106.376 192.106 105.58 191.124 105.58C190.141 105.58 189.344 106.376 189.344 107.359Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.179 107.359C183.179 108.342 183.976 109.139 184.959 109.139C185.942 109.139 186.739 108.342 186.739 107.359C186.739 106.376 185.942 105.58 184.959 105.58C183.976 105.58 183.179 106.376 183.179 107.359Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.021 107.359C177.021 108.342 177.818 109.139 178.801 109.139C179.783 109.139 180.58 108.342 180.58 107.359C180.58 106.376 179.783 105.58 178.801 105.58C177.818 105.58 177.021 106.376 177.021 107.359Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.82 107.359C170.82 108.342 171.617 109.139 172.6 109.139C173.583 109.139 174.38 108.342 174.38 107.359C174.38 106.376 173.583 105.58 172.6 105.58C171.617 105.58 170.82 106.376 170.82 107.359Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.661 107.359C164.661 108.342 165.458 109.139 166.441 109.139C167.424 109.139 168.22 108.342 168.22 107.359C168.22 106.376 167.424 105.58 166.441 105.58C165.458 105.58 164.661 106.376 164.661 107.359Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.525 112.645C303.525 113.628 304.322 114.425 305.304 114.425C306.287 114.425 307.084 113.628 307.084 112.645C307.084 111.662 306.287 110.866 305.304 110.866C304.322 110.866 303.525 111.662 303.525 112.645Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.366 112.645C297.366 113.628 298.163 114.425 299.146 114.425C300.128 114.425 300.925 113.628 300.925 112.645C300.925 111.662 300.128 110.866 299.146 110.866C298.163 110.866 297.366 111.662 297.366 112.645Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.149 112.645C291.149 113.628 291.946 114.425 292.929 114.425C293.912 114.425 294.709 113.628 294.709 112.645C294.709 111.662 293.912 110.866 292.929 110.866C291.946 110.866 291.149 111.662 291.149 112.645Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.99 112.645C284.99 113.628 285.787 114.425 286.77 114.425C287.753 114.425 288.55 113.628 288.55 112.645C288.55 111.662 287.753 110.866 286.77 110.866C285.787 110.866 284.99 111.662 284.99 112.645Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.842 112.635C278.842 113.618 279.639 114.415 280.622 114.415C281.605 114.415 282.401 113.618 282.401 112.635C282.401 111.652 281.605 110.855 280.622 110.855C279.639 110.855 278.842 111.652 278.842 112.635Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.682 112.635C272.682 113.618 273.479 114.415 274.462 114.415C275.445 114.415 276.242 113.618 276.242 112.635C276.242 111.652 275.445 110.855 274.462 110.855C273.479 110.855 272.682 111.652 272.682 112.635Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.483 112.645C266.483 113.628 267.28 114.425 268.263 114.425C269.246 114.425 270.043 113.628 270.043 112.645C270.043 111.662 269.246 110.866 268.263 110.866C267.28 110.866 266.483 111.662 266.483 112.645Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.324 112.645C260.324 113.628 261.121 114.425 262.104 114.425C263.087 114.425 263.884 113.628 263.884 112.645C263.884 111.662 263.087 110.866 262.104 110.866C261.121 110.866 260.324 111.662 260.324 112.645Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.159 112.645C254.159 113.628 254.956 114.425 255.938 114.425C256.921 114.425 257.718 113.628 257.718 112.645C257.718 111.662 256.921 110.866 255.938 110.866C254.956 110.866 254.159 111.662 254.159 112.645Z"
            fill="#B8B7B7"
          />
          <path
            d="M248 112.645C248 113.628 248.797 114.425 249.78 114.425C250.763 114.425 251.56 113.628 251.56 112.645C251.56 111.662 250.763 110.866 249.78 110.866C248.797 110.866 248 111.662 248 112.645Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.8 112.645C241.8 113.628 242.597 114.425 243.58 114.425C244.563 114.425 245.36 113.628 245.36 112.645C245.36 111.662 244.563 110.866 243.58 110.866C242.597 110.866 241.8 111.662 241.8 112.645Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.641 112.645C235.641 113.628 236.438 114.425 237.421 114.425C238.404 114.425 239.201 113.628 239.201 112.645C239.201 111.662 238.404 110.866 237.421 110.866C236.438 110.866 235.641 111.662 235.641 112.645Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.47 112.649C229.47 113.632 230.267 114.429 231.25 114.429C232.233 114.429 233.03 113.632 233.03 112.649C233.03 111.666 232.233 110.869 231.25 110.869C230.267 110.869 229.47 111.666 229.47 112.649Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.312 112.649C223.312 113.632 224.108 114.429 225.091 114.429C226.074 114.429 226.871 113.632 226.871 112.649C226.871 111.666 226.074 110.869 225.091 110.869C224.108 110.869 223.312 111.666 223.312 112.649Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.095 112.649C217.095 113.632 217.892 114.429 218.875 114.429C219.858 114.429 220.655 113.632 220.655 112.649C220.655 111.666 219.858 110.869 218.875 110.869C217.892 110.869 217.095 111.666 217.095 112.649Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.938 112.649C210.938 113.632 211.735 114.429 212.718 114.429C213.7 114.429 214.497 113.632 214.497 112.649C214.497 111.666 213.7 110.869 212.718 110.869C211.735 110.869 210.938 111.666 210.938 112.649Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.788 112.64C204.788 113.623 205.584 114.42 206.567 114.42C207.55 114.42 208.347 113.623 208.347 112.64C208.347 111.657 207.55 110.86 206.567 110.86C205.584 110.86 204.788 111.657 204.788 112.64Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.629 112.64C198.629 113.623 199.426 114.42 200.408 114.42C201.391 114.42 202.188 113.623 202.188 112.64C202.188 111.657 201.391 110.86 200.408 110.86C199.426 110.86 198.629 111.657 198.629 112.64Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.429 112.649C192.429 113.632 193.226 114.429 194.209 114.429C195.192 114.429 195.989 113.632 195.989 112.649C195.989 111.666 195.192 110.869 194.209 110.869C193.226 110.869 192.429 111.666 192.429 112.649Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.27 112.649C186.27 113.632 187.067 114.429 188.05 114.429C189.033 114.429 189.83 113.632 189.83 112.649C189.83 111.666 189.033 110.869 188.05 110.869C187.067 110.869 186.27 111.666 186.27 112.649Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.105 112.649C180.105 113.632 180.902 114.429 181.885 114.429C182.868 114.429 183.665 113.632 183.665 112.649C183.665 111.666 182.868 110.869 181.885 110.869C180.902 110.869 180.105 111.666 180.105 112.649Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.946 112.649C173.946 113.632 174.742 114.429 175.725 114.429C176.708 114.429 177.505 113.632 177.505 112.649C177.505 111.666 176.708 110.869 175.725 110.869C174.742 110.869 173.946 111.666 173.946 112.649Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.747 112.649C167.747 113.632 168.543 114.429 169.526 114.429C170.509 114.429 171.306 113.632 171.306 112.649C171.306 111.666 170.509 110.869 169.526 110.869C168.543 110.869 167.747 111.666 167.747 112.649Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.587 112.649C161.587 113.632 162.384 114.429 163.367 114.429C164.35 114.429 165.147 113.632 165.147 112.649C165.147 111.666 164.35 110.869 163.367 110.869C162.384 110.869 161.587 111.666 161.587 112.649Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.439 117.946C300.439 118.929 301.236 119.725 302.219 119.725C303.202 119.725 303.999 118.929 303.999 117.946C303.999 116.963 303.202 116.166 302.219 116.166C301.236 116.166 300.439 116.963 300.439 117.946Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.282 117.946C294.282 118.929 295.079 119.725 296.062 119.725C297.044 119.725 297.841 118.929 297.841 117.946C297.841 116.963 297.044 116.166 296.062 116.166C295.079 116.166 294.282 116.963 294.282 117.946Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.064 117.946C288.064 118.929 288.861 119.725 289.844 119.725C290.827 119.725 291.624 118.929 291.624 117.946C291.624 116.963 290.827 116.166 289.844 116.166C288.861 116.166 288.064 116.963 288.064 117.946Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.906 117.946C281.906 118.929 282.703 119.725 283.686 119.725C284.669 119.725 285.466 118.929 285.466 117.946C285.466 116.963 284.669 116.166 283.686 116.166C282.703 116.166 281.906 116.963 281.906 117.946Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.756 117.937C275.756 118.92 276.553 119.716 277.536 119.716C278.519 119.716 279.316 118.92 279.316 117.937C279.316 116.954 278.519 116.157 277.536 116.157C276.553 116.157 275.756 116.954 275.756 117.937Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.598 117.937C269.598 118.92 270.395 119.716 271.378 119.716C272.361 119.716 273.158 118.92 273.158 117.937C273.158 116.954 272.361 116.157 271.378 116.157C270.395 116.157 269.598 116.954 269.598 117.937Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.398 117.946C263.398 118.929 264.195 119.725 265.178 119.725C266.161 119.725 266.958 118.929 266.958 117.946C266.958 116.963 266.161 116.166 265.178 116.166C264.195 116.166 263.398 116.963 263.398 117.946Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.239 117.946C257.239 118.929 258.036 119.725 259.019 119.725C260.002 119.725 260.799 118.929 260.799 117.946C260.799 116.963 260.002 116.166 259.019 116.166C258.036 116.166 257.239 116.963 257.239 117.946Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.073 117.946C251.073 118.929 251.87 119.725 252.853 119.725C253.836 119.725 254.633 118.929 254.633 117.946C254.633 116.963 253.836 116.166 252.853 116.166C251.87 116.166 251.073 116.963 251.073 117.946Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.916 117.946C244.916 118.929 245.713 119.725 246.696 119.725C247.679 119.725 248.475 118.929 248.475 117.946C248.475 116.963 247.679 116.166 246.696 116.166C245.713 116.166 244.916 116.963 244.916 117.946Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.715 117.946C238.715 118.929 239.512 119.725 240.495 119.725C241.478 119.725 242.275 118.929 242.275 117.946C242.275 116.963 241.478 116.166 240.495 116.166C239.512 116.166 238.715 116.963 238.715 117.946Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.556 117.946C232.556 118.929 233.353 119.725 234.336 119.725C235.319 119.725 236.115 118.929 236.115 117.946C236.115 116.963 235.319 116.166 234.336 116.166C233.353 116.166 232.556 116.963 232.556 117.946Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.387 117.951C226.387 118.934 227.183 119.731 228.166 119.731C229.149 119.731 229.946 118.934 229.946 117.951C229.946 116.968 229.149 116.171 228.166 116.171C227.183 116.171 226.387 116.968 226.387 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.227 117.951C220.227 118.934 221.024 119.731 222.007 119.731C222.99 119.731 223.787 118.934 223.787 117.951C223.787 116.968 222.99 116.171 222.007 116.171C221.024 116.171 220.227 116.968 220.227 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.012 117.951C214.012 118.934 214.808 119.731 215.791 119.731C216.774 119.731 217.571 118.934 217.571 117.951C217.571 116.968 216.774 116.171 215.791 116.171C214.808 116.171 214.012 116.968 214.012 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.852 117.951C207.852 118.934 208.649 119.731 209.632 119.731C210.615 119.731 211.412 118.934 211.412 117.951C211.412 116.968 210.615 116.171 209.632 116.171C208.649 116.171 207.852 116.968 207.852 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.703 117.942C201.703 118.925 202.5 119.722 203.483 119.722C204.466 119.722 205.263 118.925 205.263 117.942C205.263 116.959 204.466 116.162 203.483 116.162C202.5 116.162 201.703 116.959 201.703 117.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.544 117.942C195.544 118.925 196.341 119.722 197.324 119.722C198.307 119.722 199.104 118.925 199.104 117.942C199.104 116.959 198.307 116.162 197.324 116.162C196.341 116.162 195.544 116.959 195.544 117.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.344 117.951C189.344 118.934 190.141 119.731 191.124 119.731C192.106 119.731 192.903 118.934 192.903 117.951C192.903 116.968 192.106 116.171 191.124 116.171C190.141 116.171 189.344 116.968 189.344 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.185 117.951C183.185 118.934 183.982 119.731 184.965 119.731C185.948 119.731 186.745 118.934 186.745 117.951C186.745 116.968 185.948 116.171 184.965 116.171C183.982 116.171 183.185 116.968 183.185 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.021 117.951C177.021 118.934 177.818 119.731 178.801 119.731C179.783 119.731 180.58 118.934 180.58 117.951C180.58 116.968 179.783 116.171 178.801 116.171C177.818 116.171 177.021 116.968 177.021 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.861 117.951C170.861 118.934 171.658 119.731 172.641 119.731C173.624 119.731 174.421 118.934 174.421 117.951C174.421 116.968 173.624 116.171 172.641 116.171C171.658 116.171 170.861 116.968 170.861 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.661 117.951C164.661 118.934 165.458 119.731 166.441 119.731C167.424 119.731 168.22 118.934 168.22 117.951C168.22 116.968 167.424 116.171 166.441 116.171C165.458 116.171 164.661 116.968 164.661 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.502 117.951C158.502 118.934 159.299 119.731 160.282 119.731C161.265 119.731 162.062 118.934 162.062 117.951C162.062 116.968 161.265 116.171 160.282 116.171C159.299 116.171 158.502 116.968 158.502 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.525 123.191C303.525 124.174 304.322 124.971 305.304 124.971C306.287 124.971 307.084 124.174 307.084 123.191C307.084 122.209 306.287 121.412 305.304 121.412C304.322 121.412 303.525 122.209 303.525 123.191Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.366 123.191C297.366 124.174 298.163 124.971 299.146 124.971C300.128 124.971 300.925 124.174 300.925 123.191C300.925 122.209 300.128 121.412 299.146 121.412C298.163 121.412 297.366 122.209 297.366 123.191Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.149 123.191C291.149 124.174 291.946 124.971 292.929 124.971C293.912 124.971 294.709 124.174 294.709 123.191C294.709 122.209 293.912 121.412 292.929 121.412C291.946 121.412 291.149 122.209 291.149 123.191Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.99 123.191C284.99 124.174 285.787 124.971 286.77 124.971C287.753 124.971 288.55 124.174 288.55 123.191C288.55 122.209 287.753 121.412 286.77 121.412C285.787 121.412 284.99 122.209 284.99 123.191Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.842 123.181C278.842 124.164 279.639 124.961 280.622 124.961C281.605 124.961 282.401 124.164 282.401 123.181C282.401 122.198 281.605 121.401 280.622 121.401C279.639 121.401 278.842 122.198 278.842 123.181Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.682 123.181C272.682 124.164 273.479 124.961 274.462 124.961C275.445 124.961 276.242 124.164 276.242 123.181C276.242 122.198 275.445 121.401 274.462 121.401C273.479 121.401 272.682 122.198 272.682 123.181Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.483 123.191C266.483 124.174 267.28 124.971 268.263 124.971C269.246 124.971 270.043 124.174 270.043 123.191C270.043 122.209 269.246 121.412 268.263 121.412C267.28 121.412 266.483 122.209 266.483 123.191Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.324 123.191C260.324 124.174 261.121 124.971 262.104 124.971C263.087 124.971 263.884 124.174 263.884 123.191C263.884 122.209 263.087 121.412 262.104 121.412C261.121 121.412 260.324 122.209 260.324 123.191Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.159 123.191C254.159 124.174 254.956 124.971 255.938 124.971C256.921 124.971 257.718 124.174 257.718 123.191C257.718 122.209 256.921 121.412 255.938 121.412C254.956 121.412 254.159 122.209 254.159 123.191Z"
            fill="#B8B7B7"
          />
          <path
            d="M248 123.191C248 124.174 248.797 124.971 249.78 124.971C250.763 124.971 251.56 124.174 251.56 123.191C251.56 122.209 250.763 121.412 249.78 121.412C248.797 121.412 248 122.209 248 123.191Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.8 123.191C241.8 124.174 242.597 124.971 243.58 124.971C244.563 124.971 245.36 124.174 245.36 123.191C245.36 122.209 244.563 121.412 243.58 121.412C242.597 121.412 241.8 122.209 241.8 123.191Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.641 123.191C235.641 124.174 236.438 124.971 237.421 124.971C238.404 124.971 239.201 124.174 239.201 123.191C239.201 122.209 238.404 121.412 237.421 121.412C236.438 121.412 235.641 122.209 235.641 123.191Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.47 123.195C229.47 124.178 230.267 124.975 231.25 124.975C232.233 124.975 233.03 124.178 233.03 123.195C233.03 122.212 232.233 121.416 231.25 121.416C230.267 121.416 229.47 122.212 229.47 123.195Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.312 123.195C223.312 124.178 224.108 124.975 225.091 124.975C226.074 124.975 226.871 124.178 226.871 123.195C226.871 122.212 226.074 121.416 225.091 121.416C224.108 121.416 223.312 122.212 223.312 123.195Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.095 123.195C217.095 124.178 217.892 124.975 218.875 124.975C219.858 124.975 220.655 124.178 220.655 123.195C220.655 122.212 219.858 121.416 218.875 121.416C217.892 121.416 217.095 122.212 217.095 123.195Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.938 123.195C210.938 124.178 211.735 124.975 212.718 124.975C213.7 124.975 214.497 124.178 214.497 123.195C214.497 122.212 213.7 121.416 212.718 121.416C211.735 121.416 210.938 122.212 210.938 123.195Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.788 123.186C204.788 124.169 205.584 124.966 206.567 124.966C207.55 124.966 208.347 124.169 208.347 123.186C208.347 122.203 207.55 121.407 206.567 121.407C205.584 121.407 204.788 122.203 204.788 123.186Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.629 123.186C198.629 124.169 199.426 124.966 200.408 124.966C201.391 124.966 202.188 124.169 202.188 123.186C202.188 122.203 201.391 121.407 200.408 121.407C199.426 121.407 198.629 122.203 198.629 123.186Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.429 123.195C192.429 124.178 193.226 124.975 194.209 124.975C195.192 124.975 195.989 124.178 195.989 123.195C195.989 122.212 195.192 121.416 194.209 121.416C193.226 121.416 192.429 122.212 192.429 123.195Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.27 123.195C186.27 124.178 187.067 124.975 188.05 124.975C189.033 124.975 189.83 124.178 189.83 123.195C189.83 122.212 189.033 121.416 188.05 121.416C187.067 121.416 186.27 122.212 186.27 123.195Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.105 123.195C180.105 124.178 180.902 124.975 181.885 124.975C182.868 124.975 183.665 124.178 183.665 123.195C183.665 122.212 182.868 121.416 181.885 121.416C180.902 121.416 180.105 122.212 180.105 123.195Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.946 123.195C173.946 124.178 174.742 124.975 175.725 124.975C176.708 124.975 177.505 124.178 177.505 123.195C177.505 122.212 176.708 121.416 175.725 121.416C174.742 121.416 173.946 122.212 173.946 123.195Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.747 123.195C167.747 124.178 168.543 124.975 169.526 124.975C170.509 124.975 171.306 124.178 171.306 123.195C171.306 122.212 170.509 121.416 169.526 121.416C168.543 121.416 167.747 122.212 167.747 123.195Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.587 123.195C161.587 124.178 162.384 124.975 163.367 124.975C164.35 124.975 165.147 124.178 165.147 123.195C165.147 122.212 164.35 121.416 163.367 121.416C162.384 121.416 161.587 122.212 161.587 123.195Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.598 117.918C306.598 118.901 307.395 119.698 308.378 119.698C309.361 119.698 310.158 118.901 310.158 117.918C310.158 116.935 309.361 116.139 308.378 116.139C307.395 116.139 306.598 116.935 306.598 117.918Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 128.554C306.603 129.537 307.4 130.334 308.383 130.334C309.366 130.334 310.163 129.537 310.163 128.554C310.163 127.571 309.366 126.774 308.383 126.774C307.4 126.774 306.603 127.571 306.603 128.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 128.554C300.446 129.537 301.243 130.334 302.226 130.334C303.209 130.334 304.005 129.537 304.005 128.554C304.005 127.571 303.209 126.774 302.226 126.774C301.243 126.774 300.446 127.571 300.446 128.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.23 128.554C294.23 129.537 295.026 130.334 296.009 130.334C296.992 130.334 297.789 129.537 297.789 128.554C297.789 127.571 296.992 126.774 296.009 126.774C295.026 126.774 294.23 127.571 294.23 128.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 128.554C288.07 129.537 288.867 130.334 289.85 130.334C290.833 130.334 291.63 129.537 291.63 128.554C291.63 127.571 290.833 126.774 289.85 126.774C288.867 126.774 288.07 127.571 288.07 128.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.92 128.545C281.92 129.528 282.717 130.325 283.7 130.325C284.683 130.325 285.48 129.528 285.48 128.545C285.48 127.562 284.683 126.765 283.7 126.765C282.717 126.765 281.92 127.562 281.92 128.545Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 128.545C275.763 129.528 276.56 130.325 277.542 130.325C278.525 130.325 279.322 129.528 279.322 128.545C279.322 127.562 278.525 126.765 277.542 126.765C276.56 126.765 275.763 127.562 275.763 128.545Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.562 128.554C269.562 129.537 270.359 130.334 271.342 130.334C272.325 130.334 273.122 129.537 273.122 128.554C273.122 127.571 272.325 126.774 271.342 126.774C270.359 126.774 269.562 127.571 269.562 128.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 128.554C263.403 129.537 264.2 130.334 265.183 130.334C266.166 130.334 266.963 129.537 266.963 128.554C266.963 127.571 266.166 126.774 265.183 126.774C264.2 126.774 263.403 127.571 263.403 128.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.238 128.554C257.238 129.537 258.034 130.334 259.017 130.334C260 130.334 260.797 129.537 260.797 128.554C260.797 127.571 260 126.774 259.017 126.774C258.034 126.774 257.238 127.571 257.238 128.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 128.554C251.08 129.537 251.876 130.334 252.859 130.334C253.842 130.334 254.639 129.537 254.639 128.554C254.639 127.571 253.842 126.774 252.859 126.774C251.876 126.774 251.08 127.571 251.08 128.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.879 128.554C244.879 129.537 245.676 130.334 246.659 130.334C247.642 130.334 248.439 129.537 248.439 128.554C248.439 127.571 247.642 126.774 246.659 126.774C245.676 126.774 244.879 127.571 244.879 128.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 128.554C238.72 129.537 239.517 130.334 240.5 130.334C241.483 130.334 242.28 129.537 242.28 128.554C242.28 127.571 241.483 126.774 240.5 126.774C239.517 126.774 238.72 127.571 238.72 128.554Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.551 128.559C232.551 129.542 233.348 130.339 234.331 130.339C235.314 130.339 236.111 129.542 236.111 128.559C236.111 127.576 235.314 126.78 234.331 126.78C233.348 126.78 232.551 127.576 232.551 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 128.559C226.392 129.542 227.189 130.339 228.172 130.339C229.155 130.339 229.951 129.542 229.951 128.559C229.951 127.576 229.155 126.78 228.172 126.78C227.189 126.78 226.392 127.576 226.392 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.175 128.559C220.175 129.542 220.972 130.339 221.955 130.339C222.938 130.339 223.735 129.542 223.735 128.559C223.735 127.576 222.938 126.78 221.955 126.78C220.972 126.78 220.175 127.576 220.175 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 128.559C214.017 129.542 214.813 130.339 215.796 130.339C216.779 130.339 217.576 129.542 217.576 128.559C217.576 127.576 216.779 126.78 215.796 126.78C214.813 126.78 214.017 127.576 214.017 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.868 128.549C207.868 129.532 208.665 130.329 209.648 130.329C210.631 130.329 211.427 129.532 211.427 128.549C211.427 127.566 210.631 126.769 209.648 126.769C208.665 126.769 207.868 127.566 207.868 128.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 128.549C201.709 129.532 202.506 130.329 203.489 130.329C204.471 130.329 205.268 129.532 205.268 128.549C205.268 127.566 204.471 126.769 203.489 126.769C202.506 126.769 201.709 127.566 201.709 128.549Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.508 128.559C195.508 129.542 196.305 130.339 197.288 130.339C198.271 130.339 199.068 129.542 199.068 128.559C199.068 127.576 198.271 126.78 197.288 126.78C196.305 126.78 195.508 127.576 195.508 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 128.559C189.349 129.542 190.146 130.339 191.129 130.339C192.112 130.339 192.908 129.542 192.908 128.559C192.908 127.576 192.112 126.78 191.129 126.78C190.146 126.78 189.349 127.576 189.349 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.185 128.559C183.185 129.542 183.982 130.339 184.965 130.339C185.948 130.339 186.745 129.542 186.745 128.559C186.745 127.576 185.948 126.78 184.965 126.78C183.982 126.78 183.185 127.576 183.185 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 128.559C177.026 129.542 177.823 130.339 178.806 130.339C179.789 130.339 180.585 129.542 180.585 128.559C180.585 127.576 179.789 126.78 178.806 126.78C177.823 126.78 177.026 127.576 177.026 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.825 128.559C170.825 129.542 171.622 130.339 172.605 130.339C173.588 130.339 174.385 129.542 174.385 128.559C174.385 127.576 173.588 126.78 172.605 126.78C171.622 126.78 170.825 127.576 170.825 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 128.559C164.666 129.542 165.463 130.339 166.446 130.339C167.429 130.339 168.225 129.542 168.225 128.559C168.225 127.576 167.429 126.78 166.446 126.78C165.463 126.78 164.666 127.576 164.666 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.519 133.856C303.519 134.839 304.316 135.636 305.299 135.636C306.282 135.636 307.079 134.839 307.079 133.856C307.079 132.873 306.282 132.076 305.299 132.076C304.316 132.076 303.519 132.873 303.519 133.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.36 133.856C297.36 134.839 298.157 135.636 299.14 135.636C300.123 135.636 300.92 134.839 300.92 133.856C300.92 132.873 300.123 132.076 299.14 132.076C298.157 132.076 297.36 132.873 297.36 133.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.144 133.856C291.144 134.839 291.941 135.636 292.924 135.636C293.907 135.636 294.704 134.839 294.704 133.856C294.704 132.873 293.907 132.076 292.924 132.076C291.941 132.076 291.144 132.873 291.144 133.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.985 133.856C284.985 134.839 285.782 135.636 286.765 135.636C287.748 135.636 288.545 134.839 288.545 133.856C288.545 132.873 287.748 132.076 286.765 132.076C285.782 132.076 284.985 132.873 284.985 133.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.836 133.845C278.836 134.828 279.633 135.625 280.616 135.625C281.599 135.625 282.396 134.828 282.396 133.845C282.396 132.862 281.599 132.066 280.616 132.066C279.633 132.066 278.836 132.862 278.836 133.845Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.678 133.845C272.678 134.828 273.474 135.625 274.457 135.625C275.44 135.625 276.237 134.828 276.237 133.845C276.237 132.862 275.44 132.066 274.457 132.066C273.474 132.066 272.678 132.862 272.678 133.845Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.477 133.856C266.477 134.839 267.274 135.636 268.257 135.636C269.24 135.636 270.036 134.839 270.036 133.856C270.036 132.873 269.24 132.076 268.257 132.076C267.274 132.076 266.477 132.873 266.477 133.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.318 133.856C260.318 134.839 261.115 135.636 262.098 135.636C263.081 135.636 263.878 134.839 263.878 133.856C263.878 132.873 263.081 132.076 262.098 132.076C261.115 132.076 260.318 132.873 260.318 133.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.153 133.856C254.153 134.839 254.95 135.636 255.933 135.636C256.916 135.636 257.713 134.839 257.713 133.856C257.713 132.873 256.916 132.076 255.933 132.076C254.95 132.076 254.153 132.873 254.153 133.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.995 133.856C247.995 134.839 248.791 135.636 249.774 135.636C250.757 135.636 251.554 134.839 251.554 133.856C251.554 132.873 250.757 132.076 249.774 132.076C248.791 132.076 247.995 132.873 247.995 133.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.794 133.856C241.794 134.839 242.591 135.636 243.574 135.636C244.557 135.636 245.354 134.839 245.354 133.856C245.354 132.873 244.557 132.076 243.574 132.076C242.591 132.076 241.794 132.873 241.794 133.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.635 133.856C235.635 134.839 236.432 135.636 237.415 135.636C238.398 135.636 239.195 134.839 239.195 133.856C239.195 132.873 238.398 132.076 237.415 132.076C236.432 132.076 235.635 132.873 235.635 133.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.466 133.86C229.466 134.843 230.262 135.639 231.245 135.639C232.228 135.639 233.025 134.843 233.025 133.86C233.025 132.877 232.228 132.08 231.245 132.08C230.262 132.08 229.466 132.877 229.466 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.306 133.86C223.306 134.843 224.103 135.639 225.086 135.639C226.069 135.639 226.866 134.843 226.866 133.86C226.866 132.877 226.069 132.08 225.086 132.08C224.103 132.08 223.306 132.877 223.306 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.09 133.86C217.09 134.843 217.887 135.639 218.87 135.639C219.853 135.639 220.65 134.843 220.65 133.86C220.65 132.877 219.853 132.08 218.87 132.08C217.887 132.08 217.09 132.877 217.09 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.931 133.86C210.931 134.843 211.728 135.639 212.711 135.639C213.694 135.639 214.49 134.843 214.49 133.86C214.49 132.877 213.694 132.08 212.711 132.08C211.728 132.08 210.931 132.877 210.931 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.782 133.851C204.782 134.834 205.579 135.63 206.562 135.63C207.545 135.63 208.342 134.834 208.342 133.851C208.342 132.868 207.545 132.071 206.562 132.071C205.579 132.071 204.782 132.868 204.782 133.851Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.624 133.851C198.624 134.834 199.42 135.63 200.403 135.63C201.386 135.63 202.183 134.834 202.183 133.851C202.183 132.868 201.386 132.071 200.403 132.071C199.42 132.071 198.624 132.868 198.624 133.851Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.424 133.86C192.424 134.843 193.221 135.639 194.204 135.639C195.187 135.639 195.984 134.843 195.984 133.86C195.984 132.877 195.187 132.08 194.204 132.08C193.221 132.08 192.424 132.877 192.424 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.265 133.86C186.265 134.843 187.062 135.639 188.045 135.639C189.028 135.639 189.825 134.843 189.825 133.86C189.825 132.877 189.028 132.08 188.045 132.08C187.062 132.08 186.265 132.877 186.265 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.099 133.86C180.099 134.843 180.896 135.639 181.879 135.639C182.862 135.639 183.659 134.843 183.659 133.86C183.659 132.877 182.862 132.08 181.879 132.08C180.896 132.08 180.099 132.877 180.099 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.94 133.86C173.94 134.843 174.737 135.639 175.72 135.639C176.703 135.639 177.5 134.843 177.5 133.86C177.5 132.877 176.703 132.08 175.72 132.08C174.737 132.08 173.94 132.877 173.94 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.741 133.86C167.741 134.843 168.538 135.639 169.521 135.639C170.504 135.639 171.301 134.843 171.301 133.86C171.301 132.877 170.504 132.08 169.521 132.08C168.538 132.08 167.741 132.877 167.741 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.582 133.86C161.582 134.843 162.379 135.639 163.362 135.639C164.345 135.639 165.142 134.843 165.142 133.86C165.142 132.877 164.345 132.08 163.362 132.08C162.379 132.08 161.582 132.877 161.582 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 139.1C306.603 140.083 307.4 140.88 308.383 140.88C309.366 140.88 310.163 140.083 310.163 139.1C310.163 138.117 309.366 137.321 308.383 137.321C307.4 137.321 306.603 138.117 306.603 139.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 139.1C300.446 140.083 301.243 140.88 302.226 140.88C303.209 140.88 304.005 140.083 304.005 139.1C304.005 138.117 303.209 137.321 302.226 137.321C301.243 137.321 300.446 138.117 300.446 139.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.23 139.1C294.23 140.083 295.026 140.88 296.009 140.88C296.992 140.88 297.789 140.083 297.789 139.1C297.789 138.117 296.992 137.321 296.009 137.321C295.026 137.321 294.23 138.117 294.23 139.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 139.1C288.07 140.083 288.867 140.88 289.85 140.88C290.833 140.88 291.63 140.083 291.63 139.1C291.63 138.117 290.833 137.321 289.85 137.321C288.867 137.321 288.07 138.117 288.07 139.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.92 139.091C281.92 140.074 282.717 140.871 283.7 140.871C284.683 140.871 285.48 140.074 285.48 139.091C285.48 138.108 284.683 137.311 283.7 137.311C282.717 137.311 281.92 138.108 281.92 139.091Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 139.091C275.763 140.074 276.56 140.871 277.542 140.871C278.525 140.871 279.322 140.074 279.322 139.091C279.322 138.108 278.525 137.311 277.542 137.311C276.56 137.311 275.763 138.108 275.763 139.091Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.562 139.1C269.562 140.083 270.359 140.88 271.342 140.88C272.325 140.88 273.122 140.083 273.122 139.1C273.122 138.117 272.325 137.321 271.342 137.321C270.359 137.321 269.562 138.117 269.562 139.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 139.1C263.403 140.083 264.2 140.88 265.183 140.88C266.166 140.88 266.963 140.083 266.963 139.1C266.963 138.117 266.166 137.321 265.183 137.321C264.2 137.321 263.403 138.117 263.403 139.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.238 139.1C257.238 140.083 258.034 140.88 259.017 140.88C260 140.88 260.797 140.083 260.797 139.1C260.797 138.117 260 137.321 259.017 137.321C258.034 137.321 257.238 138.117 257.238 139.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 139.1C251.08 140.083 251.876 140.88 252.859 140.88C253.842 140.88 254.639 140.083 254.639 139.1C254.639 138.117 253.842 137.321 252.859 137.321C251.876 137.321 251.08 138.117 251.08 139.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.879 139.1C244.879 140.083 245.676 140.88 246.659 140.88C247.642 140.88 248.439 140.083 248.439 139.1C248.439 138.117 247.642 137.321 246.659 137.321C245.676 137.321 244.879 138.117 244.879 139.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 139.1C238.72 140.083 239.517 140.88 240.5 140.88C241.483 140.88 242.28 140.083 242.28 139.1C242.28 138.117 241.483 137.321 240.5 137.321C239.517 137.321 238.72 138.117 238.72 139.1Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.551 139.104C232.551 140.087 233.348 140.884 234.331 140.884C235.314 140.884 236.111 140.087 236.111 139.104C236.111 138.121 235.314 137.324 234.331 137.324C233.348 137.324 232.551 138.121 232.551 139.104Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 139.104C226.392 140.087 227.189 140.884 228.172 140.884C229.155 140.884 229.951 140.087 229.951 139.104C229.951 138.121 229.155 137.324 228.172 137.324C227.189 137.324 226.392 138.121 226.392 139.104Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.175 139.104C220.175 140.087 220.972 140.884 221.955 140.884C222.938 140.884 223.735 140.087 223.735 139.104C223.735 138.121 222.938 137.324 221.955 137.324C220.972 137.324 220.175 138.121 220.175 139.104Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 139.104C214.017 140.087 214.813 140.884 215.796 140.884C216.779 140.884 217.576 140.087 217.576 139.104C217.576 138.121 216.779 137.324 215.796 137.324C214.813 137.324 214.017 138.121 214.017 139.104Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.868 139.095C207.868 140.078 208.665 140.875 209.648 140.875C210.631 140.875 211.427 140.078 211.427 139.095C211.427 138.112 210.631 137.315 209.648 137.315C208.665 137.315 207.868 138.112 207.868 139.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 139.095C201.709 140.078 202.506 140.875 203.489 140.875C204.471 140.875 205.268 140.078 205.268 139.095C205.268 138.112 204.471 137.315 203.489 137.315C202.506 137.315 201.709 138.112 201.709 139.095Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.508 139.104C195.508 140.087 196.305 140.884 197.288 140.884C198.271 140.884 199.068 140.087 199.068 139.104C199.068 138.121 198.271 137.324 197.288 137.324C196.305 137.324 195.508 138.121 195.508 139.104Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 139.104C189.349 140.087 190.146 140.884 191.129 140.884C192.112 140.884 192.908 140.087 192.908 139.104C192.908 138.121 192.112 137.324 191.129 137.324C190.146 137.324 189.349 138.121 189.349 139.104Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.185 139.104C183.185 140.087 183.982 140.884 184.965 140.884C185.948 140.884 186.745 140.087 186.745 139.104C186.745 138.121 185.948 137.324 184.965 137.324C183.982 137.324 183.185 138.121 183.185 139.104Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 139.104C177.026 140.087 177.823 140.884 178.806 140.884C179.789 140.884 180.585 140.087 180.585 139.104C180.585 138.121 179.789 137.324 178.806 137.324C177.823 137.324 177.026 138.121 177.026 139.104Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.825 139.104C170.825 140.087 171.622 140.884 172.605 140.884C173.588 140.884 174.385 140.087 174.385 139.104C174.385 138.121 173.588 137.324 172.605 137.324C171.622 137.324 170.825 138.121 170.825 139.104Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 139.104C164.666 140.087 165.463 140.884 166.446 140.884C167.429 140.884 168.225 140.087 168.225 139.104C168.225 138.121 167.429 137.324 166.446 137.324C165.463 137.324 164.666 138.121 164.666 139.104Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.53 144.39C303.53 145.373 304.327 146.17 305.31 146.17C306.293 146.17 307.09 145.373 307.09 144.39C307.09 143.407 306.293 142.61 305.31 142.61C304.327 142.61 303.53 143.407 303.53 144.39Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.371 144.39C297.371 145.373 298.168 146.17 299.151 146.17C300.134 146.17 300.93 145.373 300.93 144.39C300.93 143.407 300.134 142.61 299.151 142.61C298.168 142.61 297.371 143.407 297.371 144.39Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.155 144.39C291.155 145.373 291.951 146.17 292.934 146.17C293.917 146.17 294.714 145.373 294.714 144.39C294.714 143.407 293.917 142.61 292.934 142.61C291.951 142.61 291.155 143.407 291.155 144.39Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.995 144.39C284.995 145.373 285.792 146.17 286.775 146.17C287.758 146.17 288.555 145.373 288.555 144.39C288.555 143.407 287.758 142.61 286.775 142.61C285.792 142.61 284.995 143.407 284.995 144.39Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.847 144.381C278.847 145.364 279.644 146.161 280.626 146.161C281.609 146.161 282.406 145.364 282.406 144.381C282.406 143.398 281.609 142.601 280.626 142.601C279.644 142.601 278.847 143.398 278.847 144.381Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.688 144.381C272.688 145.364 273.485 146.161 274.468 146.161C275.451 146.161 276.248 145.364 276.248 144.381C276.248 143.398 275.451 142.601 274.468 142.601C273.485 142.601 272.688 143.398 272.688 144.381Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.489 144.39C266.489 145.373 267.286 146.17 268.269 146.17C269.252 146.17 270.048 145.373 270.048 144.39C270.048 143.407 269.252 142.61 268.269 142.61C267.286 142.61 266.489 143.407 266.489 144.39Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.33 144.39C260.33 145.373 261.126 146.17 262.109 146.17C263.092 146.17 263.889 145.373 263.889 144.39C263.889 143.407 263.092 142.61 262.109 142.61C261.126 142.61 260.33 143.407 260.33 144.39Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.164 144.39C254.164 145.373 254.961 146.17 255.944 146.17C256.927 146.17 257.723 145.373 257.723 144.39C257.723 143.407 256.927 142.61 255.944 142.61C254.961 142.61 254.164 143.407 254.164 144.39Z"
            fill="#B8B7B7"
          />
          <path
            d="M248.005 144.39C248.005 145.373 248.802 146.17 249.785 146.17C250.768 146.17 251.564 145.373 251.564 144.39C251.564 143.407 250.768 142.61 249.785 142.61C248.802 142.61 248.005 143.407 248.005 144.39Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.806 144.39C241.806 145.373 242.603 146.17 243.586 146.17C244.569 146.17 245.365 145.373 245.365 144.39C245.365 143.407 244.569 142.61 243.586 142.61C242.603 142.61 241.806 143.407 241.806 144.39Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.647 144.39C235.647 145.373 236.443 146.17 237.426 146.17C238.409 146.17 239.206 145.373 239.206 144.39C239.206 143.407 238.409 142.61 237.426 142.61C236.443 142.61 235.647 143.407 235.647 144.39Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.477 144.395C229.477 145.378 230.274 146.175 231.257 146.175C232.24 146.175 233.037 145.378 233.037 144.395C233.037 143.412 232.24 142.616 231.257 142.616C230.274 142.616 229.477 143.412 229.477 144.395Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.318 144.395C223.318 145.378 224.115 146.175 225.098 146.175C226.081 146.175 226.877 145.378 226.877 144.395C226.877 143.413 226.081 142.616 225.098 142.616C224.115 142.616 223.318 143.413 223.318 144.395Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.102 144.395C217.102 145.378 217.898 146.175 218.881 146.175C219.864 146.175 220.661 145.378 220.661 144.395C220.661 143.413 219.864 142.616 218.881 142.616C217.898 142.616 217.102 143.413 217.102 144.395Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.943 144.395C210.943 145.378 211.739 146.175 212.722 146.175C213.705 146.175 214.502 145.378 214.502 144.395C214.502 143.413 213.705 142.616 212.722 142.616C211.739 142.616 210.943 143.413 210.943 144.395Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.794 144.386C204.794 145.369 205.591 146.166 206.574 146.166C207.557 146.166 208.354 145.369 208.354 144.386C208.354 143.403 207.557 142.607 206.574 142.607C205.591 142.607 204.794 143.403 204.794 144.386Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.635 144.386C198.635 145.369 199.432 146.166 200.415 146.166C201.398 146.166 202.195 145.369 202.195 144.386C202.195 143.403 201.398 142.607 200.415 142.607C199.432 142.607 198.635 143.403 198.635 144.386Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.434 144.395C192.434 145.378 193.231 146.175 194.214 146.175C195.197 146.175 195.994 145.378 195.994 144.395C195.994 143.412 195.197 142.616 194.214 142.616C193.231 142.616 192.434 143.412 192.434 144.395Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.275 144.395C186.275 145.378 187.072 146.175 188.055 146.175C189.038 146.175 189.835 145.378 189.835 144.395C189.835 143.412 189.038 142.616 188.055 142.616C187.072 142.616 186.275 143.412 186.275 144.395Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.111 144.395C180.111 145.378 180.908 146.175 181.891 146.175C182.874 146.175 183.671 145.378 183.671 144.395C183.671 143.412 182.874 142.616 181.891 142.616C180.908 142.616 180.111 143.412 180.111 144.395Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.952 144.395C173.952 145.378 174.749 146.175 175.732 146.175C176.715 146.175 177.512 145.378 177.512 144.395C177.512 143.412 176.715 142.616 175.732 142.616C174.749 142.616 173.952 143.412 173.952 144.395Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.751 144.395C167.751 145.378 168.548 146.175 169.531 146.175C170.514 146.175 171.311 145.378 171.311 144.395C171.311 143.412 170.514 142.616 169.531 142.616C168.548 142.616 167.751 143.412 167.751 144.395Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.593 144.395C161.593 145.378 162.389 146.175 163.372 146.175C164.355 146.175 165.152 145.378 165.152 144.395C165.152 143.412 164.355 142.616 163.372 142.616C162.389 142.616 161.593 143.412 161.593 144.395Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 149.692C300.446 150.675 301.243 151.472 302.226 151.472C303.209 151.472 304.005 150.675 304.005 149.692C304.005 148.709 303.209 147.912 302.226 147.912C301.243 147.912 300.446 148.709 300.446 149.692Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.287 149.692C294.287 150.675 295.083 151.472 296.066 151.472C297.049 151.472 297.846 150.675 297.846 149.692C297.846 148.709 297.049 147.912 296.066 147.912C295.083 147.912 294.287 148.709 294.287 149.692Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 149.692C288.07 150.675 288.867 151.472 289.85 151.472C290.833 151.472 291.63 150.675 291.63 149.692C291.63 148.709 290.833 147.912 289.85 147.912C288.867 147.912 288.07 148.709 288.07 149.692Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.912 149.692C281.912 150.675 282.708 151.472 283.691 151.472C284.674 151.472 285.471 150.675 285.471 149.692C285.471 148.709 284.674 147.912 283.691 147.912C282.708 147.912 281.912 148.709 281.912 149.692Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 149.683C275.763 150.666 276.56 151.463 277.542 151.463C278.525 151.463 279.322 150.666 279.322 149.683C279.322 148.7 278.525 147.903 277.542 147.903C276.56 147.903 275.763 148.7 275.763 149.683Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.604 149.683C269.604 150.666 270.401 151.463 271.384 151.463C272.367 151.463 273.164 150.666 273.164 149.683C273.164 148.7 272.367 147.903 271.384 147.903C270.401 147.903 269.604 148.7 269.604 149.683Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 149.692C263.403 150.675 264.2 151.472 265.183 151.472C266.166 151.472 266.963 150.675 266.963 149.692C266.963 148.709 266.166 147.912 265.183 147.912C264.2 147.912 263.403 148.709 263.403 149.692Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.244 149.692C257.244 150.675 258.041 151.472 259.024 151.472C260.007 151.472 260.803 150.675 260.803 149.692C260.803 148.709 260.007 147.912 259.024 147.912C258.041 147.912 257.244 148.709 257.244 149.692Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 149.692C251.08 150.675 251.876 151.472 252.859 151.472C253.842 151.472 254.639 150.675 254.639 149.692C254.639 148.709 253.842 147.912 252.859 147.912C251.876 147.912 251.08 148.709 251.08 149.692Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.921 149.692C244.921 150.675 245.718 151.472 246.701 151.472C247.684 151.472 248.48 150.675 248.48 149.692C248.48 148.709 247.684 147.912 246.701 147.912C245.718 147.912 244.921 148.709 244.921 149.692Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 149.692C238.72 150.675 239.517 151.472 240.5 151.472C241.483 151.472 242.28 150.675 242.28 149.692C242.28 148.709 241.483 147.912 240.5 147.912C239.517 147.912 238.72 148.709 238.72 149.692Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.561 149.692C232.561 150.675 233.358 151.472 234.341 151.472C235.324 151.472 236.121 150.675 236.121 149.692C236.121 148.709 235.324 147.912 234.341 147.912C233.358 147.912 232.561 148.709 232.561 149.692Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 149.697C226.392 150.68 227.189 151.477 228.172 151.477C229.155 151.477 229.951 150.68 229.951 149.697C229.951 148.714 229.155 147.917 228.172 147.917C227.189 147.917 226.392 148.714 226.392 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.233 149.697C220.233 150.68 221.03 151.477 222.012 151.477C222.995 151.477 223.792 150.68 223.792 149.697C223.792 148.714 222.995 147.917 222.012 147.917C221.03 147.917 220.233 148.714 220.233 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 149.697C214.017 150.68 214.813 151.477 215.796 151.477C216.779 151.477 217.576 150.68 217.576 149.697C217.576 148.714 216.779 147.917 215.796 147.917C214.813 147.917 214.017 148.714 214.017 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.857 149.697C207.857 150.68 208.654 151.477 209.637 151.477C210.62 151.477 211.417 150.68 211.417 149.697C211.417 148.714 210.62 147.917 209.637 147.917C208.654 147.917 207.857 148.714 207.857 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 149.687C201.709 150.67 202.506 151.466 203.489 151.466C204.471 151.466 205.268 150.67 205.268 149.687C205.268 148.704 204.471 147.907 203.489 147.907C202.506 147.907 201.709 148.704 201.709 149.687Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.55 149.687C195.55 150.67 196.347 151.466 197.33 151.466C198.313 151.466 199.109 150.67 199.109 149.687C199.109 148.704 198.313 147.907 197.33 147.907C196.347 147.907 195.55 148.704 195.55 149.687Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 149.697C189.349 150.68 190.146 151.477 191.129 151.477C192.112 151.477 192.908 150.68 192.908 149.697C192.908 148.714 192.112 147.917 191.129 147.917C190.146 147.917 189.349 148.714 189.349 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.191 149.697C183.191 150.68 183.988 151.477 184.971 151.477C185.954 151.477 186.751 150.68 186.751 149.697C186.751 148.714 185.954 147.917 184.971 147.917C183.988 147.917 183.191 148.714 183.191 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 149.697C177.026 150.68 177.823 151.477 178.806 151.477C179.789 151.477 180.585 150.68 180.585 149.697C180.585 148.714 179.789 147.917 178.806 147.917C177.823 147.917 177.026 148.714 177.026 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.867 149.697C170.867 150.68 171.664 151.477 172.646 151.477C173.629 151.477 174.426 150.68 174.426 149.697C174.426 148.714 173.629 147.917 172.646 147.917C171.664 147.917 170.867 148.714 170.867 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 149.697C164.666 150.68 165.463 151.477 166.446 151.477C167.429 151.477 168.225 150.68 168.225 149.697C168.225 148.714 167.429 147.917 166.446 147.917C165.463 147.917 164.666 148.714 164.666 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.508 149.697C158.508 150.68 159.305 151.477 160.288 151.477C161.271 151.477 162.068 150.68 162.068 149.697C162.068 148.714 161.271 147.917 160.288 147.917C159.305 147.917 158.508 148.714 158.508 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.53 154.936C303.53 155.919 304.327 156.716 305.31 156.716C306.293 156.716 307.09 155.919 307.09 154.936C307.09 153.953 306.293 153.157 305.31 153.157C304.327 153.157 303.53 153.953 303.53 154.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.371 154.936C297.371 155.919 298.168 156.716 299.151 156.716C300.134 156.716 300.93 155.919 300.93 154.936C300.93 153.953 300.134 153.157 299.151 153.157C298.168 153.157 297.371 153.953 297.371 154.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.155 154.936C291.155 155.919 291.951 156.716 292.934 156.716C293.917 156.716 294.714 155.919 294.714 154.936C294.714 153.953 293.917 153.157 292.934 153.157C291.951 153.157 291.155 153.953 291.155 154.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.995 154.936C284.995 155.919 285.792 156.716 286.775 156.716C287.758 156.716 288.555 155.919 288.555 154.936C288.555 153.953 287.758 153.157 286.775 153.157C285.792 153.157 284.995 153.953 284.995 154.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.847 154.927C278.847 155.91 279.644 156.707 280.626 156.707C281.609 156.707 282.406 155.91 282.406 154.927C282.406 153.944 281.609 153.147 280.626 153.147C279.644 153.147 278.847 153.944 278.847 154.927Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.688 154.927C272.688 155.91 273.485 156.707 274.468 156.707C275.451 156.707 276.248 155.91 276.248 154.927C276.248 153.944 275.451 153.147 274.468 153.147C273.485 153.147 272.688 153.944 272.688 154.927Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.489 154.936C266.489 155.919 267.286 156.716 268.269 156.716C269.252 156.716 270.048 155.919 270.048 154.936C270.048 153.953 269.252 153.157 268.269 153.157C267.286 153.157 266.489 153.953 266.489 154.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.33 154.936C260.33 155.919 261.126 156.716 262.109 156.716C263.092 156.716 263.889 155.919 263.889 154.936C263.889 153.953 263.092 153.157 262.109 153.157C261.126 153.157 260.33 153.953 260.33 154.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.164 154.936C254.164 155.919 254.961 156.716 255.944 156.716C256.927 156.716 257.723 155.919 257.723 154.936C257.723 153.953 256.927 153.157 255.944 153.157C254.961 153.157 254.164 153.953 254.164 154.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M248.005 154.936C248.005 155.919 248.802 156.716 249.785 156.716C250.768 156.716 251.564 155.919 251.564 154.936C251.564 153.953 250.768 153.157 249.785 153.157C248.802 153.157 248.005 153.953 248.005 154.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.806 154.936C241.806 155.919 242.603 156.716 243.586 156.716C244.569 156.716 245.365 155.919 245.365 154.936C245.365 153.953 244.569 153.157 243.586 153.157C242.603 153.157 241.806 153.953 241.806 154.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.647 154.936C235.647 155.919 236.443 156.716 237.426 156.716C238.409 156.716 239.206 155.919 239.206 154.936C239.206 153.953 238.409 153.157 237.426 153.157C236.443 153.157 235.647 153.953 235.647 154.936Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.477 154.942C229.477 155.924 230.274 156.721 231.257 156.721C232.24 156.721 233.037 155.924 233.037 154.942C233.037 153.959 232.24 153.162 231.257 153.162C230.274 153.162 229.477 153.959 229.477 154.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.318 154.942C223.318 155.924 224.115 156.721 225.098 156.721C226.081 156.721 226.877 155.924 226.877 154.942C226.877 153.959 226.081 153.162 225.098 153.162C224.115 153.162 223.318 153.959 223.318 154.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.102 154.942C217.102 155.924 217.898 156.721 218.881 156.721C219.864 156.721 220.661 155.924 220.661 154.942C220.661 153.959 219.864 153.162 218.881 153.162C217.898 153.162 217.102 153.959 217.102 154.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.943 154.942C210.943 155.924 211.739 156.721 212.722 156.721C213.705 156.721 214.502 155.924 214.502 154.942C214.502 153.959 213.705 153.162 212.722 153.162C211.739 153.162 210.943 153.959 210.943 154.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.794 154.931C204.794 155.914 205.591 156.711 206.574 156.711C207.557 156.711 208.354 155.914 208.354 154.931C208.354 153.948 207.557 153.151 206.574 153.151C205.591 153.151 204.794 153.948 204.794 154.931Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.635 154.931C198.635 155.914 199.432 156.711 200.415 156.711C201.398 156.711 202.195 155.914 202.195 154.931C202.195 153.948 201.398 153.151 200.415 153.151C199.432 153.151 198.635 153.948 198.635 154.931Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.434 154.942C192.434 155.924 193.231 156.721 194.214 156.721C195.197 156.721 195.994 155.924 195.994 154.942C195.994 153.959 195.197 153.162 194.214 153.162C193.231 153.162 192.434 153.959 192.434 154.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.275 154.942C186.275 155.924 187.072 156.721 188.055 156.721C189.038 156.721 189.835 155.924 189.835 154.942C189.835 153.959 189.038 153.162 188.055 153.162C187.072 153.162 186.275 153.959 186.275 154.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.111 154.942C180.111 155.924 180.908 156.721 181.891 156.721C182.874 156.721 183.671 155.924 183.671 154.942C183.671 153.959 182.874 153.162 181.891 153.162C180.908 153.162 180.111 153.959 180.111 154.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.952 154.942C173.952 155.924 174.749 156.721 175.732 156.721C176.715 156.721 177.512 155.924 177.512 154.942C177.512 153.959 176.715 153.162 175.732 153.162C174.749 153.162 173.952 153.959 173.952 154.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.751 154.942C167.751 155.924 168.548 156.721 169.531 156.721C170.514 156.721 171.311 155.924 171.311 154.942C171.311 153.959 170.514 153.162 169.531 153.162C168.548 153.162 167.751 153.959 167.751 154.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.593 154.942C161.593 155.924 162.389 156.721 163.372 156.721C164.355 156.721 165.152 155.924 165.152 154.942C165.152 153.959 164.355 153.162 163.372 153.162C162.389 153.162 161.593 153.959 161.593 154.942Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 149.663C306.603 150.646 307.4 151.443 308.383 151.443C309.366 151.443 310.163 150.646 310.163 149.663C310.163 148.68 309.366 147.883 308.383 147.883C307.4 147.883 306.603 148.68 306.603 149.663Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 160.12C306.603 161.103 307.4 161.9 308.383 161.9C309.366 161.9 310.163 161.103 310.163 160.12C310.163 159.137 309.366 158.34 308.383 158.34C307.4 158.34 306.603 159.137 306.603 160.12Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 160.12C300.446 161.103 301.243 161.9 302.226 161.9C303.209 161.9 304.005 161.103 304.005 160.12C304.005 159.137 303.209 158.34 302.226 158.34C301.243 158.34 300.446 159.137 300.446 160.12Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.23 160.12C294.23 161.103 295.026 161.9 296.009 161.9C296.992 161.9 297.789 161.103 297.789 160.12C297.789 159.137 296.992 158.34 296.009 158.34C295.026 158.34 294.23 159.137 294.23 160.12Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 160.12C288.07 161.103 288.867 161.9 289.85 161.9C290.833 161.9 291.63 161.103 291.63 160.12C291.63 159.137 290.833 158.34 289.85 158.34C288.867 158.34 288.07 159.137 288.07 160.12Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.92 160.111C281.92 161.094 282.717 161.89 283.7 161.89C284.683 161.89 285.48 161.094 285.48 160.111C285.48 159.128 284.683 158.331 283.7 158.331C282.717 158.331 281.92 159.128 281.92 160.111Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 160.111C275.763 161.094 276.56 161.89 277.542 161.89C278.525 161.89 279.322 161.094 279.322 160.111C279.322 159.128 278.525 158.331 277.542 158.331C276.56 158.331 275.763 159.128 275.763 160.111Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.562 160.12C269.562 161.103 270.359 161.9 271.342 161.9C272.325 161.9 273.122 161.103 273.122 160.12C273.122 159.137 272.325 158.34 271.342 158.34C270.359 158.34 269.562 159.137 269.562 160.12Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 160.12C263.403 161.103 264.2 161.9 265.183 161.9C266.166 161.9 266.963 161.103 266.963 160.12C266.963 159.137 266.166 158.34 265.183 158.34C264.2 158.34 263.403 159.137 263.403 160.12Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.238 160.12C257.238 161.103 258.034 161.9 259.017 161.9C260 161.9 260.797 161.103 260.797 160.12C260.797 159.137 260 158.34 259.017 158.34C258.034 158.34 257.238 159.137 257.238 160.12Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 160.12C251.08 161.103 251.876 161.9 252.859 161.9C253.842 161.9 254.639 161.103 254.639 160.12C254.639 159.137 253.842 158.34 252.859 158.34C251.876 158.34 251.08 159.137 251.08 160.12Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.879 160.12C244.879 161.103 245.676 161.9 246.659 161.9C247.642 161.9 248.439 161.103 248.439 160.12C248.439 159.137 247.642 158.34 246.659 158.34C245.676 158.34 244.879 159.137 244.879 160.12Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 160.12C238.72 161.103 239.517 161.9 240.5 161.9C241.483 161.9 242.28 161.103 242.28 160.12C242.28 159.137 241.483 158.34 240.5 158.34C239.517 158.34 238.72 159.137 238.72 160.12Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.551 160.125C232.551 161.108 233.348 161.905 234.331 161.905C235.314 161.905 236.111 161.108 236.111 160.125C236.111 159.142 235.314 158.345 234.331 158.345C233.348 158.345 232.551 159.142 232.551 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 160.125C226.392 161.108 227.189 161.905 228.172 161.905C229.155 161.905 229.951 161.108 229.951 160.125C229.951 159.142 229.155 158.345 228.172 158.345C227.189 158.345 226.392 159.142 226.392 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.175 160.125C220.175 161.108 220.972 161.905 221.955 161.905C222.938 161.905 223.735 161.108 223.735 160.125C223.735 159.142 222.938 158.345 221.955 158.345C220.972 158.345 220.175 159.142 220.175 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 160.125C214.017 161.108 214.813 161.905 215.796 161.905C216.779 161.905 217.576 161.108 217.576 160.125C217.576 159.142 216.779 158.345 215.796 158.345C214.813 158.345 214.017 159.142 214.017 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.868 160.115C207.868 161.097 208.665 161.894 209.648 161.894C210.631 161.894 211.427 161.097 211.427 160.115C211.427 159.132 210.631 158.335 209.648 158.335C208.665 158.335 207.868 159.132 207.868 160.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 160.115C201.709 161.097 202.506 161.894 203.489 161.894C204.471 161.894 205.268 161.097 205.268 160.115C205.268 159.132 204.471 158.335 203.489 158.335C202.506 158.335 201.709 159.132 201.709 160.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.508 160.125C195.508 161.108 196.305 161.905 197.288 161.905C198.271 161.905 199.068 161.108 199.068 160.125C199.068 159.142 198.271 158.345 197.288 158.345C196.305 158.345 195.508 159.142 195.508 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 160.125C189.349 161.108 190.146 161.905 191.129 161.905C192.112 161.905 192.908 161.108 192.908 160.125C192.908 159.142 192.112 158.345 191.129 158.345C190.146 158.345 189.349 159.142 189.349 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.185 160.125C183.185 161.108 183.982 161.905 184.965 161.905C185.948 161.905 186.745 161.108 186.745 160.125C186.745 159.142 185.948 158.345 184.965 158.345C183.982 158.345 183.185 159.142 183.185 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 160.125C177.026 161.108 177.823 161.905 178.806 161.905C179.789 161.905 180.585 161.108 180.585 160.125C180.585 159.142 179.789 158.345 178.806 158.345C177.823 158.345 177.026 159.142 177.026 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.825 160.125C170.825 161.108 171.622 161.905 172.605 161.905C173.588 161.905 174.385 161.108 174.385 160.125C174.385 159.142 173.588 158.345 172.605 158.345C171.622 158.345 170.825 159.142 170.825 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 160.125C164.666 161.108 165.463 161.905 166.446 161.905C167.429 161.905 168.225 161.108 168.225 160.125C168.225 159.142 167.429 158.345 166.446 158.345C165.463 158.345 164.666 159.142 164.666 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.519 165.421C303.519 166.404 304.316 167.201 305.299 167.201C306.282 167.201 307.079 166.404 307.079 165.421C307.079 164.438 306.282 163.642 305.299 163.642C304.316 163.642 303.519 164.438 303.519 165.421Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.36 165.421C297.36 166.404 298.157 167.201 299.14 167.201C300.123 167.201 300.92 166.404 300.92 165.421C300.92 164.438 300.123 163.642 299.14 163.642C298.157 163.642 297.36 164.438 297.36 165.421Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.144 165.421C291.144 166.404 291.941 167.201 292.924 167.201C293.907 167.201 294.704 166.404 294.704 165.421C294.704 164.438 293.907 163.642 292.924 163.642C291.941 163.642 291.144 164.438 291.144 165.421Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.985 165.421C284.985 166.404 285.782 167.201 286.765 167.201C287.748 167.201 288.545 166.404 288.545 165.421C288.545 164.438 287.748 163.642 286.765 163.642C285.782 163.642 284.985 164.438 284.985 165.421Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.836 165.412C278.836 166.395 279.633 167.192 280.616 167.192C281.599 167.192 282.396 166.395 282.396 165.412C282.396 164.429 281.599 163.633 280.616 163.633C279.633 163.633 278.836 164.429 278.836 165.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.678 165.412C272.678 166.395 273.474 167.192 274.457 167.192C275.44 167.192 276.237 166.395 276.237 165.412C276.237 164.429 275.44 163.633 274.457 163.633C273.474 163.633 272.678 164.429 272.678 165.412Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.477 165.421C266.477 166.404 267.274 167.201 268.257 167.201C269.24 167.201 270.036 166.404 270.036 165.421C270.036 164.438 269.24 163.642 268.257 163.642C267.274 163.642 266.477 164.438 266.477 165.421Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.318 165.421C260.318 166.404 261.115 167.201 262.098 167.201C263.081 167.201 263.878 166.404 263.878 165.421C263.878 164.438 263.081 163.642 262.098 163.642C261.115 163.642 260.318 164.438 260.318 165.421Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.153 165.421C254.153 166.404 254.95 167.201 255.933 167.201C256.916 167.201 257.713 166.404 257.713 165.421C257.713 164.438 256.916 163.642 255.933 163.642C254.95 163.642 254.153 164.438 254.153 165.421Z"
            fill="#B8B7B7"
          />
          <path
            d="M247.995 165.421C247.995 166.404 248.791 167.201 249.774 167.201C250.757 167.201 251.554 166.404 251.554 165.421C251.554 164.438 250.757 163.642 249.774 163.642C248.791 163.642 247.995 164.438 247.995 165.421Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.794 165.421C241.794 166.404 242.591 167.201 243.574 167.201C244.557 167.201 245.354 166.404 245.354 165.421C245.354 164.438 244.557 163.642 243.574 163.642C242.591 163.642 241.794 164.438 241.794 165.421Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.635 165.421C235.635 166.404 236.432 167.201 237.415 167.201C238.398 167.201 239.195 166.404 239.195 165.421C239.195 164.438 238.398 163.642 237.415 163.642C236.432 163.642 235.635 164.438 235.635 165.421Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.466 165.425C229.466 166.408 230.262 167.205 231.245 167.205C232.228 167.205 233.025 166.408 233.025 165.425C233.025 164.442 232.228 163.645 231.245 163.645C230.262 163.645 229.466 164.442 229.466 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.306 165.425C223.306 166.408 224.103 167.205 225.086 167.205C226.069 167.205 226.866 166.408 226.866 165.425C226.866 164.442 226.069 163.645 225.086 163.645C224.103 163.645 223.306 164.442 223.306 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.09 165.425C217.09 166.408 217.887 167.205 218.87 167.205C219.853 167.205 220.65 166.408 220.65 165.425C220.65 164.442 219.853 163.645 218.87 163.645C217.887 163.645 217.09 164.442 217.09 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.931 165.425C210.931 166.408 211.728 167.205 212.711 167.205C213.694 167.205 214.49 166.408 214.49 165.425C214.49 164.442 213.694 163.645 212.711 163.645C211.728 163.645 210.931 164.442 210.931 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.782 165.416C204.782 166.399 205.579 167.196 206.562 167.196C207.545 167.196 208.342 166.399 208.342 165.416C208.342 164.433 207.545 163.636 206.562 163.636C205.579 163.636 204.782 164.433 204.782 165.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.624 165.416C198.624 166.399 199.42 167.196 200.403 167.196C201.386 167.196 202.183 166.399 202.183 165.416C202.183 164.433 201.386 163.636 200.403 163.636C199.42 163.636 198.624 164.433 198.624 165.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.424 165.425C192.424 166.408 193.221 167.205 194.204 167.205C195.187 167.205 195.984 166.408 195.984 165.425C195.984 164.442 195.187 163.645 194.204 163.645C193.221 163.645 192.424 164.442 192.424 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.265 165.425C186.265 166.408 187.062 167.205 188.045 167.205C189.028 167.205 189.825 166.408 189.825 165.425C189.825 164.442 189.028 163.645 188.045 163.645C187.062 163.645 186.265 164.442 186.265 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.099 165.425C180.099 166.408 180.896 167.205 181.879 167.205C182.862 167.205 183.659 166.408 183.659 165.425C183.659 164.442 182.862 163.645 181.879 163.645C180.896 163.645 180.099 164.442 180.099 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.94 165.425C173.94 166.408 174.737 167.205 175.72 167.205C176.703 167.205 177.5 166.408 177.5 165.425C177.5 164.442 176.703 163.645 175.72 163.645C174.737 163.645 173.94 164.442 173.94 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.741 165.425C167.741 166.408 168.538 167.205 169.521 167.205C170.504 167.205 171.301 166.408 171.301 165.425C171.301 164.442 170.504 163.645 169.521 163.645C168.538 163.645 167.741 164.442 167.741 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.582 165.425C161.582 166.408 162.379 167.205 163.362 167.205C164.345 167.205 165.142 166.408 165.142 165.425C165.142 164.442 164.345 163.645 163.362 163.645C162.379 163.645 161.582 164.442 161.582 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 170.666C306.603 171.649 307.4 172.446 308.383 172.446C309.366 172.446 310.163 171.649 310.163 170.666C310.163 169.683 309.366 168.886 308.383 168.886C307.4 168.886 306.603 169.683 306.603 170.666Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 170.666C300.446 171.649 301.243 172.446 302.226 172.446C303.209 172.446 304.005 171.649 304.005 170.666C304.005 169.683 303.209 168.886 302.226 168.886C301.243 168.886 300.446 169.683 300.446 170.666Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.23 170.666C294.23 171.649 295.026 172.446 296.009 172.446C296.992 172.446 297.789 171.649 297.789 170.666C297.789 169.683 296.992 168.886 296.009 168.886C295.026 168.886 294.23 169.683 294.23 170.666Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 170.666C288.07 171.649 288.867 172.446 289.85 172.446C290.833 172.446 291.63 171.649 291.63 170.666C291.63 169.683 290.833 168.886 289.85 168.886C288.867 168.886 288.07 169.683 288.07 170.666Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.92 170.657C281.92 171.64 282.717 172.437 283.7 172.437C284.683 172.437 285.48 171.64 285.48 170.657C285.48 169.674 284.683 168.877 283.7 168.877C282.717 168.877 281.92 169.674 281.92 170.657Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 170.657C275.763 171.64 276.56 172.437 277.542 172.437C278.525 172.437 279.322 171.64 279.322 170.657C279.322 169.674 278.525 168.877 277.542 168.877C276.56 168.877 275.763 169.674 275.763 170.657Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.562 170.666C269.562 171.649 270.359 172.446 271.342 172.446C272.325 172.446 273.122 171.649 273.122 170.666C273.122 169.683 272.325 168.886 271.342 168.886C270.359 168.886 269.562 169.683 269.562 170.666Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 170.666C263.403 171.649 264.2 172.446 265.183 172.446C266.166 172.446 266.963 171.649 266.963 170.666C266.963 169.683 266.166 168.886 265.183 168.886C264.2 168.886 263.403 169.683 263.403 170.666Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.238 170.666C257.238 171.649 258.034 172.446 259.017 172.446C260 172.446 260.797 171.649 260.797 170.666C260.797 169.683 260 168.886 259.017 168.886C258.034 168.886 257.238 169.683 257.238 170.666Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 170.666C251.08 171.649 251.876 172.446 252.859 172.446C253.842 172.446 254.639 171.649 254.639 170.666C254.639 169.683 253.842 168.886 252.859 168.886C251.876 168.886 251.08 169.683 251.08 170.666Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.879 170.666C244.879 171.649 245.676 172.446 246.659 172.446C247.642 172.446 248.439 171.649 248.439 170.666C248.439 169.683 247.642 168.886 246.659 168.886C245.676 168.886 244.879 169.683 244.879 170.666Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 170.666C238.72 171.649 239.517 172.446 240.5 172.446C241.483 172.446 242.28 171.649 242.28 170.666C242.28 169.683 241.483 168.886 240.5 168.886C239.517 168.886 238.72 169.683 238.72 170.666Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.551 170.671C232.551 171.654 233.348 172.451 234.331 172.451C235.314 172.451 236.111 171.654 236.111 170.671C236.111 169.688 235.314 168.891 234.331 168.891C233.348 168.891 232.551 169.688 232.551 170.671Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 170.671C226.392 171.654 227.189 172.451 228.172 172.451C229.155 172.451 229.951 171.654 229.951 170.671C229.951 169.688 229.155 168.891 228.172 168.891C227.189 168.891 226.392 169.688 226.392 170.671Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.175 170.671C220.175 171.654 220.972 172.451 221.955 172.451C222.938 172.451 223.735 171.654 223.735 170.671C223.735 169.688 222.938 168.891 221.955 168.891C220.972 168.891 220.175 169.688 220.175 170.671Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 170.671C214.017 171.654 214.813 172.451 215.796 172.451C216.779 172.451 217.576 171.654 217.576 170.671C217.576 169.688 216.779 168.891 215.796 168.891C214.813 168.891 214.017 169.688 214.017 170.671Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.868 170.661C207.868 171.644 208.665 172.44 209.648 172.44C210.631 172.44 211.427 171.644 211.427 170.661C211.427 169.678 210.631 168.881 209.648 168.881C208.665 168.881 207.868 169.678 207.868 170.661Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 170.661C201.709 171.644 202.506 172.44 203.489 172.44C204.471 172.44 205.268 171.644 205.268 170.661C205.268 169.678 204.471 168.881 203.489 168.881C202.506 168.881 201.709 169.678 201.709 170.661Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.508 170.671C195.508 171.654 196.305 172.451 197.288 172.451C198.271 172.451 199.068 171.654 199.068 170.671C199.068 169.688 198.271 168.891 197.288 168.891C196.305 168.891 195.508 169.688 195.508 170.671Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 170.671C189.349 171.654 190.146 172.451 191.129 172.451C192.112 172.451 192.908 171.654 192.908 170.671C192.908 169.688 192.112 168.891 191.129 168.891C190.146 168.891 189.349 169.688 189.349 170.671Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.185 170.671C183.185 171.654 183.982 172.451 184.965 172.451C185.948 172.451 186.745 171.654 186.745 170.671C186.745 169.688 185.948 168.891 184.965 168.891C183.982 168.891 183.185 169.688 183.185 170.671Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 170.671C177.026 171.654 177.823 172.451 178.806 172.451C179.789 172.451 180.585 171.654 180.585 170.671C180.585 169.688 179.789 168.891 178.806 168.891C177.823 168.891 177.026 169.688 177.026 170.671Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.825 170.671C170.825 171.654 171.622 172.451 172.605 172.451C173.588 172.451 174.385 171.654 174.385 170.671C174.385 169.688 173.588 168.891 172.605 168.891C171.622 168.891 170.825 169.688 170.825 170.671Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 170.671C164.666 171.654 165.463 172.451 166.446 172.451C167.429 172.451 168.225 171.654 168.225 170.671C168.225 169.688 167.429 168.891 166.446 168.891C165.463 168.891 164.666 169.688 164.666 170.671Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.53 175.956C303.53 176.939 304.327 177.736 305.31 177.736C306.293 177.736 307.09 176.939 307.09 175.956C307.09 174.973 306.293 174.176 305.31 174.176C304.327 174.176 303.53 174.973 303.53 175.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.371 175.956C297.371 176.939 298.168 177.736 299.151 177.736C300.134 177.736 300.93 176.939 300.93 175.956C300.93 174.973 300.134 174.176 299.151 174.176C298.168 174.176 297.371 174.973 297.371 175.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.155 175.956C291.155 176.939 291.951 177.736 292.934 177.736C293.917 177.736 294.714 176.939 294.714 175.956C294.714 174.973 293.917 174.176 292.934 174.176C291.951 174.176 291.155 174.973 291.155 175.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.995 175.956C284.995 176.939 285.792 177.736 286.775 177.736C287.758 177.736 288.555 176.939 288.555 175.956C288.555 174.973 287.758 174.176 286.775 174.176C285.792 174.176 284.995 174.973 284.995 175.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.847 175.947C278.847 176.93 279.644 177.726 280.626 177.726C281.609 177.726 282.406 176.93 282.406 175.947C282.406 174.964 281.609 174.167 280.626 174.167C279.644 174.167 278.847 174.964 278.847 175.947Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.688 175.947C272.688 176.93 273.485 177.726 274.468 177.726C275.451 177.726 276.248 176.93 276.248 175.947C276.248 174.964 275.451 174.167 274.468 174.167C273.485 174.167 272.688 174.964 272.688 175.947Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.489 175.956C266.489 176.939 267.286 177.736 268.269 177.736C269.252 177.736 270.048 176.939 270.048 175.956C270.048 174.973 269.252 174.176 268.269 174.176C267.286 174.176 266.489 174.973 266.489 175.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.33 175.956C260.33 176.939 261.126 177.736 262.109 177.736C263.092 177.736 263.889 176.939 263.889 175.956C263.889 174.973 263.092 174.176 262.109 174.176C261.126 174.176 260.33 174.973 260.33 175.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.164 175.956C254.164 176.939 254.961 177.736 255.944 177.736C256.927 177.736 257.723 176.939 257.723 175.956C257.723 174.973 256.927 174.176 255.944 174.176C254.961 174.176 254.164 174.973 254.164 175.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M248.005 175.956C248.005 176.939 248.802 177.736 249.785 177.736C250.768 177.736 251.564 176.939 251.564 175.956C251.564 174.973 250.768 174.176 249.785 174.176C248.802 174.176 248.005 174.973 248.005 175.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.806 175.956C241.806 176.939 242.603 177.736 243.586 177.736C244.569 177.736 245.365 176.939 245.365 175.956C245.365 174.973 244.569 174.176 243.586 174.176C242.603 174.176 241.806 174.973 241.806 175.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.647 175.956C235.647 176.939 236.443 177.736 237.426 177.736C238.409 177.736 239.206 176.939 239.206 175.956C239.206 174.973 238.409 174.176 237.426 174.176C236.443 174.176 235.647 174.973 235.647 175.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.477 175.961C229.477 176.944 230.274 177.741 231.257 177.741C232.24 177.741 233.037 176.944 233.037 175.961C233.037 174.978 232.24 174.181 231.257 174.181C230.274 174.181 229.477 174.978 229.477 175.961Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.318 175.961C223.318 176.944 224.115 177.741 225.098 177.741C226.081 177.741 226.877 176.944 226.877 175.961C226.877 174.978 226.081 174.181 225.098 174.181C224.115 174.181 223.318 174.978 223.318 175.961Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.102 175.961C217.102 176.944 217.898 177.741 218.881 177.741C219.864 177.741 220.661 176.944 220.661 175.961C220.661 174.978 219.864 174.181 218.881 174.181C217.898 174.181 217.102 174.978 217.102 175.961Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.943 175.961C210.943 176.944 211.739 177.741 212.722 177.741C213.705 177.741 214.502 176.944 214.502 175.961C214.502 174.978 213.705 174.181 212.722 174.181C211.739 174.181 210.943 174.978 210.943 175.961Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.794 175.952C204.794 176.935 205.591 177.732 206.574 177.732C207.557 177.732 208.354 176.935 208.354 175.952C208.354 174.969 207.557 174.172 206.574 174.172C205.591 174.172 204.794 174.969 204.794 175.952Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.635 175.952C198.635 176.935 199.432 177.732 200.415 177.732C201.398 177.732 202.195 176.935 202.195 175.952C202.195 174.969 201.398 174.172 200.415 174.172C199.432 174.172 198.635 174.969 198.635 175.952Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.434 175.961C192.434 176.944 193.231 177.741 194.214 177.741C195.197 177.741 195.994 176.944 195.994 175.961C195.994 174.978 195.197 174.181 194.214 174.181C193.231 174.181 192.434 174.978 192.434 175.961Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.275 175.961C186.275 176.944 187.072 177.741 188.055 177.741C189.038 177.741 189.835 176.944 189.835 175.961C189.835 174.978 189.038 174.181 188.055 174.181C187.072 174.181 186.275 174.978 186.275 175.961Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.111 175.961C180.111 176.944 180.908 177.741 181.891 177.741C182.874 177.741 183.671 176.944 183.671 175.961C183.671 174.978 182.874 174.181 181.891 174.181C180.908 174.181 180.111 174.978 180.111 175.961Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.952 175.961C173.952 176.944 174.749 177.741 175.732 177.741C176.715 177.741 177.512 176.944 177.512 175.961C177.512 174.978 176.715 174.181 175.732 174.181C174.749 174.181 173.952 174.978 173.952 175.961Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.751 175.961C167.751 176.944 168.548 177.741 169.531 177.741C170.514 177.741 171.311 176.944 171.311 175.961C171.311 174.978 170.514 174.181 169.531 174.181C168.548 174.181 167.751 174.978 167.751 175.961Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.593 175.961C161.593 176.944 162.389 177.741 163.372 177.741C164.355 177.741 165.152 176.944 165.152 175.961C165.152 174.978 164.355 174.181 163.372 174.181C162.389 174.181 161.593 174.978 161.593 175.961Z"
            fill="#B8B7B7"
          />
          <path
            d="M300.446 181.257C300.446 182.24 301.243 183.037 302.226 183.037C303.209 183.037 304.005 182.24 304.005 181.257C304.005 180.274 303.209 179.478 302.226 179.478C301.243 179.478 300.446 180.274 300.446 181.257Z"
            fill="#B8B7B7"
          />
          <path
            d="M294.287 181.257C294.287 182.24 295.083 183.037 296.066 183.037C297.049 183.037 297.846 182.24 297.846 181.257C297.846 180.274 297.049 179.478 296.066 179.478C295.083 179.478 294.287 180.274 294.287 181.257Z"
            fill="#B8B7B7"
          />
          <path
            d="M288.07 181.257C288.07 182.24 288.867 183.037 289.85 183.037C290.833 183.037 291.63 182.24 291.63 181.257C291.63 180.275 290.833 179.478 289.85 179.478C288.867 179.478 288.07 180.275 288.07 181.257Z"
            fill="#B8B7B7"
          />
          <path
            d="M281.912 181.257C281.912 182.24 282.708 183.037 283.691 183.037C284.674 183.037 285.471 182.24 285.471 181.257C285.471 180.275 284.674 179.478 283.691 179.478C282.708 179.478 281.912 180.275 281.912 181.257Z"
            fill="#B8B7B7"
          />
          <path
            d="M275.763 181.248C275.763 182.231 276.56 183.028 277.542 183.028C278.525 183.028 279.322 182.231 279.322 181.248C279.322 180.265 278.525 179.469 277.542 179.469C276.56 179.469 275.763 180.265 275.763 181.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M269.604 181.248C269.604 182.231 270.401 183.028 271.384 183.028C272.367 183.028 273.164 182.231 273.164 181.248C273.164 180.265 272.367 179.469 271.384 179.469C270.401 179.469 269.604 180.265 269.604 181.248Z"
            fill="#B8B7B7"
          />
          <path
            d="M263.403 181.257C263.403 182.24 264.2 183.037 265.183 183.037C266.166 183.037 266.963 182.24 266.963 181.257C266.963 180.275 266.166 179.478 265.183 179.478C264.2 179.478 263.403 180.275 263.403 181.257Z"
            fill="#B8B7B7"
          />
          <path
            d="M257.244 181.257C257.244 182.24 258.041 183.037 259.024 183.037C260.007 183.037 260.803 182.24 260.803 181.257C260.803 180.275 260.007 179.478 259.024 179.478C258.041 179.478 257.244 180.275 257.244 181.257Z"
            fill="#B8B7B7"
          />
          <path
            d="M251.08 181.257C251.08 182.24 251.876 183.037 252.859 183.037C253.842 183.037 254.639 182.24 254.639 181.257C254.639 180.275 253.842 179.478 252.859 179.478C251.876 179.478 251.08 180.275 251.08 181.257Z"
            fill="#B8B7B7"
          />
          <path
            d="M244.921 181.257C244.921 182.24 245.718 183.037 246.701 183.037C247.684 183.037 248.48 182.24 248.48 181.257C248.48 180.275 247.684 179.478 246.701 179.478C245.718 179.478 244.921 180.275 244.921 181.257Z"
            fill="#B8B7B7"
          />
          <path
            d="M238.72 181.257C238.72 182.24 239.517 183.037 240.5 183.037C241.483 183.037 242.28 182.24 242.28 181.257C242.28 180.275 241.483 179.478 240.5 179.478C239.517 179.478 238.72 180.275 238.72 181.257Z"
            fill="#B8B7B7"
          />
          <path
            d="M232.561 181.257C232.561 182.24 233.358 183.037 234.341 183.037C235.324 183.037 236.121 182.24 236.121 181.257C236.121 180.275 235.324 179.478 234.341 179.478C233.358 179.478 232.561 180.275 232.561 181.257Z"
            fill="#B8B7B7"
          />
          <path
            d="M226.392 181.263C226.392 182.246 227.189 183.042 228.172 183.042C229.155 183.042 229.951 182.246 229.951 181.263C229.951 180.28 229.155 179.483 228.172 179.483C227.189 179.483 226.392 180.28 226.392 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M220.233 181.263C220.233 182.246 221.03 183.042 222.012 183.042C222.995 183.042 223.792 182.246 223.792 181.263C223.792 180.28 222.995 179.483 222.012 179.483C221.03 179.483 220.233 180.28 220.233 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M214.017 181.263C214.017 182.246 214.813 183.042 215.796 183.042C216.779 183.042 217.576 182.246 217.576 181.263C217.576 180.28 216.779 179.483 215.796 179.483C214.813 179.483 214.017 180.28 214.017 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M207.857 181.263C207.857 182.246 208.654 183.042 209.637 183.042C210.62 183.042 211.417 182.246 211.417 181.263C211.417 180.28 210.62 179.483 209.637 179.483C208.654 179.483 207.857 180.28 207.857 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M201.709 181.252C201.709 182.235 202.506 183.032 203.489 183.032C204.471 183.032 205.268 182.235 205.268 181.252C205.268 180.269 204.471 179.472 203.489 179.472C202.506 179.472 201.709 180.269 201.709 181.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M195.55 181.252C195.55 182.235 196.347 183.032 197.33 183.032C198.313 183.032 199.109 182.235 199.109 181.252C199.109 180.269 198.313 179.472 197.33 179.472C196.347 179.472 195.55 180.269 195.55 181.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M189.349 181.263C189.349 182.246 190.146 183.042 191.129 183.042C192.112 183.042 192.908 182.246 192.908 181.263C192.908 180.28 192.112 179.483 191.129 179.483C190.146 179.483 189.349 180.28 189.349 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M183.191 181.263C183.191 182.246 183.988 183.042 184.971 183.042C185.954 183.042 186.751 182.246 186.751 181.263C186.751 180.28 185.954 179.483 184.971 179.483C183.988 179.483 183.191 180.28 183.191 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M177.026 181.263C177.026 182.246 177.823 183.042 178.806 183.042C179.789 183.042 180.585 182.246 180.585 181.263C180.585 180.28 179.789 179.483 178.806 179.483C177.823 179.483 177.026 180.28 177.026 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M170.867 181.263C170.867 182.246 171.664 183.042 172.646 183.042C173.629 183.042 174.426 182.246 174.426 181.263C174.426 180.28 173.629 179.483 172.646 179.483C171.664 179.483 170.867 180.28 170.867 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M164.666 181.263C164.666 182.246 165.463 183.042 166.446 183.042C167.429 183.042 168.225 182.246 168.225 181.263C168.225 180.28 167.429 179.483 166.446 179.483C165.463 179.483 164.666 180.28 164.666 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.508 181.263C158.508 182.246 159.305 183.042 160.288 183.042C161.271 183.042 162.068 182.246 162.068 181.263C162.068 180.28 161.271 179.483 160.288 179.483C159.305 179.483 158.508 180.28 158.508 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M303.53 186.502C303.53 187.485 304.327 188.282 305.31 188.282C306.293 188.282 307.09 187.485 307.09 186.502C307.09 185.519 306.293 184.722 305.31 184.722C304.327 184.722 303.53 185.519 303.53 186.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M297.371 186.502C297.371 187.485 298.168 188.282 299.151 188.282C300.134 188.282 300.93 187.485 300.93 186.502C300.93 185.519 300.134 184.722 299.151 184.722C298.168 184.722 297.371 185.519 297.371 186.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M291.155 186.502C291.155 187.485 291.951 188.282 292.934 188.282C293.917 188.282 294.714 187.485 294.714 186.502C294.714 185.519 293.917 184.722 292.934 184.722C291.951 184.722 291.155 185.519 291.155 186.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M284.995 186.502C284.995 187.485 285.792 188.282 286.775 188.282C287.758 188.282 288.555 187.485 288.555 186.502C288.555 185.519 287.758 184.722 286.775 184.722C285.792 184.722 284.995 185.519 284.995 186.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M278.847 186.493C278.847 187.476 279.644 188.273 280.626 188.273C281.609 188.273 282.406 187.476 282.406 186.493C282.406 185.51 281.609 184.713 280.626 184.713C279.644 184.713 278.847 185.51 278.847 186.493Z"
            fill="#B8B7B7"
          />
          <path
            d="M272.688 186.493C272.688 187.476 273.485 188.273 274.468 188.273C275.451 188.273 276.248 187.476 276.248 186.493C276.248 185.51 275.451 184.713 274.468 184.713C273.485 184.713 272.688 185.51 272.688 186.493Z"
            fill="#B8B7B7"
          />
          <path
            d="M266.489 186.502C266.489 187.485 267.286 188.282 268.269 188.282C269.252 188.282 270.048 187.485 270.048 186.502C270.048 185.519 269.252 184.722 268.269 184.722C267.286 184.722 266.489 185.519 266.489 186.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M260.33 186.502C260.33 187.485 261.126 188.282 262.109 188.282C263.092 188.282 263.889 187.485 263.889 186.502C263.889 185.519 263.092 184.722 262.109 184.722C261.126 184.722 260.33 185.519 260.33 186.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M254.164 186.502C254.164 187.485 254.961 188.282 255.944 188.282C256.927 188.282 257.723 187.485 257.723 186.502C257.723 185.519 256.927 184.722 255.944 184.722C254.961 184.722 254.164 185.519 254.164 186.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M248.005 186.502C248.005 187.485 248.802 188.282 249.785 188.282C250.768 188.282 251.564 187.485 251.564 186.502C251.564 185.519 250.768 184.722 249.785 184.722C248.802 184.722 248.005 185.519 248.005 186.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M241.806 186.502C241.806 187.485 242.603 188.282 243.586 188.282C244.569 188.282 245.365 187.485 245.365 186.502C245.365 185.519 244.569 184.722 243.586 184.722C242.603 184.722 241.806 185.519 241.806 186.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M235.647 186.502C235.647 187.485 236.443 188.282 237.426 188.282C238.409 188.282 239.206 187.485 239.206 186.502C239.206 185.519 238.409 184.722 237.426 184.722C236.443 184.722 235.647 185.519 235.647 186.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M229.477 186.507C229.477 187.49 230.274 188.287 231.257 188.287C232.24 188.287 233.037 187.49 233.037 186.507C233.037 185.524 232.24 184.727 231.257 184.727C230.274 184.727 229.477 185.524 229.477 186.507Z"
            fill="#B8B7B7"
          />
          <path
            d="M223.318 186.507C223.318 187.49 224.115 188.287 225.098 188.287C226.081 188.287 226.877 187.49 226.877 186.507C226.877 185.524 226.081 184.727 225.098 184.727C224.115 184.727 223.318 185.524 223.318 186.507Z"
            fill="#B8B7B7"
          />
          <path
            d="M217.102 186.507C217.102 187.49 217.898 188.287 218.881 188.287C219.864 188.287 220.661 187.49 220.661 186.507C220.661 185.524 219.864 184.727 218.881 184.727C217.898 184.727 217.102 185.524 217.102 186.507Z"
            fill="#B8B7B7"
          />
          <path
            d="M210.943 186.507C210.943 187.49 211.739 188.287 212.722 188.287C213.705 188.287 214.502 187.49 214.502 186.507C214.502 185.524 213.705 184.727 212.722 184.727C211.739 184.727 210.943 185.524 210.943 186.507Z"
            fill="#B8B7B7"
          />
          <path
            d="M204.794 186.498C204.794 187.481 205.591 188.278 206.574 188.278C207.557 188.278 208.354 187.481 208.354 186.498C208.354 185.515 207.557 184.718 206.574 184.718C205.591 184.718 204.794 185.515 204.794 186.498Z"
            fill="#B8B7B7"
          />
          <path
            d="M198.635 186.498C198.635 187.481 199.432 188.278 200.415 188.278C201.398 188.278 202.195 187.481 202.195 186.498C202.195 185.515 201.398 184.718 200.415 184.718C199.432 184.718 198.635 185.515 198.635 186.498Z"
            fill="#B8B7B7"
          />
          <path
            d="M192.434 186.507C192.434 187.49 193.231 188.287 194.214 188.287C195.197 188.287 195.994 187.49 195.994 186.507C195.994 185.524 195.197 184.727 194.214 184.727C193.231 184.727 192.434 185.524 192.434 186.507Z"
            fill="#B8B7B7"
          />
          <path
            d="M186.275 186.507C186.275 187.49 187.072 188.287 188.055 188.287C189.038 188.287 189.835 187.49 189.835 186.507C189.835 185.524 189.038 184.727 188.055 184.727C187.072 184.727 186.275 185.524 186.275 186.507Z"
            fill="#B8B7B7"
          />
          <path
            d="M180.111 186.507C180.111 187.49 180.908 188.287 181.891 188.287C182.874 188.287 183.671 187.49 183.671 186.507C183.671 185.524 182.874 184.727 181.891 184.727C180.908 184.727 180.111 185.524 180.111 186.507Z"
            fill="#B8B7B7"
          />
          <path
            d="M173.952 186.507C173.952 187.49 174.749 188.287 175.732 188.287C176.715 188.287 177.512 187.49 177.512 186.507C177.512 185.524 176.715 184.727 175.732 184.727C174.749 184.727 173.952 185.524 173.952 186.507Z"
            fill="#B8B7B7"
          />
          <path
            d="M167.751 186.507C167.751 187.49 168.548 188.287 169.531 188.287C170.514 188.287 171.311 187.49 171.311 186.507C171.311 185.524 170.514 184.727 169.531 184.727C168.548 184.727 167.751 185.524 167.751 186.507Z"
            fill="#B8B7B7"
          />
          <path
            d="M161.593 186.507C161.593 187.49 162.389 188.287 163.372 188.287C164.355 188.287 165.152 187.49 165.152 186.507C165.152 185.524 164.355 184.727 163.372 184.727C162.389 184.727 161.593 185.524 161.593 186.507Z"
            fill="#B8B7B7"
          />
          <path
            d="M306.603 181.229C306.603 182.212 307.4 183.009 308.383 183.009C309.366 183.009 310.163 182.212 310.163 181.229C310.163 180.246 309.366 179.449 308.383 179.449C307.4 179.449 306.603 180.246 306.603 181.229Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.412 102.124C155.412 103.107 156.209 103.904 157.192 103.904C158.175 103.904 158.972 103.107 158.972 102.124C158.972 101.141 158.175 100.344 157.192 100.344C156.209 100.344 155.412 101.141 155.412 102.124Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.254 102.124C149.254 103.107 150.051 103.904 151.033 103.904C152.016 103.904 152.813 103.107 152.813 102.124C152.813 101.141 152.016 100.344 151.033 100.344C150.051 100.344 149.254 101.141 149.254 102.124Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.037 102.124C143.037 103.107 143.834 103.904 144.817 103.904C145.8 103.904 146.597 103.107 146.597 102.124C146.597 101.141 145.8 100.344 144.817 100.344C143.834 100.344 143.037 101.141 143.037 102.124Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.878 102.124C136.878 103.107 137.675 103.904 138.658 103.904C139.641 103.904 140.438 103.107 140.438 102.124C140.438 101.141 139.641 100.344 138.658 100.344C137.675 100.344 136.878 101.141 136.878 102.124Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.73 102.115C130.73 103.098 131.527 103.895 132.51 103.895C133.493 103.895 134.289 103.098 134.289 102.115C134.289 101.132 133.493 100.335 132.51 100.335C131.527 100.335 130.73 101.132 130.73 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.571 102.115C124.571 103.098 125.367 103.895 126.35 103.895C127.333 103.895 128.13 103.098 128.13 102.115C128.13 101.132 127.333 100.335 126.35 100.335C125.367 100.335 124.571 101.132 124.571 102.115Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.37 102.124C118.37 103.107 119.167 103.904 120.15 103.904C121.133 103.904 121.929 103.107 121.929 102.124C121.929 101.141 121.133 100.344 120.15 100.344C119.167 100.344 118.37 101.141 118.37 102.124Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.211 102.124C112.211 103.107 113.008 103.904 113.99 103.904C114.973 103.904 115.77 103.107 115.77 102.124C115.77 101.141 114.973 100.344 113.99 100.344C113.008 100.344 112.211 101.141 112.211 102.124Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.047 102.124C106.047 103.107 106.844 103.904 107.827 103.904C108.81 103.904 109.606 103.107 109.606 102.124C109.606 101.141 108.81 100.344 107.827 100.344C106.844 100.344 106.047 101.141 106.047 102.124Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8877 102.124C99.8877 103.107 100.685 103.904 101.667 103.904C102.65 103.904 103.447 103.107 103.447 102.124C103.447 101.141 102.65 100.344 101.667 100.344C100.685 100.344 99.8877 101.141 99.8877 102.124Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.687 102.124C93.687 103.107 94.4839 103.904 95.4668 103.904C96.4498 103.904 97.2466 103.107 97.2466 102.124C97.2466 101.141 96.4498 100.344 95.4668 100.344C94.4839 100.344 93.687 101.141 93.687 102.124Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5281 102.124C87.5281 103.107 88.3249 103.904 89.3079 103.904C90.2908 103.904 91.0876 103.107 91.0876 102.124C91.0876 101.141 90.2908 100.344 89.3079 100.344C88.3249 100.344 87.5281 101.141 87.5281 102.124Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3587 102.129C81.3587 103.112 82.1555 103.909 83.1384 103.909C84.1214 103.909 84.9182 103.112 84.9182 102.129C84.9182 101.146 84.1214 100.349 83.1384 100.349C82.1555 100.349 81.3587 101.146 81.3587 102.129Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.1996 102.129C75.1996 103.112 75.9964 103.909 76.9794 103.909C77.9623 103.909 78.7592 103.112 78.7592 102.129C78.7592 101.146 77.9623 100.349 76.9794 100.349C75.9964 100.349 75.1996 101.146 75.1996 102.129Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9832 102.129C68.9832 103.112 69.78 103.909 70.763 103.909C71.7459 103.909 72.5427 103.112 72.5427 102.129C72.5427 101.146 71.7459 100.349 70.763 100.349C69.78 100.349 68.9832 101.146 68.9832 102.129Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8244 102.129C62.8244 103.112 63.6212 103.909 64.6041 103.909C65.5871 103.909 66.3839 103.112 66.3839 102.129C66.3839 101.146 65.5871 100.349 64.6041 100.349C63.6212 100.349 62.8244 101.146 62.8244 102.129Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6756 102.119C56.6756 103.102 57.4724 103.898 58.4553 103.898C59.4383 103.898 60.2351 103.102 60.2351 102.119C60.2351 101.136 59.4383 100.339 58.4553 100.339C57.4724 100.339 56.6756 101.136 56.6756 102.119Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5166 102.119C50.5166 103.102 51.3135 103.898 52.2964 103.898C53.2793 103.898 54.0762 103.102 54.0762 102.119C54.0762 101.136 53.2793 100.339 52.2964 100.339C51.3135 100.339 50.5166 101.136 50.5166 102.119Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3161 102.129C44.3161 103.112 45.1129 103.909 46.0958 103.909C47.0788 103.909 47.8756 103.112 47.8756 102.129C47.8756 101.146 47.0788 100.349 46.0958 100.349C45.1129 100.349 44.3161 101.146 44.3161 102.129Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1582 102.129C38.1582 103.112 38.9551 103.909 39.938 103.909C40.9209 103.909 41.7178 103.112 41.7178 102.129C41.7178 101.146 40.9209 100.349 39.938 100.349C38.9551 100.349 38.1582 101.146 38.1582 102.129Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.9926 102.129C31.9926 103.112 32.7894 103.909 33.7724 103.909C34.7553 103.909 35.5521 103.112 35.5521 102.129C35.5521 101.146 34.7553 100.349 33.7724 100.349C32.7894 100.349 31.9926 101.146 31.9926 102.129Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8335 102.129C25.8335 103.112 26.6304 103.909 27.6133 103.909C28.5962 103.909 29.3931 103.112 29.3931 102.129C29.3931 101.146 28.5962 100.349 27.6133 100.349C26.6304 100.349 25.8335 101.146 25.8335 102.129Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6332 102.129C19.6332 103.112 20.43 103.909 21.413 103.909C22.3959 103.909 23.1927 103.112 23.1927 102.129C23.1927 101.146 22.3959 100.349 21.413 100.349C20.43 100.349 19.6332 101.146 19.6332 102.129Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4754 102.129C13.4754 103.112 14.2722 103.909 15.2551 103.909C16.2381 103.909 17.0349 103.112 17.0349 102.129C17.0349 101.146 16.2381 100.349 15.2551 100.349C14.2722 100.349 13.4754 101.146 13.4754 102.129Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.327 107.426C152.327 108.408 153.124 109.205 154.107 109.205C155.09 109.205 155.887 108.408 155.887 107.426C155.887 106.443 155.09 105.646 154.107 105.646C153.124 105.646 152.327 106.443 152.327 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.168 107.426C146.168 108.408 146.965 109.205 147.948 109.205C148.931 109.205 149.728 108.408 149.728 107.426C149.728 106.443 148.931 105.646 147.948 105.646C146.965 105.646 146.168 106.443 146.168 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.952 107.426C139.952 108.408 140.749 109.205 141.732 109.205C142.715 109.205 143.512 108.408 143.512 107.426C143.512 106.443 142.715 105.646 141.732 105.646C140.749 105.646 139.952 106.443 139.952 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.793 107.426C133.793 108.408 134.59 109.205 135.573 109.205C136.556 109.205 137.353 108.408 137.353 107.426C137.353 106.443 136.556 105.646 135.573 105.646C134.59 105.646 133.793 106.443 133.793 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.644 107.416C127.644 108.399 128.441 109.196 129.424 109.196C130.407 109.196 131.204 108.399 131.204 107.416C131.204 106.434 130.407 105.637 129.424 105.637C128.441 105.637 127.644 106.434 127.644 107.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.485 107.416C121.485 108.399 122.282 109.196 123.265 109.196C124.248 109.196 125.045 108.399 125.045 107.416C125.045 106.434 124.248 105.637 123.265 105.637C122.282 105.637 121.485 106.434 121.485 107.416Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.285 107.426C115.285 108.408 116.081 109.205 117.064 109.205C118.047 109.205 118.844 108.408 118.844 107.426C118.844 106.443 118.047 105.646 117.064 105.646C116.081 105.646 115.285 106.443 115.285 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.127 107.426C109.127 108.408 109.924 109.205 110.907 109.205C111.89 109.205 112.687 108.408 112.687 107.426C112.687 106.443 111.89 105.646 110.907 105.646C109.924 105.646 109.127 106.443 109.127 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.961 107.426C102.961 108.408 103.758 109.205 104.741 109.205C105.724 109.205 106.521 108.408 106.521 107.426C106.521 106.443 105.724 105.646 104.741 105.646C103.758 105.646 102.961 106.443 102.961 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.802 107.426C96.802 108.408 97.5989 109.205 98.5818 109.205C99.5647 109.205 100.362 108.408 100.362 107.426C100.362 106.443 99.5647 105.646 98.5818 105.646C97.5989 105.646 96.802 106.443 96.802 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6015 107.426C90.6015 108.408 91.3983 109.205 92.3812 109.205C93.3642 109.205 94.161 108.408 94.161 107.426C94.161 106.443 93.3642 105.646 92.3812 105.646C91.3983 105.646 90.6015 106.443 90.6015 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.444 107.426C84.444 108.408 85.2408 109.205 86.2238 109.205C87.2067 109.205 88.0035 108.408 88.0035 107.426C88.0035 106.443 87.2067 105.646 86.2238 105.646C85.2408 105.646 84.444 106.443 84.444 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2733 107.429C78.2733 108.412 79.0702 109.209 80.0531 109.209C81.0361 109.209 81.8329 108.412 81.8329 107.429C81.8329 106.447 81.0361 105.65 80.0531 105.65C79.0702 105.65 78.2733 106.447 78.2733 107.429Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.114 107.429C72.114 108.412 72.9109 109.209 73.8938 109.209C74.8768 109.209 75.6736 108.412 75.6736 107.429C75.6736 106.447 74.8768 105.65 73.8938 105.65C72.9109 105.65 72.114 106.447 72.114 107.429Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.8981 107.429C65.8981 108.412 66.6949 109.209 67.6779 109.209C68.6608 109.209 69.4576 108.412 69.4576 107.429C69.4576 106.447 68.6608 105.65 67.6779 105.65C66.6949 105.65 65.8981 106.447 65.8981 107.429Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.7388 107.429C59.7388 108.412 60.5356 109.209 61.5186 109.209C62.5015 109.209 63.2983 108.412 63.2983 107.429C63.2983 106.447 62.5015 105.65 61.5186 105.65C60.5356 105.65 59.7388 106.447 59.7388 107.429Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.5902 107.42C53.5902 108.403 54.3871 109.2 55.37 109.2C56.3529 109.2 57.1498 108.403 57.1498 107.42C57.1498 106.437 56.3529 105.641 55.37 105.641C54.3871 105.641 53.5902 106.437 53.5902 107.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4311 107.42C47.4311 108.403 48.2279 109.2 49.2108 109.2C50.1938 109.2 50.9906 108.403 50.9906 107.42C50.9906 106.437 50.1938 105.641 49.2108 105.641C48.2279 105.641 47.4311 106.437 47.4311 107.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2321 107.429C41.2321 108.412 42.0289 109.209 43.0119 109.209C43.9948 109.209 44.7916 108.412 44.7916 107.429C44.7916 106.446 43.9948 105.65 43.0119 105.65C42.0289 105.65 41.2321 106.446 41.2321 107.429Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.073 107.429C35.073 108.412 35.8699 109.209 36.8528 109.209C37.8357 109.209 38.6326 108.412 38.6326 107.429C38.6326 106.446 37.8357 105.65 36.8528 105.65C35.8699 105.65 35.073 106.446 35.073 107.429Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9074 107.429C28.9074 108.412 29.7042 109.209 30.6871 109.209C31.6701 109.209 32.4669 108.412 32.4669 107.429C32.4669 106.446 31.6701 105.65 30.6871 105.65C29.7042 105.65 28.9074 106.446 28.9074 107.429Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7484 107.429C22.7484 108.412 23.5453 109.209 24.5282 109.209C25.5112 109.209 26.308 108.412 26.308 107.429C26.308 106.446 25.5112 105.65 24.5282 105.65C23.5453 105.65 22.7484 106.446 22.7484 107.429Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.549 107.429C16.549 108.412 17.3458 109.209 18.3287 109.209C19.3117 109.209 20.1085 108.412 20.1085 107.429C20.1085 106.446 19.3117 105.65 18.3288 105.65C17.3458 105.65 16.549 106.446 16.549 107.429Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.39 107.429C10.39 108.412 11.1869 109.209 12.1698 109.209C13.1528 109.209 13.9496 108.412 13.9496 107.429C13.9496 106.446 13.1528 105.65 12.1698 105.65C11.1869 105.65 10.39 106.446 10.39 107.429Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.412 112.67C155.412 113.653 156.209 114.45 157.192 114.45C158.175 114.45 158.972 113.653 158.972 112.67C158.972 111.687 158.175 110.89 157.192 110.89C156.209 110.89 155.412 111.687 155.412 112.67Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.254 112.67C149.254 113.653 150.051 114.45 151.033 114.45C152.016 114.45 152.813 113.653 152.813 112.67C152.813 111.687 152.016 110.89 151.033 110.89C150.051 110.89 149.254 111.687 149.254 112.67Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.037 112.67C143.037 113.653 143.834 114.45 144.817 114.45C145.8 114.45 146.597 113.653 146.597 112.67C146.597 111.687 145.8 110.89 144.817 110.89C143.834 110.89 143.037 111.687 143.037 112.67Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.878 112.67C136.878 113.653 137.675 114.45 138.658 114.45C139.641 114.45 140.438 113.653 140.438 112.67C140.438 111.687 139.641 110.89 138.658 110.89C137.675 110.89 136.878 111.687 136.878 112.67Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.73 112.661C130.73 113.644 131.527 114.441 132.51 114.441C133.493 114.441 134.289 113.644 134.289 112.661C134.289 111.678 133.493 110.881 132.51 110.881C131.527 110.881 130.73 111.678 130.73 112.661Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.571 112.661C124.571 113.644 125.367 114.441 126.35 114.441C127.333 114.441 128.13 113.644 128.13 112.661C128.13 111.678 127.333 110.881 126.35 110.881C125.367 110.881 124.571 111.678 124.571 112.661Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.37 112.67C118.37 113.653 119.167 114.45 120.15 114.45C121.133 114.45 121.929 113.653 121.929 112.67C121.929 111.687 121.133 110.89 120.15 110.89C119.167 110.89 118.37 111.687 118.37 112.67Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.211 112.67C112.211 113.653 113.008 114.45 113.99 114.45C114.973 114.45 115.77 113.653 115.77 112.67C115.77 111.687 114.973 110.89 113.99 110.89C113.008 110.89 112.211 111.687 112.211 112.67Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.047 112.67C106.047 113.653 106.844 114.45 107.827 114.45C108.81 114.45 109.606 113.653 109.606 112.67C109.606 111.687 108.81 110.89 107.827 110.89C106.844 110.89 106.047 111.687 106.047 112.67Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8877 112.67C99.8877 113.653 100.685 114.45 101.667 114.45C102.65 114.45 103.447 113.653 103.447 112.67C103.447 111.687 102.65 110.89 101.667 110.89C100.685 110.89 99.8877 111.687 99.8877 112.67Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.687 112.67C93.687 113.653 94.4839 114.45 95.4668 114.45C96.4498 114.45 97.2466 113.653 97.2466 112.67C97.2466 111.687 96.4498 110.89 95.4668 110.89C94.4839 110.89 93.687 111.687 93.687 112.67Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5281 112.67C87.5281 113.653 88.3249 114.45 89.3079 114.45C90.2908 114.45 91.0876 113.653 91.0876 112.67C91.0876 111.687 90.2908 110.89 89.3079 110.89C88.3249 110.89 87.5281 111.687 87.5281 112.67Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3587 112.675C81.3587 113.658 82.1555 114.455 83.1384 114.455C84.1214 114.455 84.9182 113.658 84.9182 112.675C84.9182 111.692 84.1214 110.895 83.1384 110.895C82.1555 110.895 81.3587 111.692 81.3587 112.675Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.1996 112.675C75.1996 113.658 75.9964 114.455 76.9794 114.455C77.9623 114.455 78.7592 113.658 78.7592 112.675C78.7592 111.692 77.9623 110.895 76.9794 110.895C75.9964 110.895 75.1996 111.692 75.1996 112.675Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9832 112.675C68.9832 113.658 69.78 114.455 70.763 114.455C71.7459 114.455 72.5427 113.658 72.5427 112.675C72.5427 111.692 71.7459 110.895 70.763 110.895C69.78 110.895 68.9832 111.692 68.9832 112.675Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8245 112.675C62.8245 113.658 63.6213 114.455 64.6043 114.455C65.5872 114.455 66.384 113.658 66.384 112.675C66.384 111.692 65.5872 110.895 64.6043 110.895C63.6213 110.895 62.8245 111.692 62.8245 112.675Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6756 112.665C56.6756 113.648 57.4724 114.445 58.4553 114.445C59.4383 114.445 60.2351 113.648 60.2351 112.665C60.2351 111.682 59.4383 110.885 58.4553 110.885C57.4724 110.885 56.6756 111.682 56.6756 112.665Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5166 112.665C50.5166 113.648 51.3135 114.445 52.2964 114.445C53.2793 114.445 54.0762 113.648 54.0762 112.665C54.0762 111.682 53.2793 110.885 52.2964 110.885C51.3135 110.885 50.5166 111.682 50.5166 112.665Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3161 112.675C44.3161 113.658 45.1129 114.455 46.0958 114.455C47.0788 114.455 47.8756 113.658 47.8756 112.675C47.8756 111.692 47.0788 110.895 46.0958 110.895C45.1129 110.895 44.3161 111.692 44.3161 112.675Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1582 112.675C38.1582 113.658 38.9551 114.455 39.938 114.455C40.9209 114.455 41.7178 113.658 41.7178 112.675C41.7178 111.692 40.9209 110.895 39.938 110.895C38.9551 110.895 38.1582 111.692 38.1582 112.675Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.9926 112.675C31.9926 113.658 32.7894 114.455 33.7724 114.455C34.7553 114.455 35.5521 113.658 35.5521 112.675C35.5521 111.692 34.7553 110.895 33.7724 110.895C32.7894 110.895 31.9926 111.692 31.9926 112.675Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8335 112.675C25.8335 113.658 26.6304 114.455 27.6133 114.455C28.5962 114.455 29.3931 113.658 29.3931 112.675C29.3931 111.692 28.5962 110.895 27.6133 110.895C26.6304 110.895 25.8335 111.692 25.8335 112.675Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6332 112.675C19.6332 113.658 20.43 114.455 21.413 114.455C22.3959 114.455 23.1927 113.658 23.1927 112.675C23.1927 111.692 22.3959 110.895 21.413 110.895C20.43 110.895 19.6332 111.692 19.6332 112.675Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4754 112.675C13.4754 113.658 14.2722 114.455 15.2551 114.455C16.2381 114.455 17.0349 113.658 17.0349 112.675C17.0349 111.692 16.2381 110.895 15.2551 110.895C14.2722 110.895 13.4754 111.692 13.4754 112.675Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.338 117.96C152.338 118.943 153.135 119.74 154.117 119.74C155.1 119.74 155.897 118.943 155.897 117.96C155.897 116.977 155.1 116.18 154.117 116.18C153.135 116.18 152.338 116.977 152.338 117.96Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.178 117.96C146.178 118.943 146.975 119.74 147.958 119.74C148.941 119.74 149.738 118.943 149.738 117.96C149.738 116.977 148.941 116.18 147.958 116.18C146.975 116.18 146.178 116.977 146.178 117.96Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.963 117.96C139.963 118.943 140.76 119.74 141.742 119.74C142.725 119.74 143.522 118.943 143.522 117.96C143.522 116.977 142.725 116.18 141.742 116.18C140.76 116.18 139.963 116.977 139.963 117.96Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.803 117.96C133.803 118.943 134.6 119.74 135.583 119.74C136.566 119.74 137.363 118.943 137.363 117.96C137.363 116.977 136.566 116.18 135.583 116.18C134.6 116.18 133.803 116.977 133.803 117.96Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.655 117.951C127.655 118.934 128.452 119.731 129.434 119.731C130.417 119.731 131.214 118.934 131.214 117.951C131.214 116.968 130.417 116.171 129.434 116.171C128.452 116.171 127.655 116.968 127.655 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.496 117.951C121.496 118.934 122.292 119.731 123.275 119.731C124.258 119.731 125.055 118.934 125.055 117.951C125.055 116.968 124.258 116.171 123.275 116.171C122.292 116.171 121.496 116.968 121.496 117.951Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.296 117.96C115.296 118.943 116.093 119.74 117.076 119.74C118.059 119.74 118.856 118.943 118.856 117.96C118.856 116.977 118.059 116.18 117.076 116.18C116.093 116.18 115.296 116.977 115.296 117.96Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.138 117.96C109.138 118.943 109.934 119.74 110.917 119.74C111.9 119.74 112.697 118.943 112.697 117.96C112.697 116.977 111.9 116.18 110.917 116.18C109.934 116.18 109.138 116.977 109.138 117.96Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.972 117.96C102.972 118.943 103.769 119.74 104.751 119.74C105.734 119.74 106.531 118.943 106.531 117.96C106.531 116.977 105.734 116.18 104.751 116.18C103.769 116.18 102.972 116.977 102.972 117.96Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8129 117.96C96.8129 118.943 97.6097 119.74 98.5927 119.74C99.5756 119.74 100.372 118.943 100.372 117.96C100.372 116.977 99.5756 116.18 98.5927 116.18C97.6097 116.18 96.8129 116.977 96.8129 117.96Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6133 117.96C90.6133 118.943 91.4101 119.74 92.3931 119.74C93.376 119.74 94.1729 118.943 94.1729 117.96C94.1729 116.977 93.376 116.18 92.3931 116.18C91.4101 116.18 90.6133 116.977 90.6133 117.96Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4545 117.96C84.4545 118.943 85.2513 119.74 86.2343 119.74C87.2172 119.74 88.014 118.943 88.014 117.96C88.014 116.977 87.2172 116.18 86.2343 116.18C85.2513 116.18 84.4545 116.977 84.4545 117.96Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2848 117.965C78.2848 118.948 79.0816 119.745 80.0646 119.745C81.0475 119.745 81.8444 118.948 81.8444 117.965C81.8444 116.982 81.0475 116.185 80.0646 116.185C79.0816 116.185 78.2848 116.982 78.2848 117.965Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1259 117.965C72.1259 118.948 72.9227 119.745 73.9057 119.745C74.8886 119.745 75.6854 118.948 75.6854 117.965C75.6854 116.982 74.8886 116.185 73.9057 116.185C72.9227 116.185 72.1259 116.982 72.1259 117.965Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9096 117.965C65.9096 118.948 66.7064 119.745 67.6893 119.745C68.6723 119.745 69.4691 118.948 69.4691 117.965C69.4691 116.982 68.6723 116.185 67.6893 116.185C66.7064 116.185 65.9096 116.982 65.9096 117.965Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.7505 117.965C59.7505 118.948 60.5473 119.745 61.5303 119.745C62.5132 119.745 63.3101 118.948 63.3101 117.965C63.3101 116.982 62.5132 116.185 61.5303 116.185C60.5473 116.185 59.7505 116.982 59.7505 117.965Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6017 117.956C53.6017 118.939 54.3985 119.736 55.3815 119.736C56.3644 119.736 57.1613 118.939 57.1613 117.956C57.1613 116.973 56.3644 116.176 55.3815 116.176C54.3985 116.176 53.6017 116.973 53.6017 117.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4429 117.956C47.4429 118.939 48.2397 119.736 49.2227 119.736C50.2056 119.736 51.0024 118.939 51.0024 117.956C51.0024 116.973 50.2056 116.176 49.2227 116.176C48.2397 116.176 47.4429 116.973 47.4429 117.956Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2423 117.965C41.2423 118.948 42.0392 119.745 43.0221 119.745C44.005 119.745 44.8019 118.948 44.8019 117.965C44.8019 116.982 44.005 116.185 43.0221 116.185C42.0392 116.185 41.2423 116.982 41.2423 117.965Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.083 117.965C35.083 118.948 35.8799 119.745 36.8628 119.745C37.8457 119.745 38.6426 118.948 38.6426 117.965C38.6426 116.982 37.8457 116.185 36.8628 116.185C35.8799 116.185 35.083 116.982 35.083 117.965Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9192 117.965C28.9192 118.948 29.716 119.745 30.699 119.745C31.6819 119.745 32.4788 118.948 32.4788 117.965C32.4788 116.982 31.6819 116.185 30.699 116.185C29.716 116.185 28.9192 116.982 28.9192 117.965Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7599 117.965C22.7599 118.948 23.5567 119.745 24.5397 119.745C25.5226 119.745 26.3195 118.948 26.3195 117.965C26.3195 116.982 25.5226 116.185 24.5397 116.185C23.5567 116.185 22.7599 116.982 22.7599 117.965Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5594 117.965C16.5594 118.948 17.3562 119.745 18.3391 119.745C19.3221 119.745 20.1189 118.948 20.1189 117.965C20.1189 116.982 19.3221 116.185 18.3391 116.185C17.3562 116.185 16.5594 116.982 16.5594 117.965Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.4002 117.965C10.4002 118.948 11.197 119.745 12.1799 119.745C13.1629 119.745 13.9597 118.948 13.9597 117.965C13.9597 116.982 13.1629 116.185 12.1799 116.185C11.197 116.185 10.4002 116.982 10.4002 117.965Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.254 123.262C149.254 124.245 150.051 125.041 151.033 125.041C152.016 125.041 152.813 124.245 152.813 123.262C152.813 122.279 152.016 121.482 151.033 121.482C150.051 121.482 149.254 122.279 149.254 123.262Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.094 123.262C143.094 124.245 143.891 125.041 144.874 125.041C145.857 125.041 146.654 124.245 146.654 123.262C146.654 122.279 145.857 121.482 144.874 121.482C143.891 121.482 143.094 122.279 143.094 123.262Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.878 123.262C136.878 124.245 137.675 125.041 138.658 125.041C139.641 125.041 140.438 124.245 140.438 123.262C140.438 122.279 139.641 121.482 138.658 121.482C137.675 121.482 136.878 122.279 136.878 123.262Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.719 123.262C130.719 124.245 131.516 125.041 132.499 125.041C133.482 125.041 134.279 124.245 134.279 123.262C134.279 122.279 133.482 121.482 132.499 121.482C131.516 121.482 130.719 122.279 130.719 123.262Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.571 123.253C124.571 124.235 125.367 125.032 126.35 125.032C127.333 125.032 128.13 124.235 128.13 123.253C128.13 122.27 127.333 121.473 126.35 121.473C125.367 121.473 124.571 122.27 124.571 123.253Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.412 123.253C118.412 124.235 119.208 125.032 120.191 125.032C121.174 125.032 121.971 124.235 121.971 123.253C121.971 122.27 121.174 121.473 120.191 121.473C119.208 121.473 118.412 122.27 118.412 123.253Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.211 123.262C112.211 124.245 113.008 125.041 113.99 125.041C114.973 125.041 115.77 124.245 115.77 123.262C115.77 122.279 114.973 121.482 113.99 121.482C113.008 121.482 112.211 122.279 112.211 123.262Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.052 123.262C106.052 124.245 106.849 125.041 107.832 125.041C108.815 125.041 109.611 124.245 109.611 123.262C109.611 122.279 108.815 121.482 107.832 121.482C106.849 121.482 106.052 122.279 106.052 123.262Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8877 123.262C99.8877 124.245 100.685 125.041 101.667 125.041C102.65 125.041 103.447 124.245 103.447 123.262C103.447 122.279 102.65 121.482 101.667 121.482C100.685 121.482 99.8877 122.279 99.8877 123.262Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.7287 123.262C93.7287 124.245 94.5255 125.041 95.5084 125.041C96.4914 125.041 97.2882 124.245 97.2882 123.262C97.2882 122.279 96.4914 121.482 95.5084 121.482C94.5255 121.482 93.7287 122.279 93.7287 123.262Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5281 123.262C87.5281 124.245 88.3249 125.041 89.3079 125.041C90.2908 125.041 91.0876 124.245 91.0876 123.262C91.0876 122.279 90.2908 121.482 89.3079 121.482C88.3249 121.482 87.5281 122.279 87.5281 123.262Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3688 123.262C81.3688 124.245 82.1656 125.041 83.1486 125.041C84.1315 125.041 84.9283 124.245 84.9283 123.262C84.9283 122.279 84.1315 121.482 83.1486 121.482C82.1656 121.482 81.3688 122.279 81.3688 123.262Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.1996 123.267C75.1996 124.25 75.9964 125.047 76.9794 125.047C77.9623 125.047 78.7592 124.25 78.7592 123.267C78.7592 122.284 77.9623 121.487 76.9794 121.487C75.9964 121.487 75.1996 122.284 75.1996 123.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M69.0407 123.267C69.0407 124.25 69.8375 125.047 70.8204 125.047C71.8034 125.047 72.6002 124.25 72.6002 123.267C72.6002 122.284 71.8034 121.487 70.8204 121.487C69.8375 121.487 69.0407 122.284 69.0407 123.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8245 123.267C62.8245 124.25 63.6213 125.047 64.6043 125.047C65.5872 125.047 66.384 124.25 66.384 123.267C66.384 122.284 65.5872 121.487 64.6043 121.487C63.6213 121.487 62.8245 122.284 62.8245 123.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6651 123.267C56.6651 124.25 57.4619 125.047 58.4448 125.047C59.4278 125.047 60.2246 124.25 60.2246 123.267C60.2246 122.284 59.4278 121.487 58.4448 121.487C57.4619 121.487 56.6651 122.284 56.6651 123.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5166 123.256C50.5166 124.239 51.3135 125.036 52.2964 125.036C53.2793 125.036 54.0762 124.239 54.0762 123.256C54.0762 122.273 53.2793 121.477 52.2964 121.477C51.3135 121.477 50.5166 122.273 50.5166 123.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3578 123.256C44.3578 124.239 45.1546 125.036 46.1376 125.036C47.1205 125.036 47.9174 124.239 47.9174 123.256C47.9174 122.273 47.1205 121.477 46.1376 121.477C45.1546 121.477 44.3578 122.273 44.3578 123.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1582 123.267C38.1582 124.25 38.9551 125.047 39.938 125.047C40.9209 125.047 41.7178 124.25 41.7178 123.267C41.7178 122.284 40.9209 121.487 39.938 121.487C38.9551 121.487 38.1582 122.284 38.1582 123.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.9991 123.267C31.9991 124.25 32.7959 125.047 33.7788 125.047C34.7618 125.047 35.5586 124.25 35.5586 123.267C35.5586 122.284 34.7618 121.487 33.7788 121.487C32.7959 121.487 31.9991 122.284 31.9991 123.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8335 123.267C25.8335 124.25 26.6304 125.047 27.6133 125.047C28.5962 125.047 29.3931 124.25 29.3931 123.267C29.3931 122.284 28.5962 121.487 27.6133 121.487C26.6304 121.487 25.8335 122.284 25.8335 123.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6747 123.267C19.6747 124.25 20.4715 125.047 21.4545 125.047C22.4374 125.047 23.2343 124.25 23.2343 123.267C23.2343 122.284 22.4374 121.487 21.4545 121.487C20.4715 121.487 19.6747 122.284 19.6747 123.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4754 123.267C13.4754 124.25 14.2722 125.047 15.2551 125.047C16.2381 125.047 17.0349 124.25 17.0349 123.267C17.0349 122.284 16.2381 121.487 15.2551 121.487C14.2722 121.487 13.4754 122.284 13.4754 123.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.31631 123.267C7.31631 124.25 8.11314 125.047 9.09608 125.047C10.079 125.047 10.8759 124.25 10.8759 123.267C10.8759 122.284 10.079 121.487 9.09608 121.487C8.11314 121.487 7.31631 122.284 7.31631 123.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.338 128.506C152.338 129.489 153.135 130.286 154.117 130.286C155.1 130.286 155.897 129.489 155.897 128.506C155.897 127.523 155.1 126.726 154.117 126.726C153.135 126.726 152.338 127.523 152.338 128.506Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.178 128.506C146.178 129.489 146.975 130.286 147.958 130.286C148.941 130.286 149.738 129.489 149.738 128.506C149.738 127.523 148.941 126.726 147.958 126.726C146.975 126.726 146.178 127.523 146.178 128.506Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.963 128.506C139.963 129.489 140.76 130.286 141.742 130.286C142.725 130.286 143.522 129.489 143.522 128.506C143.522 127.523 142.725 126.726 141.742 126.726C140.76 126.726 139.963 127.523 139.963 128.506Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.803 128.506C133.803 129.489 134.6 130.286 135.583 130.286C136.566 130.286 137.363 129.489 137.363 128.506C137.363 127.523 136.566 126.726 135.583 126.726C134.6 126.726 133.803 127.523 133.803 128.506Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.655 128.497C127.655 129.48 128.452 130.277 129.434 130.277C130.417 130.277 131.214 129.48 131.214 128.497C131.214 127.514 130.417 126.717 129.434 126.717C128.452 126.717 127.655 127.514 127.655 128.497Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.496 128.497C121.496 129.48 122.292 130.277 123.275 130.277C124.258 130.277 125.055 129.48 125.055 128.497C125.055 127.514 124.258 126.717 123.275 126.717C122.292 126.717 121.496 127.514 121.496 128.497Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.296 128.506C115.296 129.489 116.093 130.286 117.076 130.286C118.059 130.286 118.856 129.489 118.856 128.506C118.856 127.523 118.059 126.726 117.076 126.726C116.093 126.726 115.296 127.523 115.296 128.506Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.138 128.506C109.138 129.489 109.934 130.286 110.917 130.286C111.9 130.286 112.697 129.489 112.697 128.506C112.697 127.523 111.9 126.726 110.917 126.726C109.934 126.726 109.138 127.523 109.138 128.506Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.972 128.506C102.972 129.489 103.769 130.286 104.751 130.286C105.734 130.286 106.531 129.489 106.531 128.506C106.531 127.523 105.734 126.726 104.751 126.726C103.769 126.726 102.972 127.523 102.972 128.506Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8129 128.506C96.8129 129.489 97.6097 130.286 98.5927 130.286C99.5756 130.286 100.372 129.489 100.372 128.506C100.372 127.523 99.5756 126.726 98.5927 126.726C97.6097 126.726 96.8129 127.523 96.8129 128.506Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6133 128.506C90.6133 129.489 91.4101 130.286 92.3931 130.286C93.376 130.286 94.1729 129.489 94.1729 128.506C94.1729 127.523 93.376 126.726 92.3931 126.726C91.4101 126.726 90.6133 127.523 90.6133 128.506Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4545 128.506C84.4545 129.489 85.2513 130.286 86.2343 130.286C87.2172 130.286 88.014 129.489 88.014 128.506C88.014 127.523 87.2172 126.726 86.2343 126.726C85.2513 126.726 84.4545 127.523 84.4545 128.506Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2848 128.511C78.2848 129.494 79.0816 130.291 80.0646 130.291C81.0475 130.291 81.8444 129.494 81.8444 128.511C81.8444 127.528 81.0475 126.732 80.0646 126.732C79.0816 126.732 78.2848 127.528 78.2848 128.511Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1259 128.511C72.1259 129.494 72.9227 130.291 73.9057 130.291C74.8886 130.291 75.6854 129.494 75.6854 128.511C75.6854 127.528 74.8886 126.732 73.9057 126.732C72.9227 126.732 72.1259 127.528 72.1259 128.511Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9096 128.511C65.9096 129.494 66.7064 130.291 67.6893 130.291C68.6723 130.291 69.4691 129.494 69.4691 128.511C69.4691 127.528 68.6723 126.732 67.6893 126.732C66.7064 126.732 65.9096 127.528 65.9096 128.511Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.7505 128.511C59.7505 129.494 60.5473 130.291 61.5303 130.291C62.5132 130.291 63.3101 129.494 63.3101 128.511C63.3101 127.528 62.5132 126.732 61.5303 126.732C60.5473 126.732 59.7505 127.528 59.7505 128.511Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6017 128.502C53.6017 129.485 54.3985 130.282 55.3815 130.282C56.3644 130.282 57.1613 129.485 57.1613 128.502C57.1613 127.519 56.3644 126.722 55.3815 126.722C54.3985 126.722 53.6017 127.519 53.6017 128.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4429 128.502C47.4429 129.485 48.2397 130.282 49.2227 130.282C50.2056 130.282 51.0024 129.485 51.0024 128.502C51.0024 127.519 50.2056 126.722 49.2227 126.722C48.2397 126.722 47.4429 127.519 47.4429 128.502Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2423 128.511C41.2423 129.494 42.0392 130.291 43.0221 130.291C44.005 130.291 44.8019 129.494 44.8019 128.511C44.8019 127.528 44.005 126.731 43.0221 126.731C42.0392 126.731 41.2423 127.528 41.2423 128.511Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.083 128.511C35.083 129.494 35.8799 130.291 36.8628 130.291C37.8457 130.291 38.6426 129.494 38.6426 128.511C38.6426 127.528 37.8457 126.731 36.8628 126.731C35.8799 126.731 35.083 127.528 35.083 128.511Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9192 128.511C28.9192 129.494 29.716 130.291 30.699 130.291C31.6819 130.291 32.4788 129.494 32.4788 128.511C32.4788 127.528 31.6819 126.732 30.699 126.732C29.716 126.732 28.9192 127.528 28.9192 128.511Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7599 128.511C22.7599 129.494 23.5567 130.291 24.5397 130.291C25.5226 130.291 26.3195 129.494 26.3195 128.511C26.3195 127.528 25.5226 126.732 24.5397 126.732C23.5567 126.732 22.7599 127.528 22.7599 128.511Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5594 128.511C16.5594 129.494 17.3562 130.291 18.3391 130.291C19.3221 130.291 20.1189 129.494 20.1189 128.511C20.1189 127.528 19.3221 126.732 18.3391 126.732C17.3562 126.732 16.5594 127.528 16.5594 128.511Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.4002 128.511C10.4002 129.494 11.197 130.291 12.1799 130.291C13.1629 130.291 13.9597 129.494 13.9597 128.511C13.9597 127.528 13.1629 126.732 12.1799 126.732C11.197 126.732 10.4002 127.528 10.4002 128.511Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.412 123.233C155.412 124.216 156.209 125.013 157.192 125.013C158.175 125.013 158.972 124.216 158.972 123.233C158.972 122.25 158.175 121.453 157.192 121.453C156.209 121.453 155.412 122.25 155.412 123.233Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 133.87C155.418 134.853 156.215 135.65 157.198 135.65C158.18 135.65 158.977 134.853 158.977 133.87C158.977 132.887 158.18 132.09 157.198 132.09C156.215 132.09 155.418 132.887 155.418 133.87Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 133.87C149.259 134.853 150.056 135.65 151.039 135.65C152.022 135.65 152.819 134.853 152.819 133.87C152.819 132.887 152.022 132.09 151.039 132.09C150.056 132.09 149.259 132.887 149.259 133.87Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.042 133.87C143.042 134.853 143.839 135.65 144.822 135.65C145.805 135.65 146.602 134.853 146.602 133.87C146.602 132.887 145.805 132.09 144.822 132.09C143.839 132.09 143.042 132.887 143.042 133.87Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 133.87C136.883 134.853 137.68 135.65 138.663 135.65C139.646 135.65 140.443 134.853 140.443 133.87C140.443 132.887 139.646 132.09 138.663 132.09C137.68 132.09 136.883 132.887 136.883 133.87Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.735 133.86C130.735 134.843 131.532 135.639 132.515 135.639C133.498 135.639 134.294 134.843 134.294 133.86C134.294 132.877 133.498 132.08 132.515 132.08C131.532 132.08 130.735 132.877 130.735 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 133.86C124.576 134.843 125.373 135.639 126.356 135.639C127.339 135.639 128.135 134.843 128.135 133.86C128.135 132.877 127.339 132.08 126.356 132.08C125.373 132.08 124.576 132.877 124.576 133.86Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.375 133.87C118.375 134.853 119.172 135.65 120.155 135.65C121.138 135.65 121.935 134.853 121.935 133.87C121.935 132.887 121.138 132.09 120.155 132.09C119.172 132.09 118.375 132.887 118.375 133.87Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 133.87C112.216 134.853 113.013 135.65 113.996 135.65C114.979 135.65 115.776 134.853 115.776 133.87C115.776 132.887 114.979 132.09 113.996 132.09C113.013 132.09 112.216 132.887 112.216 133.87Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.052 133.87C106.052 134.853 106.849 135.65 107.832 135.65C108.815 135.65 109.611 134.853 109.611 133.87C109.611 132.887 108.815 132.09 107.832 132.09C106.849 132.09 106.052 132.887 106.052 133.87Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 133.87C99.8931 134.853 100.69 135.65 101.673 135.65C102.656 135.65 103.453 134.853 103.453 133.87C103.453 132.887 102.656 132.09 101.673 132.09C100.69 132.09 99.8931 132.887 99.8931 133.87Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.6922 133.87C93.6922 134.853 94.489 135.65 95.4719 135.65C96.4549 135.65 97.2517 134.853 97.2517 133.87C97.2517 132.887 96.4549 132.09 95.4719 132.09C94.489 132.09 93.6922 132.887 93.6922 133.87Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5331 133.87C87.5331 134.853 88.3299 135.65 89.3129 135.65C90.2958 135.65 91.0927 134.853 91.0927 133.87C91.0927 132.887 90.2958 132.09 89.3129 132.09C88.3299 132.09 87.5331 132.887 87.5331 133.87Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3638 133.874C81.3638 134.857 82.1606 135.654 83.1436 135.654C84.1265 135.654 84.9233 134.857 84.9233 133.874C84.9233 132.891 84.1265 132.094 83.1436 132.094C82.1606 132.094 81.3638 132.891 81.3638 133.874Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 133.874C75.2046 134.857 76.0014 135.654 76.9844 135.654C77.9673 135.654 78.7642 134.857 78.7642 133.874C78.7642 132.891 77.9673 132.094 76.9844 132.094C76.0014 132.094 75.2046 132.891 75.2046 133.874Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9887 133.874C68.9887 134.857 69.7855 135.654 70.7684 135.654C71.7514 135.654 72.5482 134.857 72.5482 133.874C72.5482 132.891 71.7514 132.094 70.7684 132.094C69.7855 132.094 68.9887 132.891 68.9887 133.874Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 133.874C62.8294 134.857 63.6262 135.654 64.6091 135.654C65.5921 135.654 66.3889 134.857 66.3889 133.874C66.3889 132.891 65.5921 132.094 64.6091 132.094C63.6262 132.094 62.8294 132.891 62.8294 133.874Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6808 133.865C56.6808 134.848 57.4776 135.645 58.4606 135.645C59.4435 135.645 60.2404 134.848 60.2404 133.865C60.2404 132.882 59.4435 132.085 58.4606 132.085C57.4776 132.085 56.6808 132.882 56.6808 133.865Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 133.865C50.5216 134.848 51.3185 135.645 52.3014 135.645C53.2843 135.645 54.0812 134.848 54.0812 133.865C54.0812 132.882 53.2843 132.085 52.3014 132.085C51.3185 132.085 50.5216 132.882 50.5216 133.865Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3225 133.874C44.3225 134.857 45.1194 135.654 46.1023 135.654C47.0852 135.654 47.8821 134.857 47.8821 133.874C47.8821 132.891 47.0852 132.094 46.1023 132.094C45.1194 132.094 44.3225 132.891 44.3225 133.874Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 133.874C38.1634 134.857 38.9602 135.654 39.9431 135.654C40.9261 135.654 41.7229 134.857 41.7229 133.874C41.7229 132.891 40.9261 132.094 39.9431 132.094C38.9602 132.094 38.1634 132.891 38.1634 133.874Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.998 133.874C31.998 134.857 32.7948 135.654 33.7777 135.654C34.7607 135.654 35.5575 134.857 35.5575 133.874C35.5575 132.891 34.7607 132.094 33.7777 132.094C32.7948 132.094 31.998 132.891 31.998 133.874Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 133.874C25.8387 134.857 26.6355 135.654 27.6184 135.654C28.6014 135.654 29.3982 134.857 29.3982 133.874C29.3982 132.891 28.6014 132.094 27.6184 132.094C26.6355 132.094 25.8387 132.891 25.8387 133.874Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6396 133.874C19.6396 134.857 20.4364 135.654 21.4193 135.654C22.4023 135.654 23.1991 134.857 23.1991 133.874C23.1991 132.891 22.4023 132.094 21.4193 132.094C20.4364 132.094 19.6396 132.891 19.6396 133.874Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4803 133.874C13.4803 134.857 14.2771 135.654 15.26 135.654C16.243 135.654 17.0398 134.857 17.0398 133.874C17.0398 132.891 16.243 132.094 15.26 132.094C14.2771 132.094 13.4803 132.891 13.4803 133.874Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.333 139.17C152.333 140.153 153.129 140.95 154.112 140.95C155.095 140.95 155.892 140.153 155.892 139.17C155.892 138.187 155.095 137.391 154.112 137.391C153.129 137.391 152.333 138.187 152.333 139.17Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.173 139.17C146.173 140.153 146.97 140.95 147.953 140.95C148.936 140.95 149.733 140.153 149.733 139.17C149.733 138.187 148.936 137.391 147.953 137.391C146.97 137.391 146.173 138.187 146.173 139.17Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.957 139.17C139.957 140.153 140.754 140.95 141.737 140.95C142.72 140.95 143.517 140.153 143.517 139.17C143.517 138.187 142.72 137.391 141.737 137.391C140.754 137.391 139.957 138.187 139.957 139.17Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.798 139.17C133.798 140.153 134.595 140.95 135.578 140.95C136.561 140.95 137.358 140.153 137.358 139.17C137.358 138.187 136.561 137.391 135.578 137.391C134.595 137.391 133.798 138.187 133.798 139.17Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.65 139.161C127.65 140.144 128.447 140.941 129.43 140.941C130.413 140.941 131.209 140.144 131.209 139.161C131.209 138.178 130.413 137.382 129.43 137.382C128.447 137.382 127.65 138.178 127.65 139.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.491 139.161C121.491 140.144 122.287 140.941 123.27 140.941C124.253 140.941 125.05 140.144 125.05 139.161C125.05 138.178 124.253 137.382 123.27 137.382C122.287 137.382 121.491 138.178 121.491 139.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.291 139.17C115.291 140.153 116.088 140.95 117.071 140.95C118.054 140.95 118.851 140.153 118.851 139.17C118.851 138.187 118.054 137.391 117.071 137.391C116.088 137.391 115.291 138.187 115.291 139.17Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.132 139.17C109.132 140.153 109.929 140.95 110.912 140.95C111.895 140.95 112.692 140.153 112.692 139.17C112.692 138.187 111.895 137.391 110.912 137.391C109.929 137.391 109.132 138.187 109.132 139.17Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.967 139.17C102.967 140.153 103.764 140.95 104.747 140.95C105.73 140.95 106.526 140.153 106.526 139.17C106.526 138.187 105.73 137.391 104.747 137.391C103.764 137.391 102.967 138.187 102.967 139.17Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8074 139.17C96.8074 140.153 97.6042 140.95 98.5872 140.95C99.5701 140.95 100.367 140.153 100.367 139.17C100.367 138.187 99.5701 137.391 98.5872 137.391C97.6042 137.391 96.8074 138.187 96.8074 139.17Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6079 139.17C90.6079 140.153 91.4048 140.95 92.3877 140.95C93.3706 140.95 94.1675 140.153 94.1675 139.17C94.1675 138.187 93.3707 137.391 92.3877 137.391C91.4048 137.391 90.6079 138.187 90.6079 139.17Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4491 139.17C84.4491 140.153 85.246 140.95 86.2289 140.95C87.2118 140.95 88.0087 140.153 88.0087 139.17C88.0087 138.187 87.2118 137.391 86.2289 137.391C85.246 137.391 84.4491 138.187 84.4491 139.17Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2783 139.176C78.2783 140.159 79.0752 140.955 80.0581 140.955C81.0411 140.955 81.8379 140.159 81.8379 139.176C81.8379 138.193 81.0411 137.396 80.0581 137.396C79.0752 137.396 78.2783 138.193 78.2783 139.176Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1205 139.176C72.1205 140.159 72.9173 140.955 73.9003 140.955C74.8832 140.955 75.6801 140.159 75.6801 139.176C75.6801 138.193 74.8832 137.396 73.9003 137.396C72.9173 137.396 72.1205 138.193 72.1205 139.176Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9046 139.176C65.9046 140.159 66.7014 140.955 67.6843 140.955C68.6673 140.955 69.4641 140.159 69.4641 139.176C69.4641 138.193 68.6673 137.396 67.6843 137.396C66.7014 137.396 65.9046 138.193 65.9046 139.176Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.7453 139.176C59.7453 140.159 60.5421 140.955 61.525 140.955C62.508 140.955 63.3048 140.159 63.3048 139.176C63.3048 138.193 62.508 137.396 61.525 137.396C60.5421 137.396 59.7453 138.193 59.7453 139.176Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.5954 139.167C53.5954 140.149 54.3922 140.946 55.3751 140.946C56.3581 140.946 57.1549 140.149 57.1549 139.167C57.1549 138.184 56.3581 137.387 55.3751 137.387C54.3922 137.387 53.5954 138.184 53.5954 139.167Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.438 139.167C47.438 140.149 48.2348 140.946 49.2178 140.946C50.2007 140.946 50.9976 140.149 50.9976 139.167C50.9976 138.184 50.2007 137.387 49.2178 137.387C48.2348 137.387 47.438 138.184 47.438 139.167Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.237 139.176C41.237 140.159 42.0338 140.955 43.0167 140.955C43.9997 140.955 44.7965 140.159 44.7965 139.176C44.7965 138.193 43.9997 137.396 43.0167 137.396C42.0338 137.396 41.237 138.193 41.237 139.176Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.078 139.176C35.078 140.159 35.8749 140.955 36.8578 140.955C37.8407 140.955 38.6376 140.159 38.6376 139.176C38.6376 138.193 37.8407 137.396 36.8578 137.396C35.8749 137.396 35.078 138.193 35.078 139.176Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9124 139.176C28.9124 140.159 29.7092 140.955 30.6922 140.955C31.6751 140.955 32.4719 140.159 32.4719 139.176C32.4719 138.193 31.6751 137.396 30.6922 137.396C29.7092 137.396 28.9124 138.193 28.9124 139.176Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7549 139.176C22.7549 140.159 23.5517 140.955 24.5347 140.955C25.5176 140.955 26.3145 140.159 26.3145 139.176C26.3145 138.193 25.5176 137.396 24.5347 137.396C23.5517 137.396 22.7549 138.193 22.7549 139.176Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.554 139.176C16.554 140.159 17.3508 140.955 18.3338 140.955C19.3167 140.955 20.1135 140.159 20.1135 139.176C20.1135 138.193 19.3167 137.396 18.3338 137.396C17.3508 137.396 16.554 138.193 16.554 139.176Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.3952 139.176C10.3952 140.159 11.192 140.955 12.1749 140.955C13.1579 140.955 13.9547 140.159 13.9547 139.176C13.9547 138.193 13.1579 137.396 12.1749 137.396C11.192 137.396 10.3952 138.193 10.3952 139.176Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 144.415C155.418 145.398 156.215 146.195 157.198 146.195C158.18 146.195 158.977 145.398 158.977 144.415C158.977 143.432 158.18 142.635 157.198 142.635C156.215 142.635 155.418 143.432 155.418 144.415Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 144.415C149.259 145.398 150.056 146.195 151.039 146.195C152.022 146.195 152.819 145.398 152.819 144.415C152.819 143.432 152.022 142.635 151.039 142.635C150.056 142.635 149.259 143.432 149.259 144.415Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.042 144.415C143.042 145.398 143.839 146.195 144.822 146.195C145.805 146.195 146.602 145.398 146.602 144.415C146.602 143.432 145.805 142.635 144.822 142.635C143.839 142.635 143.042 143.432 143.042 144.415Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 144.415C136.883 145.398 137.68 146.195 138.663 146.195C139.646 146.195 140.443 145.398 140.443 144.415C140.443 143.432 139.646 142.635 138.663 142.635C137.68 142.635 136.883 143.432 136.883 144.415Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.735 144.406C130.735 145.389 131.532 146.186 132.515 146.186C133.498 146.186 134.294 145.389 134.294 144.406C134.294 143.423 133.498 142.626 132.515 142.626C131.532 142.626 130.735 143.423 130.735 144.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 144.406C124.576 145.389 125.373 146.186 126.356 146.186C127.339 146.186 128.135 145.389 128.135 144.406C128.135 143.423 127.339 142.626 126.356 142.626C125.373 142.626 124.576 143.423 124.576 144.406Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.375 144.415C118.375 145.398 119.172 146.195 120.155 146.195C121.138 146.195 121.935 145.398 121.935 144.415C121.935 143.432 121.138 142.635 120.155 142.635C119.172 142.635 118.375 143.432 118.375 144.415Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 144.415C112.216 145.398 113.013 146.195 113.996 146.195C114.979 146.195 115.776 145.398 115.776 144.415C115.776 143.432 114.979 142.635 113.996 142.635C113.013 142.635 112.216 143.432 112.216 144.415Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.052 144.415C106.052 145.398 106.849 146.195 107.832 146.195C108.815 146.195 109.611 145.398 109.611 144.415C109.611 143.432 108.815 142.635 107.832 142.635C106.849 142.635 106.052 143.432 106.052 144.415Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 144.415C99.8931 145.398 100.69 146.195 101.673 146.195C102.656 146.195 103.453 145.398 103.453 144.415C103.453 143.432 102.656 142.635 101.673 142.635C100.69 142.635 99.8931 143.432 99.8931 144.415Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.6922 144.415C93.6922 145.398 94.489 146.195 95.4719 146.195C96.4549 146.195 97.2517 145.398 97.2517 144.415C97.2517 143.432 96.4549 142.635 95.4719 142.635C94.489 142.635 93.6922 143.432 93.6922 144.415Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5331 144.415C87.5331 145.398 88.3299 146.195 89.3129 146.195C90.2958 146.195 91.0927 145.398 91.0927 144.415C91.0927 143.432 90.2958 142.635 89.3129 142.635C88.3299 142.635 87.5331 143.432 87.5331 144.415Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3638 144.42C81.3638 145.403 82.1606 146.2 83.1436 146.2C84.1265 146.2 84.9233 145.403 84.9233 144.42C84.9233 143.437 84.1265 142.64 83.1436 142.64C82.1606 142.64 81.3638 143.437 81.3638 144.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 144.42C75.2046 145.403 76.0014 146.2 76.9844 146.2C77.9673 146.2 78.7642 145.403 78.7642 144.42C78.7642 143.437 77.9673 142.64 76.9844 142.64C76.0014 142.64 75.2046 143.437 75.2046 144.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9887 144.42C68.9887 145.403 69.7855 146.2 70.7684 146.2C71.7514 146.2 72.5482 145.403 72.5482 144.42C72.5482 143.437 71.7514 142.64 70.7684 142.64C69.7855 142.64 68.9887 143.437 68.9887 144.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 144.42C62.8294 145.403 63.6262 146.2 64.6091 146.2C65.5921 146.2 66.3889 145.403 66.3889 144.42C66.3889 143.437 65.5921 142.64 64.6091 142.64C63.6262 142.64 62.8294 143.437 62.8294 144.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6808 144.411C56.6808 145.394 57.4776 146.191 58.4606 146.191C59.4435 146.191 60.2404 145.394 60.2404 144.411C60.2404 143.428 59.4435 142.631 58.4606 142.631C57.4776 142.631 56.6808 143.428 56.6808 144.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 144.411C50.5216 145.394 51.3185 146.191 52.3014 146.191C53.2843 146.191 54.0812 145.394 54.0812 144.411C54.0812 143.428 53.2843 142.631 52.3014 142.631C51.3185 142.631 50.5216 143.428 50.5216 144.411Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3225 144.42C44.3225 145.403 45.1194 146.2 46.1023 146.2C47.0852 146.2 47.8821 145.403 47.8821 144.42C47.8821 143.437 47.0852 142.64 46.1023 142.64C45.1194 142.64 44.3225 143.437 44.3225 144.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 144.42C38.1634 145.403 38.9602 146.2 39.9431 146.2C40.9261 146.2 41.7229 145.403 41.7229 144.42C41.7229 143.437 40.9261 142.64 39.9431 142.64C38.9602 142.64 38.1634 143.437 38.1634 144.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.998 144.42C31.998 145.403 32.7948 146.2 33.7777 146.2C34.7607 146.2 35.5575 145.403 35.5575 144.42C35.5575 143.437 34.7607 142.64 33.7777 142.64C32.7948 142.64 31.998 143.437 31.998 144.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 144.42C25.8387 145.403 26.6355 146.2 27.6184 146.2C28.6014 146.2 29.3982 145.403 29.3982 144.42C29.3982 143.437 28.6014 142.64 27.6184 142.64C26.6355 142.64 25.8387 143.437 25.8387 144.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6396 144.42C19.6396 145.403 20.4364 146.2 21.4193 146.2C22.4023 146.2 23.1991 145.403 23.1991 144.42C23.1991 143.437 22.4023 142.64 21.4193 142.64C20.4364 142.64 19.6396 143.437 19.6396 144.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4803 144.42C13.4803 145.403 14.2771 146.2 15.26 146.2C16.243 146.2 17.0398 145.403 17.0398 144.42C17.0398 143.437 16.243 142.64 15.26 142.64C14.2771 142.64 13.4803 143.437 13.4803 144.42Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.343 149.706C152.343 150.689 153.14 151.486 154.123 151.486C155.106 151.486 155.903 150.689 155.903 149.706C155.903 148.723 155.106 147.926 154.123 147.926C153.14 147.926 152.343 148.723 152.343 149.706Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.185 149.706C146.185 150.689 146.982 151.486 147.965 151.486C148.948 151.486 149.744 150.689 149.744 149.706C149.744 148.723 148.948 147.926 147.965 147.926C146.982 147.926 146.185 148.723 146.185 149.706Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.969 149.706C139.969 150.689 140.766 151.486 141.749 151.486C142.732 151.486 143.529 150.689 143.529 149.706C143.529 148.723 142.732 147.926 141.749 147.926C140.766 147.926 139.969 148.723 139.969 149.706Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.81 149.706C133.81 150.689 134.607 151.486 135.589 151.486C136.572 151.486 137.369 150.689 137.369 149.706C137.369 148.723 136.572 147.926 135.589 147.926C134.607 147.926 133.81 148.723 133.81 149.706Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.66 149.697C127.66 150.68 128.457 151.477 129.44 151.477C130.423 151.477 131.22 150.68 131.22 149.697C131.22 148.714 130.423 147.917 129.44 147.917C128.457 147.917 127.66 148.714 127.66 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.502 149.697C121.502 150.68 122.299 151.477 123.282 151.477C124.265 151.477 125.062 150.68 125.062 149.697C125.062 148.714 124.265 147.917 123.282 147.917C122.299 147.917 121.502 148.714 121.502 149.697Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.302 149.706C115.302 150.689 116.099 151.486 117.082 151.486C118.064 151.486 118.861 150.689 118.861 149.706C118.861 148.723 118.064 147.926 117.082 147.926C116.099 147.926 115.302 148.723 115.302 149.706Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.143 149.706C109.143 150.689 109.939 151.486 110.922 151.486C111.905 151.486 112.702 150.689 112.702 149.706C112.702 148.723 111.905 147.926 110.922 147.926C109.939 147.926 109.143 148.723 109.143 149.706Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.977 149.706C102.977 150.689 103.774 151.486 104.757 151.486C105.74 151.486 106.537 150.689 106.537 149.706C106.537 148.723 105.74 147.926 104.757 147.926C103.774 147.926 102.977 148.723 102.977 149.706Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8192 149.706C96.8192 150.689 97.6161 151.486 98.599 151.486C99.582 151.486 100.379 150.689 100.379 149.706C100.379 148.723 99.582 147.926 98.599 147.926C97.6161 147.926 96.8192 148.723 96.8192 149.706Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6188 149.706C90.6188 150.689 91.4156 151.486 92.3986 151.486C93.3815 151.486 94.1783 150.689 94.1783 149.706C94.1783 148.723 93.3815 147.926 92.3986 147.926C91.4156 147.926 90.6188 148.723 90.6188 149.706Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4594 149.706C84.4594 150.689 85.2562 151.486 86.2392 151.486C87.2221 151.486 88.0189 150.689 88.0189 149.706C88.0189 148.723 87.2221 147.926 86.2392 147.926C85.2562 147.926 84.4594 148.723 84.4594 149.706Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2898 149.71C78.2898 150.693 79.0867 151.49 80.0696 151.49C81.0525 151.49 81.8494 150.693 81.8494 149.71C81.8494 148.727 81.0525 147.93 80.0696 147.93C79.0867 147.93 78.2898 148.727 78.2898 149.71Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1309 149.71C72.1309 150.693 72.9277 151.49 73.9107 151.49C74.8936 151.49 75.6904 150.693 75.6904 149.71C75.6904 148.727 74.8936 147.93 73.9107 147.93C72.9277 147.93 72.1309 148.727 72.1309 149.71Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9149 149.71C65.9149 150.693 66.7118 151.49 67.6947 151.49C68.6777 151.49 69.4745 150.693 69.4745 149.71C69.4745 148.727 68.6777 147.93 67.6947 147.93C66.7118 147.93 65.9149 148.727 65.9149 149.71Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.756 149.71C59.756 150.693 60.5528 151.49 61.5358 151.49C62.5187 151.49 63.3156 150.693 63.3156 149.71C63.3156 148.727 62.5187 147.93 61.5358 147.93C60.5528 147.93 59.756 148.727 59.756 149.71Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6073 149.701C53.6073 150.684 54.4042 151.481 55.3871 151.481C56.37 151.481 57.1669 150.684 57.1669 149.701C57.1669 148.718 56.37 147.921 55.3871 147.921C54.4042 147.921 53.6073 148.718 53.6073 149.701Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4479 149.701C47.4479 150.684 48.2447 151.481 49.2277 151.481C50.2106 151.481 51.0074 150.684 51.0074 149.701C51.0074 148.718 50.2106 147.921 49.2277 147.921C48.2447 147.921 47.4479 148.718 47.4479 149.701Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2475 149.71C41.2475 150.693 42.0443 151.49 43.0272 151.49C44.0102 151.49 44.807 150.693 44.807 149.71C44.807 148.727 44.0102 147.93 43.0272 147.93C42.0443 147.93 41.2475 148.727 41.2475 149.71Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.0884 149.71C35.0884 150.693 35.8852 151.49 36.8682 151.49C37.8511 151.49 38.6479 150.693 38.6479 149.71C38.6479 148.727 37.8511 147.93 36.8682 147.93C35.8852 147.93 35.0884 148.727 35.0884 149.71Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9241 149.71C28.9241 150.693 29.7209 151.49 30.7039 151.49C31.6868 151.49 32.4836 150.693 32.4836 149.71C32.4836 148.727 31.6868 147.93 30.7039 147.93C29.7209 147.93 28.9241 148.727 28.9241 149.71Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7649 149.71C22.7649 150.693 23.5618 151.49 24.5447 151.49C25.5276 151.49 26.3245 150.693 26.3245 149.71C26.3245 148.727 25.5276 147.93 24.5447 147.93C23.5618 147.93 22.7649 148.727 22.7649 149.71Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5645 149.71C16.5645 150.693 17.3613 151.49 18.3443 151.49C19.3272 151.49 20.124 150.693 20.124 149.71C20.124 148.727 19.3272 147.93 18.3443 147.93C17.3613 147.93 16.5645 148.727 16.5645 149.71Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.4054 149.71C10.4054 150.693 11.2023 151.49 12.1852 151.49C13.1681 151.49 13.965 150.693 13.965 149.71C13.965 148.727 13.1681 147.93 12.1852 147.93C11.2023 147.93 10.4054 148.727 10.4054 149.71Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 155.008C149.259 155.991 150.056 156.788 151.039 156.788C152.022 156.788 152.819 155.991 152.819 155.008C152.819 154.025 152.022 153.228 151.039 153.228C150.056 153.228 149.259 154.025 149.259 155.008Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.1 155.008C143.1 155.991 143.896 156.788 144.879 156.788C145.862 156.788 146.659 155.991 146.659 155.008C146.659 154.025 145.862 153.228 144.879 153.228C143.896 153.228 143.1 154.025 143.1 155.008Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 155.008C136.883 155.991 137.68 156.788 138.663 156.788C139.646 156.788 140.443 155.991 140.443 155.008C140.443 154.025 139.646 153.228 138.663 153.228C137.68 153.228 136.883 154.025 136.883 155.008Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.724 155.008C130.724 155.991 131.521 156.788 132.504 156.788C133.487 156.788 134.284 155.991 134.284 155.008C134.284 154.025 133.487 153.228 132.504 153.228C131.521 153.228 130.724 154.025 130.724 155.008Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 154.997C124.576 155.98 125.373 156.777 126.356 156.777C127.339 156.777 128.135 155.98 128.135 154.997C128.135 154.014 127.339 153.218 126.356 153.218C125.373 153.218 124.576 154.014 124.576 154.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.417 154.997C118.417 155.98 119.214 156.777 120.197 156.777C121.179 156.777 121.976 155.98 121.976 154.997C121.976 154.014 121.179 153.218 120.197 153.218C119.214 153.218 118.417 154.014 118.417 154.997Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 155.008C112.216 155.991 113.013 156.788 113.996 156.788C114.979 156.788 115.776 155.991 115.776 155.008C115.776 154.025 114.979 153.228 113.996 153.228C113.013 153.228 112.216 154.025 112.216 155.008Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.057 155.008C106.057 155.991 106.854 156.788 107.837 156.788C108.82 156.788 109.616 155.991 109.616 155.008C109.616 154.025 108.82 153.228 107.837 153.228C106.854 153.228 106.057 154.025 106.057 155.008Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 155.008C99.8931 155.991 100.69 156.788 101.673 156.788C102.656 156.788 103.453 155.991 103.453 155.008C103.453 154.025 102.656 153.228 101.673 153.228C100.69 153.228 99.8931 154.025 99.8931 155.008Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.7337 155.008C93.7337 155.991 94.5305 156.788 95.5134 156.788C96.4964 156.788 97.2932 155.991 97.2932 155.008C97.2932 154.025 96.4964 153.228 95.5134 153.228C94.5305 153.228 93.7337 154.025 93.7337 155.008Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5332 155.008C87.5332 155.991 88.3301 156.788 89.313 156.788C90.2959 156.788 91.0928 155.991 91.0928 155.008C91.0928 154.025 90.2959 153.228 89.313 153.228C88.3301 153.228 87.5332 154.025 87.5332 155.008Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3741 155.008C81.3741 155.991 82.1709 156.788 83.1538 156.788C84.1368 156.788 84.9336 155.991 84.9336 155.008C84.9336 154.025 84.1368 153.228 83.1538 153.228C82.1709 153.228 81.3741 154.025 81.3741 155.008Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 155.012C75.2046 155.995 76.0014 156.791 76.9844 156.791C77.9673 156.791 78.7642 155.995 78.7642 155.012C78.7642 154.029 77.9673 153.232 76.9844 153.232C76.0014 153.232 75.2046 154.029 75.2046 155.012Z"
            fill="#B8B7B7"
          />
          <path
            d="M69.0458 155.012C69.0458 155.995 69.8426 156.791 70.8256 156.791C71.8085 156.791 72.6053 155.995 72.6053 155.012C72.6053 154.029 71.8085 153.232 70.8256 153.232C69.8426 153.232 69.0458 154.029 69.0458 155.012Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 155.012C62.8294 155.995 63.6262 156.791 64.6091 156.791C65.5921 156.791 66.3889 155.995 66.3889 155.012C66.3889 154.029 65.5921 153.232 64.6091 153.232C63.6262 153.232 62.8294 154.029 62.8294 155.012Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6704 155.012C56.6704 155.995 57.4673 156.791 58.4502 156.791C59.4331 156.791 60.23 155.995 60.23 155.012C60.23 154.029 59.4332 153.232 58.4502 153.232C57.4673 153.232 56.6704 154.029 56.6704 155.012Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 155.003C50.5216 155.986 51.3185 156.782 52.3014 156.782C53.2843 156.782 54.0812 155.986 54.0812 155.003C54.0812 154.02 53.2843 153.223 52.3014 153.223C51.3185 153.223 50.5216 154.02 50.5216 155.003Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3627 155.003C44.3627 155.986 45.1595 156.782 46.1425 156.782C47.1254 156.782 47.9222 155.986 47.9222 155.003C47.9222 154.02 47.1254 153.223 46.1425 153.223C45.1595 153.223 44.3627 154.02 44.3627 155.003Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 155.012C38.1634 155.995 38.9602 156.791 39.9431 156.791C40.9261 156.791 41.7229 155.995 41.7229 155.012C41.7229 154.029 40.9261 153.232 39.9431 153.232C38.9602 153.232 38.1634 154.029 38.1634 155.012Z"
            fill="#B8B7B7"
          />
          <path
            d="M32.0044 155.012C32.0044 155.995 32.8013 156.791 33.7842 156.791C34.7671 156.791 35.564 155.995 35.564 155.012C35.564 154.029 34.7671 153.232 33.7842 153.232C32.8013 153.232 32.0044 154.029 32.0044 155.012Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 155.012C25.8387 155.995 26.6355 156.791 27.6184 156.791C28.6014 156.791 29.3982 155.995 29.3982 155.012C29.3982 154.029 28.6014 153.232 27.6184 153.232C26.6355 153.232 25.8387 154.029 25.8387 155.012Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6797 155.012C19.6797 155.995 20.4765 156.791 21.4595 156.791C22.4424 156.791 23.2393 155.995 23.2393 155.012C23.2393 154.029 22.4424 153.232 21.4595 153.232C20.4765 153.232 19.6797 154.029 19.6797 155.012Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4804 155.012C13.4804 155.995 14.2772 156.791 15.2601 156.791C16.2431 156.791 17.0399 155.995 17.0399 155.012C17.0399 154.029 16.2431 153.232 15.2601 153.232C14.2772 153.232 13.4804 154.029 13.4804 155.012Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.32144 155.012C7.32144 155.995 8.11827 156.791 9.10121 156.791C10.0842 156.791 10.881 155.995 10.881 155.012C10.881 154.029 10.0842 153.232 9.10121 153.232C8.11827 153.232 7.32144 154.029 7.32144 155.012Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.343 160.252C152.343 161.235 153.14 162.032 154.123 162.032C155.106 162.032 155.903 161.235 155.903 160.252C155.903 159.269 155.106 158.472 154.123 158.472C153.14 158.472 152.343 159.269 152.343 160.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.185 160.252C146.185 161.235 146.982 162.032 147.965 162.032C148.948 162.032 149.744 161.235 149.744 160.252C149.744 159.269 148.948 158.472 147.965 158.472C146.982 158.472 146.185 159.269 146.185 160.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.969 160.252C139.969 161.235 140.766 162.032 141.749 162.032C142.732 162.032 143.529 161.235 143.529 160.252C143.529 159.269 142.732 158.472 141.749 158.472C140.766 158.472 139.969 159.269 139.969 160.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.81 160.252C133.81 161.235 134.607 162.032 135.589 162.032C136.572 162.032 137.369 161.235 137.369 160.252C137.369 159.269 136.572 158.472 135.589 158.472C134.607 158.472 133.81 159.269 133.81 160.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.66 160.242C127.66 161.225 128.457 162.022 129.44 162.022C130.423 162.022 131.22 161.225 131.22 160.242C131.22 159.259 130.423 158.462 129.44 158.462C128.457 158.462 127.66 159.259 127.66 160.242Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.502 160.242C121.502 161.225 122.299 162.022 123.282 162.022C124.265 162.022 125.062 161.225 125.062 160.242C125.062 159.259 124.265 158.462 123.282 158.462C122.299 158.462 121.502 159.259 121.502 160.242Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.302 160.252C115.302 161.235 116.099 162.032 117.082 162.032C118.064 162.032 118.861 161.235 118.861 160.252C118.861 159.269 118.064 158.472 117.082 158.472C116.099 158.472 115.302 159.269 115.302 160.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.143 160.252C109.143 161.235 109.939 162.032 110.922 162.032C111.905 162.032 112.702 161.235 112.702 160.252C112.702 159.269 111.905 158.472 110.922 158.472C109.939 158.472 109.143 159.269 109.143 160.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.977 160.252C102.977 161.235 103.774 162.032 104.757 162.032C105.74 162.032 106.537 161.235 106.537 160.252C106.537 159.269 105.74 158.472 104.757 158.472C103.774 158.472 102.977 159.269 102.977 160.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8192 160.252C96.8192 161.235 97.6161 162.032 98.599 162.032C99.582 162.032 100.379 161.235 100.379 160.252C100.379 159.269 99.582 158.472 98.599 158.472C97.6161 158.472 96.8192 159.269 96.8192 160.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6188 160.252C90.6188 161.235 91.4156 162.032 92.3986 162.032C93.3815 162.032 94.1783 161.235 94.1783 160.252C94.1783 159.269 93.3815 158.472 92.3986 158.472C91.4156 158.472 90.6188 159.269 90.6188 160.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4594 160.252C84.4594 161.235 85.2562 162.032 86.2392 162.032C87.2221 162.032 88.0189 161.235 88.0189 160.252C88.0189 159.269 87.2221 158.472 86.2392 158.472C85.2562 158.472 84.4594 159.269 84.4594 160.252Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2898 160.256C78.2898 161.239 79.0867 162.036 80.0696 162.036C81.0525 162.036 81.8494 161.239 81.8494 160.256C81.8494 159.273 81.0525 158.476 80.0696 158.476C79.0867 158.476 78.2898 159.273 78.2898 160.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1309 160.256C72.1309 161.239 72.9277 162.036 73.9107 162.036C74.8936 162.036 75.6904 161.239 75.6904 160.256C75.6904 159.273 74.8936 158.476 73.9107 158.476C72.9277 158.476 72.1309 159.273 72.1309 160.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9149 160.256C65.9149 161.239 66.7118 162.036 67.6947 162.036C68.6777 162.036 69.4745 161.239 69.4745 160.256C69.4745 159.273 68.6777 158.476 67.6947 158.476C66.7118 158.476 65.9149 159.273 65.9149 160.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.756 160.256C59.756 161.239 60.5528 162.036 61.5358 162.036C62.5187 162.036 63.3156 161.239 63.3156 160.256C63.3156 159.273 62.5187 158.476 61.5358 158.476C60.5528 158.476 59.756 159.273 59.756 160.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6073 160.247C53.6073 161.23 54.4042 162.027 55.3871 162.027C56.37 162.027 57.1669 161.23 57.1669 160.247C57.1669 159.264 56.37 158.467 55.3871 158.467C54.4042 158.467 53.6073 159.264 53.6073 160.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4479 160.247C47.4479 161.23 48.2447 162.027 49.2277 162.027C50.2106 162.027 51.0074 161.23 51.0074 160.247C51.0074 159.264 50.2106 158.467 49.2277 158.467C48.2447 158.467 47.4479 159.264 47.4479 160.247Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2475 160.256C41.2475 161.239 42.0443 162.036 43.0272 162.036C44.0102 162.036 44.807 161.239 44.807 160.256C44.807 159.273 44.0102 158.476 43.0272 158.476C42.0443 158.476 41.2475 159.273 41.2475 160.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.0884 160.256C35.0884 161.239 35.8852 162.036 36.8682 162.036C37.8511 162.036 38.6479 161.239 38.6479 160.256C38.6479 159.273 37.8511 158.476 36.8682 158.476C35.8852 158.476 35.0884 159.273 35.0884 160.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9241 160.256C28.9241 161.239 29.7209 162.036 30.7039 162.036C31.6868 162.036 32.4836 161.239 32.4836 160.256C32.4836 159.273 31.6868 158.476 30.7039 158.476C29.7209 158.476 28.9241 159.273 28.9241 160.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7649 160.256C22.7649 161.239 23.5618 162.036 24.5447 162.036C25.5276 162.036 26.3245 161.239 26.3245 160.256C26.3245 159.273 25.5276 158.476 24.5447 158.476C23.5618 158.476 22.7649 159.273 22.7649 160.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5645 160.256C16.5645 161.239 17.3613 162.036 18.3443 162.036C19.3272 162.036 20.124 161.239 20.124 160.256C20.124 159.273 19.3272 158.476 18.3443 158.476C17.3613 158.476 16.5645 159.273 16.5645 160.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.4055 160.256C10.4055 161.239 11.2024 162.036 12.1853 162.036C13.1683 162.036 13.9651 161.239 13.9651 160.256C13.9651 159.273 13.1683 158.476 12.1853 158.476C11.2024 158.476 10.4055 159.273 10.4055 160.256Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 154.979C155.418 155.962 156.215 156.759 157.198 156.759C158.181 156.759 158.978 155.962 158.978 154.979C158.978 153.996 158.181 153.199 157.198 153.199C156.215 153.199 155.418 153.996 155.418 154.979Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 165.436C155.418 166.419 156.215 167.215 157.198 167.215C158.181 167.215 158.978 166.419 158.978 165.436C158.978 164.453 158.181 163.656 157.198 163.656C156.215 163.656 155.418 164.453 155.418 165.436Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 165.436C149.259 166.419 150.056 167.215 151.039 167.215C152.022 167.215 152.819 166.419 152.819 165.436C152.819 164.453 152.022 163.656 151.039 163.656C150.056 163.656 149.259 164.453 149.259 165.436Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.042 165.436C143.042 166.419 143.839 167.215 144.822 167.215C145.805 167.215 146.602 166.419 146.602 165.436C146.602 164.453 145.805 163.656 144.822 163.656C143.839 163.656 143.042 164.453 143.042 165.436Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 165.436C136.883 166.419 137.68 167.215 138.663 167.215C139.646 167.215 140.443 166.419 140.443 165.436C140.443 164.453 139.646 163.656 138.663 163.656C137.68 163.656 136.883 164.453 136.883 165.436Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.735 165.425C130.735 166.408 131.532 167.205 132.515 167.205C133.498 167.205 134.294 166.408 134.294 165.425C134.294 164.442 133.498 163.645 132.515 163.645C131.532 163.645 130.735 164.442 130.735 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 165.425C124.576 166.408 125.373 167.205 126.356 167.205C127.339 167.205 128.135 166.408 128.135 165.425C128.135 164.442 127.339 163.645 126.356 163.645C125.373 163.645 124.576 164.442 124.576 165.425Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.375 165.436C118.375 166.419 119.172 167.215 120.155 167.215C121.138 167.215 121.935 166.419 121.935 165.436C121.935 164.453 121.138 163.656 120.155 163.656C119.172 163.656 118.375 164.453 118.375 165.436Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 165.436C112.216 166.419 113.013 167.215 113.996 167.215C114.979 167.215 115.776 166.419 115.776 165.436C115.776 164.453 114.979 163.656 113.996 163.656C113.013 163.656 112.216 164.453 112.216 165.436Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.052 165.436C106.052 166.419 106.849 167.215 107.832 167.215C108.815 167.215 109.611 166.419 109.611 165.436C109.611 164.453 108.815 163.656 107.832 163.656C106.849 163.656 106.052 164.453 106.052 165.436Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 165.436C99.8931 166.419 100.69 167.215 101.673 167.215C102.656 167.215 103.453 166.419 103.453 165.436C103.453 164.453 102.656 163.656 101.673 163.656C100.69 163.656 99.8931 164.453 99.8931 165.436Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.6922 165.436C93.6922 166.419 94.489 167.215 95.4719 167.215C96.4549 167.215 97.2517 166.419 97.2517 165.436C97.2517 164.453 96.4549 163.656 95.4719 163.656C94.489 163.656 93.6922 164.453 93.6922 165.436Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5332 165.436C87.5332 166.419 88.3301 167.215 89.313 167.215C90.2959 167.215 91.0928 166.419 91.0928 165.436C91.0928 164.453 90.2959 163.656 89.313 163.656C88.3301 163.656 87.5332 164.453 87.5332 165.436Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3638 165.44C81.3638 166.422 82.1606 167.219 83.1436 167.219C84.1265 167.219 84.9233 166.422 84.9233 165.44C84.9233 164.457 84.1265 163.66 83.1436 163.66C82.1606 163.66 81.3638 164.457 81.3638 165.44Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 165.44C75.2046 166.422 76.0014 167.219 76.9844 167.219C77.9673 167.219 78.7642 166.422 78.7642 165.44C78.7642 164.457 77.9673 163.66 76.9844 163.66C76.0014 163.66 75.2046 164.457 75.2046 165.44Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9887 165.44C68.9887 166.422 69.7855 167.219 70.7684 167.219C71.7514 167.219 72.5482 166.422 72.5482 165.44C72.5482 164.457 71.7514 163.66 70.7684 163.66C69.7855 163.66 68.9887 164.457 68.9887 165.44Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 165.44C62.8294 166.422 63.6262 167.219 64.6091 167.219C65.5921 167.219 66.3889 166.422 66.3889 165.44C66.3889 164.457 65.5921 163.66 64.6091 163.66C63.6262 163.66 62.8294 164.457 62.8294 165.44Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6808 165.43C56.6808 166.413 57.4776 167.21 58.4606 167.21C59.4435 167.21 60.2404 166.413 60.2404 165.43C60.2404 164.448 59.4435 163.651 58.4606 163.651C57.4776 163.651 56.6808 164.448 56.6808 165.43Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 165.43C50.5216 166.413 51.3185 167.21 52.3014 167.21C53.2843 167.21 54.0812 166.413 54.0812 165.43C54.0812 164.448 53.2843 163.651 52.3014 163.651C51.3185 163.651 50.5216 164.448 50.5216 165.43Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3225 165.44C44.3225 166.423 45.1194 167.219 46.1023 167.219C47.0852 167.219 47.8821 166.423 47.8821 165.44C47.8821 164.457 47.0852 163.66 46.1023 163.66C45.1194 163.66 44.3225 164.457 44.3225 165.44Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 165.44C38.1634 166.423 38.9602 167.219 39.9431 167.219C40.9261 167.219 41.7229 166.423 41.7229 165.44C41.7229 164.457 40.9261 163.66 39.9431 163.66C38.9602 163.66 38.1634 164.457 38.1634 165.44Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.998 165.44C31.998 166.423 32.7948 167.219 33.7777 167.219C34.7607 167.219 35.5575 166.423 35.5575 165.44C35.5575 164.457 34.7607 163.66 33.7777 163.66C32.7948 163.66 31.998 164.457 31.998 165.44Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 165.44C25.8387 166.423 26.6355 167.219 27.6184 167.219C28.6014 167.219 29.3982 166.423 29.3982 165.44C29.3982 164.457 28.6014 163.66 27.6184 163.66C26.6355 163.66 25.8387 164.457 25.8387 165.44Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6396 165.44C19.6396 166.423 20.4364 167.219 21.4193 167.219C22.4023 167.219 23.1991 166.423 23.1991 165.44C23.1991 164.457 22.4023 163.66 21.4193 163.66C20.4364 163.66 19.6396 164.457 19.6396 165.44Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4804 165.44C13.4804 166.423 14.2772 167.219 15.2601 167.219C16.2431 167.219 17.0399 166.423 17.0399 165.44C17.0399 164.457 16.2431 163.66 15.2601 163.66C14.2772 163.66 13.4804 164.457 13.4804 165.44Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.333 170.736C152.333 171.719 153.129 172.516 154.112 172.516C155.095 172.516 155.892 171.719 155.892 170.736C155.892 169.753 155.095 168.956 154.112 168.956C153.129 168.956 152.333 169.753 152.333 170.736Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.173 170.736C146.173 171.719 146.97 172.516 147.953 172.516C148.936 172.516 149.733 171.719 149.733 170.736C149.733 169.753 148.936 168.956 147.953 168.956C146.97 168.956 146.173 169.753 146.173 170.736Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.957 170.736C139.957 171.719 140.754 172.516 141.737 172.516C142.72 172.516 143.517 171.719 143.517 170.736C143.517 169.753 142.72 168.956 141.737 168.956C140.754 168.956 139.957 169.753 139.957 170.736Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.798 170.736C133.798 171.719 134.595 172.516 135.578 172.516C136.561 172.516 137.358 171.719 137.358 170.736C137.358 169.753 136.561 168.956 135.578 168.956C134.595 168.956 133.798 169.753 133.798 170.736Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.65 170.727C127.65 171.71 128.447 172.507 129.43 172.507C130.413 172.507 131.209 171.71 131.209 170.727C131.209 169.744 130.413 168.947 129.43 168.947C128.447 168.947 127.65 169.744 127.65 170.727Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.491 170.727C121.491 171.71 122.287 172.507 123.27 172.507C124.253 172.507 125.05 171.71 125.05 170.727C125.05 169.744 124.253 168.947 123.27 168.947C122.287 168.947 121.491 169.744 121.491 170.727Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.291 170.736C115.291 171.719 116.088 172.516 117.071 172.516C118.054 172.516 118.851 171.719 118.851 170.736C118.851 169.753 118.054 168.956 117.071 168.956C116.088 168.956 115.291 169.753 115.291 170.736Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.132 170.736C109.132 171.719 109.929 172.516 110.912 172.516C111.895 172.516 112.692 171.719 112.692 170.736C112.692 169.753 111.895 168.956 110.912 168.956C109.929 168.956 109.132 169.753 109.132 170.736Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.967 170.736C102.967 171.719 103.764 172.516 104.747 172.516C105.73 172.516 106.526 171.719 106.526 170.736C106.526 169.753 105.73 168.956 104.747 168.956C103.764 168.956 102.967 169.753 102.967 170.736Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8074 170.736C96.8074 171.719 97.6042 172.516 98.5872 172.516C99.5701 172.516 100.367 171.719 100.367 170.736C100.367 169.753 99.5701 168.956 98.5872 168.956C97.6042 168.956 96.8074 169.753 96.8074 170.736Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6079 170.736C90.6079 171.719 91.4048 172.516 92.3877 172.516C93.3706 172.516 94.1675 171.719 94.1675 170.736C94.1675 169.753 93.3707 168.956 92.3877 168.956C91.4048 168.956 90.6079 169.753 90.6079 170.736Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4491 170.736C84.4491 171.719 85.246 172.516 86.2289 172.516C87.2118 172.516 88.0087 171.719 88.0087 170.736C88.0087 169.753 87.2118 168.956 86.2289 168.956C85.246 168.956 84.4491 169.753 84.4491 170.736Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2783 170.741C78.2783 171.724 79.0752 172.521 80.0581 172.521C81.0411 172.521 81.8379 171.724 81.8379 170.741C81.8379 169.758 81.0411 168.961 80.0581 168.961C79.0752 168.961 78.2783 169.758 78.2783 170.741Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1205 170.741C72.1205 171.724 72.9173 172.521 73.9003 172.521C74.8832 172.521 75.6801 171.724 75.6801 170.741C75.6801 169.758 74.8832 168.961 73.9003 168.961C72.9173 168.961 72.1205 169.758 72.1205 170.741Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9046 170.741C65.9046 171.724 66.7014 172.521 67.6843 172.521C68.6673 172.521 69.4641 171.724 69.4641 170.741C69.4641 169.758 68.6673 168.961 67.6843 168.961C66.7014 168.961 65.9046 169.758 65.9046 170.741Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.7453 170.741C59.7453 171.724 60.5421 172.521 61.525 172.521C62.508 172.521 63.3048 171.724 63.3048 170.741C63.3048 169.758 62.508 168.961 61.525 168.961C60.5421 168.961 59.7453 169.758 59.7453 170.741Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.5954 170.732C53.5954 171.715 54.3922 172.512 55.3751 172.512C56.3581 172.512 57.1549 171.715 57.1549 170.732C57.1549 169.749 56.3581 168.952 55.3751 168.952C54.3922 168.952 53.5954 169.749 53.5954 170.732Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.438 170.732C47.438 171.715 48.2348 172.512 49.2178 172.512C50.2007 172.512 50.9976 171.715 50.9976 170.732C50.9976 169.749 50.2007 168.952 49.2178 168.952C48.2348 168.952 47.438 169.749 47.438 170.732Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.237 170.741C41.237 171.724 42.0338 172.521 43.0167 172.521C43.9997 172.521 44.7965 171.724 44.7965 170.741C44.7965 169.758 43.9997 168.961 43.0167 168.961C42.0338 168.961 41.237 169.758 41.237 170.741Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.078 170.741C35.078 171.724 35.8749 172.521 36.8578 172.521C37.8407 172.521 38.6376 171.724 38.6376 170.741C38.6376 169.758 37.8407 168.961 36.8578 168.961C35.8749 168.961 35.078 169.758 35.078 170.741Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9124 170.741C28.9124 171.724 29.7092 172.521 30.6922 172.521C31.6751 172.521 32.4719 171.724 32.4719 170.741C32.4719 169.758 31.6751 168.961 30.6922 168.961C29.7092 168.961 28.9124 169.758 28.9124 170.741Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7549 170.741C22.7549 171.724 23.5517 172.521 24.5347 172.521C25.5176 172.521 26.3145 171.724 26.3145 170.741C26.3145 169.758 25.5176 168.961 24.5347 168.961C23.5517 168.961 22.7549 169.758 22.7549 170.741Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.554 170.741C16.554 171.724 17.3508 172.521 18.3338 172.521C19.3167 172.521 20.1135 171.724 20.1135 170.741C20.1135 169.758 19.3167 168.961 18.3338 168.961C17.3508 168.961 16.554 169.758 16.554 170.741Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.3952 170.741C10.3952 171.724 11.192 172.521 12.1749 172.521C13.1579 172.521 13.9547 171.724 13.9547 170.741C13.9547 169.758 13.1579 168.961 12.1749 168.961C11.192 168.961 10.3952 169.758 10.3952 170.741Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 175.982C155.418 176.965 156.215 177.762 157.198 177.762C158.181 177.762 158.978 176.965 158.978 175.982C158.978 174.999 158.181 174.202 157.198 174.202C156.215 174.202 155.418 174.999 155.418 175.982Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 175.982C149.259 176.965 150.056 177.762 151.039 177.762C152.022 177.762 152.819 176.965 152.819 175.982C152.819 174.999 152.022 174.202 151.039 174.202C150.056 174.202 149.259 174.999 149.259 175.982Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.042 175.982C143.042 176.965 143.839 177.762 144.822 177.762C145.805 177.762 146.602 176.965 146.602 175.982C146.602 174.999 145.805 174.202 144.822 174.202C143.839 174.202 143.042 174.999 143.042 175.982Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 175.982C136.883 176.965 137.68 177.762 138.663 177.762C139.646 177.762 140.443 176.965 140.443 175.982C140.443 174.999 139.646 174.202 138.663 174.202C137.68 174.202 136.883 174.999 136.883 175.982Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.735 175.971C130.735 176.954 131.532 177.751 132.515 177.751C133.498 177.751 134.294 176.954 134.294 175.971C134.294 174.988 133.498 174.192 132.515 174.192C131.532 174.192 130.735 174.988 130.735 175.971Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 175.971C124.576 176.954 125.373 177.751 126.356 177.751C127.339 177.751 128.135 176.954 128.135 175.971C128.135 174.988 127.339 174.192 126.356 174.192C125.373 174.192 124.576 174.988 124.576 175.971Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.375 175.982C118.375 176.965 119.172 177.762 120.155 177.762C121.138 177.762 121.935 176.965 121.935 175.982C121.935 174.999 121.138 174.202 120.155 174.202C119.172 174.202 118.375 174.999 118.375 175.982Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 175.982C112.216 176.965 113.013 177.762 113.996 177.762C114.979 177.762 115.776 176.965 115.776 175.982C115.776 174.999 114.979 174.202 113.996 174.202C113.013 174.202 112.216 174.999 112.216 175.982Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.052 175.982C106.052 176.965 106.849 177.762 107.832 177.762C108.815 177.762 109.611 176.965 109.611 175.982C109.611 174.999 108.815 174.202 107.832 174.202C106.849 174.202 106.052 174.999 106.052 175.982Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 175.982C99.8931 176.965 100.69 177.762 101.673 177.762C102.656 177.762 103.453 176.965 103.453 175.982C103.453 174.999 102.656 174.202 101.673 174.202C100.69 174.202 99.8931 174.999 99.8931 175.982Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.6922 175.982C93.6922 176.965 94.489 177.762 95.4719 177.762C96.4549 177.762 97.2517 176.965 97.2517 175.982C97.2517 174.999 96.4549 174.202 95.4719 174.202C94.489 174.202 93.6922 174.999 93.6922 175.982Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5332 175.982C87.5332 176.965 88.3301 177.762 89.313 177.762C90.2959 177.762 91.0928 176.965 91.0928 175.982C91.0928 174.999 90.2959 174.202 89.313 174.202C88.3301 174.202 87.5332 174.999 87.5332 175.982Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3638 175.986C81.3638 176.969 82.1606 177.765 83.1436 177.765C84.1265 177.765 84.9233 176.969 84.9233 175.986C84.9233 175.003 84.1265 174.206 83.1436 174.206C82.1606 174.206 81.3638 175.003 81.3638 175.986Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 175.986C75.2046 176.969 76.0014 177.765 76.9844 177.765C77.9673 177.765 78.7642 176.969 78.7642 175.986C78.7642 175.003 77.9673 174.206 76.9844 174.206C76.0014 174.206 75.2046 175.003 75.2046 175.986Z"
            fill="#B8B7B7"
          />
          <path
            d="M68.9887 175.986C68.9887 176.969 69.7855 177.765 70.7684 177.765C71.7514 177.765 72.5482 176.969 72.5482 175.986C72.5482 175.003 71.7514 174.206 70.7684 174.206C69.7855 174.206 68.9887 175.003 68.9887 175.986Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 175.986C62.8294 176.969 63.6262 177.765 64.6091 177.765C65.5921 177.765 66.3889 176.969 66.3889 175.986C66.3889 175.003 65.5921 174.206 64.6091 174.206C63.6262 174.206 62.8294 175.003 62.8294 175.986Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6808 175.977C56.6808 176.96 57.4776 177.756 58.4606 177.756C59.4435 177.756 60.2404 176.96 60.2404 175.977C60.2404 174.994 59.4435 174.197 58.4606 174.197C57.4776 174.197 56.6808 174.994 56.6808 175.977Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 175.977C50.5216 176.96 51.3185 177.756 52.3014 177.756C53.2843 177.756 54.0812 176.96 54.0812 175.977C54.0812 174.994 53.2843 174.197 52.3014 174.197C51.3185 174.197 50.5216 174.994 50.5216 175.977Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3225 175.986C44.3225 176.969 45.1194 177.765 46.1023 177.765C47.0852 177.765 47.8821 176.969 47.8821 175.986C47.8821 175.003 47.0852 174.206 46.1023 174.206C45.1194 174.206 44.3225 175.003 44.3225 175.986Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 175.986C38.1634 176.969 38.9602 177.765 39.9431 177.765C40.9261 177.765 41.7229 176.969 41.7229 175.986C41.7229 175.003 40.9261 174.206 39.9431 174.206C38.9602 174.206 38.1634 175.003 38.1634 175.986Z"
            fill="#B8B7B7"
          />
          <path
            d="M31.998 175.986C31.998 176.969 32.7948 177.765 33.7777 177.765C34.7607 177.765 35.5575 176.969 35.5575 175.986C35.5575 175.003 34.7607 174.206 33.7777 174.206C32.7948 174.206 31.998 175.003 31.998 175.986Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 175.986C25.8387 176.969 26.6355 177.765 27.6184 177.765C28.6014 177.765 29.3982 176.969 29.3982 175.986C29.3982 175.003 28.6014 174.206 27.6184 174.206C26.6355 174.206 25.8387 175.003 25.8387 175.986Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6396 175.986C19.6396 176.969 20.4364 177.765 21.4193 177.765C22.4023 177.765 23.1991 176.969 23.1991 175.986C23.1991 175.003 22.4023 174.206 21.4193 174.206C20.4364 174.206 19.6396 175.003 19.6396 175.986Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4804 175.986C13.4804 176.969 14.2772 177.765 15.2601 177.765C16.2431 177.765 17.0399 176.969 17.0399 175.986C17.0399 175.003 16.2431 174.206 15.2601 174.206C14.2772 174.206 13.4804 175.003 13.4804 175.986Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.343 181.272C152.343 182.255 153.14 183.052 154.123 183.052C155.106 183.052 155.903 182.255 155.903 181.272C155.903 180.289 155.106 179.492 154.123 179.492C153.14 179.492 152.343 180.289 152.343 181.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.185 181.272C146.185 182.255 146.982 183.052 147.965 183.052C148.948 183.052 149.744 182.255 149.744 181.272C149.744 180.289 148.948 179.492 147.965 179.492C146.982 179.492 146.185 180.289 146.185 181.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.969 181.272C139.969 182.255 140.766 183.052 141.749 183.052C142.732 183.052 143.529 182.255 143.529 181.272C143.529 180.289 142.732 179.492 141.749 179.492C140.766 179.492 139.969 180.289 139.969 181.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.81 181.272C133.81 182.255 134.607 183.052 135.589 183.052C136.572 183.052 137.369 182.255 137.369 181.272C137.369 180.289 136.572 179.492 135.589 179.492C134.607 179.492 133.81 180.289 133.81 181.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.66 181.263C127.66 182.246 128.457 183.042 129.44 183.042C130.423 183.042 131.22 182.246 131.22 181.263C131.22 180.28 130.423 179.483 129.44 179.483C128.457 179.483 127.66 180.28 127.66 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.502 181.263C121.502 182.246 122.299 183.042 123.282 183.042C124.265 183.042 125.062 182.246 125.062 181.263C125.062 180.28 124.265 179.483 123.282 179.483C122.299 179.483 121.502 180.28 121.502 181.263Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.302 181.272C115.302 182.255 116.099 183.052 117.082 183.052C118.064 183.052 118.861 182.255 118.861 181.272C118.861 180.289 118.064 179.492 117.082 179.492C116.099 179.492 115.302 180.289 115.302 181.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.143 181.272C109.143 182.255 109.939 183.052 110.922 183.052C111.905 183.052 112.702 182.255 112.702 181.272C112.702 180.289 111.905 179.492 110.922 179.492C109.939 179.492 109.143 180.289 109.143 181.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.977 181.272C102.977 182.255 103.774 183.052 104.757 183.052C105.74 183.052 106.537 182.255 106.537 181.272C106.537 180.289 105.74 179.492 104.757 179.492C103.774 179.492 102.977 180.289 102.977 181.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.8192 181.272C96.8192 182.255 97.6161 183.051 98.599 183.051C99.582 183.051 100.379 182.255 100.379 181.272C100.379 180.289 99.582 179.492 98.599 179.492C97.6161 179.492 96.8192 180.289 96.8192 181.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6188 181.272C90.6188 182.255 91.4156 183.051 92.3986 183.051C93.3815 183.051 94.1783 182.255 94.1783 181.272C94.1783 180.289 93.3815 179.492 92.3986 179.492C91.4156 179.492 90.6188 180.289 90.6188 181.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.4594 181.272C84.4594 182.255 85.2562 183.051 86.2392 183.051C87.2221 183.051 88.0189 182.255 88.0189 181.272C88.0189 180.289 87.2221 179.492 86.2392 179.492C85.2562 179.492 84.4594 180.289 84.4594 181.272Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2898 181.277C78.2898 182.26 79.0867 183.057 80.0696 183.057C81.0525 183.057 81.8494 182.26 81.8494 181.277C81.8494 180.294 81.0525 179.497 80.0696 179.497C79.0867 179.497 78.2898 180.294 78.2898 181.277Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.1309 181.277C72.1309 182.26 72.9277 183.057 73.9107 183.057C74.8936 183.057 75.6904 182.26 75.6904 181.277C75.6904 180.294 74.8936 179.497 73.9107 179.497C72.9277 179.497 72.1309 180.294 72.1309 181.277Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9149 181.277C65.9149 182.26 66.7118 183.057 67.6947 183.057C68.6777 183.057 69.4745 182.26 69.4745 181.277C69.4745 180.294 68.6777 179.497 67.6947 179.497C66.7118 179.497 65.9149 180.294 65.9149 181.277Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.756 181.277C59.756 182.26 60.5528 183.057 61.5358 183.057C62.5187 183.057 63.3156 182.26 63.3156 181.277C63.3156 180.294 62.5187 179.497 61.5358 179.497C60.5528 179.497 59.756 180.294 59.756 181.277Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6073 181.267C53.6073 182.249 54.4042 183.046 55.3871 183.046C56.37 183.046 57.1669 182.249 57.1669 181.267C57.1669 180.284 56.37 179.487 55.3871 179.487C54.4042 179.487 53.6073 180.284 53.6073 181.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4479 181.267C47.4479 182.249 48.2447 183.046 49.2277 183.046C50.2106 183.046 51.0074 182.249 51.0074 181.267C51.0074 180.284 50.2106 179.487 49.2277 179.487C48.2447 179.487 47.4479 180.284 47.4479 181.267Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2475 181.277C41.2475 182.26 42.0443 183.057 43.0272 183.057C44.0102 183.057 44.807 182.26 44.807 181.277C44.807 180.294 44.0102 179.497 43.0272 179.497C42.0443 179.497 41.2475 180.294 41.2475 181.277Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.0884 181.277C35.0884 182.26 35.8852 183.057 36.8682 183.057C37.8511 183.057 38.6479 182.26 38.6479 181.277C38.6479 180.294 37.8511 179.497 36.8682 179.497C35.8852 179.497 35.0884 180.294 35.0884 181.277Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9241 181.277C28.9241 182.26 29.7209 183.057 30.7039 183.057C31.6868 183.057 32.4836 182.26 32.4836 181.277C32.4836 180.294 31.6868 179.497 30.7039 179.497C29.7209 179.497 28.9241 180.294 28.9241 181.277Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7649 181.277C22.7649 182.26 23.5618 183.057 24.5447 183.057C25.5276 183.057 26.3245 182.26 26.3245 181.277C26.3245 180.294 25.5276 179.497 24.5447 179.497C23.5618 179.497 22.7649 180.294 22.7649 181.277Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5645 181.277C16.5645 182.26 17.3613 183.057 18.3443 183.057C19.3272 183.057 20.124 182.26 20.124 181.277C20.124 180.294 19.3272 179.497 18.3443 179.497C17.3613 179.497 16.5645 180.294 16.5645 181.277Z"
            fill="#B8B7B7"
          />
          <path
            d="M10.4055 181.277C10.4055 182.26 11.2024 183.057 12.1853 183.057C13.1683 183.057 13.9651 182.26 13.9651 181.277C13.9651 180.294 13.1683 179.497 12.1853 179.497C11.2024 179.497 10.4055 180.294 10.4055 181.277Z"
            fill="#B8B7B7"
          />
          <path
            d="M149.259 186.573C149.259 187.556 150.056 188.353 151.039 188.353C152.022 188.353 152.819 187.556 152.819 186.573C152.819 185.59 152.022 184.794 151.039 184.794C150.056 184.794 149.259 185.59 149.259 186.573Z"
            fill="#B8B7B7"
          />
          <path
            d="M143.1 186.573C143.1 187.556 143.896 188.353 144.879 188.353C145.862 188.353 146.659 187.556 146.659 186.573C146.659 185.59 145.862 184.794 144.879 184.794C143.896 184.794 143.1 185.59 143.1 186.573Z"
            fill="#B8B7B7"
          />
          <path
            d="M136.883 186.573C136.883 187.556 137.68 188.353 138.663 188.353C139.646 188.353 140.443 187.556 140.443 186.573C140.443 185.59 139.646 184.794 138.663 184.794C137.68 184.794 136.883 185.59 136.883 186.573Z"
            fill="#B8B7B7"
          />
          <path
            d="M130.724 186.573C130.724 187.556 131.521 188.353 132.504 188.353C133.487 188.353 134.284 187.556 134.284 186.573C134.284 185.59 133.487 184.794 132.504 184.794C131.521 184.794 130.724 185.59 130.724 186.573Z"
            fill="#B8B7B7"
          />
          <path
            d="M124.576 186.563C124.576 187.546 125.373 188.343 126.356 188.343C127.339 188.343 128.136 187.546 128.136 186.563C128.136 185.58 127.339 184.783 126.356 184.783C125.373 184.783 124.576 185.58 124.576 186.563Z"
            fill="#B8B7B7"
          />
          <path
            d="M118.417 186.563C118.417 187.546 119.214 188.343 120.197 188.343C121.179 188.343 121.976 187.546 121.976 186.563C121.976 185.58 121.179 184.783 120.197 184.783C119.214 184.783 118.417 185.58 118.417 186.563Z"
            fill="#B8B7B7"
          />
          <path
            d="M112.216 186.573C112.216 187.556 113.013 188.353 113.996 188.353C114.979 188.353 115.776 187.556 115.776 186.573C115.776 185.59 114.979 184.794 113.996 184.794C113.013 184.794 112.216 185.59 112.216 186.573Z"
            fill="#B8B7B7"
          />
          <path
            d="M106.057 186.573C106.057 187.556 106.854 188.353 107.837 188.353C108.82 188.353 109.616 187.556 109.616 186.573C109.616 185.59 108.82 184.794 107.837 184.794C106.854 184.794 106.057 185.59 106.057 186.573Z"
            fill="#B8B7B7"
          />
          <path
            d="M99.8931 186.573C99.8931 187.556 100.69 188.353 101.673 188.353C102.656 188.353 103.453 187.556 103.453 186.573C103.453 185.59 102.656 184.794 101.673 184.794C100.69 184.794 99.8931 185.59 99.8931 186.573Z"
            fill="#B8B7B7"
          />
          <path
            d="M93.7337 186.573C93.7337 187.556 94.5305 188.353 95.5134 188.353C96.4964 188.353 97.2932 187.556 97.2932 186.573C97.2932 185.59 96.4964 184.794 95.5134 184.794C94.5305 184.794 93.7337 185.59 93.7337 186.573Z"
            fill="#B8B7B7"
          />
          <path
            d="M87.5332 186.573C87.5332 187.556 88.3301 188.353 89.313 188.353C90.2959 188.353 91.0928 187.556 91.0928 186.573C91.0928 185.59 90.2959 184.794 89.313 184.794C88.3301 184.794 87.5332 185.59 87.5332 186.573Z"
            fill="#B8B7B7"
          />
          <path
            d="M81.3741 186.573C81.3741 187.556 82.1709 188.353 83.1538 188.353C84.1368 188.353 84.9336 187.556 84.9336 186.573C84.9336 185.59 84.1368 184.794 83.1538 184.794C82.1709 184.794 81.3741 185.59 81.3741 186.573Z"
            fill="#B8B7B7"
          />
          <path
            d="M75.2046 186.577C75.2046 187.56 76.0014 188.357 76.9844 188.357C77.9673 188.357 78.7642 187.56 78.7642 186.577C78.7642 185.594 77.9673 184.797 76.9844 184.797C76.0014 184.797 75.2046 185.594 75.2046 186.577Z"
            fill="#B8B7B7"
          />
          <path
            d="M69.0458 186.577C69.0458 187.56 69.8426 188.357 70.8256 188.357C71.8085 188.357 72.6053 187.56 72.6053 186.577C72.6053 185.594 71.8085 184.797 70.8256 184.797C69.8426 184.797 69.0458 185.594 69.0458 186.577Z"
            fill="#B8B7B7"
          />
          <path
            d="M62.8294 186.577C62.8294 187.56 63.6262 188.357 64.6091 188.357C65.5921 188.357 66.3889 187.56 66.3889 186.577C66.3889 185.594 65.5921 184.798 64.6091 184.798C63.6262 184.798 62.8294 185.594 62.8294 186.577Z"
            fill="#B8B7B7"
          />
          <path
            d="M56.6704 186.577C56.6704 187.56 57.4673 188.357 58.4502 188.357C59.4331 188.357 60.23 187.56 60.23 186.577C60.23 185.594 59.4332 184.798 58.4502 184.798C57.4673 184.798 56.6704 185.594 56.6704 186.577Z"
            fill="#B8B7B7"
          />
          <path
            d="M50.5216 186.568C50.5216 187.551 51.3185 188.348 52.3014 188.348C53.2843 188.348 54.0812 187.551 54.0812 186.568C54.0812 185.585 53.2843 184.788 52.3014 184.788C51.3185 184.788 50.5216 185.585 50.5216 186.568Z"
            fill="#B8B7B7"
          />
          <path
            d="M44.3627 186.568C44.3627 187.551 45.1595 188.348 46.1425 188.348C47.1254 188.348 47.9222 187.551 47.9222 186.568C47.9222 185.585 47.1254 184.788 46.1425 184.788C45.1595 184.788 44.3627 185.585 44.3627 186.568Z"
            fill="#B8B7B7"
          />
          <path
            d="M38.1634 186.577C38.1634 187.56 38.9602 188.357 39.9431 188.357C40.9261 188.357 41.7229 187.56 41.7229 186.577C41.7229 185.594 40.9261 184.798 39.9431 184.798C38.9602 184.798 38.1634 185.594 38.1634 186.577Z"
            fill="#B8B7B7"
          />
          <path
            d="M32.0044 186.577C32.0044 187.56 32.8013 188.357 33.7842 188.357C34.7671 188.357 35.564 187.56 35.564 186.577C35.564 185.594 34.7671 184.798 33.7842 184.798C32.8013 184.798 32.0044 185.594 32.0044 186.577Z"
            fill="#B8B7B7"
          />
          <path
            d="M25.8387 186.577C25.8387 187.56 26.6355 188.357 27.6184 188.357C28.6014 188.357 29.3982 187.56 29.3982 186.577C29.3982 185.594 28.6014 184.798 27.6184 184.798C26.6355 184.798 25.8387 185.594 25.8387 186.577Z"
            fill="#B8B7B7"
          />
          <path
            d="M19.6797 186.577C19.6797 187.56 20.4765 188.357 21.4595 188.357C22.4424 188.357 23.2393 187.56 23.2393 186.577C23.2393 185.594 22.4424 184.798 21.4595 184.798C20.4765 184.798 19.6797 185.594 19.6797 186.577Z"
            fill="#B8B7B7"
          />
          <path
            d="M13.4804 186.577C13.4804 187.56 14.2772 188.357 15.2601 188.357C16.2431 188.357 17.0399 187.56 17.0399 186.577C17.0399 185.594 16.2431 184.798 15.2601 184.798C14.2772 184.798 13.4804 185.594 13.4804 186.577Z"
            fill="#B8B7B7"
          />
          <path
            d="M7.32144 186.577C7.32144 187.56 8.11827 188.357 9.10121 188.357C10.0842 188.357 10.881 187.56 10.881 186.577C10.881 185.594 10.0842 184.798 9.10121 184.798C8.11827 184.798 7.32144 185.594 7.32144 186.577Z"
            fill="#B8B7B7"
          />
          <path
            d="M155.418 186.545C155.418 187.528 156.215 188.325 157.198 188.325C158.181 188.325 158.978 187.528 158.978 186.545C158.978 185.562 158.181 184.765 157.198 184.765C156.215 184.765 155.418 185.562 155.418 186.545Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.497 96.8651C158.497 97.848 159.293 98.6449 160.276 98.6449C161.259 98.6449 162.056 97.848 162.056 96.8651C162.056 95.8821 161.259 95.0853 160.276 95.0853C159.293 95.0853 158.497 95.8821 158.497 96.8651Z"
            fill="#B8B7B7"
          />
          <path
            d="M152.338 96.8651C152.338 97.848 153.135 98.6449 154.117 98.6449C155.1 98.6449 155.897 97.848 155.897 96.8651C155.897 95.8821 155.1 95.0853 154.117 95.0853C153.135 95.0853 152.338 95.8821 152.338 96.8651Z"
            fill="#B8B7B7"
          />
          <path
            d="M146.121 96.8651C146.121 97.848 146.918 98.6449 147.901 98.6449C148.884 98.6449 149.681 97.848 149.681 96.8651C149.681 95.8821 148.884 95.0853 147.901 95.0853C146.918 95.0853 146.121 95.8821 146.121 96.8651Z"
            fill="#B8B7B7"
          />
          <path
            d="M139.963 96.8651C139.963 97.848 140.76 98.6449 141.742 98.6449C142.725 98.6449 143.522 97.848 143.522 96.8651C143.522 95.8821 142.725 95.0853 141.742 95.0853C140.76 95.0853 139.963 95.8821 139.963 96.8651Z"
            fill="#B8B7B7"
          />
          <path
            d="M133.814 96.856C133.814 97.839 134.61 98.6358 135.593 98.6358C136.576 98.6358 137.373 97.839 137.373 96.856C137.373 95.8731 136.576 95.0763 135.593 95.0763C134.61 95.0763 133.814 95.8731 133.814 96.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M127.655 96.856C127.655 97.839 128.452 98.6358 129.434 98.6358C130.417 98.6358 131.214 97.839 131.214 96.856C131.214 95.8731 130.417 95.0763 129.434 95.0763C128.452 95.0763 127.655 95.8731 127.655 96.856Z"
            fill="#B8B7B7"
          />
          <path
            d="M121.455 96.8651C121.455 97.848 122.252 98.6449 123.235 98.6449C124.218 98.6449 125.015 97.848 125.015 96.8651C125.015 95.8821 124.218 95.0853 123.235 95.0853C122.252 95.0853 121.455 95.8821 121.455 96.8651Z"
            fill="#B8B7B7"
          />
          <path
            d="M115.296 96.8651C115.296 97.848 116.093 98.6449 117.076 98.6449C118.059 98.6449 118.856 97.848 118.856 96.8651C118.856 95.8821 118.059 95.0853 117.076 95.0853C116.093 95.0853 115.296 95.8821 115.296 96.8651Z"
            fill="#B8B7B7"
          />
          <path
            d="M109.131 96.8651C109.131 97.848 109.928 98.6449 110.911 98.6449C111.894 98.6449 112.691 97.848 112.691 96.8651C112.691 95.8821 111.894 95.0853 110.911 95.0853C109.928 95.0853 109.131 95.8821 109.131 96.8651Z"
            fill="#B8B7B7"
          />
          <path
            d="M102.972 96.8651C102.972 97.848 103.769 98.6449 104.751 98.6449C105.734 98.6449 106.531 97.848 106.531 96.8651C106.531 95.8821 105.734 95.0853 104.751 95.0853C103.769 95.0853 102.972 95.8821 102.972 96.8651Z"
            fill="#B8B7B7"
          />
          <path
            d="M96.7722 96.8651C96.7722 97.848 97.5691 98.6449 98.552 98.6449C99.535 98.6449 100.332 97.848 100.332 96.8651C100.332 95.8821 99.535 95.0853 98.552 95.0853C97.5691 95.0853 96.7722 95.8821 96.7722 96.8651Z"
            fill="#B8B7B7"
          />
          <path
            d="M90.6133 96.8651C90.6133 97.848 91.4101 98.6449 92.3931 98.6449C93.376 98.6449 94.1729 97.848 94.1729 96.8651C94.1729 95.8821 93.376 95.0853 92.3931 95.0853C91.4101 95.0853 90.6133 95.8821 90.6133 96.8651Z"
            fill="#B8B7B7"
          />
          <path
            d="M84.444 96.8703C84.444 97.8532 85.2408 98.6501 86.2238 98.6501C87.2067 98.6501 88.0035 97.8532 88.0035 96.8703C88.0035 95.8874 87.2067 95.0905 86.2238 95.0905C85.2408 95.0905 84.444 95.8874 84.444 96.8703Z"
            fill="#B8B7B7"
          />
          <path
            d="M78.2848 96.8703C78.2848 97.8532 79.0816 98.6501 80.0646 98.6501C81.0475 98.6501 81.8444 97.8532 81.8444 96.8703C81.8444 95.8874 81.0475 95.0905 80.0646 95.0905C79.0816 95.0905 78.2848 95.8874 78.2848 96.8703Z"
            fill="#B8B7B7"
          />
          <path
            d="M72.0689 96.8703C72.0689 97.8532 72.8657 98.6501 73.8486 98.6501C74.8316 98.6501 75.6284 97.8532 75.6284 96.8703C75.6284 95.8874 74.8316 95.0905 73.8486 95.0905C72.8657 95.0905 72.0689 95.8874 72.0689 96.8703Z"
            fill="#B8B7B7"
          />
          <path
            d="M65.9096 96.8703C65.9096 97.8532 66.7064 98.6501 67.6893 98.6501C68.6723 98.6501 69.4691 97.8532 69.4691 96.8703C69.4691 95.8874 68.6723 95.0905 67.6893 95.0905C66.7064 95.0905 65.9096 95.8874 65.9096 96.8703Z"
            fill="#B8B7B7"
          />
          <path
            d="M59.761 96.8599C59.761 97.8429 60.5578 98.6397 61.5408 98.6397C62.5237 98.6397 63.3206 97.8429 63.3206 96.8599C63.3206 95.877 62.5237 95.0802 61.5408 95.0802C60.5578 95.0802 59.761 95.877 59.761 96.8599Z"
            fill="#B8B7B7"
          />
          <path
            d="M53.6017 96.8599C53.6017 97.8429 54.3985 98.6397 55.3815 98.6397C56.3644 98.6397 57.1613 97.8429 57.1613 96.8599C57.1613 95.877 56.3644 95.0802 55.3815 95.0802C54.3985 95.0802 53.6017 95.877 53.6017 96.8599Z"
            fill="#B8B7B7"
          />
          <path
            d="M47.4013 96.8703C47.4013 97.8532 48.1981 98.6501 49.181 98.6501C50.164 98.6501 50.9608 97.8532 50.9608 96.8703C50.9608 95.8874 50.164 95.0905 49.181 95.0905C48.1981 95.0905 47.4013 95.8874 47.4013 96.8703Z"
            fill="#B8B7B7"
          />
          <path
            d="M41.2423 96.8703C41.2423 97.8532 42.0392 98.6501 43.0221 98.6501C44.005 98.6501 44.8019 97.8532 44.8019 96.8703C44.8019 95.8874 44.005 95.0905 43.0221 95.0905C42.0392 95.0905 41.2423 95.8874 41.2423 96.8703Z"
            fill="#B8B7B7"
          />
          <path
            d="M35.078 96.8703C35.078 97.8532 35.8749 98.6501 36.8578 98.6501C37.8407 98.6501 38.6376 97.8532 38.6376 96.8703C38.6376 95.8874 37.8407 95.0905 36.8578 95.0905C35.8749 95.0905 35.078 95.8874 35.078 96.8703Z"
            fill="#B8B7B7"
          />
          <path
            d="M28.9192 96.8703C28.9192 97.8532 29.716 98.6501 30.699 98.6501C31.6819 98.6501 32.4788 97.8532 32.4788 96.8703C32.4788 95.8874 31.6819 95.0905 30.699 95.0905C29.716 95.0905 28.9192 95.8874 28.9192 96.8703Z"
            fill="#B8B7B7"
          />
          <path
            d="M22.7182 96.8703C22.7182 97.8532 23.515 98.6501 24.4979 98.6501C25.4809 98.6501 26.2777 97.8532 26.2777 96.8703C26.2777 95.8874 25.4809 95.0905 24.4979 95.0905C23.515 95.0905 22.7182 95.8874 22.7182 96.8703Z"
            fill="#B8B7B7"
          />
          <path
            d="M16.5594 96.8703C16.5594 97.8532 17.3562 98.6501 18.3391 98.6501C19.3221 98.6501 20.1189 97.8532 20.1189 96.8703C20.1189 95.8874 19.3221 95.0905 18.3391 95.0905C17.3562 95.0905 16.5594 95.8874 16.5594 96.8703Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.979 107.426C158.979 108.408 159.776 109.205 160.759 109.205C161.741 109.205 162.538 108.408 162.538 107.426C162.538 106.443 161.741 105.646 160.759 105.646C159.776 105.646 158.979 106.443 158.979 107.426Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.497 128.559C158.497 129.542 159.293 130.339 160.276 130.339C161.259 130.339 162.056 129.542 162.056 128.559C162.056 127.576 161.259 126.78 160.276 126.78C159.293 126.78 158.497 127.576 158.497 128.559Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.497 139.161C158.497 140.144 159.293 140.941 160.276 140.941C161.259 140.941 162.056 140.144 162.056 139.161C162.056 138.178 161.259 137.382 160.276 137.382C159.293 137.382 158.497 138.178 158.497 139.161Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.497 160.125C158.497 161.108 159.293 161.905 160.276 161.905C161.259 161.905 162.056 161.108 162.056 160.125C162.056 159.142 161.259 158.345 160.276 158.345C159.293 158.345 158.497 159.142 158.497 160.125Z"
            fill="#B8B7B7"
          />
          <path
            d="M158.508 170.671C158.508 171.654 159.305 172.451 160.288 172.451C161.271 172.451 162.068 171.654 162.068 170.671C162.068 169.688 161.271 168.891 160.288 168.891C159.305 168.891 158.508 169.688 158.508 170.671Z"
            fill="#B8B7B7"
          />
        </mask>
        <g mask="url(#mask0_21_10691)">
          <circle cx="162.124" cy="142.342" r="133.302" fill="#C4C4C4" />
        </g>
        <path
          d="M91.9145 160.691C90.5689 161.892 88.6168 162.147 86.8217 161.981C85.0266 161.815 83.2746 161.298 81.4764 161.174C79.8136 161.064 77.8831 161.455 77.0794 162.917C76.2203 164.488 77.0794 166.409 77.9662 167.967C78.853 169.525 79.7767 171.397 79.0162 173.017C78.582 173.94 77.6829 174.556 77.1287 175.406C76.0202 177.124 76.5129 179.409 77.3319 181.284C78.0863 183.018 79.1578 184.726 80.8328 185.595C82.7419 186.605 85.1282 186.337 87.0834 185.419C89.0386 184.502 90.6582 183.005 92.2347 181.527C93.4971 180.342 94.8673 179.273 96.5454 178.901C98.0573 177.269 99.9324 175.495 102.137 175.754C104.6 176.043 106.048 178.775 106.257 181.244C106.466 183.713 105.881 186.229 106.306 188.674C106.325 188.936 106.432 189.182 106.614 189.37C106.83 189.511 107.085 189.579 107.344 189.564L113.958 189.828C114.881 189.865 115.836 189.912 116.667 190.321C117.782 190.869 118.496 191.987 119.063 193.092C120.273 195.463 121.074 198.022 121.434 200.661C121.655 202.283 122.25 204.371 123.851 204.722C127.854 203.977 131.958 203.183 135.401 201.027C138.754 198.921 141.275 195.626 144.773 193.776C147.338 192.415 150.257 191.928 153.118 191.448C158.968 190.478 164.818 189.508 170.736 189.293C173.384 189.194 176.183 189.293 178.452 190.657C180.608 191.972 182.2 194.401 184.694 194.881C187.188 195.362 189.546 193.677 191.948 192.794C194.886 191.728 198.122 191.845 200.976 193.12C202.947 194.013 204.806 195.734 204.831 197.896C206.007 199.044 207.91 199.127 209.533 198.819C211.155 198.512 212.68 197.85 214.305 197.606C217.692 197.101 221.387 198.422 224.408 196.809C225.947 195.99 227.004 194.53 228.383 193.483C229.762 192.436 231.394 191.836 233.02 191.276C234.966 190.607 236.927 189.992 238.904 189.428C241.331 188.738 244.163 188.197 246.199 189.684C248.234 191.171 248.579 194.145 248.018 196.615C247.458 199.084 246.208 201.36 245.718 203.841C244.736 208.805 246.83 214.289 244.625 218.84C243.498 221.171 241.404 222.861 239.391 224.471C238.298 228.345 237.488 232.231 235.634 235.806C232.247 242.349 226.813 247.565 221.47 252.654L213.354 260.435L208.055 265.488C205.989 267.462 203.895 269.454 201.419 270.879C198.944 272.305 196.006 273.136 193.204 272.582C193.272 268.552 194.467 264.577 194.304 260.552C194.14 256.528 192.047 252.088 188.13 251.133C183.795 251.133 179.428 251.275 175.093 251.29C173.791 251.29 172.464 251.29 171.235 250.865C168.621 249.942 167.054 247.358 164.978 245.526C163.155 243.919 160.902 242.881 158.497 242.533C156.298 242.225 154.041 242.503 151.864 242.084C149.688 241.665 147.443 240.255 147.086 238.066C146.839 236.572 147.523 235.076 147.489 233.561C147.427 231.75 146.368 230.125 144.736 229.336C142.929 228.49 141.519 226.873 141.171 224.912C140.823 222.95 141.386 220.909 142.242 219.117C142.63 218.298 143.086 217.491 143.246 216.598C143.659 214.347 142.014 212.1 139.921 211.167C137.827 210.234 135.425 210.354 133.168 210.739C130.911 211.123 128.682 211.755 126.394 211.792C122.003 211.819 117.88 209.682 115.371 206.08C113.705 203.638 111.408 201.307 108.56 200.513C106.907 200.051 105.102 199.983 103.634 199.1C102.768 198.582 102.094 197.819 101.352 197.123C99.5291 195.389 97.2937 194.007 94.8181 193.57C92.2901 193.123 89.7068 193.68 87.2096 194.281C84.7125 194.881 82.1722 195.531 79.6166 195.278C77.0609 195.026 74.4529 193.656 73.4769 191.276C70.7611 191.448 67.6943 189.736 66.3549 187.378C65.0155 185.019 64.6583 182.214 64.4736 179.498C64.2889 176.782 64.2519 174.017 63.4606 171.412C62.9063 169.58 61.9949 167.884 61.0897 166.196L56.6589 157.951C55.6397 158.36 55.0608 159.49 54.9777 160.577C54.8945 161.664 55.2178 162.732 55.5381 163.795C56.6989 167.591 57.8566 171.391 59.0174 175.187C57.909 176.502 55.6304 176.09 54.4696 174.824C53.3088 173.559 52.9301 171.776 52.576 170.095C51.8924 166.926 51.0672 163.792 50.0973 160.691C49.463 158.662 48.5578 156.414 46.5656 155.647C47.1321 152.454 46.5256 149.098 45.4325 146.044C43.9853 142.059 41.2295 138.608 40.1549 134.5C38.8525 129.549 40.1703 124.339 41.4851 119.379C42.2764 116.401 42.7999 113.941 44.3209 111.262C47.0213 106.508 46.0699 100.587 47.1414 95.2264C47.7572 92.2212 48.9888 89.3761 50.0388 86.5095C50.4422 85.4041 50.824 84.2494 50.7347 83.0763C50.5653 81.2442 49.306 79.6954 47.5447 79.1566C47.6925 76.6317 49.7832 74.538 51.3105 72.5365C52.9024 70.4304 53.8292 67.9179 55.0269 65.5501C57.9675 59.7491 63.128 54.607 69.5695 53.6925C70.2962 53.5878 71.2907 53.7356 71.38 54.4623C71.4293 54.8595 71.1552 55.2166 70.8843 55.5092C69.4279 57.0857 67.5896 58.2803 66.1302 59.8507C64.6707 61.421 63.5899 63.6226 64.1534 65.701C64.9847 68.7431 68.6642 69.8547 70.8781 72.1024C72.1313 73.3771 72.9996 75.1168 74.6038 75.9082C77.2734 77.2229 80.3494 75.2677 82.5756 73.294C84.8018 71.3203 87.4806 69.0633 90.3719 69.7654C91.8314 71.6128 91.8621 74.4117 90.649 76.4254C89.8915 77.6848 88.6938 78.6024 87.653 79.6431C85.6516 81.6507 84.2106 84.1478 83.4685 86.882C83.1422 88.0952 82.9759 89.4623 83.5948 90.5554C84.0289 91.2205 84.6047 91.7809 85.2821 92.1935C89.248 94.9523 93.7435 96.8614 98.4853 97.7913C99.138 97.9175 99.8278 98.0253 100.456 97.7913C100.961 97.5727 101.413 97.2524 101.789 96.8491L106.934 92.0334C108.317 90.7402 109.826 88.9389 109.127 87.1838C108.689 86.0815 107.485 85.4226 107.061 84.3172C106.334 82.4235 108.104 79.8925 106.694 78.4299C107.873 76.7056 109.613 74.8828 111.685 75.1415C113.758 75.4001 115.18 77.4939 117.228 77.8326C120.239 78.3314 123.284 74.8705 125.985 76.293C127.007 76.8288 127.583 77.9219 128.288 78.8395C131.17 82.5744 136.327 83.4335 140.761 85.05C141.048 85.1331 141.312 85.2778 141.54 85.4687C142.261 86.1554 141.787 87.3655 141.217 88.1814C139.003 91.3375 135.893 93.7546 132.288 95.1186C131.287 95.4943 130.231 95.7991 129.381 96.4457C127.533 97.8652 127.145 100.504 127.296 102.832C127.349 103.651 127.484 104.538 128.085 105.095C128.497 105.427 128.99 105.652 129.513 105.745C130.997 106.108 132.528 106.253 134.052 106.173C134.218 107.386 134.819 109.082 134.15 110.108C133.43 111.207 132.029 111.576 130.859 112.183C128.159 113.639 126.551 116.534 126.742 119.594C126.853 121.011 127.339 122.519 126.699 123.788C125.732 125.703 123.066 125.666 120.941 125.977C120.532 126.011 120.137 126.15 119.799 126.381C119.5 126.652 119.272 126.99 119.137 127.369C118.506 128.804 118.074 130.322 117.856 131.874C117.459 134.685 118.472 137.921 117.24 140.477C116.8 141.385 116.064 142.106 115.417 142.875C113.822 144.781 112.717 147.044 112.196 149.474C111.993 150.438 111.889 151.503 112.39 152.353C112.812 153.076 113.588 153.526 114.044 154.225C115.079 155.817 114.232 158.308 115.648 159.573C116.15 160.02 116.843 160.189 117.357 160.633C118.296 161.424 118.398 162.809 118.429 164.038L118.567 169.429C118.601 169.768 118.561 170.11 118.447 170.43C118.182 170.923 117.69 171.249 117.135 171.305C115.5 171.557 113.992 170.301 113.148 168.878C112.304 167.456 111.882 165.799 110.993 164.426C110.161 163.148 108.973 162.157 107.8 161.184L100.542 155.155C100.253 154.915 99.9263 154.659 99.5445 154.693C99.2643 154.745 99.0056 154.884 98.8024 155.084C96.4592 156.978 94.1561 158.687 91.9145 160.691Z"
          fill="#10C695"
        />
        <path
          d="M131.462 181.767C132.765 183.101 133.944 184.92 135.801 185.053C136.897 185.133 137.922 184.572 138.935 184.154C141.198 183.221 143.674 182.928 146.094 183.304C148.613 183.701 151.021 184.822 153.567 184.843C156.114 184.865 159.008 183.181 158.974 180.631C158.956 179.055 157.785 177.672 156.388 176.936C154.99 176.2 153.385 175.997 151.818 175.803L146.291 175.113C144.604 174.904 142.843 174.698 141.232 175.255C139.302 175.923 137.593 177.663 135.579 177.327C134.655 177.173 133.858 176.585 133.116 175.991C131.536 174.701 130.018 173.26 128.125 172.496C125.218 171.323 119.368 173.509 122.194 177.37C123.013 178.488 124.596 178.537 125.828 178.836C127.977 179.363 129.892 180.166 131.462 181.767Z"
          fill="#03684D"
        />
        <path
          d="M284.681 103.466C281.605 104.784 279.394 107.561 278.806 110.856C278.529 112.506 278.68 114.197 278.637 115.872C278.517 120.376 276.974 124.721 275.185 128.859C274.184 131.175 272.574 133.81 270.049 133.786C268.457 133.786 267.072 132.631 266.206 131.295C265.341 129.959 264.867 128.413 264.168 126.984C260.658 119.841 252.07 116.463 248.015 109.612C245.712 105.723 245.093 100.99 245.7 96.5072C246.097 93.579 246.864 90.1951 244.899 87.9905C241.577 84.2709 240.419 79.5137 240.022 74.5441C239.939 74.0021 239.97 73.451 240.114 72.9245C240.299 72.4995 240.539 72.1054 240.832 71.7482C242.618 69.171 243.076 65.898 242.063 62.9297C241.257 60.6358 239.6 58.6467 239.231 56.245C239.169 55.8262 239.166 55.3459 239.461 55.0411C239.692 54.8471 239.976 54.727 240.274 54.7024C241.925 54.4099 243.621 54.5053 245.232 54.9764C246.331 55.2997 247.387 55.8016 248.545 55.854C251.411 55.9833 253.998 53.286 256.8 53.8957C257.724 54.0989 258.278 55.0996 258.921 55.8109C264.174 61.618 269.298 67.5822 273.544 74.1623C277.79 80.7423 281.162 88.0059 282.633 95.7036C283.148 98.3793 283.111 101.221 284.681 103.466Z"
          fill="#0CB08A"
        />
        <path
          d="M240.656 45.1449C240.059 44.9663 239.495 44.6892 238.984 44.332C238.467 43.9626 238.184 43.3467 238.236 42.7124C238.307 42.3891 238.439 42.0812 238.627 41.8072L239.338 40.6002C239.665 40.0459 240.077 39.4332 240.715 39.3439C241.571 39.2238 242.189 40.086 242.778 40.7203C243.701 41.7117 244.933 42.3183 246.063 43.045C247.603 44.0303 252.039 46.9739 248.68 48.2948C246.109 49.3017 242.996 46.0132 240.656 45.1449Z"
          fill="#0CB08A"
        />
        <path
          d="M188.419 52.3069C189.518 52.9935 190.765 53.5385 192.062 53.4985C193.358 53.4584 194.694 52.741 195.141 51.5279C195.587 50.3147 195.085 48.9014 194.553 47.6698C196.566 47.8052 198.506 48.498 200.151 49.6712C201.358 50.5333 202.414 51.6572 203.793 52.2022C205.173 52.7472 207.072 52.4362 207.642 51.066C208.212 49.6958 207.202 48.2455 206.247 47.1278C204.988 45.656 203.713 44.1965 202.423 42.7494C201.564 41.7887 200.671 40.8095 199.525 40.2183C197.73 39.2946 195.603 39.4301 193.589 39.2392C190.944 38.9898 188.391 38.14 185.777 37.6596C183.163 37.1793 180.337 37.1054 177.975 38.3247C177.652 38.4571 177.381 38.6942 177.205 38.999C176.882 39.698 177.541 40.4339 178.129 40.9235C180.284 42.6847 182.095 43.9133 183.231 46.4042C184.37 48.8213 186.168 50.8689 188.419 52.3069Z"
          fill="#0CB08A"
        />
        <path
          d="M226.455 31.2459C226.631 32.5976 225.43 33.8169 224.109 34.1525C222.788 34.4882 221.4 34.1772 220.073 33.8631C219.106 35.1255 220.048 37.0592 221.433 37.8351C222.819 38.6111 224.482 38.6572 226.024 39.0514C227.567 39.4455 229.184 40.44 229.387 42.0165L225.492 42.2136C225.042 43.0604 225.307 44.135 225.849 44.9294C226.391 45.7238 227.167 46.318 227.863 46.98C230.197 49.2155 231.573 52.2484 232.891 55.2012C233.768 57.1657 234.661 59.204 234.6 61.3594C234.581 62.0645 234.458 62.785 234.655 63.4624C234.941 64.457 235.834 65.1344 236.447 65.9688C237.5 67.4375 237.691 69.3558 236.943 71.0031C236.062 72.8783 233.654 73.7743 231.755 74.5841C229.855 75.3939 227.444 75.3878 225.904 74.0022C224.913 73.1092 224.423 71.8037 223.814 70.6152C222.49 68.0595 220.491 65.9103 218.037 64.4046C217.163 63.8719 216.221 63.4132 215.497 62.6896C214.773 61.966 214.29 60.8852 214.604 59.9184C214.983 58.7514 216.381 58.1725 217.597 58.3173C218.813 58.462 219.894 59.1455 220.922 59.8137C221.627 57.8831 220.497 55.7308 219.007 54.3144C217.517 52.8981 215.651 51.9004 214.256 50.3886C211.322 47.211 210.61 41.955 206.722 40.0613C203.449 38.4663 201.065 35.3595 197.703 33.9555C196.311 33.3735 194.732 33.198 193.5 32.3266C192.558 31.6585 191.914 30.6485 191.037 29.8849C189.673 28.7118 187.856 28.2068 186.082 28.5147C184.207 28.8565 182.588 30.0758 180.722 30.4515C178.797 30.8394 176.777 30.279 175.072 29.303C173.366 28.3269 171.922 26.9659 170.493 25.608C166.66 25.916 162.749 23.9392 159.408 22.0117C157.496 20.9032 155.439 19.6254 154.734 17.5316L162.352 16.3369C163.71 16.1244 165.194 15.8381 166.047 14.7666C165.363 12.8606 162.921 12.4141 160.905 12.2694L154.235 11.7891C178.274 10.1664 202.269 15.484 223.373 27.1045C223.983 27.3939 224.531 27.8004 224.987 28.2961C225.652 29.072 226.329 30.2575 226.455 31.2459Z"
          fill="#0CB08A"
        />
        <path
          d="M105.342 60.993C107.855 62.3355 109.447 65.6332 112.295 65.6332C113.57 65.6332 114.718 64.925 115.901 64.457C116.741 64.1245 117.637 63.8997 118.404 63.4163C119.171 62.9328 119.805 62.1076 119.731 61.2055C119.642 60.1093 118.604 59.3765 117.668 58.8007L114.336 56.75C113.656 56.282 112.908 55.9187 112.119 55.6693C111.263 55.4476 110.361 55.4999 109.49 55.3613C107.984 55.1058 106.654 54.2652 105.228 53.714C101.186 52.2176 96.6439 53.0736 93.4231 55.9402C90.9229 58.228 91.1908 61.1131 94.701 60.9222C98.0387 60.7313 102.226 59.3303 105.342 60.993Z"
          fill="#10C695"
        />
        <path
          d="M106.675 45.2065C107.639 44.8709 108.624 44.6061 109.625 44.409C111.531 44.135 113.471 44.6522 115.232 45.4282C117.271 46.3273 119.137 47.5651 120.756 49.0954C121.501 49.7974 122.206 50.5733 123.109 51.0568C124.627 51.8666 126.569 51.7865 127.906 52.8703C129.291 53.9911 129.605 56.0295 130.889 57.2673C132.173 58.5051 134.162 58.6744 135.93 59.0624C138.313 59.5797 140.549 60.6389 142.95 61.1069C145.352 61.5749 148.086 61.3348 149.82 59.6166C150.072 59.4103 150.232 59.1117 150.263 58.7853C150.263 58.3049 149.78 57.9909 149.376 57.7353C146.839 56.128 144.976 53.6463 144.142 50.7612C143.36 48.0177 143.471 44.8493 141.608 42.6878C141.013 42.0011 140.182 41.2191 140.487 40.3631C140.644 39.9197 141.103 39.6025 141.155 39.1314C141.214 38.7158 140.949 38.3278 140.699 37.9922C139.16 35.9415 137.568 33.8323 135.333 32.5853C133.485 31.5569 131.33 31.1997 129.236 31.018C116.799 30.0235 104.539 34.4481 95.5999 43.1558C92.5701 46.1456 95.3659 46.3704 98.171 46.3088C101.038 46.2472 103.92 46.0194 106.675 45.2065Z"
          fill="#03684D"
        />
        <path
          d="M106.241 23.1979C107.627 22.7514 109.099 22.5205 110.389 21.8462C111.808 21.1072 113.101 19.8201 114.699 19.9187C114.253 19.0842 113.255 18.6655 112.313 18.6655C111.371 18.6655 110.466 19.0196 109.6 19.4014C107.753 20.2204 105.419 21.218 103.96 22.6283C101.598 24.913 104.939 23.6136 106.241 23.1979Z"
          fill="#A7DDE8"
          stroke="#A7DDE8"
          stroke-width="2"
          stroke-miterlimit="10"
        />
        <path
          d="M127.582 21.6553C129.304 21.3012 130.991 20.787 132.617 20.1157C134.788 19.2782 136.924 18.3607 139.027 17.363C137.7 15.026 134.569 14.5364 131.881 14.5672C128.297 14.6072 124.596 15.1492 121.56 17.0551C119.937 18.0712 118.591 19.1674 116.732 19.7247C115.445 20.1065 114.099 20.4052 115.928 21.5321C117.255 22.3512 119.845 21.9109 121.356 21.9509C123.444 22.0063 125.535 22.034 127.582 21.6553Z"
          fill="#A7DDE8"
          stroke="#A7DDE8"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </g>
    </svg>
  );
};
